export const medicalAidResults = [
  {
    "scheme": "Aeci",
    "plan": "Comprehensive",
    "administrator": "Medscheme",
    "contactInfo": {
      "email": [
        "aecisociety@medscheme.co.za"
      ],
      "fax": [],
      "phone": [
        "0861 002 103"
      ]
    },
    "networked": "Yes",
    "nonNetworkedPayment": "Yes",
    "balancedBilling": "Yes",
    "basicTreatment": "Yes with limitations",
    "rct": "Yes",
    "dentures": "Yes",
    "crownsOrBridges": "Yes",
    "implants": "Yes",
    "surgicalExtractions": "Yes",
    "exclusions": "Dental bleaching (whitening) and porcelain veneers.\nMaterials: The cost of gold, precious metal, or other inlays in a denture or crown is excluded.",
    "preAuth": "Advanced Dentistry: Yes, pre-authorisation is required before treatment starts. These procedures are paid subject to your specialised dentistry benefit.",
    "crucialRules": "Basic Dentistry: Generally limited to two consultations/visits per beneficiary per year, covering only cleaning, fillings, and extractions. Plastic/Acrylic Dentures: Limited to one set per beneficiary every 24 months.",
    "notes": "General dental practitioners are paid at cost or Scheme Tariff (whichever is lower). Specialist dental practitioners (e.g., maxillo-facial surgeons) are covered at cost or at 1.5 times the Scheme Tariff (whichever is lower).",
    "source": "https://aecimedicalaidsociety.co.za/benefits/everyday/",
    "lastUpdated": "Jan-26"
  },
  {
    "scheme": "Aeci",
    "plan": "Value",
    "administrator": "Universal",
    "contactInfo": {
      "email": [
        "network@universal.co.za"
      ],
      "fax": [],
      "phone": [
        "0803 628 677"
      ]
    },
    "networked": "Yes",
    "nonNetworkedPayment": "Yes",
    "balancedBilling": "No",
    "basicTreatment": "Yes with limitations",
    "rct": "Emergency pain relief.",
    "dentures": "Yes",
    "crownsOrBridges": "No",
    "implants": "No",
    "surgicalExtractions": "Yes, but with significant limitations.",
    "exclusions": "Advanced Dentistry: Procedures typically classified as \"advanced dentistry\" (e.g., root canals, crowns, bridges, periodontic treatment, implants, orthodontics) are not covered by the Value option.",
    "preAuth": "Maxillo-facial procedures: These may be covered from the risk benefit if they are pre-authorised and performed by a maxillo-facial surgeon, either in rooms or in a hospital, but coverage is subject to specific benefits and limits detailed in the member guide.",
    "crucialRules": "Limited Basic Dentistry: The Value Option covers only basic dentistry, which is limited to: Two consultations/visits per beneficiary per year.Fillings and extractions. Plastic/acrylic dentures (limited to one set per beneficiary every 24 months). No Cover for Advanced Dentistry:",
    "notes": "it generally does not cover advanced or in-hospital dentistry, unless it is a Prescribed Minimum Benefit (PMB) or a specific maxillo-facial procedure that has been pre-authorised.",
    "source": "https://aecimedicalaidsociety.co.za/benefits/everyday/",
    "lastUpdated": "Jan-26"
  },
  {
    "scheme": "Affinity",
    "plan": "Bronze",
    "administrator": "DRC",
    "contactInfo": {
      "email": [
        "auth@dentalrisk.com or fax 086 687 1285"
      ],
      "fax": [
        " 086 687 1285"
      ],
      "phone": [
        "086 111 0033 / 087 943 9611"
      ]
    },
    "networked": "Yes",
    "nonNetworkedPayment": "Yes",
    "balancedBilling": "No",
    "basicTreatment": "Yes with limitations",
    "rct": "No",
    "dentures": "No",
    "crownsOrBridges": "No",
    "implants": "No",
    "surgicalExtractions": "cover for the surgical removal of impacted wisdom teeth, specifically allowing for the removal of up to four impacted teeth per member, per year. This benefit requires pre-authorisation and has a three-month waiting period.",
    "exclusions": "Hospital-Based Dentistry: The benefit is for \"in-chair\" procedures only. General anesthesia or hospital costs for dental work are typically excluded unless specifically related to a pre-authorised accident.",
    "preAuth": "More than 3 restorations requires pre-authorisation. Surgical Removals: Surgical removals are only covered when authorised. Extraction: More than 4 extractions per annum require pre authorisation. Maximum of 1 X 8201 per \nquadrant per visit. 3 restorations per member per annum. \n More than 3 restorations require pre-authorisation. 1 Restoration code per tooth number in a 9-month period. Pre-authorisation and x-rays required for any 3 or 4 surface restorations on wisdom teeth. Lower jaw posterior fillings involving anaesthetic cannot be performed across the midline.",
    "crucialRules": "The crucial rules to be aware of primarily involve waiting periods, the use of network providers, pre-authorisation requirements, and specific annual limits or frequencies for benefits.",
    "notes": "Waiting Periods: General benefits: Most dental benefits have a 3-month waiting period from the commencement date.\nPre-existing conditions: Any dental issues considered pre-existing conditions are subject to a 12-month waiting period.\nEmergency Root Canal: This specific benefit has a 1-month waiting period.",
    "source": "https://www.affinityhealth.co.za/",
    "lastUpdated": "Jan-26"
  },
  {
    "scheme": "AFFINITY DENTAL PLAN:",
    "plan": "SILVER OPTION",
    "administrator": "DRC",
    "contactInfo": {
      "email": [
        "auth@dentalrisk.com or fax 086 687 1286"
      ],
      "fax": [
        " 086 687 1286"
      ],
      "phone": [
        "087 111 0033 / 087 943 9611"
      ]
    },
    "networked": "Yes",
    "nonNetworkedPayment": "Yes",
    "balancedBilling": "Network No, Non-Network Yes",
    "basicTreatment": "Yes with limitations",
    "rct": "No",
    "dentures": "No",
    "crownsOrBridges": "No",
    "implants": "No",
    "surgicalExtractions": "No",
    "exclusions": "Root Canal Treatment: This is a major exclusion for Silver members; Crowns and Bridges: These specialized restorative procedures are excluded.",
    "preAuth": "Limited to 3 restorations per member per covered period. \u2022 1 Restoration code per tooth number in a 9-month period. \u2022 Pre-authorisation and x-rays required for any 3 or 4 surface restorations on wisdom teeth.",
    "crucialRules": "The crucial rules to be aware of primarily involve waiting periods, the use of network providers, pre-authorisation requirements, and specific annual limits or frequencies for benefits.",
    "notes": "Advanced Dentistry \u2013 R900 (3 Months waiting period)\nAs this is a generic Rand limited benefit any dental code claimed that is not in the above listings will be processed\nand paid at the billed rate to the maximum of the Rand limit.",
    "source": "https://www.affinityhealth.co.za/",
    "lastUpdated": "Jan-26"
  },
  {
    "scheme": "AFFINITY DENTAL PLAN:",
    "plan": "GOLD",
    "administrator": "DRC",
    "contactInfo": {
      "email": [
        "auth@dentalrisk.com or fax 086 687 1286"
      ],
      "fax": [
        " 086 687 1286"
      ],
      "phone": [
        "087 111 0033 / 087 943 9611"
      ]
    },
    "networked": "Yes",
    "nonNetworkedPayment": "Yes",
    "balancedBilling": "No",
    "basicTreatment": "Yes with limitations",
    "rct": "Yes",
    "dentures": "No",
    "crownsOrBridges": "Yes",
    "implants": "No",
    "surgicalExtractions": "Limited to 2 extractions per member per annum.",
    "exclusions": "The plan does not cover services that are primarily for cosmetic purposes, such as teeth whitening or veneers, unless there is a specific medical necessity.",
    "preAuth": "Limited to 5 restorations per member per annum. \u2022 Pre-authorisation required for more than 3 restorations per visit. \u2022 1 Restoration code per tooth number in a 12-month period. \u2022 Pre-authorisation and x-rays required for any 3 or 4 surface restorations on wisdom teeth. \u2022 Lower jaw posterior fillings involving anaesthetic cannot be performed across the midline.",
    "crucialRules": "include mandatory pre-authorisation for advanced procedures, specific annual limits on treatments like fillings and crowns, and a 3-month waiting period for most benefits. Pre-existing conditions are subject to a longer, 12-month waiting period.",
    "notes": "Advanced Dentistry \u2013 R1 400 per policy per annum (3 Months waiting period)\nAs this is a generic Rand limited benefit any dental code claimed that is not in the above listings will be processed\nand paid at the billed rate to the maximum of the Rand limit.",
    "source": "https://www.affinityhealth.co.za/",
    "lastUpdated": "Jan-26"
  },
  {
    "scheme": "AFFINITY DENTAL PLAN:",
    "plan": "PLATINUM",
    "administrator": "DRC",
    "contactInfo": {
      "email": [
        "auth@dentalrisk.com or fax 086 687 1286"
      ],
      "fax": [
        " 086 687 1286"
      ],
      "phone": [
        "087 111 0033 / 087 943 9611"
      ]
    },
    "networked": "Yes",
    "nonNetworkedPayment": "Yes",
    "balancedBilling": "No",
    "basicTreatment": "Yes with limitations",
    "rct": "Yes",
    "dentures": "No",
    "crownsOrBridges": "Yes",
    "implants": "No",
    "surgicalExtractions": "Limited to 3 extractions per member per annum.",
    "exclusions": "In-hospital procedures are not covered by the plan. Pre-existing conditions are subject to a 12-month waiting period from the commencement date, during which claims will not be paid. Cosmetic dentistry, such as teeth whitening or veneers, is often considered an elective procedure and is generally not covered.",
    "preAuth": "All specialised dentistry must be pre-authorised. Pre-authorisation required for more than 3 restorations per visit. \u2022 1 Restoration code per tooth number in a 12-month period. \u2022 Pre-authorisation and x-rays required for any 3 or 4 surface restorations on wisdom teeth.",
    "crucialRules": "include mandatory pre-authorisation for advanced procedures, specific annual limits on treatments like fillings and crowns, and a 3-month waiting period for most benefits. Pre-existing conditions are subject to a longer, 12-month waiting period.",
    "notes": "Advanced Dentistry \u2013 R2 100 per policy per annum (3 Months waiting period) As this is a generic Rand limited benefit any dental code claimed that is not in the above listings will be processed and paid at the billed rate to the maximum of the Rand limit.",
    "source": "https://www.affinityhealth.co.za/",
    "lastUpdated": "Jan-26"
  },
  {
    "scheme": "AFFINITY DENTAL PLAN:",
    "plan": "PLATINUM PLUS",
    "administrator": "DRC",
    "contactInfo": {
      "email": [
        "auth@dentalrisk.com or fax 086 687 1286"
      ],
      "fax": [
        " 086 687 1286"
      ],
      "phone": [
        "087 111 0033 / 087 943 9611"
      ]
    },
    "networked": "Yes",
    "nonNetworkedPayment": "Yes",
    "balancedBilling": "Network No, Non-Network Yes",
    "basicTreatment": "Yes with limitations",
    "rct": "Yes",
    "dentures": "Yes",
    "crownsOrBridges": "Yes",
    "implants": "No",
    "surgicalExtractions": "Limited to 3 extractions per member per annum.",
    "exclusions": "PANOREX. In-hospital procedures are not covered by the plan. Pre-existing conditions are subject to a 12-month waiting period from the commencement date, during which claims will not be paid. Cosmetic dentistry, such as teeth whitening or veneers, is often considered an elective procedure and is generally not covered.",
    "preAuth": "Maximum of 5 restorations per annum. Pre-authorisation required for more than 3 restorations per visit. 1 Restoration code per tooth number in a 12-month period. Pre-authorisation and x-rays required for any 3 or 4 surface restorations on wisdom teeth. Root Canal: Maximum of 2 teeth per annum. Benefit includes Emergency Root Canal. All specialised dentistry must be pre-authorised. Impaction: Maximum of 2 extractions per annum. Applicable to Wisdom teeth only (tooth 18, 28, 38, 48). All specialised dentistry must be pre-authorised. Crown: 2 Crown per member per annum with a maximum of R3 500.00. 1 Per tooth per 5 years. All specialised dentistry must be pre-authorised.",
    "crucialRules": "Advanced Dentistry \u2013 R2 800 per policy per annum (3 Months waiting period) As this is a generic Rand limited benefit any dental code claimed that is not in the above listings will be processed and paid at the billed rate to the maximum of the Rand limit.",
    "notes": "Advanced Dentistry \u2013 R2 800 per policy per annum (3 Months waiting period) As this is a generic Rand limited benefit any dental code claimed that is not in the above listings will be processed\nand paid at the billed rate to the maximum of the Rand limit.",
    "source": "https://www.affinityhealth.co.za/",
    "lastUpdated": "Jan-26"
  },
  {
    "scheme": "Affinity Health",
    "plan": "Combined",
    "administrator": "DRC",
    "contactInfo": {
      "email": [
        "auth@dentalrisk.com or fax 086 687 1285"
      ],
      "fax": [
        " 086 687 1285"
      ],
      "phone": [
        "086 111 0033 / 087 943 9611"
      ]
    },
    "networked": "Yes",
    "nonNetworkedPayment": "Yes",
    "balancedBilling": "Network No, Non-Network Yes",
    "basicTreatment": "Yes with limitations",
    "rct": "No",
    "dentures": "No",
    "crownsOrBridges": "No",
    "implants": "No",
    "surgicalExtractions": "covers surgical extractions, but coverage is subject to specific limits, pre-authorisation requirements, and waiting periods, and typically applies only to wisdom teeth.",
    "exclusions": "On extraction and restorations codes tooth numbers should not cross posterior quadrants but should be in a combination of 1st and 4th quadrants or 2nd and 3rd quadrants per visit. Any deviation requires authorisation. No panorex x-rays. Benefits for amalgam restorations to be replaced with composite are only available where such \ntreatment is necessary to restore secondary caries. Resin restorations are not covered on non\u0002carious teeth restored with amalgams. Metal base to complete or partial dentures, including laboratory cost. onservative dental treatment (restorations; extractions and root canal therapy) for adults in\u0002hospital. No specialised dentistry.",
    "preAuth": "More than 3 restorations requires pre-authorisation. Surgical Removals: Surgical removals are only covered when authorised. Extraction: More than 4 extractions per annum require pre authorisation. Maximum of 1 X 8201 per \nquadrant per visit. 3 restorations per member per annum. \n More than 3 restorations require pre-authorisation. 1 Restoration code per tooth number in a 9-month period. Pre-authorisation and x-rays required for any 3 or 4 surface restorations on wisdom teeth. Lower jaw posterior fillings involving anaesthetic cannot be performed across the midline.",
    "crucialRules": "1. No Specialised dentistry applies: Patient to consent to such - form to be completed and signed by patient 2. Limit of 3 fillings per annum. No cover for anterior restorations.",
    "notes": "1. Very basic option 2. Lower rate applies to non network provider 3. Patient written consent needed for procedures not covered. 4. Authorisation is not a guarantee of payment but a clinical indication as at time and date that the authorisation was processed.",
    "source": "https://www.affinityhealth.co.za/",
    "lastUpdated": "Jan-26"
  },
  {
    "scheme": "Affinity Health",
    "plan": "Day to Day (Network Option)",
    "administrator": "DRC",
    "contactInfo": {
      "email": [
        "auth@dentalrisk.com or fax 086 687 1285"
      ],
      "fax": [
        " 086 687 1285"
      ],
      "phone": [
        "086 111 0033 / 087 943 9611"
      ]
    },
    "networked": "Yes",
    "nonNetworkedPayment": "Yes",
    "balancedBilling": "Network No, Non-Network Yes",
    "basicTreatment": "Yes with limitations",
    "rct": "No",
    "dentures": "No",
    "crownsOrBridges": "No",
    "implants": "No",
    "surgicalExtractions": "No, the Affinity Health Day-to-Day plan generally covers basic extractions, but not specifically \"surgical\" extractions as a standard benefit.",
    "exclusions": "Common exclusions include crowns beyond limits, cosmetic procedures, orthodontic braces, specialist prosthetics, and treatments by non-network dentists, with costs for these falling to the member.",
    "preAuth": "More than 3 restorations requires pre-authorisation. Surgical Removals: Surgical removals are only covered when authorised. Extraction: More than 4 extractions per annum require pre authorisation. Maximum of 1 X 8201 per \nquadrant per visit. 3 restorations per member per annum. \n More than 3 restorations require pre-authorisation. 1 Restoration code per tooth number in a 9-month period. Pre-authorisation and x-rays required for any 3 or 4 surface restorations on wisdom teeth. Lower jaw posterior fillings involving anaesthetic cannot be performed across the midline.",
    "crucialRules": "Pre-authorisation is Required: All dental treatments and procedures must be pre-authorised",
    "notes": "1. Very basic option 2. Lower rate applies to non network provider 3. Patient written consent needed for procedures not covered. 4. Authorisation is not a guarantee of payment but a clinical indication as at time and date that the authorisation was processed.",
    "source": "https://www.affinityhealth.co.za/",
    "lastUpdated": "Jan-26"
  },
  {
    "scheme": "Affinity Health",
    "plan": "GOLD MAX,",
    "administrator": "DRC",
    "contactInfo": {
      "email": [
        "auth@dentalrisk.com or fax 086 687 1285"
      ],
      "fax": [
        " 086 687 1285"
      ],
      "phone": [
        "086 111 0033 / 087 943 9611"
      ]
    },
    "networked": "Yes",
    "nonNetworkedPayment": "Yes",
    "balancedBilling": "Network No, Non-Network Yes",
    "basicTreatment": "Yes with limitations",
    "rct": "No",
    "dentures": "No",
    "crownsOrBridges": "No",
    "implants": "No",
    "surgicalExtractions": "Surgical Extractions/Impaction Removals: These are specifically covered, often limited to wisdom teeth only. The benefit usually includes: Limited to 2 extractions per member per year (wisdom teeth only).\nPre-authorisation is mandatory for all surgical removals.",
    "exclusions": "does not cover in-hospital dental procedures, cosmetic dentistry, orthodontics, or dental implants.",
    "preAuth": "More than 3 restorations requires pre-authorisation. Surgical Removals: Surgical removals are only covered when authorised. Extraction: More than 4 extractions per annum require pre authorisation. Maximum of 1 X 8201 per \nquadrant per visit. 3 restorations per member per annum. \n More than 3 restorations require pre-authorisation. 1 Restoration code per tooth number in a 9-month period. Pre-authorisation and x-rays required for any 3 or 4 surface restorations on wisdom teeth. Lower jaw posterior fillings involving anaesthetic cannot be performed across the midline.",
    "crucialRules": "Intraoral X-rays: Maximum of 3 X-rays annually.",
    "notes": "Waiting Periods:\nMost standard benefits (consultations, scale and polish) have a one-month waiting period.\nMore extensive procedures (extractions, fillings, root canals, crowns) are subject to a three-month waiting period.\nPre-existing conditions have a 12-month waiting period from the policy commencement date.",
    "source": "https://www.affinityhealth.co.za/",
    "lastUpdated": "Jan-26"
  },
  {
    "scheme": "Affinity Health",
    "plan": "PLATINUM MAX",
    "administrator": "DRC",
    "contactInfo": {
      "email": [
        "auth@dentalrisk.com or fax 086 687 1285"
      ],
      "fax": [
        " 086 687 1285"
      ],
      "phone": [
        "086 111 0033 / 087 943 9611"
      ]
    },
    "networked": "Yes",
    "nonNetworkedPayment": "Yes",
    "balancedBilling": "Network No, Non-Network Yes",
    "basicTreatment": "Yes with limitations",
    "rct": "No",
    "dentures": "No",
    "crownsOrBridges": "No",
    "implants": "No",
    "surgicalExtractions": "The Affinity Health Platinum Max plan covers specific surgical extractions, primarily the removal of impacted wisdom teeth, with a limit of up to 4 teeth per member per year. All other standard extractions are limited to 7 per member per year.",
    "exclusions": "he plan specifically covers only in-chair procedures. Complex procedures requiring hospitalisation (unless a separate hospital plan is purchased and the admission is for an accident-related injury) are not covered.",
    "preAuth": "More than 3 restorations requires pre-authorisation. Surgical Removals: Surgical removals are only covered when authorised. Extraction: More than 4 extractions per annum require pre authorisation. Maximum of 1 X 8201 per \nquadrant per visit. 3 restorations per member per annum. \n More than 3 restorations require pre-authorisation. 1 Restoration code per tooth number in a 9-month period. Pre-authorisation and x-rays required for any 3 or 4 surface restorations on wisdom teeth. Lower jaw posterior fillings involving anaesthetic cannot be performed across the midline.",
    "crucialRules": "The crucial rules to be aware of primarily involve waiting periods, the use of network providers, pre-authorisation requirements, and specific annual limits or frequencies for benefits.",
    "notes": "Waiting Periods: General benefits: Most dental benefits have a 3-month waiting period from the commencement date.\nPre-existing conditions: Any dental issues considered pre-existing conditions are subject to a 12-month waiting period.\nEmergency Root Canal: This specific benefit has a 1-month waiting period.",
    "source": "https://www.affinityhealth.co.za/",
    "lastUpdated": "Jan-26"
  },
  {
    "scheme": "Affinity Health",
    "plan": "TITANIUM MAX",
    "administrator": "DRC",
    "contactInfo": {
      "email": [
        "auth@dentalrisk.com or fax 086 687 1285"
      ],
      "fax": [
        " 086 687 1285"
      ],
      "phone": [
        "086 111 0033 / 087 943 9611"
      ]
    },
    "networked": "Yes",
    "nonNetworkedPayment": "Yes",
    "balancedBilling": "Network No, Non-Network Yes",
    "basicTreatment": "Yes with limitations",
    "rct": "No",
    "dentures": "No",
    "crownsOrBridges": "No",
    "implants": "No",
    "surgicalExtractions": "Surgical Impactions: The removal of up to 4 impacted wisdom teeth per member per year.",
    "exclusions": "Hospital-Based Dentistry: The benefit is for \"in-chair\" procedures only. General anesthesia or hospital costs for dental work are typically excluded unless specifically related to a pre-authorised accident.",
    "preAuth": "More than 3 restorations requires pre-authorisation. Surgical Removals: Surgical removals are only covered when authorised. Extraction: More than 4 extractions per annum require pre authorisation. Maximum of 1 X 8201 per \nquadrant per visit. 3 restorations per member per annum. \n More than 3 restorations require pre-authorisation. 1 Restoration code per tooth number in a 9-month period. Pre-authorisation and x-rays required for any 3 or 4 surface restorations on wisdom teeth. Lower jaw posterior fillings involving anaesthetic cannot be performed across the midline.",
    "crucialRules": "The crucial rules to be aware of primarily involve waiting periods, the use of network providers, pre-authorisation requirements, and specific annual limits or frequencies for benefits.",
    "notes": "Waiting Periods: General benefits: Most dental benefits have a 3-month waiting period from the commencement date.\nPre-existing conditions: Any dental issues considered pre-existing conditions are subject to a 12-month waiting period.\nEmergency Root Canal: This specific benefit has a 1-month waiting period.",
    "source": "https://www.affinityhealth.co.za/",
    "lastUpdated": "Jan-26"
  },
  {
    "scheme": "Affinity Health",
    "plan": "Silver Max",
    "administrator": "DRC",
    "contactInfo": {
      "email": [
        "auth@dentalrisk.com or fax 086 687 1285"
      ],
      "fax": [
        " 086 687 1285"
      ],
      "phone": [
        "086 111 0033 / 087 943 9611"
      ]
    },
    "networked": "Yes",
    "nonNetworkedPayment": "Yes",
    "balancedBilling": "Network No, Non-Network Yes",
    "basicTreatment": "Yes with limitations",
    "rct": "No",
    "dentures": "No",
    "crownsOrBridges": "No",
    "implants": "No",
    "surgicalExtractions": "cover for the surgical removal of impacted wisdom teeth, specifically allowing for the removal of up to four impacted teeth per member, per year. This benefit requires pre-authorisation and has a three-month waiting period.",
    "exclusions": "Hospital-Based Dentistry: The benefit is for \"in-chair\" procedures only. General anesthesia or hospital costs for dental work are typically excluded unless specifically related to a pre-authorised accident.",
    "preAuth": "More than 3 restorations requires pre-authorisation. Surgical Removals: Surgical removals are only covered when authorised. Extraction: More than 4 extractions per annum require pre authorisation. Maximum of 1 X 8201 per \nquadrant per visit. 3 restorations per member per annum. \n More than 3 restorations require pre-authorisation. 1 Restoration code per tooth number in a 9-month period. Pre-authorisation and x-rays required for any 3 or 4 surface restorations on wisdom teeth. Lower jaw posterior fillings involving anaesthetic cannot be performed across the midline.",
    "crucialRules": "The crucial rules to be aware of primarily involve waiting periods, the use of network providers, pre-authorisation requirements, and specific annual limits or frequencies for benefits.",
    "notes": "Waiting Periods: General benefits: Most dental benefits have a 3-month waiting period from the commencement date.\nPre-existing conditions: Any dental issues considered pre-existing conditions are subject to a 12-month waiting period.\nEmergency Root Canal: This specific benefit has a 1-month waiting period.",
    "source": "https://www.affinityhealth.co.za/",
    "lastUpdated": "Jan-26"
  },
  {
    "scheme": "Affinity Health",
    "plan": "Delta Max",
    "administrator": "DRC",
    "contactInfo": {
      "email": [
        "auth@dentalrisk.com or fax 086 687 1285"
      ],
      "fax": [
        " 086 687 1285"
      ],
      "phone": [
        "086 111 0033 / 087 943 9611"
      ]
    },
    "networked": "Yes",
    "nonNetworkedPayment": "Yes",
    "balancedBilling": "Network No, Non-Network Yes",
    "basicTreatment": "Yes with limitations",
    "rct": "No",
    "dentures": "No",
    "crownsOrBridges": "No",
    "implants": "No",
    "surgicalExtractions": "cover for the surgical removal of impacted wisdom teeth, specifically allowing for the removal of up to four impacted teeth per member, per year. This benefit requires pre-authorisation and has a three-month waiting period.",
    "exclusions": "Hospital-Based Dentistry: The benefit is for \"in-chair\" procedures only. General anesthesia or hospital costs for dental work are typically excluded unless specifically related to a pre-authorised accident.",
    "preAuth": "More than 3 restorations requires pre-authorisation. Surgical Removals: Surgical removals are only covered when authorised. Extraction: More than 4 extractions per annum require pre authorisation. Maximum of 1 X 8201 per \nquadrant per visit. 3 restorations per member per annum. \n More than 3 restorations require pre-authorisation. 1 Restoration code per tooth number in a 9-month period. Pre-authorisation and x-rays required for any 3 or 4 surface restorations on wisdom teeth. Lower jaw posterior fillings involving anaesthetic cannot be performed across the midline.",
    "crucialRules": "The crucial rules to be aware of primarily involve waiting periods, the use of network providers, pre-authorisation requirements, and specific annual limits or frequencies for benefits.",
    "notes": "Waiting Periods: General benefits: Most dental benefits have a 3-month waiting period from the commencement date.\nPre-existing conditions: Any dental issues considered pre-existing conditions are subject to a 12-month waiting period.\nEmergency Root Canal: This specific benefit has a 1-month waiting period.",
    "source": "https://www.affinityhealth.co.za/",
    "lastUpdated": "Jan-26"
  },
  {
    "scheme": "Affinity Health",
    "plan": "AFFINITY REEF",
    "administrator": "DRC",
    "contactInfo": {
      "email": [
        "auth@dentalrisk.com or fax 086 687 1286"
      ],
      "fax": [
        " 086 687 1286"
      ],
      "phone": [
        "087 111 0033 / 087 943 9611"
      ]
    },
    "networked": "Yes",
    "nonNetworkedPayment": "Yes",
    "balancedBilling": "Network No, Non-Network Yes",
    "basicTreatment": "Yes with limitations",
    "rct": "No",
    "dentures": "No",
    "crownsOrBridges": "No",
    "implants": "No",
    "surgicalExtractions": "The Affinity Health Day-to-Day Plan (Affinity Reef) covers standard surgical extractions, with a limit of 3 extractions per member per year. For the surgical removal of impacted wisdom teeth, the plan covers the removal of 4 wisdom teeth per member per year, applicable only to wisdom teeth that are impacted. Both benefits require a 3-month waiting period and pre-authorisation.",
    "exclusions": "Hospital-Based Dentistry: The benefit is for \"in-chair\" procedures only. General anesthesia or hospital costs for dental work are typically excluded unless specifically related to a pre-authorised accident.",
    "preAuth": "3 restorations per member per annum. \u2022 More than 3 restorations require pre-authorisation. \u2022 1 Restoration code per tooth number in a 9-month period. \u2022 Pre-authorisation and x-rays required for any 3 or 4 surface restorations on wisdom teeth. \u2022 Lower jaw posterior fillings involving anaesthetic cannot be performed across the midline.",
    "crucialRules": "The crucial rules to be aware of primarily involve waiting periods, the use of network providers, pre-authorisation requirements, and specific annual limits or frequencies for benefits.",
    "notes": "Waiting Periods: General benefits: Most dental benefits have a 3-month waiting period from the commencement date.\nPre-existing conditions: Any dental issues considered pre-existing conditions are subject to a 12-month waiting period.\nEmergency Root Canal: This specific benefit has a 1-month waiting period.",
    "source": "https://www.affinityhealth.co.za/",
    "lastUpdated": "Jan-26"
  },
  {
    "scheme": "Affinity Health",
    "plan": "Elevate",
    "administrator": "DRC",
    "contactInfo": {
      "email": [
        "auth@dentalrisk.com or fax 086 687 1285"
      ],
      "fax": [
        " 086 687 1285"
      ],
      "phone": [
        "086 111 0033 / 087 943 9611"
      ]
    },
    "networked": "Yes",
    "nonNetworkedPayment": "Yes",
    "balancedBilling": "Network No, Non-Network Yes",
    "basicTreatment": "Yes with limitations",
    "rct": "No",
    "dentures": "No",
    "crownsOrBridges": "No",
    "implants": "No",
    "surgicalExtractions": "Surgical/Impacted Wisdom Teeth Extractions: The removal of impacted wisdom teeth (up to 4 teeth per year) falls under a specific benefit and is subject to pre-authorisation and a 3-month waiting period.",
    "exclusions": "cover for dental procedures is limited to in-chair treatments by network dentists, while in-hospital dental procedures, cosmetic dentistry, are generally excluded.",
    "preAuth": "Limited to 3 restorations per member per covered period. \u2022 1 Restoration code per tooth number in a 9-month period. \u2022 Pre-authorisation and x-rays required for any 3 or 4 surface restorations on wisdom teeth.\n\u2022 Lower jaw posterior fillings involving anaesthetic cannot be performed across the midline.",
    "crucialRules": "The crucial rules to be aware of primarily involve waiting periods, the use of network providers, pre-authorisation requirements, and specific annual limits or frequencies for benefits.",
    "notes": "Waiting Periods: General benefits: Most dental benefits have a 3-month waiting period from the commencement date.\nPre-existing conditions: Any dental issues considered pre-existing conditions are subject to a 12-month waiting period.\nEmergency Root Canal: This specific benefit has a 1-month waiting period.",
    "source": "https://www.affinityhealth.co.za/",
    "lastUpdated": "Jan-26"
  },
  {
    "scheme": "Affinity Health",
    "plan": "Vital",
    "administrator": "DRC",
    "contactInfo": {
      "email": [
        "auth@dentalrisk.com or fax 086 687 1286"
      ],
      "fax": [
        " 086 687 1286"
      ],
      "phone": [
        "087 111 0033 / 087 943 9611"
      ]
    },
    "networked": "Yes",
    "nonNetworkedPayment": "Yes",
    "balancedBilling": "Network No, Non-Network Yes",
    "basicTreatment": "Yes with limitations",
    "rct": "No",
    "dentures": "No",
    "crownsOrBridges": "No",
    "implants": "No",
    "surgicalExtractions": "Surgical/Impacted Wisdom Teeth Extractions: The removal of impacted wisdom teeth (up to 4 teeth per year) falls under a specific benefit and is subject to pre-authorisation and a 3-month waiting period.",
    "exclusions": "cover for dental procedures is limited to in-chair treatments by network dentists, while in-hospital dental procedures, cosmetic dentistry, are generally excluded.",
    "preAuth": "Limited to 3 restorations per member per covered period. \u2022 1 Restoration code per tooth number in a 9-month period. \u2022 Pre-authorisation and x-rays required for any 3 or 4 surface restorations on wisdom teeth.\n\u2022 Lower jaw posterior fillings involving anaesthetic cannot be performed across the midline.",
    "crucialRules": "The crucial rules to be aware of primarily involve waiting periods, the use of network providers, pre-authorisation requirements, and specific annual limits or frequencies for benefits.",
    "notes": "Waiting Periods: General benefits: Most dental benefits have a 3-month waiting period from the commencement date.\nPre-existing conditions: Any dental issues considered pre-existing conditions are subject to a 12-month waiting period.\nEmergency Root Canal: This specific benefit has a 1-month waiting period.",
    "source": "https://www.affinityhealth.co.za/",
    "lastUpdated": "Jan-26"
  },
  {
    "scheme": "AFRICAN UNITY (AUL)",
    "plan": "NFS-1 PREMIUM",
    "administrator": "DRC",
    "contactInfo": {
      "email": [
        "auth@dentalrisk.com"
      ],
      "fax": [],
      "phone": [
        "087 943 9612"
      ]
    },
    "networked": "Yes",
    "nonNetworkedPayment": "No",
    "balancedBilling": "Network No, Non-Network Yes",
    "basicTreatment": "Yes with limitations",
    "rct": "No",
    "dentures": "No",
    "crownsOrBridges": "No",
    "implants": "No",
    "surgicalExtractions": "No",
    "exclusions": "Pan Scan NO BENEFITS. Bite Plate NO BENEITS. Mouth Guard NO BENEFITS. Root Canal NO BENEFITS. Temporary Crown NO BENEFITS",
    "preAuth": "Maximum of 1 X 8201 per quadrant per visit. \u2022 More than 4 extractions per visit require pre-authorisation.",
    "crucialRules": "Posterior restorations are covered to the value of amalgam restorations. Pre-authorisation and X-rays required for: \u2022 More than 4 restorations per annum. \u2022 Any 3 or 4 surface restorations on wisdom teeth.",
    "notes": "Posterior restorations are covered to the value of amalgam restorations",
    "source": "https://dentalrisk.com/member-benefits/",
    "lastUpdated": "Jan-26"
  },
  {
    "scheme": "AFRICAN UNITY (AUL)",
    "plan": "PREMIUM",
    "administrator": "DRC",
    "contactInfo": {
      "email": [
        "auth@dentalrisk.com"
      ],
      "fax": [],
      "phone": [
        "087 943 9612"
      ]
    },
    "networked": "Yes",
    "nonNetworkedPayment": "No",
    "balancedBilling": "Network No, Non-Network Yes",
    "basicTreatment": "Yes with limitations",
    "rct": "No",
    "dentures": "No",
    "crownsOrBridges": "No",
    "implants": "No",
    "surgicalExtractions": "No",
    "exclusions": "Pan Scan NO BENEFITS. Bite Plate NO BENEITS. Mouth Guard NO BENEFITS. Root Canal NO BENEFITS. Temporary Crown NO BENEFITS",
    "preAuth": "Maximum of 1 X 8201 per quadrant per visit. \u2022 More than 4 extractions per visit require pre-authorisation.",
    "crucialRules": "Posterior restorations are covered to the value of amalgam restorations. Pre-authorisation and X-rays required for: \u2022 More than 4 restorations per annum. \u2022 Any 3 or 4 surface restorations on wisdom teeth.",
    "notes": "Posterior restorations are covered to the value of amalgam restorations",
    "source": "https://dentalrisk.com/member-benefits/",
    "lastUpdated": "Jan-26"
  },
  {
    "scheme": "AFRICAN UNITY (AUL)",
    "plan": "PRESTIGE",
    "administrator": "DRC",
    "contactInfo": {
      "email": [
        "auth@dentalrisk.com"
      ],
      "fax": [],
      "phone": [
        "087 943 9612"
      ]
    },
    "networked": "Yes",
    "nonNetworkedPayment": "No",
    "balancedBilling": "Network No, Non-Network Yes",
    "basicTreatment": "Yes with limitations",
    "rct": "No",
    "dentures": "No",
    "crownsOrBridges": "No",
    "implants": "No",
    "surgicalExtractions": "No",
    "exclusions": "Pan Scan NO BENEFITS. Bite Plate NO BENEITS. Mouth Guard NO BENEFITS. Root Canal NO BENEFITS. Temporary Crown NO BENEFITS",
    "preAuth": "Maximum of 1 X 8201 per quadrant per visit. \u2022 More than 4 extractions per visit require pre-authorisation.",
    "crucialRules": "Posterior restorations are covered to the value of amalgam restorations. Pre-authorisation and X-rays required for: \u2022 More than 4 restorations per annum. \u2022 Any 3 or 4 surface restorations on wisdom teeth.",
    "notes": "Posterior restorations are covered to the value of amalgam restorations",
    "source": "https://dentalrisk.com/member-benefits/",
    "lastUpdated": "Jan-26"
  },
  {
    "scheme": "AGS HEALTH:",
    "plan": "PRIME OPTION,",
    "administrator": "DRC",
    "contactInfo": {
      "email": [
        "auth@dentalrisk.com"
      ],
      "fax": [],
      "phone": [
        "0879439611"
      ]
    },
    "networked": "Yes",
    "nonNetworkedPayment": "Yes",
    "balancedBilling": "No",
    "basicTreatment": "Yes with limitations",
    "rct": "No",
    "dentures": "No",
    "crownsOrBridges": "No",
    "implants": "No",
    "surgicalExtractions": "No",
    "exclusions": "Bite Plate NO BENEFITS Mouth Guard NO BENEFITS Root Canal NO BENEFITS Temporary Crown NO BENEFITS Specialised Dentistry Benefits NO BENEFITS",
    "preAuth": "Limited of 2 restorations per member per annum. \u2022 1 Restoration code per tooth number in a 9-month period. \u2022 Lower jaw posterior fillings involving anaesthetic cannot be performed across the midline.",
    "crucialRules": "3 Consultations per member per annum \u2022 One 8101 per 6 months per member from date of service. \u2022 8104 - Not within 4 weeks of code 8101. 2 x-rays per member per annum. Emergency Root Canal Maximum of 2 per annum. Limited to 2 extractions per member per annum. \u2022 Maximum of 1 X 8201 per quadrant per visit.",
    "notes": ". 1. Very basic option 2. Lower rate applies to non network provider 3. Patient written consent needed for procedures not covered.",
    "source": "https://dentalrisk.com/member-benefits/",
    "lastUpdated": "Jan-26"
  },
  {
    "scheme": "AGS HEALTH:",
    "plan": "GREEN",
    "administrator": "DRC",
    "contactInfo": {
      "email": [
        "auth@dentalrisk.com"
      ],
      "fax": [],
      "phone": [
        "0879439612"
      ]
    },
    "networked": "Yes",
    "nonNetworkedPayment": "Yes",
    "balancedBilling": "No",
    "basicTreatment": "Yes with limitations",
    "rct": "No",
    "dentures": "No",
    "crownsOrBridges": "No",
    "implants": "No",
    "surgicalExtractions": "No",
    "exclusions": "Bite Plate NO BENEFITS Mouth Guard NO BENEFITS Root Canal NO BENEFITS Temporary Crown NO BENEFITS Specialised Dentistry Benefits NO BENEFITS",
    "preAuth": "Limited of 2 restorations per member per annum. \u2022 1 Restoration code per tooth number in a 9-month period. \u2022 Lower jaw posterior fillings involving anaesthetic cannot be performed across the midline.",
    "crucialRules": "4 Consultations per member per annum \u2022 One 8101 per 6 months per member from date of service. \u2022 8104 - Not within 4 weeks of code 8101. 2 x-rays per member per annum. Emergency Root Canal Maximum of 2 per annum. Limited to 2 extractions per member per annum. \u2022 Maximum of 1 X 8201 per quadrant per visit.",
    "notes": ". 1. Very basic option 2. Lower rate applies to non network provider 3. Patient written consent needed for procedures not covered.",
    "source": "https://dentalrisk.com/member-benefits/",
    "lastUpdated": "Jan-26"
  },
  {
    "scheme": "AGS HEALTH:",
    "plan": "GREEN COMBO",
    "administrator": "DRC",
    "contactInfo": {
      "email": [
        "auth@dentalrisk.com or fax 086 687 1286"
      ],
      "fax": [
        " 086 687 1286"
      ],
      "phone": [
        "087 111 0033 / 087 943 9611"
      ]
    },
    "networked": "Yes",
    "nonNetworkedPayment": "Yes",
    "balancedBilling": "Network No, Non-Network Yes",
    "basicTreatment": "Yes with limitations",
    "rct": "No",
    "dentures": "No",
    "crownsOrBridges": "No",
    "implants": "No",
    "surgicalExtractions": "No",
    "exclusions": "Scale and Polish NO BENEFITS, Pan Scan NO BENEFITS. Bite Plate NO BENEITS\nMouth Guard NO BENEFITS\nRoot Canal NO BENEFITS\nTemporary Crown NO BENEFITS\nSpecialised Dentistry Benefits NO BENEFITS",
    "preAuth": "",
    "crucialRules": "Limited of 2 restorations per member per annum. Posterior restorations are covered to the value of amalgam restorations). 3 Consultations per member per annum.",
    "notes": "",
    "source": "https://dentalrisk.com/member-benefits/",
    "lastUpdated": "Jan-26"
  },
  {
    "scheme": "AGS HEALTH:",
    "plan": "GREEN COMBO OPTIONS",
    "administrator": "DRC",
    "contactInfo": {
      "email": [
        "auth@dentalrisk.com"
      ],
      "fax": [],
      "phone": [
        "0879439613"
      ]
    },
    "networked": "Yes",
    "nonNetworkedPayment": "Yes",
    "balancedBilling": "No",
    "basicTreatment": "Yes with limitations",
    "rct": "No",
    "dentures": "No",
    "crownsOrBridges": "No",
    "implants": "No",
    "surgicalExtractions": "No",
    "exclusions": "Bite Plate NO BENEFITS Mouth Guard NO BENEFITS Root Canal NO BENEFITS Temporary Crown NO BENEFITS Specialised Dentistry Benefits NO BENEFITS",
    "preAuth": "Limited of 2 restorations per member per annum. \u2022 1 Restoration code per tooth number in a 9-month period. \u2022 Lower jaw posterior fillings involving anaesthetic cannot be performed across the midline.",
    "crucialRules": "5 Consultations per member per annum \u2022 One 8101 per 6 months per member from date of service. \u2022 8104 - Not within 4 weeks of code 8101. 2 x-rays per member per annum. Emergency Root Canal Maximum of 2 per annum. Limited to 2 extractions per member per annum. \u2022 Maximum of 1 X 8201 per quadrant per visit.",
    "notes": ". 1. Very basic option 2. Lower rate applies to non network provider 3. Patient written consent needed for procedures not covered.",
    "source": "https://dentalrisk.com/member-benefits/",
    "lastUpdated": "Jan-26"
  },
  {
    "scheme": "AGS HEALTH:",
    "plan": "Bronze",
    "administrator": "DRC",
    "contactInfo": {
      "email": [
        "auth@dentalrisk.com"
      ],
      "fax": [],
      "phone": [
        "0879439611"
      ]
    },
    "networked": "Yes",
    "nonNetworkedPayment": "Yes",
    "balancedBilling": "No",
    "basicTreatment": "Yes with limitations",
    "rct": "No",
    "dentures": "Yes",
    "crownsOrBridges": "No",
    "implants": "No",
    "surgicalExtractions": "No",
    "exclusions": "Impaction in the Chair NO BENEFITS, Impaction in Hospital NO BENEFITS, Crown NO BENEFITS, Root Canal NO BENEFITS),Implants NO BENEFITS",
    "preAuth": "8410 Provisional crown Pre-authorisation and x rays required. 1 per member per annum. Dentures One full set of plastic dentures per member every 5 years.",
    "crucialRules": "3 Consultations per annum. 8101 - Once per 6 months per member . 8104 - Not within 4 weeks of code 8101. Emergency Root Canal. Maximum of 2 per year. . 8159 & 8151 per member per annum. 3 x-rays per member per annum. 8115 Panoramic x-ray Once per lifetime. Emergency root canal treatment Maximum of 2 per annum. Limited to 3 restorations per member per annum. \u2022 1 Restoration code per tooth number in a 9month period. \u2022 Lower jaw posterior fillings involving anaesthetic cannot be performed across the midline. 8169 Occlusal guard 1 Bite plate per member per annum. 8171 Mouth guard (members younger than 23) 1 Mouth guard per member per annum.",
    "notes": "Patient written consent needed for procedures not covered. Trauma (1 Month) Stated Benefit All relevant trauma codes are covered to the maximum of the stated benefits (a policy\nreport/emergency room report is required) Once per year @ R30 212",
    "source": "https://dentalrisk.com/member-benefits/",
    "lastUpdated": "Jan-26"
  },
  {
    "scheme": "AGS HEALTH:",
    "plan": "SILVER OPTION,",
    "administrator": "DRC",
    "contactInfo": {
      "email": [
        "auth@dentalrisk.com"
      ],
      "fax": [],
      "phone": [
        "0879439611"
      ]
    },
    "networked": "Yes",
    "nonNetworkedPayment": "Yes",
    "balancedBilling": "No",
    "basicTreatment": "Yes with limitations",
    "rct": "Yes",
    "dentures": "Yes",
    "crownsOrBridges": "Yes",
    "implants": "Yes",
    "surgicalExtractions": "Yes",
    "exclusions": "Scale and Polish NO BENEFITS. Pan Scan NO BENEFITS. Bite Plate NO BENEITS. Mouth Guard NO BENEFITS. Root Canal NO BENEFITS. Temporary Crown NO BENEFITS",
    "preAuth": "Limited to 2 root canals per member per annum. \u2022 Pre-authorisation and x-rays required. Temporary Crown (Including Lab Costs) Provisional crown Pre-authorisation and x-rays required. Maximum of 2 temporary crowns per annum. Surgical removal of impacted tooth Limited to 4 extractions per member per annum. Impaction in Hospital Limited to 2 extractions per member per annum. 1 Crown per member per annum up to R4 446 per crown. One full set of plastic dentures per member every 5 years. 1 Implant per member per annum up to R6 349 per implant.",
    "crucialRules": "4 Consultations per member per annum. \u2022 One 8101 per 6 months per member from date of service. \u2022 8104 - Not within 4 weeks of code 8101. Scale and Polish 1 per member per annum. 5 x-rays per member per annum. 8115 Panoramic x-ray Once per lifetime. Limited to 3 extractions per member per annum. \u2022 Maximum of 1 X 8201 per quadrant per visit. Limited to 4 restorations per member per annum. \u2022 1 Restoration code per tooth number in a 9 month period. Occlusal guard 761.50 N/A 1 Bite plate per member per annum. 1 Mouth guard per member per annum.",
    "notes": "Patient written consent needed for procedures not covered. (1 Month waiting period) Stated Benefit All relevant trauma codes are covered to the\nmaximum of the stated benefits (a policy report/emergency room report is required) Once per year @ R30 212",
    "source": "https://dentalrisk.com/member-benefits/",
    "lastUpdated": "Jan-26"
  },
  {
    "scheme": "AGS HEALTH:",
    "plan": "BLUE COMBO",
    "administrator": "DRC",
    "contactInfo": {
      "email": [
        "auth@dentalrisk.com"
      ],
      "fax": [],
      "phone": [
        "0879439612"
      ]
    },
    "networked": "Yes",
    "nonNetworkedPayment": "Yes",
    "balancedBilling": "No",
    "basicTreatment": "Yes with limitations",
    "rct": "Yes",
    "dentures": "Yes",
    "crownsOrBridges": "Yes",
    "implants": "Yes",
    "surgicalExtractions": "Yes",
    "exclusions": "Scale and Polish NO BENEFITS. Pan Scan NO BENEFITS. Bite Plate NO BENEITS. Mouth Guard NO BENEFITS. Root Canal NO BENEFITS. Temporary Crown NO BENEFITS",
    "preAuth": "Limited to 2 root canals per member per annum. \u2022 Pre-authorisation and x-rays required. Temporary Crown (Including Lab Costs) Provisional crown Pre-authorisation and x-rays required. Maximum of 2 temporary crowns per annum. Surgical removal of impacted tooth Limited to 4 extractions per member per annum. Impaction in Hospital Limited to 2 extractions per member per annum. 1 Crown per member per annum up to R4 446 per crown. One full set of plastic dentures per member every 5 years. 1 Implant per member per annum up to R6 349 per implant.",
    "crucialRules": "5 Consultations per member per annum. \u2022 One 8101 per 6 months per member from date of service. \u2022 8104 - Not within 4 weeks of code 8101. Scale and Polish 1 per member per annum. 5 x-rays per member per annum. 8115 Panoramic x-ray Once per lifetime. Limited to 3 extractions per member per annum. \u2022 Maximum of 1 X 8201 per quadrant per visit. Limited to 4 restorations per member per annum. \u2022 1 Restoration code per tooth number in a 9 month period. Occlusal guard 761.50 N/A 1 Bite plate per member per annum. 1 Mouth guard per member per annum.",
    "notes": "Patient written consent needed for procedures not covered. (1 Month waiting period) Stated Benefit All relevant trauma codes are covered to the\nmaximum of the stated benefits (a policy report/emergency room report is required) Once per year @ R30 212",
    "source": "https://dentalrisk.com/member-benefits/",
    "lastUpdated": "Jan-26"
  },
  {
    "scheme": "AGS HEALTH:",
    "plan": "RED",
    "administrator": "DRC",
    "contactInfo": {
      "email": [
        "auth@dentalrisk.com"
      ],
      "fax": [],
      "phone": [
        "0879439612"
      ]
    },
    "networked": "Yes",
    "nonNetworkedPayment": "Yes",
    "balancedBilling": "No",
    "basicTreatment": "Yes with limitations",
    "rct": "Yes",
    "dentures": "Yes",
    "crownsOrBridges": "Yes",
    "implants": "Yes",
    "surgicalExtractions": "Yes",
    "exclusions": "Scale and Polish NO BENEFITS. Pan Scan NO BENEFITS. Bite Plate NO BENEITS. Mouth Guard NO BENEFITS. Root Canal NO BENEFITS. Temporary Crown NO BENEFITS",
    "preAuth": "Limited to 2 root canals per member per annum. \u2022 Pre-authorisation and x-rays required. Temporary Crown (Including Lab Costs) Provisional crown Pre-authorisation and x-rays required. Maximum of 2 temporary crowns per annum. Surgical removal of impacted tooth Limited to 4 extractions per member per annum. Impaction in Hospital Limited to 2 extractions per member per annum. 1 Crown per member per annum up to R4 446 per crown. One full set of plastic dentures per member every 5 years. 1 Implant per member per annum up to R6 349 per implant.",
    "crucialRules": "5 Consultations per member per annum. \u2022 One 8101 per 6 months per member from date of service. \u2022 8104 - Not within 4 weeks of code 8101. Scale and Polish 1 per member per annum. 5 x-rays per member per annum. 8115 Panoramic x-ray Once per lifetime. Limited to 3 extractions per member per annum. \u2022 Maximum of 1 X 8201 per quadrant per visit. Limited to 4 restorations per member per annum. \u2022 1 Restoration code per tooth number in a 9 month period. Occlusal guard 761.50 N/A 1 Bite plate per member per annum. 1 Mouth guard per member per annum.",
    "notes": "Patient written consent needed for procedures not covered. (1 Month waiting period) Stated Benefit All relevant trauma codes are covered to the\nmaximum of the stated benefits (a policy report/emergency room report is required) Once per year @ R30 212",
    "source": "https://dentalrisk.com/member-benefits/",
    "lastUpdated": "Jan-26"
  },
  {
    "scheme": "AGS HEALTH:",
    "plan": "RED COMBO OPTION",
    "administrator": "DRC",
    "contactInfo": {
      "email": [
        "auth@dentalrisk.com"
      ],
      "fax": [],
      "phone": [
        "0879439612"
      ]
    },
    "networked": "Yes",
    "nonNetworkedPayment": "Yes",
    "balancedBilling": "No",
    "basicTreatment": "Yes with limitations",
    "rct": "Yes",
    "dentures": "Yes",
    "crownsOrBridges": "Yes",
    "implants": "Yes",
    "surgicalExtractions": "Yes",
    "exclusions": "Scale and Polish NO BENEFITS. Pan Scan NO BENEFITS. Bite Plate NO BENEITS. Mouth Guard NO BENEFITS. Root Canal NO BENEFITS. Temporary Crown NO BENEFITS",
    "preAuth": "Limited to 2 root canals per member per annum. \u2022 Pre-authorisation and x-rays required. Temporary Crown (Including Lab Costs) Provisional crown Pre-authorisation and x-rays required. Maximum of 2 temporary crowns per annum. Surgical removal of impacted tooth Limited to 4 extractions per member per annum. Impaction in Hospital Limited to 2 extractions per member per annum. 1 Crown per member per annum up to R4 446 per crown. One full set of plastic dentures per member every 5 years. 1 Implant per member per annum up to R6 349 per implant.",
    "crucialRules": "5 Consultations per member per annum. \u2022 One 8101 per 6 months per member from date of service. \u2022 8104 - Not within 4 weeks of code 8101. Scale and Polish 1 per member per annum. 5 x-rays per member per annum. 8115 Panoramic x-ray Once per lifetime. Limited to 3 extractions per member per annum. \u2022 Maximum of 1 X 8201 per quadrant per visit. Limited to 4 restorations per member per annum. \u2022 1 Restoration code per tooth number in a 9 month period. Occlusal guard 761.50 N/A 1 Bite plate per member per annum. 1 Mouth guard per member per annum.",
    "notes": "Patient written consent needed for procedures not covered. (1 Month waiting period) Stated Benefit All relevant trauma codes are covered to the maximum of the stated benefits (a policy report/emergency room report is required) Once per year @ R30 212",
    "source": "https://dentalrisk.com/member-benefits/",
    "lastUpdated": "Jan-26"
  },
  {
    "scheme": "AGS HEALTH:",
    "plan": "GOLD",
    "administrator": "DRC",
    "contactInfo": {
      "email": [
        "auth@dentalrisk.com"
      ],
      "fax": [],
      "phone": [
        "0879439612"
      ]
    },
    "networked": "Yes",
    "nonNetworkedPayment": "Yes",
    "balancedBilling": "No",
    "basicTreatment": "Yes with limitations",
    "rct": "Yes",
    "dentures": "Yes",
    "crownsOrBridges": "Yes",
    "implants": "Yes",
    "surgicalExtractions": "Yes",
    "exclusions": "Benefits for amalgam restorations to be replaced with composite are only available where such treatment is necessary to restore secondary caries. Resin restorations are not covered on non carious teeth restored with amalgams",
    "preAuth": "Limited to 3 root canals per member per annum. \u2022 Pre-authorisation and x-rays required. Provisional crown Pre-authorisation and x-rays required. Maximum of 3 teeth per annum. All specialised dentistry must be pre-authorised. 2 Crowns per member per annum up to R5 080 per crown.",
    "crucialRules": "5 Consultations per member per annum. One 8101 per 6 months per member from date of service. 8104 - Not within 4 weeks of code 8101. Intra Oral Radiographs 6 x-rays per member per annum. 8115 Panoramic x-ray Once per lifetime. Emergency Root Canal Maximum of 3 per annum. Extraction Limited to 4 extractions per member per annum. Limited to 4 restorations per member per annum. 1 Restoration code per tooth number in a 9 month period. Occlusal guard 1 per member per annum. Mouth guard (members younger than 23) 1 per member per annum",
    "notes": ". 1. Very basic option 2. Lower rate applies to non network provider 3. Patient written consent needed for procedures not covered. VTrauma (1 Month) Stated Benefit\nAll relevant trauma codes are covered to the maximum of the stated benefits (a policy report/emergency room report is required) Once per year R30 212",
    "source": "https://dentalrisk.com/member-benefits/",
    "lastUpdated": "Jan-26"
  },
  {
    "scheme": "ANGLO MED:",
    "plan": "Standard Care Option",
    "administrator": "Discovery / DRC",
    "contactInfo": {
      "email": [
        "auth@dentalrisk.com or fax 086 687 1286"
      ],
      "fax": [
        " 086 687 1286"
      ],
      "phone": [
        "0860 445 566"
      ]
    },
    "networked": "Yes",
    "nonNetworkedPayment": "Yes",
    "balancedBilling": "No",
    "basicTreatment": "Yes with limitations",
    "rct": "Yes",
    "dentures": "Yes",
    "crownsOrBridges": "No",
    "implants": "No",
    "surgicalExtractions": "No",
    "exclusions": "No Panorex. No Crown &, Bridges, Ortho, Implants or Roor canal Fillings. No Specialized Dentistry. No Crowns & bridges, Implants,Ortho, Dentures or Root canal fillings. No Dental in Theatre .",
    "preAuth": "Pre-auth \u2022 More than 5 restorations per year. \u2022 Two or more: 3 or 4 surface restorations per visit. \u2022 More than 2 anterior restorations per visit. Pre-authorisation required for: \u2022 RCT on posterior teeth limited to members 12 years and older. \u2022 Retreatment subject to preauthorisation and managed care protocols.",
    "crucialRules": "Maximum of 4 x-rays per visit per member. (Overall max of 7 per annum).",
    "notes": "R1 970 per adult and R495 per child per year. This limit applies to both network and non-network providers. Additional dentistry codes not stated above are covered by the stated benefit calculated per dependant. Anybody in the family can use the Family limit: Adult \u2013 R1 970 per dependant Child \u2013 R495 per child",
    "source": "https://dentalrisk.com/member-benefits/",
    "lastUpdated": "Jan-26"
  },
  {
    "scheme": "Anglo Medical aid",
    "plan": "Managed Care",
    "administrator": "Discovery",
    "contactInfo": {
      "email": [
        "member@angloms.co.za"
      ],
      "fax": [],
      "phone": [
        "0860 222 633"
      ]
    },
    "networked": "Yes",
    "nonNetworkedPayment": "Yes",
    "balancedBilling": "No",
    "basicTreatment": "Yes with limitations",
    "rct": "Yes",
    "dentures": "Yes",
    "crownsOrBridges": "Yes",
    "implants": "Yes",
    "surgicalExtractions": "Yes",
    "exclusions": "Root Canal Not covered for non-functional wisdom teeth.",
    "preAuth": "Specialised treatments including crowns, bridges, inlays, study models, dentures, orthodontics, osseo-integrated implants or similar tooth implants and periodontics.",
    "crucialRules": "Conservative treatments including fillings, x-rays, extractions and oral hygiene. Specialised treatments including crowns, bridges, inlays, study models, dentures, orthodontics, osseo-integrated implants or similar tooth implants and periodontics.",
    "notes": "Dental hospitalisation : authorisation before undergoing dental treatments in hospital: in the case of trauma if patients are under the age of 7 years requiring anaesthetic,for the removal of impacted molars or maxillo-facial and oral surgery (PMB conditions). Authorised specialist services in hospital are paid at the Top-Up rate of 230% of SRR, or in full if PMB.",
    "source": "https://www.angloms.co.za/portal/",
    "lastUpdated": "Jan-26"
  },
  {
    "scheme": "Anglo Medical aid",
    "plan": "Value",
    "administrator": "Primecure",
    "contactInfo": {
      "email": [
        "support@primecure.co.za"
      ],
      "fax": [],
      "phone": [
        "0861 665 665"
      ]
    },
    "networked": "Yes",
    "nonNetworkedPayment": "Yes",
    "balancedBilling": "No",
    "basicTreatment": "Yes with limitations",
    "rct": "No",
    "dentures": "No",
    "crownsOrBridges": "No",
    "implants": "No",
    "surgicalExtractions": "No",
    "exclusions": "Panoramic and other extra oral x-rays (e.g., 8115) does not form part of the benefit schedule.",
    "preAuth": "Restorations: Cover for composite (white) fillings is limited to anterior (front) teeth only, with a maximum of four fillings before pre-authorisation is required. X-rays: Two sets of x-rays (inclusive of one intra-oral radiograph) are covered; any additional x-rays up to a maximum of four require pre-authorisation. A family is entitled to 80% of the Prime Cure agreed tariff of two sets of acrylic dentures every 36 months . Dental hospital admission For children under the age of 7, for the removal of impacted third molars and trauma (PMB), subject to authorisation and the Family Hospital Limit of R208 000 per year.",
    "crucialRules": "8101 Consultation oral examination Once per year, 8104 Examination for a specific problem not requiring full mouth examination. 8107, 8112 Intra oral radiographs/Bite Wing X-rays, per film (maximum of four X-rays per family per year). 8155 Polishing only Once a year for ages 3-12yrs.8159 Scaling and polishing Once a year over the age 12 yrs 8161 Topical application of fluoride Once a year for ages 3 to 12 yrs. 8132 Gross pulpal debridement, primary & permanent teeth (emergency root canal). Pre-authorisation if a patient neesd repairs to four or more teeth (including fillings) per person per year. One (1) consultations/ examinations code 8101 per beneficiary per year.",
    "notes": "8201, 8202 Extraction, single tooth. Code 8201 is charged for the first extraction in a quadrant. Maximum for 8201 & 8202 is three (3), thereafter pre-authorisation required for the first extraction in a quad-rant.",
    "source": "https://www.primecure.co.za/wp-content/uploads/2025/12/PC-2026-Dental-Manual.pdf",
    "lastUpdated": "Jan-26"
  },
  {
    "scheme": "Bankmed",
    "plan": "Basic",
    "administrator": "Discovery / DRC",
    "contactInfo": {
      "email": [
        "auth@dentalrisk.com or fax 086 687 1285"
      ],
      "fax": [
        " 086 687 1285"
      ],
      "phone": [
        "087 943 9611"
      ]
    },
    "networked": "Yes",
    "nonNetworkedPayment": "Yes",
    "balancedBilling": "Yes",
    "basicTreatment": "Yes with limitations",
    "rct": "No",
    "dentures": "Yes",
    "crownsOrBridges": "No",
    "implants": "No",
    "surgicalExtractions": "No",
    "exclusions": "No Panorex or specialised dentistry. No Specialised dentistry applies No Benefit for root canal treatment . No Benefit for Crowns",
    "preAuth": "8132 cannot be claimed with 8131 or any restoration, root canal and extraction codes. Maximum of 1 per treatment date. The subsequent restoration will need to be pre-authorised with an emailed or scanned x-ray to show the complete root canal. Pre-auth More than 4 restorations per year. Two or more 3 or 4 surface restorations per visit. More than 2 anterior restorations per visit. Multiple restorations on an anterior tooth on the same service date. Any 3 or 4 surface restorations on wisdom teeth. Denture Codes Once every 24 months per dependant One per jaw (set of dentures) every 2 years for patients older than 18 years. Extraction Codes: Maximum 1 x 8201 per quadrant per visit. More than 4 extractions per visit require pre-authorisation.",
    "crucialRules": "8104 Not within 4 weeks of 8101, 8102, 8104. x-ray Maximum of 2 x-rays per visit per member. Maximum quantity of 7 per year. 8110 Will only be paid if code 8201 or 8202 is claimed. Rebase, remodel, reline, repair,adjustment of denture Benefit covered if denture is in patient history, or suitable motivation/evidence of existing denture is supplied. More than one per 365 days require motivation/pre authorisation.",
    "notes": "No Panorex. 1. Very basic option 2. Lower rate applies to non network provider 3. Patient written consent needed for procedures not covered. Should there be no authorisation obtained where indicated in limitations \u2013 no benefit. Provider to write off account. Only codes stated below with limitations are covered should a code not be in the manual then it is not covered. Posterior Amalgam and Resin restorations remunerated at the same tariff below",
    "source": "https://www.dentalrisk.com/medical_aid_network/list_of_benefits.html",
    "lastUpdated": "Jan-26"
  },
  {
    "scheme": "Bankmed",
    "plan": "ESSENTIAL OPTION",
    "administrator": "Discovery / DRC",
    "contactInfo": {
      "email": [
        "auth@dentalrisk.com or fax 086 687 1285"
      ],
      "fax": [
        " 086 687 1285"
      ],
      "phone": [
        "087 943 9611"
      ]
    },
    "networked": "Yes",
    "nonNetworkedPayment": "Yes",
    "balancedBilling": "Yes",
    "basicTreatment": "Yes with limitations",
    "rct": "No",
    "dentures": "No",
    "crownsOrBridges": "No",
    "implants": "No",
    "surgicalExtractions": "No",
    "exclusions": "There is no benefit for dental surgery on the Essential Plan unless the procedure qualifies as a PMB.",
    "preAuth": "Only applicable for children between 3 and 17 years.",
    "crucialRules": "8110 Maximum 1 per visit. Will only be paid if code 8201 or 8202 is claimed. Periapical x-ray \u2022 Maximum of 2 x-rays per visit per member. \u2022 Maximum quantity of 7 per year.",
    "notes": "Only applicable for children between 3 and 17 years.",
    "source": "https://www.bankmed.co.za/portal/",
    "lastUpdated": "Jan-26"
  },
  {
    "scheme": "Bankmed",
    "plan": "Traditional",
    "administrator": "Discovery",
    "contactInfo": {
      "email": [
        "treatment@bankmed.co.za"
      ],
      "fax": [],
      "phone": [
        "0800 226 5633"
      ]
    },
    "networked": "\u00ddes",
    "nonNetworkedPayment": "\u00ddes",
    "balancedBilling": "Yes",
    "basicTreatment": "Yes with limitations",
    "rct": "Yes",
    "dentures": "Yes",
    "crownsOrBridges": "Yes",
    "implants": "Yes",
    "surgicalExtractions": "Yes",
    "exclusions": "No metal base partial dentures. Bleaching of teeth that have not been root canal treated and metal inlays in dentures and front teeth;",
    "preAuth": "Authorisation all Advanced Dentistry. In-Hospital Dental Procedures: Any dental surgery or procedure requiring admission to a hospital or day clinic requires pre-authorisation. Advanced Dentistry: Procedures such as orthodontics or advanced dentistry require pre-authorisation and are subject to specific insured limits. Wisdom Teeth Removal: Covered in a dentist\u2019s office, but requires pre-authorisation and a co-payment applies.",
    "crucialRules": "Combined limit for advanced dentistry, orthodontics and all other dental services. Limited to eight molar teeth pb per lifetime.",
    "notes": "Plastic dentures pays from basic dentistry.",
    "source": "https://www.bankmed.co.za/portal/",
    "lastUpdated": "Jan-26"
  },
  {
    "scheme": "Bankmed",
    "plan": "Core saver",
    "administrator": "Discovery",
    "contactInfo": {
      "email": [
        "treatment@bankmed.co.za"
      ],
      "fax": [],
      "phone": [
        "0800 226 5633"
      ]
    },
    "networked": "\u00ddes",
    "nonNetworkedPayment": "\u00ddes",
    "balancedBilling": "Yes",
    "basicTreatment": "Yes with limitations",
    "rct": "Yes",
    "dentures": "Yes",
    "crownsOrBridges": "Yes",
    "implants": "Yes",
    "surgicalExtractions": "Yes",
    "exclusions": "Cosmetic Dentistry: Bleaching of teeth that have not been root canal treated and the use of metal inlays in front teeth are excluded. Gold and Precious Metals: Gold used in dentures, devices, or materials is not covered. Oral Hygiene Products: Toothbrushes, toothpaste, and dental floss are excluded.",
    "preAuth": "Authorisation all Advanced Dentistry",
    "crucialRules": "Combined limit for advanced dentistry, orthodontics and all other dental services. Limited to eight molar teeth pb per lifetime.",
    "notes": "Subject to available Medical Savings Account. There is no benefit for dental surgery unless it is for a Prescribed Minimum Benefit (PMB)",
    "source": "https://www.bankmed.co.za/portal/",
    "lastUpdated": "Jan-26"
  },
  {
    "scheme": "Bankmed",
    "plan": "Comprehensive",
    "administrator": "Discovery",
    "contactInfo": {
      "email": [
        "treatment@bankmed.co.za"
      ],
      "fax": [],
      "phone": [
        "0800 226 5633"
      ]
    },
    "networked": "\u00ddes",
    "nonNetworkedPayment": "\u00ddes",
    "balancedBilling": "Yes",
    "basicTreatment": "Yes with limitations",
    "rct": "Yes",
    "dentures": "Yes",
    "crownsOrBridges": "Yes",
    "implants": "Yes",
    "surgicalExtractions": "Yes",
    "exclusions": "Cosmetic Dentistry: Bleaching of teeth that have not been root canal treated and the use of metal inlays in front teeth are excluded. Gold and Precious Metals: Gold used in dentures, devices, or materials is not covered. Oral Hygiene Products: Toothbrushes, toothpaste, and dental floss are excluded.",
    "preAuth": "Crowns & Bridgework: Pre-authorisation is generally required for crown procedures. Clinical motivation, including X-rays and a treatment plan, may be requested by the Scheme or its dental administrator to confirm necessity. Dentures (including Metal Base): While plastic dentures are part of basic dentistry, metal-framed dentures (metal base partials) are classified as specialized dentistry and require pre-authorisation prior to the commencement of treatment.",
    "crucialRules": "Combined limit for advanced dentistry, orthodontics and all other dental services. Limited to eight molar teeth pb per lifetime.",
    "notes": "Unlimited; paid from Insured Benefit",
    "source": "https://www.bankmed.co.za/portal/",
    "lastUpdated": "Jan-26"
  },
  {
    "scheme": "Bankmed",
    "plan": "Plus Plan",
    "administrator": "Discovery",
    "contactInfo": {
      "email": [
        "treatment@bankmed.co.za"
      ],
      "fax": [],
      "phone": [
        "0800 226 5633"
      ]
    },
    "networked": "\u00ddes",
    "nonNetworkedPayment": "\u00ddes",
    "balancedBilling": "Yes",
    "basicTreatment": "Yes with limitations",
    "rct": "Yes",
    "dentures": "Yes",
    "crownsOrBridges": "Yes",
    "implants": "Yes",
    "surgicalExtractions": "Yes",
    "exclusions": "Cosmetic Dentistry: Bleaching of teeth that have not been root canal treated and the use of metal inlays in front teeth are excluded. Gold and Precious Metals: Gold used in dentures, devices, or materials is not covered. Oral Hygiene Products: Toothbrushes, toothpaste, and dental floss are excluded.",
    "preAuth": "Pre-authorisation: Essential for crowns, bridgework, and metal-based dentures (specialised dentistry).",
    "crucialRules": "Combined limit for advanced dentistry, orthodontics and all other dental services. Limited to eight molar teeth pb per lifetime.",
    "notes": "subject to available Medical Savings Account",
    "source": "https://www.bankmed.co.za/portal/",
    "lastUpdated": "Jan-26"
  },
  {
    "scheme": "Barloworld",
    "plan": "Barloworld",
    "administrator": "Medscheme",
    "contactInfo": {
      "email": [
        "barloworld.authorisations@medscheme.co.za"
      ],
      "fax": [],
      "phone": [
        "0860 002 106"
      ]
    },
    "networked": "Yes",
    "nonNetworkedPayment": "Yes",
    "balancedBilling": "No",
    "basicTreatment": "Yes with limitations",
    "rct": "Yes",
    "dentures": "Yes",
    "crownsOrBridges": "Yes",
    "implants": "Yes",
    "surgicalExtractions": "Yes",
    "exclusions": "\u2022 Laboratory delivery fees \u2022 Othognatic surgery \u2022 Sinus lift \u2022 Gum guards or mouth protectors",
    "preAuth": "Authorisation all Advanced Dentistry. Orthodontic Treatment is included in the combined benefit. The combined benefit incorporates more advanced dental procedures, including treatment for inlays, crowns, root canal therapy, bridges, mounted study models, dentures,and the treatment by periodontists, prosthodontists and dental technician\u2019s fees for all such dentistry. pre-authorisation is required for any dental or special dental procedure where general anaesthetic or conscious sedation is performed.",
    "crucialRules": "Benefit for retreatment of a tooth is subject to clinical protocols.",
    "notes": "The combined benefit incorporates more advanced dental procedures, including treatment for inlays, crowns, root canal therapy, bridges, mounted study models, dentures and the treatment by periodontists, prosthodontists and dental technician's fees for all such dentistry. The benefit includes Oral medical procedures and metal base to complete denture code 8663.",
    "source": "",
    "lastUpdated": "Jan-26"
  },
  {
    "scheme": "BCIMAS",
    "plan": "Plus",
    "administrator": "Universal",
    "contactInfo": {
      "email": [
        "bcima@universal.co.za"
      ],
      "fax": [],
      "phone": [
        "011 208 1005"
      ]
    },
    "networked": "No",
    "nonNetworkedPayment": "No",
    "balancedBilling": "No",
    "basicTreatment": "Yes with limitations",
    "rct": "Yes",
    "dentures": "Yes",
    "crownsOrBridges": "Yes",
    "implants": "Yes",
    "surgicalExtractions": "Yes",
    "exclusions": "\u2022 Laboratory delivery fees \u2022 Othognatic surgery \u2022 Sinus lift \u2022 Gum guards or mouth protectors",
    "preAuth": "Authorisation all Advanced Dentistry. Orthodontic Treatment is included in the combined benefit.",
    "crucialRules": "Conservative: Subject and limited to available PMSA. Specialised Dentistry: Subject and limited to available PMSA. Orthodontic treatment: Subject and limited to available PMSA.",
    "notes": "Very basic option",
    "source": "https://bcima.co.za/benefits/",
    "lastUpdated": "Jan-26"
  },
  {
    "scheme": "BCIMAS",
    "plan": "Basic",
    "administrator": "Universal",
    "contactInfo": {
      "email": [
        "bcima@universal.co.za"
      ],
      "fax": [],
      "phone": [
        "011 208 1005"
      ]
    },
    "networked": "No",
    "nonNetworkedPayment": "No",
    "balancedBilling": "No",
    "basicTreatment": "Yes with limitations",
    "rct": "Yes",
    "dentures": "Yes",
    "crownsOrBridges": "Yes",
    "implants": "Yes",
    "surgicalExtractions": "Yes",
    "exclusions": "Bone Augmentations \u2022 Bone and tissue regeneration procedures \u2022 Crowns and bridges for cosmetic reasons and associated laboratory costs \u2022 Enamel micro abrasion \u2022 Fillings: the cost of gold, precious metal, semi-precious metal and platinum foil \u2022 Laboratory delivery fees \u2022 Othognatic surgery \u2022 Sinus lift \u2022 Gum guards or mouth protectors",
    "preAuth": "Authorisation all Advanced Dentistry Specialised: crowns, bridgework, orthodontics, periodontics, prosthodontics, plastic dentures, maxillo-facial, oral surgery, etc. . Orthodontic Treatment is included in the combined benefit. \u2022 Dentistry (in-hospital procedures, subject to pre-authorisation) In Hospital Dentistry, Subject to pre-authorisation. Specialised:Crowns, bridgework, orthodontics, periodontics, prosthodontics, plastic dentures, maxillo-facial, oral surgery, etc. Subject to Annual Limit R 7 110 per family, per year",
    "crucialRules": "Preventative Care Benefit - Unlimited and will not affect your Hospital and Day-to-Day Limits. \u2022 Conservative Dentistry \u2022 For beneficiaries under 6 years of age. Basic/Conservative: Fillings, scaling & polishing, extractions, etc.Subject to Annual Limit R 4 950 per family, per year.",
    "notes": "Basic dentistry consultations will be available twice per year per beneficiary.",
    "source": "https://bcima.co.za/benefits/",
    "lastUpdated": "Jan-26"
  },
  {
    "scheme": "Bestmed",
    "plan": "Beat 2 HOSPITAL PLAN (WITH SAVINGS)",
    "administrator": "Bestmed",
    "contactInfo": {
      "email": [
        "service@bestmed.co.za"
      ],
      "fax": [],
      "phone": [
        "0860 002 378"
      ]
    },
    "networked": "Yes",
    "nonNetworkedPayment": "Yes",
    "balancedBilling": "Yes",
    "basicTreatment": "Yes with limitations",
    "rct": "Yes",
    "dentures": "Yes",
    "crownsOrBridges": "Yes",
    "implants": "Yes",
    "surgicalExtractions": "Yes",
    "exclusions": "\u2022 Laboratory delivery fees \u2022 Othognatic surgery \u2022 Sinus lift \u2022 Gum guards or mouth protectors",
    "preAuth": "PMBs only at DSP day hospitals. Beneficiaries 7 years and younger Limited to R6 642 per family. Beneficiaries over 7 years Dental surgical procedures paid from savings for procedures performed in the doctor\u2019s rooms only. 100% Scheme tariff.",
    "crucialRules": "Basic: Preventative benefit or savings account. Specialised: Savings account. Orthodontic: Subject to pre-authorisation. Out-of-hospital dentistry (like routine RCT) is paid from the MSA. If savings are exhausted, these costs are for the member's account.",
    "notes": "Space maintainers During primary and mixed denture stage. Panorex Once every 36 months. Intra-oral radiograph 2 x photos per year. Scaling and/or polishing. Twice a year. t is crucial to obtain pre-authorisation for all planned dental procedures to ensure coverage. Benefits are subject to the available funds in your MSA and specific Scheme rules.",
    "source": "https://www.bestmed.co.za/plans-and-options/brochures-guides-and-forms",
    "lastUpdated": "Jan-26"
  },
  {
    "scheme": "Bestmed",
    "plan": "Beat 3 HOSPITAL PLAN (WITH SAVINGS AND \nSELECTED RISK BENEFITS)",
    "administrator": "Bestmed",
    "contactInfo": {
      "email": [
        "service@bestmed.co.za"
      ],
      "fax": [],
      "phone": [
        "0860 002 378"
      ]
    },
    "networked": "Yes",
    "nonNetworkedPayment": "Yes",
    "balancedBilling": "Yes",
    "basicTreatment": "Yes with limitations",
    "rct": "Yes",
    "dentures": "Yes",
    "crownsOrBridges": "Yes",
    "implants": "Yes",
    "surgicalExtractions": "Yes",
    "exclusions": "Surgical extractions of teeth / roots / impactions / failed implants; - Surgical drainage of dental abscess;",
    "preAuth": "provides cover for specialized dentistry primarily through the Medical Savings Account (MSA) for day-to-day needs, while in-hospital dental and oral surgery are covered at 100% of the Scheme tariff, subject to a limit of R7,690 per family.",
    "crucialRules": "Basic: Preventative benefit or savings account. Specialised: Savings account. Orthodontic: Subject to pre-authorisation.",
    "notes": "Space maintainers During primary and mixed denture stage. Panorex Once every 36 months. Intra-oral radiograph 2 x photos per year. Scaling and/or polishing. Twice a year.",
    "source": "https://www.bestmed.co.za/plans-and-options/brochures-guides-and-forms",
    "lastUpdated": "Jan-26"
  },
  {
    "scheme": "Bestmed",
    "plan": "Beat 3 PLUS HOSPITAL PLAN (WITH SAVINGS AND \nSELECTED RISK BENEFITS)",
    "administrator": "Bestmed",
    "contactInfo": {
      "email": [
        "service@bestmed.co.za"
      ],
      "fax": [],
      "phone": [
        "0860 002 378"
      ]
    },
    "networked": "Yes",
    "nonNetworkedPayment": "Yes",
    "balancedBilling": "Yes",
    "basicTreatment": "Yes with limitations",
    "rct": "Yes",
    "dentures": "Yes",
    "crownsOrBridges": "Yes",
    "implants": "Yes",
    "surgicalExtractions": "Yes",
    "exclusions": "Surgical extractions of teeth / roots / impactions / failed implants; - Surgical drainage of dental abscess;",
    "preAuth": "provides cover for specialized dentistry primarily through the Medical Savings Account (MSA) for day-to-day needs, while in-hospital dental and oral surgery are covered at 100% of the Scheme tariff, subject to a limit of R7,690 per family.",
    "crucialRules": "Basic: Preventative benefit or savings account. Specialised: Savings account. Orthodontic: Subject to pre-authorisation.",
    "notes": "Space maintainers During primary and mixed denture stage. Panorex Once every 36 months. Intra-oral radiograph 2 x photos per year. Scaling and/or polishing. Twice a year.",
    "source": "https://www.bestmed.co.za/plans-and-options/brochures-guides-and-forms",
    "lastUpdated": "Jan-26"
  },
  {
    "scheme": "Bestmed",
    "plan": "Beat 4 Savings account/\nDay-to-day benefits",
    "administrator": "Bestmed",
    "contactInfo": {
      "email": [
        "service@bestmed.co.za"
      ],
      "fax": [],
      "phone": [
        "0860 002 378"
      ]
    },
    "networked": "Yes",
    "nonNetworkedPayment": "Yes",
    "balancedBilling": "Yes",
    "basicTreatment": "Yes with limitations",
    "rct": "Yes",
    "dentures": "Yes",
    "crownsOrBridges": "Yes",
    "implants": "Yes",
    "surgicalExtractions": "Yes",
    "exclusions": "\u2022 Laboratory delivery fees \u2022 Othognatic surgery \u2022 Sinus lift \u2022 Gum guards or mouth protectors",
    "preAuth": "Specialised Dentistry: Covers crowns, bridges, and inlays, initially funded from available savings. In-Hospital Specialized Dentistry For dental procedures requiring hospitalisation, the following 2026 limits apply: Dental and Oral Surgery: Limited to R12,772 per family per annum (covers both in- and out-of-hospital surgical procedures). Major Maxillofacial Surgery: Limited to R16,678 per family per annum, strictly related to certain medical conditions.",
    "crucialRules": "Basic: Preventative benefit or savings account. Specialised: Savings account. Orthodontic: Subject to pre-authorisation. Basic and specialised dentistry Savings and then from day-to-day limit.Orthodontics are subject to pre\u0002authorisation.",
    "notes": "Space maintainers During primary and mixed denture stage. Panorex Once every 36 months. Intra-oral radiograph 2 x photos per year. Scaling and/or polishing. Twice a year. certain major maxillofacial procedures, such as total joint reconstruction, are no longer covered on the Beat4 plan.",
    "source": "https://www.bestmed.co.za/plans-and-options/brochures-guides-and-forms",
    "lastUpdated": "Jan-26"
  },
  {
    "scheme": "Bestmed",
    "plan": "Pace1 COMPREHENSIVE COVER\n(IN- AND OUT-OF-HOSPITAL)",
    "administrator": "Bestmed",
    "contactInfo": {
      "email": [
        "service@bestmed.co.za"
      ],
      "fax": [],
      "phone": [
        "0860 002 378"
      ]
    },
    "networked": "Yes",
    "nonNetworkedPayment": "Yes",
    "balancedBilling": "Yes",
    "basicTreatment": "Yes with limitations",
    "rct": "Yes",
    "dentures": "Yes",
    "crownsOrBridges": "Yes",
    "implants": "Yes",
    "surgicalExtractions": "Yes",
    "exclusions": "\u2022 Laboratory delivery fees \u2022 Othognatic surgery \u2022 Sinus lift \u2022 Gum guards or mouth protectors",
    "preAuth": "Specialised dentistry. Subject to pre-authorisation. Preventative dentistry may be subject to pre-authorisation,In-hospital procedures and certain specialised treatments may require pre-authorisation .",
    "crucialRules": "Standard and Specialised Dentistry (including RCT): This is funded from your available day-to-day benefits and savings account. Preventative Dentistry: Specific preventative services (like yearly exams, cleanings, and X-rays) are covered by the Scheme risk and do not affect your savings.",
    "notes": "Space maintainers During primary and mixed denture stage. Panorex Once every 36 months. Intra-oral radiograph 2 x photos per year. Scaling and/or polishing. Twice a year. Dental and oral surgery: R10,217 per family, in or out of hospital\nMajor maxillofacial surgery: R16,527 per family",
    "source": "https://www.bestmed.co.za/plans-and-options/brochures-guides-and-forms",
    "lastUpdated": "Jan-26"
  },
  {
    "scheme": "Bestmed",
    "plan": "Pace2 COMPREHENSIVE COVER",
    "administrator": "Bestmed",
    "contactInfo": {
      "email": [
        "service@bestmed.co.za"
      ],
      "fax": [],
      "phone": [
        "0860 002 378"
      ]
    },
    "networked": "Yes",
    "nonNetworkedPayment": "Yes",
    "balancedBilling": "Yes",
    "basicTreatment": "Yes with limitations",
    "rct": "Yes",
    "dentures": "Yes",
    "crownsOrBridges": "Yes",
    "implants": "Yes",
    "surgicalExtractions": "Yes",
    "exclusions": "\u2022 Laboratory delivery fees \u2022 Othognatic surgery \u2022 Sinus lift \u2022 Gum guards or mouth protectors",
    "preAuth": "RCT Specifics: Root canal treatments are considered specialized dentistry, which is funded from the day-to-day limit.",
    "crucialRules": "Implants & Crowns: Generally funded from the specialized dentistry benefit, which comes out of your daily limit/savings.",
    "notes": "Space maintainers During primary and mixed denture stage. Panorex Once every 36 months. Intra-oral radiograph 2 x photos per year. Scaling and/or polishing. Twice a year.",
    "source": "https://www.bestmed.co.za/plans-and-options/brochures-guides-and-forms",
    "lastUpdated": "Jan-26"
  },
  {
    "scheme": "Bestmed",
    "plan": "Pace3",
    "administrator": "Bestmed",
    "contactInfo": {
      "email": [
        "service@bestmed.co.za"
      ],
      "fax": [],
      "phone": [
        "0860 002 378"
      ]
    },
    "networked": "Yes",
    "nonNetworkedPayment": "Yes",
    "balancedBilling": "Yes",
    "basicTreatment": "Yes with limitations",
    "rct": "Yes",
    "dentures": "Yes",
    "crownsOrBridges": "Yes",
    "implants": "Yes",
    "surgicalExtractions": "Yes",
    "exclusions": "\u2022 Laboratory delivery fees \u2022 Othognatic surgery \u2022 Sinus lift \u2022 Gum guards or mouth protectors",
    "preAuth": "Basic and specialised dentistry Savings first. 100% Scheme tariff. Limited to M = R9 442, M1+ = R17 603. (Subject to overall day-to-day limit) Orthodontic services subject to pre-authorisation.",
    "crucialRules": "Standard dentistry: from day-to-day benefit. Specialised Dentistry: From day-to-day benefit. In-Hospital Dentistry: Dental and oral surgery: R21,335 per family, in or out of hospital Major maxillofacial surgery: Scheme rate. Intra-oral radiograph All ages. 2 photos per year. Full-mouth intra-oral radiographs All ages. Once every 36 months.",
    "notes": "Space maintainers During primary and mixed denture stage. Panorex Once every 36 months. Intra-oral radiograph 2 x photos per year. Scaling and/or polishing. Twice a year.",
    "source": "https://www.bestmed.co.za/plans-and-options/brochures-guides-and-forms",
    "lastUpdated": "Jan-26"
  },
  {
    "scheme": "Bestmed",
    "plan": "Pace4",
    "administrator": "Bestmed",
    "contactInfo": {
      "email": [
        "service@bestmed.co.za"
      ],
      "fax": [],
      "phone": [
        "0860 002 378"
      ]
    },
    "networked": "Yes",
    "nonNetworkedPayment": "Yes",
    "balancedBilling": "Yes",
    "basicTreatment": "Yes with limitations",
    "rct": "Yes",
    "dentures": "Yes",
    "crownsOrBridges": "Yes",
    "implants": "Yes",
    "surgicalExtractions": "Yes",
    "exclusions": "\u2022 Laboratory delivery fees \u2022 Othognatic surgery \u2022 Sinus lift \u2022 Gum guards or mouth protectors",
    "preAuth": "Specialised dentistry Subject to pre-authorisation. Preventative dentistry may be subject to pre-authorisation. Major medical maxillo-facial surgery strictly related to certain conditions\n100% Scheme tariff.",
    "crucialRules": "Basic and specialised dentistry 100% Scheme tariff. Limited to M = R15 759, M1+ = R26 598. (Subject to overall day-to-day limit) Orthodontic services subject to pre-authorisation.",
    "notes": "Space maintainers During primary and mixed denture stage. Panorex Once every 36 months. Intra-oral radiograph 2 x photos per year. Scaling and/or polishing. Twice a year.",
    "source": "https://www.bestmed.co.za/plans-and-options/brochures-guides-and-forms",
    "lastUpdated": "Jan-26"
  },
  {
    "scheme": "Bestmed",
    "plan": "Rhythm 2 (Pulse)",
    "administrator": "Bestmed",
    "contactInfo": {
      "email": [
        "service@bestmed.co.za"
      ],
      "fax": [],
      "phone": [
        "0860 002 378"
      ]
    },
    "networked": "Yes",
    "nonNetworkedPayment": "Yes",
    "balancedBilling": "Yes",
    "basicTreatment": "Yes with limitations",
    "rct": "No",
    "dentures": "Yes",
    "crownsOrBridges": "No",
    "implants": "No",
    "surgicalExtractions": "No",
    "exclusions": "Specialized Dentistry: Generally, crowns and complex, specialized dental procedures are excluded from this option.",
    "preAuth": "Denture Coverage: Limited to a maximum of 2 removable acrylic dentures (i.e., 2 single denture plates) per family every 24 months.",
    "crucialRules": "81 two 2 consultation for full mouth examination per beneficiary per year. 8104  Maximum of 3 per year, not within 4 weeks after 8101. Maximum of two films (8107 x2 or 8112 x2 or combination of 8107 & 8112) every 6 months. 8159 : Two (2) per beneficiary of 12 years and older. Once every 6 months. 8155 : Two (2) per beneficiary younger than 12 years. Once every 6 months. 8161 Two (2) per beneficiary younger than 12 years. Once every 6 months. 8162 : Two (2) per beneficiary of 12 years and older. Once every 6 months. 8201 Basic extractions if clinically necessary (1 per quadrant per beneficiary per year). Restorations are limited to 6 restoration codes per beneficiary.",
    "notes": "Space maintainers During primary and mixed denture stage. Panorex Once every 36 months. Intra-oral radiograph 2 x photos per year. Scaling and/or polishing. Twice a year.",
    "source": "https://www.bestmed.co.za/plans-and-options/brochures-guides-and-forms",
    "lastUpdated": "Jan-26"
  },
  {
    "scheme": "Bestmed",
    "plan": "Rhythm 1 (Pulse)",
    "administrator": "Bestmed",
    "contactInfo": {
      "email": [
        "service@bestmed.co.za"
      ],
      "fax": [],
      "phone": [
        "0860 002 379"
      ]
    },
    "networked": "Yes",
    "nonNetworkedPayment": "Yes",
    "balancedBilling": "Yes",
    "basicTreatment": "Yes with limitations",
    "rct": "No",
    "dentures": "No",
    "crownsOrBridges": "No",
    "implants": "No",
    "surgicalExtractions": "No",
    "exclusions": "Specialised dentistry is not covered on Bestmed Rhythm 1. Dentures: Not covered on Rhythm 1. You would likely need to pay for dentures yourself",
    "preAuth": "Pre-authorisation is Required: All planned dental procedures requiring in-hospital, day clinic, or specialized in-room treatment must be pre-authorised.",
    "crucialRules": "8101 1 (one) consultation for full mouth examination per beneficiary per year. 8104  Maximum of 3 per year, not within 4 weeks after 8101.  Maximum of two films (8107 x2 or 8112 x2 or combination of 8107 & 8112) every 6 months. 8159 : Once per year per beneficiary of 12 years and older. 8155 : Once per year per beneficiary of 12 years and older. 8161 Once per year per beneficiary younger than 12 years. 8162 Once per year per beneficiary of 12 years and older. 8201 Basic extractions if clinically necessary (1 per quadrant per beneficiary per year). Restorations are limited to 6 restoration codes per beneficiary.",
    "notes": "No savings account available. Day-to-day benefits are available. Basic dentistry Where clinically appropriate and subject to Rhythm1protocols, Rhythm Dental Network Providers and Rhythm approved dental codes",
    "source": "https://www.bestmed.co.za/plans-and-options/brochures-guides-and-forms",
    "lastUpdated": "Jan-26"
  },
  {
    "scheme": "Bestmed",
    "plan": "BEAT1 OPTION HOSPITAL PLAN",
    "administrator": "Bestmed",
    "contactInfo": {
      "email": [
        "service@bestmed.co.za"
      ],
      "fax": [],
      "phone": [
        "0860 002 380"
      ]
    },
    "networked": "Yes",
    "nonNetworkedPayment": "Yes",
    "balancedBilling": "Yes",
    "basicTreatment": "Yes with limitations",
    "rct": "No",
    "dentures": "No",
    "crownsOrBridges": "No",
    "implants": "No",
    "surgicalExtractions": "No",
    "exclusions": "basic and advanced dental",
    "preAuth": "Dental and oral surgery (in or out of hospital) PMBs only at DSP day hospitals. General Surgery Limit: For specific surgical extractions (teeth, roots, impactions, failed implants) and related procedures (abscess drainage, alveolectomy), benefits are limited . Pre-authorisation must be obtained for all dental and/or maxilla-facial surgical procedure that need to be performed in theatre or in doctor\u2019s rooms and shall be payable at 100% Scheme tariff.",
    "crucialRules": "",
    "notes": "",
    "source": "https://www.bestmed.co.za/plans-and-options/brochures-guides-and-forms",
    "lastUpdated": "Jan-26"
  },
  {
    "scheme": "BMW Employees M",
    "plan": "",
    "administrator": "Discovery",
    "contactInfo": {
      "email": [
        "fax 0860 445 566"
      ],
      "fax": [],
      "phone": [
        "0860 002 107"
      ]
    },
    "networked": "Yes",
    "nonNetworkedPayment": "Yes",
    "balancedBilling": "Yes",
    "basicTreatment": "Yes with limitations",
    "rct": "Yes",
    "dentures": "Yes",
    "crownsOrBridges": "Yes",
    "implants": "Yes",
    "surgicalExtractions": "Yes",
    "exclusions": "Bleaching of teeth that have not had root canal treatment, metal inlays in dentures and front teeth. Mouth protectors and gold dentures",
    "preAuth": "Basic Dentistry in-hospital for members eight years and older is not covered. For children under eight, the hospital and anaesthetist accounts will be covered from the overall annual limit (OAL). The dentist\u2019s account will be paid from the Day-to-day Benefit limits, subject to obtaining authorisation from us.",
    "crucialRules": "Specialised dentistry Cover is subject to the overall annual limit (OAL) and includes services for inlays, crowns, bridges, mounted study models, metal base partial dentures, and the treatment by peridontists, prosthodontists and dental technicians fees. We pay for treatment limited to R13 850 for each beneficiary, and further limited to R30 000 for a family each year.",
    "notes": "Basic (conservative) dentistry including minor oral surgery Cover is subject to the overall annual limit (OAL) and thereafter paid from day-to day benefits. Cover includes removal of teeth and roots, exposure of teeth for orthodontic reasons and suturing of traumatic wounds. Specialised dentistry Cover is subject to the overall annual limit (OAL) and includes services for inlays, crowns, bridges, mounted study models, metal base partial dentures.",
    "source": "https://www.bemas.co.za/portal/",
    "lastUpdated": "Jan-26"
  },
  {
    "scheme": "BONITAS",
    "plan": "BonComprehensive",
    "administrator": "DENIS",
    "contactInfo": {
      "email": [
        "crowns@denis.co.za, hospitalenq@denis.co.za, customercare@denis.co.za"
      ],
      "fax": [],
      "phone": [
        "0861 033 647"
      ]
    },
    "networked": "Yes",
    "nonNetworkedPayment": "Yes",
    "balancedBilling": "Yes",
    "basicTreatment": "Yes with limitations",
    "rct": "Yes",
    "dentures": "Yes",
    "crownsOrBridges": "Yes",
    "implants": "Yes",
    "surgicalExtractions": "Yes",
    "exclusions": "\u2022 Crowns on third molars \u2022 Crown and bridge procedures for cosmetic reasons \u2022 Provisional crowns \u2022 Porcelain veneers and inlays, \u2022 Apicectomies, Dentectomies Frenectomies, \u2022 Professional oral hygiene procedures Surgical tooth exposures for orthodontic reasons",
    "preAuth": "Pre-authorisation is required for: Dentures, Crown & Bridge, Implants, Orthodontics, Periodontics, Hospital Admissions, and Moderate / Deep Sedation in the Dental Rooms.",
    "crucialRules": "Consultations Two check-ups per beneficiary per year (once every 6 months). X-rays: Extraoral One per beneficiary in a 3-year period. X-rays: Intraoral Benefit subject to managed care protocols.8159,8155 Once per 6 months per member from date of service. 8161, Once per 6 months per member from date of service. 8163 Fissure sealant Limited to beneficiaries from age 5 and younger than 16 years of age. Root Canal Therapy and Extractions Benefit subject to managed care protocols",
    "notes": "Benefit for orthodontic treatment granted once per beneficiary per lifetime. Patient written Accountability form needed for procedures not covered. Benefit for a mouth guard: Benefit available for both the clinical and the associated laboratory fee for a mouth guard (no pre-authorisation required).",
    "source": "https://denis.co.za/wp-content/uploads/2026/01/Bonitas-Dental-Benefit-Table-2026-v2.pdf",
    "lastUpdated": "Jan-26"
  },
  {
    "scheme": "BONITAS",
    "plan": "BonClassic",
    "administrator": "DENIS",
    "contactInfo": {
      "email": [
        "crowns@denis.co.za, hospitalenq@denis.co.za, customercare@denis.co.za"
      ],
      "fax": [],
      "phone": [
        "0861 033 647"
      ]
    },
    "networked": "Yes",
    "nonNetworkedPayment": "Yes",
    "balancedBilling": "Yes",
    "basicTreatment": "Yes with limitations",
    "rct": "Yes",
    "dentures": "Yes",
    "crownsOrBridges": "Yes",
    "implants": "No",
    "surgicalExtractions": "Yes",
    "exclusions": "Benefit not available for the clinical fee of denture repairs, denture tooth replacements and the addition of a soft base to new dentures; the laboratory fee will be covered (no preauthorisation required). Implants* and Associated\nLaboratory Costs No benefit",
    "preAuth": "Hospitalisation, and certain dentistry procedures and treatments must be pre-authorised. Pre-authorisation is required for: Dentures, Crown & Bridge, Orthodontics, Periodontics, Hospital Admissions and Moderate/Deep Sedation in the Dental Rooms. General anaesthetic benefit available for children under the age of 5 years. General anaesthetic benefit available for the removal of impacted teeth:",
    "crucialRules": "Benefit for fillings: Granted once per tooth in 720 days. Benefit for a mouth guard: Benefit available for both the clinical and the associated laboratory fee for a mouth guard (no pre-authorisation required).",
    "notes": "Conservative Dentistry limit of R6 400 per family per year. Specialised Dentistry limit of R7 710 per family per year. Benefit for orthodontic treatment granted once per beneficiary per lifetime",
    "source": "https://denis.co.za/wp-content/uploads/2026/01/Bonitas-Dental-Benefit-Table-2026-v2.pdf",
    "lastUpdated": "Jan-26"
  },
  {
    "scheme": "BONITAS",
    "plan": "Standard",
    "administrator": "DENIS",
    "contactInfo": {
      "email": [
        "crowns@denis.co.za, hospitalenq@denis.co.za, customercare@denis.co.za"
      ],
      "fax": [],
      "phone": [
        "0861 033 647"
      ]
    },
    "networked": "Yes",
    "nonNetworkedPayment": "Yes",
    "balancedBilling": "Yes",
    "basicTreatment": "Yes with limitations",
    "rct": "Yes",
    "dentures": "Yes",
    "crownsOrBridges": "Yes",
    "implants": "No",
    "surgicalExtractions": "Yes",
    "exclusions": "Implants and Associated Laboratory Costs No benefit",
    "preAuth": "Hospitalisation, and certain dentistry procedures and treatments must be pre-authorised. Pre-authorisation is required for Dentures, Crown & Bridge, Orthodontics, Periodontics, Hospital Admissions and Moderate/Deep Sedation in the Dental Rooms.",
    "crucialRules": "Benefit for fillings: Granted once per tooth in 720 days. Benefit for a mouth guard: Benefit available for both the clinical and the associated laboratory fee for a mouth guard (no pre-authorisation required). Benefit not available for the clinical fee of denture repairs, denture tooth replacements and the addition of a soft base to new dentures; the laboratory fee will be covered (no preauthorisation required).",
    "notes": "Hospitalisation, and certain dentistry procedures and treatments must be pre-authorised. Pre-authorisation is required for Dentures, Crown & Bridge, Orthodontics, Periodontics,",
    "source": "https://denis.co.za/wp-content/uploads/2026/01/Bonitas-Dental-Benefit-Table-2026-v2.pdf",
    "lastUpdated": "Jan-26"
  },
  {
    "scheme": "BONITAS",
    "plan": "Standard Select",
    "administrator": "DENIS",
    "contactInfo": {
      "email": [
        "crowns@denis.co.za, hospitalenq@denis.co.za, customercare@denis.co.za"
      ],
      "fax": [],
      "phone": [
        "0861 033 647"
      ]
    },
    "networked": "Yes",
    "nonNetworkedPayment": "Yes",
    "balancedBilling": "Yes",
    "basicTreatment": "Yes with limitations",
    "rct": "Yes",
    "dentures": "Yes",
    "crownsOrBridges": "Yes",
    "implants": "No",
    "surgicalExtractions": "Yes",
    "exclusions": "Implants and Associated Laboratory Costs No benefit",
    "preAuth": "Hospitalisation, and certain dentistry procedures and treatments must be pre-authorised. Pre-authorisation is required for Dentures, Crown & Bridge, Orthodontics, Periodontics, Hospital Admissions and Moderate/Deep Sedation in the Dental Rooms.",
    "crucialRules": "Benefit for fillings: Granted once per tooth in 720 days. Benefit for a mouth guard: Benefit available for both the clinical and the associated laboratory fee for a mouth guard (no pre-authorisation required). Benefit not available for the clinical fee of denture repairs, denture tooth replacements and the addition of a soft base to new dentures; the laboratory fee will be covered (no preauthorisation required).",
    "notes": "Hospitalisation, and certain dentistry procedures and treatments must be pre-authorised. Pre-authorisation is required for Dentures, Crown & Bridge, Orthodontics, Periodontics,",
    "source": "https://denis.co.za/wp-content/uploads/2026/01/Bonitas-Dental-Benefit-Table-2026-v2.pdf",
    "lastUpdated": "Jan-26"
  },
  {
    "scheme": "BONITAS",
    "plan": "BonComplete",
    "administrator": "DENIS",
    "contactInfo": {
      "email": [
        "crowns@denis.co.za, hospitalenq@denis.co.za, customercare@denis.co.za"
      ],
      "fax": [],
      "phone": [
        "0861 033 647"
      ]
    },
    "networked": "Yes",
    "nonNetworkedPayment": "Yes",
    "balancedBilling": "Yes",
    "basicTreatment": "Yes with limitations",
    "rct": "Yes",
    "dentures": "Yes",
    "crownsOrBridges": "Yes",
    "implants": "No",
    "surgicalExtractions": "Yes",
    "exclusions": "Implants and Associated Laboratory Costs No benefit",
    "preAuth": "Hospitalisation, and certain dentistry procedures and treatments must be pre-authorised. Pre-authorisation is required for Dentures, Crown & Bridge, Orthodontics, Periodontics, Hospital Admissions and Moderate/Deep Sedation in the Dental Rooms.",
    "crucialRules": "Benefit for fillings: Granted once per tooth in 720 days. Benefit for a mouth guard: Benefit available for both the clinical and the associated laboratory fee for a mouth guard (no pre-authorisation required). Benefit not available for the clinical fee of denture repairs, denture tooth replacements and the addition of a soft base to new dentures; the laboratory fee will be covered (no preauthorisation required).",
    "notes": "Hospitalisation, and certain dentistry procedures and treatments must be pre-authorised. Pre-authorisation is required for Dentures, Crown & Bridge, Orthodontics, Periodontics,",
    "source": "https://denis.co.za/wp-content/uploads/2026/01/Bonitas-Dental-Benefit-Table-2026-v2.pdf",
    "lastUpdated": "Jan-26"
  },
  {
    "scheme": "BONITAS",
    "plan": "Primary",
    "administrator": "DENIS",
    "contactInfo": {
      "email": [
        "crowns@denis.co.za, hospitalenq@denis.co.za, customercare@denis.co.za"
      ],
      "fax": [],
      "phone": [
        "0861 033 647"
      ]
    },
    "networked": "Yes",
    "nonNetworkedPayment": "Yes",
    "balancedBilling": "Yes",
    "basicTreatment": "Yes with limitations",
    "rct": "Yes",
    "dentures": "Yes",
    "crownsOrBridges": "Yes",
    "implants": "No",
    "surgicalExtractions": "Yes",
    "exclusions": "Plastic Dentures* and Associated Laboratory Costs No benefit, Partial Chrome Cobalt Frame Dentures, Crown & Bridge, Implants,",
    "preAuth": "A treatment plan and X-rays may be required for multiple fillings. No benefit for In Hospital (General Anaesthetic) dentistry, except for PMBs.- Subject to Primary Select Hospital Network, *Subject to pre-authorisation, Moderate/Deep Sedation in the Dental Rooms* - Benefit limited to extensive dental treatment,*Pre-authorisation required",
    "crucialRules": "Granted once per tooth in 720 days. Benefit for root canal therapy includes all teeth except primary teeth and permanent molars.",
    "notes": "Covered at 75% of the BDT",
    "source": "https://denis.co.za/wp-content/uploads/2026/01/Bonitas-Dental-Benefit-Table-2026-v2.pdf",
    "lastUpdated": "Jan-26"
  },
  {
    "scheme": "BONITAS",
    "plan": "BonPrime",
    "administrator": "DENIS",
    "contactInfo": {
      "email": [
        "crowns@denis.co.za, hospitalenq@denis.co.za, customercare@denis.co.za"
      ],
      "fax": [],
      "phone": [
        "0861 033 647"
      ]
    },
    "networked": "Yes",
    "nonNetworkedPayment": "Yes",
    "balancedBilling": "Yes",
    "basicTreatment": "Yes with limitations",
    "rct": "Yes",
    "dentures": "Yes",
    "crownsOrBridges": "Yes",
    "implants": "No",
    "surgicalExtractions": "Yes",
    "exclusions": "Implants* and Associated Laboratory Costs No benefit",
    "preAuth": "Pre-authorisation is required for: Dentures, Crown & Bridge, Orthodontics, Periodontics, Hospital Admissions and Moderate/Deep Sedation in the Dental Rooms. Conservative Dentistry payable from available Savings Plastic Dentures* and Associated Laboratory Costs, *Pre-authorisation required for Dentures. Specialised Dentistry payable from available Savings\nPartial Chrome Cobalt Frame Dentures*Pre-authorisation required",
    "crucialRules": "Dental benefits are paid at the Bonitas Dental Tariff (BDT) subject to the available financial limit that includes the family day-to-day savings or Benefit Booster where activated and applicable. The following dental tariff codes are payable from the Benefit Booster, subject to manged care protocols and activation on a beneficiary level: 8101 Oral Examination\n8109 Infection Control, 8110 Sterilised Instrumentation\n8155 Polishing, 8159 Scale and Polishing, 8161 Fluoride \u2013 Children, younger than 13, 8162 Fluouride \u2013 Adult, younger than 16\n8163 Fissure Sealants",
    "notes": "Benefit not available for the clinical fee of denture repairs, denture tooth replacements and the addition of a soft base to new dentures; the laboratory fee will be covered (no pre-authorisation required).",
    "source": "https://denis.co.za/wp-content/uploads/2026/01/Bonitas-Dental-Benefit-Table-2026-v2.pdf",
    "lastUpdated": "Jan-26"
  },
  {
    "scheme": "BONITAS",
    "plan": "BonSave",
    "administrator": "DENIS",
    "contactInfo": {
      "email": [
        "crowns@denis.co.za, hospitalenq@denis.co.za, customercare@denis.co.za"
      ],
      "fax": [],
      "phone": [
        "0861 033 647"
      ]
    },
    "networked": "Yes",
    "nonNetworkedPayment": "Yes",
    "balancedBilling": "Yes",
    "basicTreatment": "Yes with limitations",
    "rct": "Yes",
    "dentures": "Yes",
    "crownsOrBridges": "Yes",
    "implants": "No",
    "surgicalExtractions": "Yes",
    "exclusions": "Crown and bridge procedures for cosmetic reasons and associated laboratory costs - Crowns on third molars - Emergency crowns that are not placed for the immediate protection in tooth injury",
    "preAuth": "Hospitalisation, and certain dentistry procedures and treatments must be pre-authorised. Pre-authorisation is required for Dentures, Crown & Bridge, Orthodontics, Periodontics, Hospital Admissions and Moderate/Deep Sedation in the Dental Rooms.General anaesthetic benefit available for children under the age of 5 years for extensive dental treatment:",
    "crucialRules": "Granted once per tooth in 720 days. Moderate/Deep Sedation in the Dental Rooms* *Pre-authorisation required - Benefit limited to extensive dental treatment & the removal of Impacted Teeth - For extensive dental treatment, the Anaesthetist account is payable from Risk and the Dental Provider\u2019s account is payable from Savings - For the removal of impacted teeth, both the Anaesthetist and the Dental Provider\u2019s accounts are payable from Risk",
    "notes": "Preventative Dentistry payable by DENIS from Risk. All 3 accounts (the Hospital, Anaesthetist and Dental Provider\u2019s accounts) are payable from Risk",
    "source": "https://denis.co.za/wp-content/uploads/2026/01/Bonitas-Dental-Benefit-Table-2026-v2.pdf",
    "lastUpdated": "Jan-26"
  },
  {
    "scheme": "BONITAS",
    "plan": "BonFit",
    "administrator": "DENIS",
    "contactInfo": {
      "email": [
        "crowns@denis.co.za, hospitalenq@denis.co.za, customercare@denis.co.za"
      ],
      "fax": [],
      "phone": [
        "0861 033 647"
      ]
    },
    "networked": "Yes",
    "nonNetworkedPayment": "Yes",
    "balancedBilling": "Yes",
    "basicTreatment": "Yes with limitations",
    "rct": "Yes",
    "dentures": "Yes",
    "crownsOrBridges": "Yes",
    "implants": "No",
    "surgicalExtractions": "Yes",
    "exclusions": "One set of plastic dentures (an upper and a lower) per beneficiary in a 4-year period - Benefit not available for the clinical fee of denture repairs, denture tooth replacements and the addition of a soft base to new dentures; the laboratory fee will be covered (no preauthorisation required). Implants* and Associated Laboratory Costs No benefit",
    "preAuth": "Pre-authorisation is required for Dentures, Crown & Bridge, Orthodontics, Periodontics, No benefit for In Hospital (General Anaesthetic) dentistry, except for PMBs. - Subject to BonFit Select Hospital Network. Moderate/Deep Sedation in the Dental Rooms* *Pre-authorisation required - Payable from Savings",
    "crucialRules": "Granted once per tooth in 720 days. Multiple fillings: A treatment plan and X-rays may be required for multiple fillings",
    "notes": "Preventative Dentistry payable by DENIS from Risk. Conservative Dentistry payable from available Savings",
    "source": "https://denis.co.za/wp-content/uploads/2026/01/Bonitas-Dental-Benefit-Table-2026-v2.pdf",
    "lastUpdated": "Jan-26"
  },
  {
    "scheme": "BONITAS",
    "plan": "BonCap",
    "administrator": "DENIS",
    "contactInfo": {
      "email": [
        "crowns@denis.co.za, hospitalenq@denis.co.za, customercare@denis.co.za"
      ],
      "fax": [],
      "phone": [
        "0861 033 647"
      ]
    },
    "networked": "No",
    "nonNetworkedPayment": "No",
    "balancedBilling": "Yes",
    "basicTreatment": "Yes with limitations",
    "rct": "No",
    "dentures": "No",
    "crownsOrBridges": "No",
    "implants": "No",
    "surgicalExtractions": "No",
    "exclusions": "X-rays Extraoral \u2013 NO Benefit",
    "preAuth": "PMB** treatment is the only dental treatment covered in hospital on the BonCap option. Pre-authorisation by DENIS is required for any dental related PMB hospitalisation. No benefits for in hospital (general anaesthetic) dentistry, except for PMBs",
    "crucialRules": "Benefit for 4 fillings per beneficiary per year - Benefit for fillings are granted once per tooth in 720 days",
    "notes": "Please note that PHA will be responsible for the payment of all dental claims (Out-of-hospital dentistry, In-hospital PMB dentistry and related anaesthetics) on the BonCap option.",
    "source": "https://denis.co.za/wp-content/uploads/2026/01/Bonitas-Dental-Benefit-Table-2026-v2.pdf",
    "lastUpdated": "Jan-26"
  },
  {
    "scheme": "BONITAS",
    "plan": "Hospital Standard",
    "administrator": "DENIS",
    "contactInfo": {
      "email": [
        "crowns@denis.co.za, hospitalenq@denis.co.za, customercare@denis.co.za"
      ],
      "fax": [],
      "phone": [
        "0861 033 647"
      ]
    },
    "networked": "No",
    "nonNetworkedPayment": "No",
    "balancedBilling": "No",
    "basicTreatment": "Yes with limitations",
    "rct": "No",
    "dentures": "No",
    "crownsOrBridges": "No",
    "implants": "No",
    "surgicalExtractions": "No",
    "exclusions": "NO Conservative Dentistry, NO Specialised dental",
    "preAuth": "General anaesthetic benefit available for children under the age of 5 years for extensive dental treatment. General anaesthetic benefit available for the removal of impacted teeth. Moderate/Deep Sedation in\nthe Dental Rooms**Pre-authorisation required - Benefit subject to managed care protocols",
    "crucialRules": "Preventative Care - Fissure sealants (tariff code 8163) are available for beneficiaries younger than 16 years of age and limited to one per tooth in 3 years",
    "notes": "",
    "source": "https://denis.co.za/wp-content/uploads/2026/01/Bonitas-Dental-Benefit-Table-2026-v2.pdf",
    "lastUpdated": "Jan-26"
  },
  {
    "scheme": "BONITAS",
    "plan": "BonEssential",
    "administrator": "DENIS",
    "contactInfo": {
      "email": [
        "crowns@denis.co.za, hospitalenq@denis.co.za, customercare@denis.co.za"
      ],
      "fax": [],
      "phone": [
        "0861 033 647"
      ]
    },
    "networked": "\u00ddes",
    "nonNetworkedPayment": "\u00ddes",
    "balancedBilling": "No",
    "basicTreatment": "No",
    "rct": "No",
    "dentures": "No",
    "crownsOrBridges": "No",
    "implants": "No",
    "surgicalExtractions": "No",
    "exclusions": "NO Conservative Dentistry, NO Specialised dental",
    "preAuth": "Moderate/Deep Sedation in the Dental Rooms* *Pre-authorisation required - Benefit subject to managed care protocols",
    "crucialRules": "General anaesthetic benefit available for the removal of impacted teeth ONLY:",
    "notes": "",
    "source": "https://denis.co.za/wp-content/uploads/2026/01/Bonitas-Dental-Benefit-Table-2026-v2.pdf",
    "lastUpdated": "Jan-26"
  },
  {
    "scheme": "BONITAS",
    "plan": "BonEssential Select",
    "administrator": "DENIS",
    "contactInfo": {
      "email": [
        "crowns@denis.co.za, hospitalenq@denis.co.za, customercare@denis.co.za"
      ],
      "fax": [],
      "phone": [
        "0861 033 647"
      ]
    },
    "networked": "\u00ddes",
    "nonNetworkedPayment": "\u00ddes",
    "balancedBilling": "No",
    "basicTreatment": "No",
    "rct": "No",
    "dentures": "No",
    "crownsOrBridges": "No",
    "implants": "No",
    "surgicalExtractions": "No",
    "exclusions": "NO Conservative Dentistry, NO Specialised dental",
    "preAuth": "Moderate/Deep Sedation in the Dental Rooms* *Pre-authorisation required - Benefit subject to managed care protocols",
    "crucialRules": "General anaesthetic benefit available for the removal of impacted teeth ONLY:",
    "notes": "",
    "source": "https://denis.co.za/wp-content/uploads/2026/01/Bonitas-Dental-Benefit-Table-2026-v2.pdf",
    "lastUpdated": "Jan-26"
  },
  {
    "scheme": "BONITAS",
    "plan": "BonStart",
    "administrator": "DENIS",
    "contactInfo": {
      "email": [
        "crowns@denis.co.za, hospitalenq@denis.co.za, customercare@denis.co.za"
      ],
      "fax": [],
      "phone": [
        "0861 033 647"
      ]
    },
    "networked": "\u00ddes",
    "nonNetworkedPayment": "\u00ddes",
    "balancedBilling": "Yes",
    "basicTreatment": "No",
    "rct": "No",
    "dentures": "No",
    "crownsOrBridges": "No",
    "implants": "No",
    "surgicalExtractions": "No",
    "exclusions": "NO Conservative Dentistry, NO Specialised dental",
    "preAuth": "No benefit for In-hospital (General Anaesthetic) dentistry, except for PMBs.",
    "crucialRules": "ONLY Preventative Dentistry",
    "notes": "Pre-authorisation by DENIS is required for any dental related PMB hospitalisation. Subject to BonStart and BonStart Plus Hospital Network.",
    "source": "https://denis.co.za/wp-content/uploads/2026/01/Bonitas-Dental-Benefit-Table-2026-v2.pdf",
    "lastUpdated": "Jan-26"
  },
  {
    "scheme": "BONITAS",
    "plan": "BonStart Plus",
    "administrator": "DENIS",
    "contactInfo": {
      "email": [
        "crowns@denis.co.za, hospitalenq@denis.co.za, customercare@denis.co.za"
      ],
      "fax": [],
      "phone": [
        "0861 033 647"
      ]
    },
    "networked": "\u00ddes",
    "nonNetworkedPayment": "\u00ddes",
    "balancedBilling": "Yes",
    "basicTreatment": "No",
    "rct": "No",
    "dentures": "No",
    "crownsOrBridges": "No",
    "implants": "No",
    "surgicalExtractions": "No",
    "exclusions": "NO Conservative Dentistry, NO Specialised dental",
    "preAuth": "No benefit for In-hospital (General Anaesthetic) dentistry, except for PMBs.",
    "crucialRules": "ONLY Preventative Dentistry",
    "notes": "Pre-authorisation by DENIS is required for any dental related PMB hospitalisation. Subject to BonStart and BonStart Plus Hospital Network.",
    "source": "https://denis.co.za/wp-content/uploads/2026/01/Bonitas-Dental-Benefit-Table-2026-v2.pdf",
    "lastUpdated": "Jan-26"
  },
  {
    "scheme": "BONITAS",
    "plan": "BonCore",
    "administrator": "DENIS",
    "contactInfo": {
      "email": [
        "crowns@denis.co.za, hospitalenq@denis.co.za, customercare@denis.co.za"
      ],
      "fax": [],
      "phone": [
        "0861 033 647"
      ]
    },
    "networked": "\u00ddes",
    "nonNetworkedPayment": "\u00ddes",
    "balancedBilling": "Yes",
    "basicTreatment": "No",
    "rct": "No",
    "dentures": "No",
    "crownsOrBridges": "No",
    "implants": "No",
    "surgicalExtractions": "No",
    "exclusions": "NO Conservative Dentistry, NO Specialised dental",
    "preAuth": "Hospitalisation (General Anaesthetic)* *Authorisation required for PMBs - No benefits for in hospital (general anaesthetic) dentistry, except for PMBs.",
    "crucialRules": "Payable from the Family Benefit Booster of R1 000 per family once activated. ONLY Preventative Dentistry",
    "notes": "Pre-authorisation by DENIS is required for any dental related PMB hospitalisation. Subject to BonStart and BonStart Plus Hospital Network.",
    "source": "https://denis.co.za/wp-content/uploads/2026/01/Bonitas-Dental-Benefit-Table-2026-v2.pdf",
    "lastUpdated": "Jan-26"
  },
  {
    "scheme": "BONVIE",
    "plan": "PRIMARY STANDARD WITH HOSPITAL PLAN",
    "administrator": "DRC",
    "contactInfo": {
      "email": [
        "auth@dentalrisk.com"
      ],
      "fax": [],
      "phone": [
        "0879 439 612"
      ]
    },
    "networked": "Yes",
    "nonNetworkedPayment": "No",
    "balancedBilling": "No",
    "basicTreatment": "Yes with limitations",
    "rct": "No",
    "dentures": "No",
    "crownsOrBridges": "No",
    "implants": "No",
    "surgicalExtractions": "No",
    "exclusions": "Pan Scan NO BENEFITS. Bite Plate NO BENEITS. Mouth Guard NO BENEFITS. Root Canal NO BENEFITS. Temporary Crown NO BENEFITS",
    "preAuth": "Maximum of 1 X 8201 per quadrant per visit. \u2022 More than 4 extractions per visit require pre-authorisation.",
    "crucialRules": "Posterior restorations are covered to the value of amalgam restorations. Pre-authorisation and X-rays required for: \u2022 More than 4 restorations per annum. \u2022 Any 3 or 4 surface restorations on wisdom teeth.",
    "notes": "Posterior restorations are covered to the value of amalgam restorations",
    "source": "https://dentalrisk.com/member-benefits/",
    "lastUpdated": "Jan-26"
  },
  {
    "scheme": "BONVIE",
    "plan": "COMPREHENSIVE PLAN",
    "administrator": "DRC",
    "contactInfo": {
      "email": [
        "auth@dentalrisk.com"
      ],
      "fax": [],
      "phone": [
        "0879 439 612"
      ]
    },
    "networked": "Yes",
    "nonNetworkedPayment": "No",
    "balancedBilling": "No",
    "basicTreatment": "Yes with limitations",
    "rct": "No",
    "dentures": "No",
    "crownsOrBridges": "No",
    "implants": "No",
    "surgicalExtractions": "No",
    "exclusions": "Pan Scan NO BENEFITS. Bite Plate NO BENEITS. Mouth Guard NO BENEFITS. Root Canal NO BENEFITS. Temporary Crown NO BENEFITS",
    "preAuth": "Maximum of 1 X 8201 per quadrant per visit. \u2022 More than 4 extractions per visit require pre-authorisation.",
    "crucialRules": "Posterior restorations are covered to the value of amalgam restorations. Pre-authorisation and X-rays required for: \u2022 More than 4 restorations per annum. \u2022 Any 3 or 4 surface restorations on wisdom teeth.",
    "notes": "Posterior restorations are covered to the value of amalgam restorations",
    "source": "https://dentalrisk.com/member-benefits/",
    "lastUpdated": "Jan-26"
  },
  {
    "scheme": "CAMAF",
    "plan": "Alliance/ ALLIANCE PLUS",
    "administrator": "Camaf",
    "contactInfo": {
      "email": [
        "custserv@camaf.co.za",
        "preauth@camaf.co.za"
      ],
      "fax": [],
      "phone": [
        "0860 100 545 or 011 707 8400"
      ]
    },
    "networked": "Yes",
    "nonNetworkedPayment": "Yes",
    "balancedBilling": "Yes",
    "basicTreatment": "Yes with limitations",
    "rct": "Yes",
    "dentures": "Yes",
    "crownsOrBridges": "Yes",
    "implants": "Yes",
    "surgicalExtractions": "Yes",
    "exclusions": "Bleaching of teeth that have not had root canal treatment, metal inlays in dentures and front teeth. Mouth protectors and gold dentures",
    "preAuth": "ADVANCED DENTISTRY CROWNS, BRIDGES, ORTHODONTICS, DENTURES 80% CBT limited to:, M0 R23 535, M1 R35 175, M2+ R42 420. Pre-Aut: Advanced dentistry, including implants, typically requires prior approval from the scheme to ensure clinical necessity and benefit availability.",
    "crucialRules": "DENTAL IMPLANTS \nR68 250 per beneficiary for the case as a whole (facility fee, tooth implant and provider accounts)",
    "notes": "Preventative Checkups: Members are entitled to one dentistry consultation for a general checkup per year, covered at 100% of the CAMAF Base Tariff (CBT).",
    "source": "https://camaf.co.za/orientation-guide/",
    "lastUpdated": "Jan-26"
  },
  {
    "scheme": "CAMAF",
    "plan": "Double Plus",
    "administrator": "Camaf",
    "contactInfo": {
      "email": [
        "custserv@camaf.co.za",
        "preauth@camaf.co.za"
      ],
      "fax": [],
      "phone": [
        "0860 100 545 or 011 707 8400"
      ]
    },
    "networked": "Yes",
    "nonNetworkedPayment": "Yes",
    "balancedBilling": "Yes",
    "basicTreatment": "Yes with limitations",
    "rct": "Yes",
    "dentures": "Yes",
    "crownsOrBridges": "Yes",
    "implants": "Yes",
    "surgicalExtractions": "Yes",
    "exclusions": "Bleaching of teeth that have not had root canal treatment, metal inlays in dentures and front teeth. Mouth protectors and gold dentures",
    "preAuth": "Specialised Dentistry: Includes more complex procedures like crowns, bridges, and orthodontic work. These typically require pre-authorization and may be subject to additional limits",
    "crucialRules": "No benefits for dental veneers are available for Members on any Benefit Option except where members have accumulated (positive) funds in MSA. Dental x-rays performed by dentists, consultations and procedures performed by these practitioners; basic dentistry 80% CBT.",
    "notes": "Advanced Dentistry Crowns, Bridges, Orthodontics, Dentures 80% CBT limited to: M0 R17 530 M1 R25 245 M2+ R33 995. Dental Implants R57 750 per beneficiary for the case as a whole (facility fee and provider accounts)",
    "source": "https://camaf.co.za/orientation-guide/",
    "lastUpdated": "Jan-26"
  },
  {
    "scheme": "CAMAF",
    "plan": "Essential Plus",
    "administrator": "Camaf",
    "contactInfo": {
      "email": [
        "custserv@camaf.co.za",
        "preauth@camaf.co.za"
      ],
      "fax": [],
      "phone": [
        "0860 100 545 or 011 707 8400"
      ]
    },
    "networked": "Yes",
    "nonNetworkedPayment": "Yes",
    "balancedBilling": "Yes",
    "basicTreatment": "Yes with limitations",
    "rct": "Yes",
    "dentures": "Yes",
    "crownsOrBridges": "Yes",
    "implants": "No",
    "surgicalExtractions": "Yes",
    "exclusions": "Bleaching of teeth that have not had root canal treatment, metal inlays in dentures and front teeth. Mouth protectors and gold dentures. No benefits for osseo-integrated implants are available",
    "preAuth": "Pre-authorisation is for advanced dental procedures, including crowns, bridges, dentures, and orthodontics. Any non-emergency admission to a hospital or day clinic for dental surgery ( wisdom tooth removal) requires pre-authorisation . Advanced Dentistry Limits: Crowns, bridges, dentures, and orthodontics are covered at 80% CBT but are subject to sub-limits based on family size: M0 (Principal only): R23,535 M1 (Principal + 1): R35,175 M2+ (Family): R42,420 Dental Implants: Covered up to a total of R68,250 per beneficiary for the entire case (including facility, tooth implant, and provider accounts).",
    "crucialRules": "Preventive Dental Checkup: Covered at 100% CBT for one annual consultation per adult beneficiary. Basic Dentistry: Procedures, X-rays, and consultations are covered at 80% CBT.",
    "notes": "Dental x-rays performed by dentists, consultations and procedures \nperformed by these practitioners: Basic dentistry. Subject to Medical Savings Account",
    "source": "https://camaf.co.za/orientation-guide/",
    "lastUpdated": "Jan-26"
  },
  {
    "scheme": "CAMAF",
    "plan": "Essential Network",
    "administrator": "Camaf",
    "contactInfo": {
      "email": [
        "custserv@camaf.co.za",
        "preauth@camaf.co.za"
      ],
      "fax": [],
      "phone": [
        "0860 100 545 or 011 707 8400"
      ]
    },
    "networked": "Yes",
    "nonNetworkedPayment": "Yes",
    "balancedBilling": "Yes",
    "basicTreatment": "Yes with limitations",
    "rct": "Yes",
    "dentures": "Yes",
    "crownsOrBridges": "Yes",
    "implants": "Yes",
    "surgicalExtractions": "Yes",
    "exclusions": "Bleaching of teeth that have not had root canal treatment, metal inlays in dentures and front teeth. Mouth protectors and gold dentures. No benefits for osseo-integrated implants are available",
    "preAuth": "ADVANCED DENTISTRY Crowns, bridges, orthodontics, dentures.. Subject to Medical Savings Account",
    "crucialRules": "DENTAL IMPLANTS Subject to Medical Savings Account",
    "notes": "Dental x-rays performed by dentists, consultations and procedures \nperformed by these practitioners: Basic dentistry. Subject to Medical Savings Account",
    "source": "https://camaf.co.za/orientation-guide/",
    "lastUpdated": "Jan-26"
  },
  {
    "scheme": "CAMAF",
    "plan": "First Choice",
    "administrator": "Camaf",
    "contactInfo": {
      "email": [
        "custserv@camaf.co.za",
        "preauth@camaf.co.za"
      ],
      "fax": [],
      "phone": [
        "0860 100 545 or 011 707 8400"
      ]
    },
    "networked": "Yes",
    "nonNetworkedPayment": "Yes",
    "balancedBilling": "Yes",
    "basicTreatment": "Yes with limitations",
    "rct": "Yes",
    "dentures": "Yes",
    "crownsOrBridges": "Yes",
    "implants": "No",
    "surgicalExtractions": "Yes",
    "exclusions": "Bleaching of teeth that have not had root canal treatment, metal inlays in dentures and front teeth. Mouth protectors and gold dentures. No benefits for osseo-integrated implants are available",
    "preAuth": "ADVANCED DENTISTRY CROWNS, BRIDGES, ORTHODONTICS, DENTURES 50% CBT Subject to limit Advanced Dentistry R9 060",
    "crucialRules": "Dental x-rays performed by dentists, consultations and procedures\nperformed by these practitioners; basic dentistry. 80% CBT",
    "notes": "BASIC DENTISTRY 80% CBT R4 325",
    "source": "https://camaf.co.za/orientation-guide/",
    "lastUpdated": "Jan-26"
  },
  {
    "scheme": "CAMAF",
    "plan": "Network Choice",
    "administrator": "Camaf",
    "contactInfo": {
      "email": [
        "custserv@camaf.co.za",
        "preauth@camaf.co.za"
      ],
      "fax": [],
      "phone": [
        "0860 100 545 or 011 707 8400"
      ]
    },
    "networked": "Yes",
    "nonNetworkedPayment": "Yes",
    "balancedBilling": "Yes",
    "basicTreatment": "Yes with limitations",
    "rct": "Yes",
    "dentures": "Yes",
    "crownsOrBridges": "Yes",
    "implants": "No",
    "surgicalExtractions": "Yes",
    "exclusions": "Bleaching of teeth that have not had root canal treatment, metal inlays in dentures and front teeth. Mouth protectors and gold dentures. No benefits for osseo-integrated implants are available",
    "preAuth": "ADVANCED DENTISTRY CROWNS, BRIDGES, ORTHODONTICS, DENTURES 50% CBT Subject to limit Advanced Dentistry R9 061",
    "crucialRules": "Dental x-rays performed by dentists, consultations and procedures\nperformed by these practitioners; basic dentistry. 80% CBT",
    "notes": "BASIC DENTISTRY 80% CBT R4 326",
    "source": "https://camaf.co.za/orientation-guide/",
    "lastUpdated": "Jan-26"
  },
  {
    "scheme": "CAMAF",
    "plan": "Vital",
    "administrator": "Camaf",
    "contactInfo": {
      "email": [
        "custserv@camaf.co.za",
        "preauth@camaf.co.za"
      ],
      "fax": [],
      "phone": [
        "0860 100 545 or 011 707 8400"
      ]
    },
    "networked": "Yes",
    "nonNetworkedPayment": "Yes",
    "balancedBilling": "Yes",
    "basicTreatment": "Yes with limitations",
    "rct": "No",
    "dentures": "No",
    "crownsOrBridges": "No",
    "implants": "No",
    "surgicalExtractions": "No",
    "exclusions": "ADVANCED DENTISTRY CROWNS, BRIDGES, ORTHODONTICS, DENTURES No Benefit",
    "preAuth": "",
    "crucialRules": "Basic Dentistry: Cover is provided for basic dentistry (such as consultations and simple fillings) but is subject to a combined annual limit for day-to-day services.",
    "notes": "General dentistry (basic procedures, fillings, X-rays) is covered at 80% of the CBT.",
    "source": "https://camaf.co.za/orientation-guide/",
    "lastUpdated": "Jan-26"
  },
  {
    "scheme": "CAMAF",
    "plan": "Vital Network",
    "administrator": "Camaf",
    "contactInfo": {
      "email": [
        "custserv@camaf.co.za",
        "preauth@camaf.co.za"
      ],
      "fax": [],
      "phone": [
        "0860 100 545 or 011 707 8400"
      ]
    },
    "networked": "Yes",
    "nonNetworkedPayment": "Yes",
    "balancedBilling": "Yes",
    "basicTreatment": "Yes with limitations",
    "rct": "No",
    "dentures": "No",
    "crownsOrBridges": "No",
    "implants": "No",
    "surgicalExtractions": "No",
    "exclusions": "ADVANCED DENTISTRY CROWNS, BRIDGES, ORTHODONTICS, DENTURES No Benefit",
    "preAuth": "",
    "crucialRules": "Basic Dentistry: Cover is provided for basic dentistry (such as consultations and simple fillings) but is subject to a combined annual limit for day-to-day services.",
    "notes": "",
    "source": "https://camaf.co.za/orientation-guide/",
    "lastUpdated": "Jan-26"
  },
  {
    "scheme": "Compcare",
    "plan": "SELFCARE / PLUS",
    "administrator": "Universal",
    "contactInfo": {
      "email": [
        "dental@universal.co.za",
        "compcare@universal.co.za"
      ],
      "fax": [],
      "phone": [
        "0861 222 777"
      ]
    },
    "networked": "Yes",
    "nonNetworkedPayment": "Yes",
    "balancedBilling": "Yes",
    "basicTreatment": "Yes with limitations",
    "rct": "Yes",
    "dentures": "Yes",
    "crownsOrBridges": "Yes",
    "implants": "No",
    "surgicalExtractions": "Yes",
    "exclusions": "Dental procedures and treatments: Dental extractions for non-medical purposes. Bleaching of teeth that have not been root canal treated. High impact acrylic dentures. The cost of the use of gold in dentures. Discretionary procedures \u2013 elective treatments and surgery for personal reasons and not directly caused and related to illness,\naccident or disease.",
    "preAuth": "Specialised dentistry Including maxillofacial and oral surgery- in-and-out of hospital combined benefit. (A quotation must be submitted for approval prior to the commencement of the treatment. Orthodontic treatment for patients older than 18 is excluded.)",
    "crucialRules": "Conservative dentistry Including consultations, preventative care, fillings, extractions including wisdom teeth, root canal treatment and infection control 100% of the CompCare rate. Paid from the PMSA. One consultation PB paid from risk. Protocols apply.",
    "notes": "Basic dentistry \u2013 limited to one consultation per beneficiary including preventative care, infection control, fillings, extractions and dental X-rays at a Universal Network dentist \u2013 R2 080 per beneficiary up to R3 580 per family, subject to AFB",
    "source": "https://compcare.co.za/2026-options/",
    "lastUpdated": "Jan-26"
  },
  {
    "scheme": "Compcare",
    "plan": "SaverCare",
    "administrator": "Universal",
    "contactInfo": {
      "email": [
        "dental@universal.co.za",
        "compcare@universal.co.za"
      ],
      "fax": [],
      "phone": [
        "0861 222 777"
      ]
    },
    "networked": "Yes",
    "nonNetworkedPayment": "Yes",
    "balancedBilling": "Yes",
    "basicTreatment": "Yes with limitations",
    "rct": "Yes",
    "dentures": "Yes",
    "crownsOrBridges": "Yes",
    "implants": "No",
    "surgicalExtractions": "Yes",
    "exclusions": "Dental procedures and treatments: Dental extractions for non-medical purposes. Bleaching of teeth that have not been root canal treated. High impact acrylic dentures. The cost of the use of gold in dentures",
    "preAuth": "Specialised dentistry Dentures, crowns, bridgework, metal fillings and inlays.",
    "crucialRules": "Multiple fillings: A treatment plan and X\u0002rays may be required for multiple fillings. Once per tooth within 12 months. Benefit for retreatment of a tooth is subject to clinical protocols.",
    "notes": "Basic dentistry Conservative and restorative. Specialised dentistry Dentures, crowns, bridgework, metal fillings and inlays. Subject to protocols. A quotation must be submitted for approval prior to the commencement of the treatment. No benefit for orthodontic treatment for patients older than 18 years",
    "source": "https://compcare.co.za/2026-options/",
    "lastUpdated": "Jan-26"
  },
  {
    "scheme": "Compcare",
    "plan": "ExtraCare",
    "administrator": "Universal",
    "contactInfo": {
      "email": [
        "dental@universal.co.za",
        "compcare@universal.co.za"
      ],
      "fax": [],
      "phone": [
        "0861 222 777"
      ]
    },
    "networked": "Yes",
    "nonNetworkedPayment": "Yes",
    "balancedBilling": "Yes",
    "basicTreatment": "Yes with limitations",
    "rct": "Yes",
    "dentures": "Yes",
    "crownsOrBridges": "Yes",
    "implants": "No",
    "surgicalExtractions": "Yes",
    "exclusions": "Dental procedures and treatments: Dental extractions for non-medical purposes. Bleaching of teeth that have not been root canal treated. High impact acrylic dentures. The cost of the use of gold in dentures.",
    "preAuth": "Specialised procedures (e.g. surgical extractions, impacted teeth, complex cases, treatment under anaesthetic, etc.) Pre-authorisation is required.",
    "crucialRules": "Conservative dentistry including consultations, preventative care, fillings, extractions, and infection control. Subject to PMSA. No benefit for orthodontic treatment for patients older than 18 years. Kids under 6 get unlimited visits to basic dentistry. Paid from Risk. Subject to PMSA, AFB and SPG.",
    "notes": "Specialised dentistry, including maxillofacial and oral surgery- in-and-out of hospital combined limit",
    "source": "https://compcare.co.za/2026-options/",
    "lastUpdated": "Jan-26"
  },
  {
    "scheme": "Compcare",
    "plan": "UltraCare UltraCare+",
    "administrator": "Universal",
    "contactInfo": {
      "email": [
        "dental@universal.co.za",
        "compcare@universal.co.za"
      ],
      "fax": [],
      "phone": [
        "0861 222 777"
      ]
    },
    "networked": "Yes",
    "nonNetworkedPayment": "Yes",
    "balancedBilling": "Yes",
    "basicTreatment": "Yes with limitations",
    "rct": "Yes",
    "dentures": "Yes",
    "crownsOrBridges": "Yes",
    "implants": "No",
    "surgicalExtractions": "Yes",
    "exclusions": "Dental procedures and treatments: Dental extractions for non-medical purposes. Bleaching of teeth that have not been root canal treated. High impact acrylic dentures. The cost of the use of gold in dentures",
    "preAuth": "A quotation must be submitted for approval prior to the commencement of any specialised dental treatment or maxillofacial surgery.",
    "crucialRules": "Conservative dentistry including consultations, preventative care, fillings, extractions, and infection control. Subject to PMSA. No benefit for orthodontic treatment for patients older than 18 years.",
    "notes": "Specialised dentistry, including maxillofacial and oral surgery- in-and-out of hospital combined limit",
    "source": "https://compcare.co.za/2026-options/",
    "lastUpdated": "Jan-26"
  },
  {
    "scheme": "Compcare",
    "plan": "ExecuCare | ExecuCare+",
    "administrator": "Universal",
    "contactInfo": {
      "email": [
        "dental@universal.co.za",
        "compcare@universal.co.za"
      ],
      "fax": [],
      "phone": [
        "0861 222 777"
      ]
    },
    "networked": "Yes",
    "nonNetworkedPayment": "Yes",
    "balancedBilling": "Yes",
    "basicTreatment": "Yes with limitations",
    "rct": "Yes",
    "dentures": "Yes",
    "crownsOrBridges": "Yes",
    "implants": "No",
    "surgicalExtractions": "Yes",
    "exclusions": "Dental procedures and treatments: Dental extractions for non-medical purposes. Bleaching of teeth that have not been root canal treated. High impact acrylic dentures. The cost of the use of gold in dentures",
    "preAuth": "Specialised dentistry. Dentures, crowns, bridgework, metal fillings and inlays. Specialised dentistry. Dentures, crowns, bridgework, metal fillings and inlays. Subject to protocols. A quotation must be submitted for approval prior to the commencement of treatment. No benefit for orthodontic treatment for patients older than 18 years.",
    "crucialRules": "Conservative dentistry including consultations, preventative care, fillings, extractions, and infection control.. No benefit for orthodontic treatment for patients older than 18 years.",
    "notes": "Specialised dentistry, including maxillofacial and oral surgery- in-and-out of hospital combined limit",
    "source": "https://compcare.co.za/2026-options/",
    "lastUpdated": "Jan-26"
  },
  {
    "scheme": "COMPCARE",
    "plan": "Umbono Option & Umbono ED* \nOption",
    "administrator": "Universal",
    "contactInfo": {
      "email": [
        "network@universal.co.za"
      ],
      "fax": [],
      "phone": [
        "0803 628 677"
      ]
    },
    "networked": "Yes",
    "nonNetworkedPayment": "Yes",
    "balancedBilling": "Yes",
    "basicTreatment": "Yes with limitations",
    "rct": "Root Canal Treatment Emergency only",
    "dentures": "Yes",
    "crownsOrBridges": "No",
    "implants": "No",
    "surgicalExtractions": "No",
    "exclusions": "No benefits for pulpotomy. No benefits for surgical removal of impacted teeth. No panorex.",
    "preAuth": "Fillings pre\u0002authorisation required if >4 per annum per beneficiary . Only anterior composite fillings are covered. Pre-authorisation required for 4 or more extractions per annum per beneficiary. Wisdom teeth extractions to be done in dentist\u2019s rooms under local anaesthesia. Oral Radiographs Pre authorisation required if >2 per beneficiary per annum. Root Canal Treatment . 80% of cost payable by the scheme and includes professional and laboratory fees. 20% member liability",
    "crucialRules": "Limited to 1 consultation per beneficiary. One set of dentures every 24 months per beneficiary. A 20% co- payment applies. Restorations /Composite Fillings Preauthorisation required if >4 per annum per beneficiary. Only anterior composite fillings are covered. Extractions re-authorisation required for 4 or more extractions per annum per beneficiary. Teeth extractions to be done in dentist\u2019s rooms under local anaesthesia. Oral Radiographs Pre authorisation required if >2 per beneficiary per annum. Root Canal Treatment Emergency only.",
    "notes": "Confirmation of benefits is not a guarantee of payment \u2013An authorisation granted is not a guarantee of payment",
    "source": "https://compcare.co.za/2026-options/",
    "lastUpdated": "Jan-26"
  },
  {
    "scheme": "Consumer Goods Medical Scheme (CGMS)",
    "plan": "Base Option",
    "administrator": "Universal",
    "contactInfo": {
      "email": [
        "network@universal.co.za"
      ],
      "fax": [],
      "phone": [
        "0803 628 677"
      ]
    },
    "networked": "Yes",
    "nonNetworkedPayment": "Yes",
    "balancedBilling": "No",
    "basicTreatment": "Yes with limitations",
    "rct": "Root Canal Treatment Emergency only",
    "dentures": "Yes",
    "crownsOrBridges": "No",
    "implants": "No",
    "surgicalExtractions": "No",
    "exclusions": "No benefits for pulpotomy. No benefits for surgical removal of impacted teeth. No panorex.",
    "preAuth": "Fillings pre\u0002authorisation required if >4 per annum per beneficiary . Only anterior composite fillings are covered. Pre-authorisation required for 4 or more extractions per annum per beneficiary. Wisdom teeth extractions to be done in dentist\u2019s rooms under local anaesthesia. Oral Radiographs Pre authorisation required if >2 per beneficiary per annum. Root Canal Treatment . 80% of cost payable by the scheme and includes professional and laboratory fees. 20% member liability",
    "crucialRules": "Limited to 1 consultation per beneficiary. One set of dentures every 24 months per beneficiary. A 20% co- payment applies. Restorations /Composite Fillings Preauthorisation required if >4 per annum per beneficiary. Only anterior composite fillings are covered. Extractions re-authorisation required for 4 or more extractions per annum per beneficiary. Teeth extractions to be done in dentist\u2019s rooms under local anaesthesia. Oral Radiographs Pre authorisation required if >2 per beneficiary per annum. Root Canal Treatment Emergency only.",
    "notes": "Confirmation of benefits is not a guarantee of payment \u2013An authorisation granted is not a guarantee of paymen",
    "source": "https://cgmedicalscheme.co.za/benefit-options/",
    "lastUpdated": "Jan-26"
  },
  {
    "scheme": "Consumer Goods Medical Scheme (CGMS)",
    "plan": "A",
    "administrator": "Universal",
    "contactInfo": {
      "email": [
        "network@universal.co.za"
      ],
      "fax": [],
      "phone": [
        "0803 628 677"
      ]
    },
    "networked": "Yes",
    "nonNetworkedPayment": "Yes",
    "balancedBilling": "No",
    "basicTreatment": "Yes with limitations",
    "rct": "Root Canal Treatment Emergency only",
    "dentures": "Yes",
    "crownsOrBridges": "No",
    "implants": "No",
    "surgicalExtractions": "No",
    "exclusions": "No benefits for pulpotomy. No benefits for surgical removal of impacted teeth. No panorex.",
    "preAuth": "Fillings pre\u0002authorisation required if >4 per annum per beneficiary . Only anterior composite fillings are covered. Pre-authorisation required for 4 or more extractions per annum per beneficiary. Wisdom teeth extractions to be done in dentist\u2019s rooms under local anaesthesia. Oral Radiographs Pre authorisation required if >2 per beneficiary per annum. Root Canal Treatment . 80% of cost payable by the scheme and includes professional and laboratory fees. 20% member liability",
    "crucialRules": "Limited to 1 consultation per beneficiary. One set of dentures every 24 months per beneficiary. A 20% co- payment applies. Restorations /Composite Fillings Preauthorisation required if >4 per annum per beneficiary. Only anterior composite fillings are covered. Extractions re-authorisation required for 4 or more extractions per annum per beneficiary. Teeth extractions to be done in dentist\u2019s rooms under local anaesthesia. Oral Radiographs Pre authorisation required if >2 per beneficiary per annum. Root Canal Treatment Emergency only.",
    "notes": "Confirmation of benefits is not a guarantee of payment \u2013An authorisation granted is not a guarantee of paymen",
    "source": "https://cgmedicalscheme.co.za/benefit-options/",
    "lastUpdated": "Jan-26"
  },
  {
    "scheme": "Consumer Goods Medical Scheme (CGMS)",
    "plan": "B",
    "administrator": "Universal",
    "contactInfo": {
      "email": [
        "network@universal.co.za"
      ],
      "fax": [],
      "phone": [
        "0803 628 678"
      ]
    },
    "networked": "Yes",
    "nonNetworkedPayment": "Yes",
    "balancedBilling": "No",
    "basicTreatment": "Yes with limitations",
    "rct": "Root Canal Treatment Emergency only",
    "dentures": "Yes",
    "crownsOrBridges": "No",
    "implants": "No",
    "surgicalExtractions": "No",
    "exclusions": "No benefits for pulpotomy. No benefits for surgical removal of impacted teeth. No panorex.",
    "preAuth": "Fillings pre\u0002authorisation required if >4 per annum per beneficiary . Only anterior composite fillings are covered. Pre-authorisation required for 4 or more extractions per annum per beneficiary. Wisdom teeth extractions to be done in dentist\u2019s rooms under local anaesthesia. Oral Radiographs Pre authorisation required if >2 per beneficiary per annum. Root Canal Treatment . 80% of cost payable by the scheme and includes professional and laboratory fees. 20% member liability",
    "crucialRules": "Limited to 1 consultation per beneficiary. One set of dentures every 24 months per beneficiary. A 20% co- payment applies. Restorations /Composite Fillings Preauthorisation required if >4 per annum per beneficiary. Only anterior composite fillings are covered. Extractions re-authorisation required for 4 or more extractions per annum per beneficiary. Teeth extractions to be done in dentist\u2019s rooms under local anaesthesia. Oral Radiographs Pre authorisation required if >2 per beneficiary per annum. Root Canal Treatment Emergency only.",
    "notes": "Confirmation of benefits is not a guarantee of payment \u2013An authorisation granted is not a guarantee of paymen",
    "source": "https://cgmedicalscheme.co.za/benefit-options/",
    "lastUpdated": "Jan-26"
  },
  {
    "scheme": "Consumer Goods Medical Scheme (CGMS)",
    "plan": "C",
    "administrator": "Universal",
    "contactInfo": {
      "email": [
        "network@universal.co.za"
      ],
      "fax": [],
      "phone": [
        "0803 628 679"
      ]
    },
    "networked": "Yes",
    "nonNetworkedPayment": "Yes",
    "balancedBilling": "No",
    "basicTreatment": "Yes with limitations",
    "rct": "Root Canal Treatment Emergency only",
    "dentures": "Yes",
    "crownsOrBridges": "No",
    "implants": "No",
    "surgicalExtractions": "No",
    "exclusions": "No benefits for pulpotomy. No benefits for surgical removal of impacted teeth. No panorex.",
    "preAuth": "Fillings pre\u0002authorisation required if >4 per annum per beneficiary . Only anterior composite fillings are covered. Pre-authorisation required for 4 or more extractions per annum per beneficiary. Wisdom teeth extractions to be done in dentist\u2019s rooms under local anaesthesia. Oral Radiographs Pre authorisation required if >2 per beneficiary per annum. Root Canal Treatment . 80% of cost payable by the scheme and includes professional and laboratory fees. 20% member liability",
    "crucialRules": "Limited to 1 consultation per beneficiary. One set of dentures every 24 months per beneficiary. A 20% co- payment applies. Restorations /Composite Fillings Preauthorisation required if >4 per annum per beneficiary. Only anterior composite fillings are covered. Extractions re-authorisation required for 4 or more extractions per annum per beneficiary. Teeth extractions to be done in dentist\u2019s rooms under local anaesthesia. Oral Radiographs Pre authorisation required if >2 per beneficiary per annum. Root Canal Treatment Emergency only.",
    "notes": "Confirmation of benefits is not a guarantee of payment \u2013An authorisation granted is not a guarantee of paymen",
    "source": "https://cgmedicalscheme.co.za/benefit-options/",
    "lastUpdated": "Jan-26"
  },
  {
    "scheme": "Consumer Goods Medical Scheme (CGMS)",
    "plan": "ULTRASAVE",
    "administrator": "Universal",
    "contactInfo": {
      "email": [
        "network@universal.co.za"
      ],
      "fax": [],
      "phone": [
        "0803 628 680"
      ]
    },
    "networked": "Yes",
    "nonNetworkedPayment": "Yes",
    "balancedBilling": "No",
    "basicTreatment": "Yes with limitations",
    "rct": "Root Canal Treatment Emergency only",
    "dentures": "Yes",
    "crownsOrBridges": "No",
    "implants": "No",
    "surgicalExtractions": "No",
    "exclusions": "No benefits for pulpotomy. No benefits for surgical removal of impacted teeth. No panorex.",
    "preAuth": "Fillings pre\u0002authorisation required if >4 per annum per beneficiary . Only anterior composite fillings are covered. Pre-authorisation required for 4 or more extractions per annum per beneficiary. Wisdom teeth extractions to be done in dentist\u2019s rooms under local anaesthesia. Oral Radiographs Pre authorisation required if >2 per beneficiary per annum. Root Canal Treatment . 80% of cost payable by the scheme and includes professional and laboratory fees. 20% member liability",
    "crucialRules": "Limited to 1 consultation per beneficiary. One set of dentures every 24 months per beneficiary. A 20% co- payment applies. Restorations /Composite Fillings Preauthorisation required if >4 per annum per beneficiary. Only anterior composite fillings are covered. Extractions re-authorisation required for 4 or more extractions per annum per beneficiary. Teeth extractions to be done in dentist\u2019s rooms under local anaesthesia. Oral Radiographs Pre authorisation required if >2 per beneficiary per annum. Root Canal Treatment Emergency only.",
    "notes": "Confirmation of benefits is not a guarantee of payment \u2013An authorisation granted is not a guarantee of paymen",
    "source": "https://cgmedicalscheme.co.za/benefit-options/",
    "lastUpdated": "Jan-26"
  },
  {
    "scheme": "De Beers",
    "plan": "De Beers",
    "administrator": "De Beers",
    "contactInfo": {
      "email": [
        "debeerspreauth@ppsha.co.za"
      ],
      "fax": [],
      "phone": [
        "0538 073 111"
      ]
    },
    "networked": "Yes",
    "nonNetworkedPayment": "Yes",
    "balancedBilling": "Yes",
    "basicTreatment": "Yes with limitations",
    "rct": "Yes",
    "dentures": "Yes",
    "crownsOrBridges": "Yes",
    "implants": "Yes",
    "surgicalExtractions": "Yes",
    "exclusions": "Dental procedures and treatments: \u2022 Dental extractions for non-medical purposes. \u2022 Bleaching of teeth that have not been root canal treated. \u2022 High impact acrylic dentures. \u2022 The cost of the use of gold in dentures",
    "preAuth": "Pre-authorisation is required in respect of:- Elective procedures where general anaesthesia is required; - Children under the age of nine (limited to one admission per year); and Removal of impacted wisdom teeth, apicectomies, removal of teeth and roots or exposure of teeth for orthodontic reasons. \u2022 No limit applies in respect of dentistry required as a result of trauma.PRE-AUTHORISATION REQUIRED ONLY IF DONE IN HOSPITAL \u2022 Limited to R10 150. \u2022 Includes crowns, dentures, bridges and periodontal treatment.",
    "crucialRules": "1 oral examination, scale and polish every 6 months, from date of last service. \u2022 Includes preventative and diagnostic consultations, fillings, extractions, cleanings, and X-rays.",
    "notes": "Limited to R5 310, with a sub-limit of 1 oral examination, scale and polish every 6 months, from date of last service.\u2022 Includes preventative and diagnostic consultations, fillings, extractions, cleanings, and X-rays.",
    "source": "https://dbbs.co.za/wpfd_file/dbbs-member-guide-2026/",
    "lastUpdated": "Jan-26"
  },
  {
    "scheme": "Dis-Chem Health",
    "plan": "MyHealth Core",
    "administrator": "Prime Cure Health",
    "contactInfo": {
      "email": [
        "dischemhealth@kaelo.co.za"
      ],
      "fax": [],
      "phone": [
        "0861 029 894"
      ]
    },
    "networked": "Yes",
    "nonNetworkedPayment": "No",
    "balancedBilling": "Yes",
    "basicTreatment": "Yes with limitations",
    "rct": "No",
    "dentures": "No",
    "crownsOrBridges": "No",
    "implants": "No",
    "surgicalExtractions": "Yes",
    "exclusions": "Panoramic and other extra oral x-rays (e.g., 8115) does not form part of the benefit schedule.",
    "preAuth": "8935 Treatment of septic socket First treatment no authorisation is required. Extractions - Pre-Authorisation is needed for four or more extractions per beneficiary per year. One (1) surgical extraction per beneficiary per year. Must be authorised . 8941 Surgical removal of impacted tooth - first tooth, 8943 Surgical removal of impacted tooth . Fillings - White/Resin (anterior only) or Amalgam posterior - Note: Posterior Resin fillings will be paid for at Amalgam rates. Denture are limited to pre-authorisation. Dentures, reline, rebase and all specialised dentistry - Partial dentures. Conscious sedation pre auth. Inhalation sedation: under 7 years of age.",
    "crucialRules": "8101 Consultation oral examination Once per year, 8104 Examination for a specific problem. Intra oral radiographs (maximum of four X-rays per family per year). Polishing only Once a year for ages 3-12yrs. Scaling and polishing Once a year over the age 12 yrs. Topical application of fluoride Once a year for ages 3 to 12 yrs. 8132 Gross pulpal debridement, primary & permanent teeth (emergency root canal). Pre-authorisation if a patient neesd repairs to four or more teeth (including fillings) per person per year. One (1) consultations/ examinations code 8101 per beneficiary per year.",
    "notes": "8201, 8202 Extraction, single tooth. Code 8201 is charged for the first extraction in a quadrant. Maximum for 8201 & 8202 is three (3), thereafter pre-authorisation required for the first extraction in a quad-rant.",
    "source": "https://dischemhealth.co.za/medical-insurance/myhealth-core/",
    "lastUpdated": "Jan-26"
  },
  {
    "scheme": "Dis-Chem Health",
    "plan": "MyHealth Plus",
    "administrator": "Prime Cure Health",
    "contactInfo": {
      "email": [
        "dischemhealth@kaelo.co.za"
      ],
      "fax": [],
      "phone": [
        "0861 029 895"
      ]
    },
    "networked": "Yes",
    "nonNetworkedPayment": "No",
    "balancedBilling": "Yes",
    "basicTreatment": "Yes with limitations",
    "rct": "No",
    "dentures": "No",
    "crownsOrBridges": "No",
    "implants": "No",
    "surgicalExtractions": "No",
    "exclusions": "Panoramic and other extra oral x-rays (e.g., 8115) does not form part of the benefit schedule.",
    "preAuth": "8936 Treatment of septic socket First treatment no authorisation is required. Extractions - Pre-Authorisation is needed for four or more extractions per beneficiary per year. One (1) surgical extraction per beneficiary per year. Must be authorised . 8941 Surgical removal of impacted tooth - first tooth, 8943 Surgical removal of impacted tooth . Fillings - White/Resin (anterior only) or Amalgam posterior - Note: Posterior Resin fillings will be paid for at Amalgam rates. Denture are limited to pre-authorisation. Dentures, reline, rebase and all specialised dentistry - Partial dentures. Conscious sedation pre auth. Inhalation sedation: under 7 years of age.",
    "crucialRules": "8102 Consultation oral examination Once per year, 8104 Examination for a specific problem. Intra oral radiographs (maximum of four X-rays per family per year). Polishing only Once a year for ages 3-12yrs. Scaling and polishing Once a year over the age 12 yrs. Topical application of fluoride Once a year for ages 3 to 12 yrs. 8132 Gross pulpal debridement, primary & permanent teeth (emergency root canal). Pre-authorisation if a patient neesd repairs to four or more teeth (including fillings) per person per year. One (1) consultations/ examinations code 8101 per beneficiary per year.",
    "notes": "8201, 8202 Extraction, single tooth. Code 8201 is charged for the first extraction in a quadrant. Maximum for 8201 & 8202 is three (3), thereafter pre-authorisation required for the first extraction in a quad-rant.",
    "source": "https://dischemhealth.co.za/medical-insurance/myhealth-core/",
    "lastUpdated": "Jan-26"
  },
  {
    "scheme": "Discovery",
    "plan": "Flexicare & Flexicare Plus",
    "administrator": "Discovery / DRC",
    "contactInfo": {
      "email": [
        "auth@dentalrisk.com or fax 086 687 1285"
      ],
      "fax": [
        " 086 687 1285"
      ],
      "phone": [
        "0860 445 566"
      ]
    },
    "networked": "Yes",
    "nonNetworkedPayment": "No",
    "balancedBilling": "No",
    "basicTreatment": "Yes with limitations",
    "rct": "No",
    "dentures": "No",
    "crownsOrBridges": "No",
    "implants": "No",
    "surgicalExtractions": "No",
    "exclusions": "No Panorex. No Crown &, Bridges, Ortho, Implants or Roor canal Fillings. No Specialized Dentistry. No Crowns & bridges, Implants,Ortho, Dentures or Root canal fillings. No Dental in Theatre .",
    "preAuth": "Restoration Codes: Max of 3 restorations per annum. 2 Posterior restorations per member per 365 days. Posterior resin restorations covered at amalgam rates Lower jaw posterior teeth restorations cannot be performed across the midline. Deviations will only be covered if pre-authorised. 1 anterior restoration per member per 365 days. 1 Restoration code per tooth number in a 9-month period.",
    "crucialRules": "Consultation for a specific problem: 1 per member per 365 days. Not within 4 weeks of 8101, 8102, 8104 (Motivation required for code 8104 if no covered clinical procedure is charged). Maximum quantity of 7 X rays per year. Sterilised instrumentation Will only be paid if code 8731, 9013, 9011, 8201 or 8202 is claimed. Maximum 1 x 8201 per quadrant per member per 365 days. Emergency Codes: 8132 cannot be claimed with 8131 or any restoration, root canal and extraction codes. Maximum of 1 per treatment date. Not covered on primary teeth. The subsequent restoration will need to be pre-authorised with an emailed or scanned x-ray to show the complete root canal. Once per tooth number per lifetime.",
    "notes": "If a procedure does not attract benefit; all other treatment costs associated with the specific event does not receive benefit. 1. Very basic option 2. Lower rate applies to non network provider 3. Patient written consent needed for procedures not covered",
    "source": "https://dentalrisk.com/member-benefits/",
    "lastUpdated": "Jan-26"
  },
  {
    "scheme": "DISCOVERY",
    "plan": "FLEXICARE HOUSEHOLD OPTIONS",
    "administrator": "Discovery / DRC",
    "contactInfo": {
      "email": [
        "auth@dentalrisk.com or fax 086 687 1285"
      ],
      "fax": [
        " 086 687 1285"
      ],
      "phone": [
        "0860 445 566"
      ]
    },
    "networked": "Yes",
    "nonNetworkedPayment": "No",
    "balancedBilling": "No",
    "basicTreatment": "Yes with limitations",
    "rct": "No",
    "dentures": "No",
    "crownsOrBridges": "No",
    "implants": "No",
    "surgicalExtractions": "No",
    "exclusions": "No Panorex. No Crown &, Bridges, Ortho, Implants or Roor canal Fillings. No Specialized Dentistry. No Crowns & bridges, Implants,Ortho, Dentures or Root canal fillings. No Dental in Theatre .",
    "preAuth": "Restoration Codes: Max of 3 restorations per annum. 2 Posterior restorations per member per 365 days. Posterior resin restorations covered at amalgam rates Lower jaw posterior teeth restorations cannot be performed across the midline. Deviations will only be covered if pre-authorised. 1 anterior restoration per member per 365 days. 1 Restoration code per tooth number in a 9-month period.",
    "crucialRules": "Consultation for a specific problem: 1 per member per 365 days. Not within 4 weeks of 8101, 8102, 8104 (Motivation required for code 8104 if no covered clinical procedure is charged). Maximum quantity of 7 X rays per year. Sterilised instrumentation Will only be paid if code 8731, 9013, 9011, 8201 or 8202 is claimed. Maximum 1 x 8201 per quadrant per member per 365 days. Emergency Codes: 8132 cannot be claimed with 8131 or any restoration, root canal and extraction codes. Maximum of 1 per treatment date. Not covered on primary teeth. The subsequent restoration will need to be pre-authorised with an emailed or scanned x-ray to show the complete root canal. Once per tooth number per lifetime.",
    "notes": "If a procedure does not attract benefit; all other treatment costs associated with the specific event does not receive benefit. 1. Very basic option 2. Lower rate applies to non network provider 3. Patient written consent needed for procedures not covered",
    "source": "https://www.discovery.co.za/medical-aid/product-benefit-enhancements",
    "lastUpdated": "Jan-26"
  },
  {
    "scheme": "DISCOVERY",
    "plan": "EXECUTIVE PLAN",
    "administrator": "Discovery",
    "contactInfo": {
      "email": [
        "fax 0860 445 566"
      ],
      "fax": [],
      "phone": [
        "0860 445 566"
      ]
    },
    "networked": "Yes",
    "nonNetworkedPayment": "Yes",
    "balancedBilling": "Yes",
    "basicTreatment": "Yes with limitations",
    "rct": "Yes",
    "dentures": "Yes",
    "crownsOrBridges": "Yes",
    "implants": "Yes",
    "surgicalExtractions": "Yes",
    "exclusions": "Dental procedures and treatments: \u2022 Dental extractions for non-medical purposes. \u2022 Bleaching of teeth that have not been root canal treated. \u2022 High impact acrylic dentures. \u2022 The cost of the use of gold in dentures",
    "preAuth": "Dental limit: There is no overall limit for basic dental treatment. However, all dental appliances and prostheses, their placement, and orthodontic treatment (including related accounts for orthognathic surgery) are paid at 100%",
    "crucialRules": "Includes preventative and diagnostic consultations, fillings, extractions, cleanings and x-rays. . For members who are 13 years old or older, we cover routine conservative dentistry, such as preventive treatment, simple fillings and root canal treatment from your available day-to-day benefits.",
    "notes": "If you are 16 years and younger, you are covered for two dental sealants for each dental quadrant each year. If you are older than 16 years, you are covered for two professionally applied fluoride treatments and cleanings each year.",
    "source": "https://www.discovery.co.za/medical-aid/product-benefit-enhancements",
    "lastUpdated": "Jan-26"
  },
  {
    "scheme": "DISCOVERY",
    "plan": "COMPREHENSIVE SERIES",
    "administrator": "Discovery",
    "contactInfo": {
      "email": [
        "fax 0860 445 567"
      ],
      "fax": [],
      "phone": [
        "0860 445 566"
      ]
    },
    "networked": "Yes",
    "nonNetworkedPayment": "Yes",
    "balancedBilling": "Yes",
    "basicTreatment": "Yes with limitations",
    "rct": "Yes",
    "dentures": "Yes",
    "crownsOrBridges": "Yes",
    "implants": "Yes",
    "surgicalExtractions": "Yes",
    "exclusions": "Dental procedures and treatments: \u2022 Dental extractions for non-medical purposes. \u2022 Bleaching of teeth that have not been root canal treated. \u2022 High impact acrylic dentures. \u2022 The cost of the use of gold in dentures",
    "preAuth": "The Severe Dental and Oral Surgery Benefit covers a defined list of procedures, with no upfront payment and no overall limit. This benefit is subject to authorisation",
    "crucialRules": "For members 13 and older, we cover routine conservative dentistry, such as preventive treatment, simple fillings and root canal treatment from your available day-to-day benefits. Claims are paid from your day-to-day benefits (regardless of the place of service), up to an annual limit of R36,150 per person. These are not separate benefits.",
    "notes": "We pay for basic dental treatment done in the dentist's or dental specialist's rooms at 100% of the Discovery Health Rate from your available day-to-day benefits (Medical Savings Account and Above Threshold Benefit).We pay all dental appliances and their placement, as well as orthodontic treatment (including related accounts for orthognathic surgery) at 100% of the Discovery Health Rate.",
    "source": "https://www.discovery.co.za/medical-aid/product-benefit-enhancements",
    "lastUpdated": "Jan-26"
  },
  {
    "scheme": "DISCOVERY",
    "plan": "PRIORITY SERIES",
    "administrator": "Discovery",
    "contactInfo": {
      "email": [
        "fax 0860 445 568"
      ],
      "fax": [],
      "phone": [
        "0860 445 566"
      ]
    },
    "networked": "Yes",
    "nonNetworkedPayment": "Yes",
    "balancedBilling": "Yes",
    "basicTreatment": "Yes with limitations",
    "rct": "Yes",
    "dentures": "Yes",
    "crownsOrBridges": "Yes",
    "implants": "Yes",
    "surgicalExtractions": "Yes",
    "exclusions": "Dental procedures and treatments: \u2022 Dental extractions for non-medical purposes. \u2022 Bleaching of teeth that have not been root canal treated. \u2022 High impact acrylic dentures. \u2022 The cost of the use of gold in dentures",
    "preAuth": "Dental limit: There is no overall limit for basic dental treatment. However, all dental appliances and prostheses, their placement, and orthodontic treatment (including related accounts for orthognathic surgery) are paid at 100% of the Discovery Health Rate (DHR). We pay these claims from your day-to-day benefits. Severe dental and oral surgery in hospital The Severe Dental and Oral Surgery Benefit covers a defined list of procedures, with no upfront payment and no overall limit. This benefit is subject to authorisation and the Scheme\u2019s Rules.",
    "crucialRules": "Includes preventative and diagnostic consultations, fillings, extractions, cleanings and x-rays. . For members who are 13 years old or older, we cover routine conservative dentistry, such as preventive treatment, simple fillings and root canal treatment from your available day-to-day benefits.",
    "notes": "We pay for basic dental treatment done in the dentist's or dental specialist's rooms at 100% of the Discovery Health Rate from your available day-to-day benefits (Medical Savings Account and Above Threshold Benefit).We pay all dental appliances and their placement, as well as orthodontic treatment (including related accounts for orthognathic surgery) at 100% of the Discovery Health Rate.",
    "source": "https://www.discovery.co.za/medical-aid/product-benefit-enhancements",
    "lastUpdated": "Jan-26"
  },
  {
    "scheme": "DISCOVERY",
    "plan": "SAVER SERIES",
    "administrator": "Discovery",
    "contactInfo": {
      "email": [
        "fax 0860 445 566"
      ],
      "fax": [],
      "phone": [
        "0860 445 566"
      ]
    },
    "networked": "Yes",
    "nonNetworkedPayment": "Yes",
    "balancedBilling": "Yes",
    "basicTreatment": "Yes with limitations",
    "rct": "Yes",
    "dentures": "Yes",
    "crownsOrBridges": "Yes",
    "implants": "Yes",
    "surgicalExtractions": "Yes",
    "exclusions": "Dental procedures and treatments: \u2022 Dental extractions for non-medical purposes. \u2022 Bleaching of teeth that have not been root canal treated. \u2022 High impact acrylic dentures. \u2022 The cost of the use of gold in dentures",
    "preAuth": "Cover for basic dental treatment : What we pay for We pay for basic dental treatment done in the dentist's or dental specialist's rooms from your available day-to-day benefits (Medical Savings Account) at 100% of the Discovery Health Rate. There is no overall limit for basic dental treatment.",
    "crucialRules": ": You are covered in full at private hospitals and day clinics in the Delta Hospital Network. If you are on the Coastal Saver Plan: You must go to an approved hospital in one of the four coastal provinces for a planned hospital admission. If you do not use a coastal hospital, we will pay up to a maximum of 70% of the hospital account and you must pay the difference.",
    "notes": "For members 13 and older, we cover routine conservative dentistry, such as preventive treatment, simple fillings and root canal treatment from your available funds in your Medical Savings Account. The Severe Dental and Oral Surgery Benefit covers a defined list of procedures, with no upfront payment and no overall limit. This benefit is subject to authorisation and the Scheme's rules.",
    "source": "https://www.discovery.co.za/medical-aid/product-benefit-enhancements",
    "lastUpdated": "Jan-26"
  },
  {
    "scheme": "DISCOVERY",
    "plan": "SMART SERIES",
    "administrator": "Discovery",
    "contactInfo": {
      "email": [
        "fax 0860 445 566"
      ],
      "fax": [],
      "phone": [
        "0860 445 566"
      ]
    },
    "networked": "Yes",
    "nonNetworkedPayment": "Yes",
    "balancedBilling": "Yes",
    "basicTreatment": "Yes with limitations",
    "rct": "Yes",
    "dentures": "Yes",
    "crownsOrBridges": "Yes",
    "implants": "Yes",
    "surgicalExtractions": "Yes",
    "exclusions": "Dental procedures and treatments: \u2022 Dental extractions for non-medical purposes. \u2022 Bleaching of teeth that have not been root canal treated. \u2022 High impact acrylic dentures. \u2022 The cost of the use of gold in dentures",
    "preAuth": "Cover for basic dental treatment : What we pay for We pay for basic dental treatment done in the dentist's or dental specialist's rooms from your available day-to-day benefits (Medical Savings Account) at 100% of the Discovery Health Rate. There is no overall limit for basic dental treatment.",
    "crucialRules": "You have to pay the cost of all dental appliances and their placements as well as orthodontic treatment (including the related accounts for orthognathic surgery). In-hospital dental treatment is not covered on the Essential Smart, Essential Dynamic Smart and Active Smart plans. A co-payment of R125 on the Classic Smart Plan and R190 on the Essential Smart, Essential Dynamic Smart and Active Smart plans applies with the balance of this fee covered up to the Discovery Health Rate (DHR). Your co-payment may be more if the healthcare professional charges above the Discovery Health Rate (DHR).",
    "notes": "Smart plan members have cover for one defined dental check-up for each member each year at any dentist or dental therapist. This check-up covers you for a consultation, two bitewing X-rays, scale and polish, and fluoride.",
    "source": "https://www.discovery.co.za/medical-aid/product-benefit-enhancements",
    "lastUpdated": "Jan-26"
  },
  {
    "scheme": "DISCOVERY",
    "plan": "CORE SERIES",
    "administrator": "Discovery",
    "contactInfo": {
      "email": [
        "fax 0860 445 566"
      ],
      "fax": [],
      "phone": [
        "0860 445 566"
      ]
    },
    "networked": "Yes",
    "nonNetworkedPayment": "Yes",
    "balancedBilling": "Yes",
    "basicTreatment": "Yes with limitations",
    "rct": "Yes",
    "dentures": "Yes",
    "crownsOrBridges": "Yes",
    "implants": "Yes",
    "surgicalExtractions": "Yes",
    "exclusions": "Dental procedures and treatments: \u2022 Dental extractions for non-medical purposes. \u2022 Bleaching of teeth that have not been root canal treated. \u2022 High impact acrylic dentures. \u2022 The cost of the use of gold in dentures",
    "preAuth": "The Severe Dental and Oral Surgery Benefit covers a defined list of procedures, with no upfront payment and no overall limit. This benefit is subject to authorisation and the Scheme\u2019s rules. You must preauthorise your admission to hospital. You must go to an approved hospital in one of the four coastal provinces for a planned hospital admission. If you don\u2019t use a coastal hospital, the Scheme will pay up to a maximum of 70% of the hospital account and you must pay the difference.",
    "crucialRules": "Core plans do not cover out-of-hospital day-to-day costs so you must pay these costs yourself",
    "notes": "",
    "source": "https://www.discovery.co.za/medical-aid/product-benefit-enhancements",
    "lastUpdated": "Jan-26"
  },
  {
    "scheme": "DISCOVERY HEALTH",
    "plan": "KEYCARE PLUS",
    "administrator": "DRC",
    "contactInfo": {
      "email": [
        "auth@dentalrisk.com or fax 086 687 1285"
      ],
      "fax": [
        " 086 687 1285"
      ],
      "phone": [
        "0860 445 566"
      ]
    },
    "networked": "Yes",
    "nonNetworkedPayment": "No",
    "balancedBilling": "Yes",
    "basicTreatment": "Yes with limitations",
    "rct": "No",
    "dentures": "No",
    "crownsOrBridges": "No",
    "implants": "No",
    "surgicalExtractions": "No",
    "exclusions": "Sterilised instrumentation will only be paid if code 8731, 9013, 9011, 8201 or 8202 is claimed. 8132 cannot be claimed with 8131 or any restoration, root canal and extraction codes. Maximum of 1 per treatment date. Not covered on primary teeth.. Replacement of non-carious amalgam with resin. Restorations on non-functional wisdom teeth. No Panorex. No Crown &, Bridges, Ortho, Implants or Roor canal Fillings.",
    "preAuth": "X-ray: Pre-auth when quantity is more than the following: With 8101, 8112x2 and 8107x1, \uf0b7 With 8104, 8112x1 or 8107x1. No consult 8112x1 or 8107x1, Maximum quantity of 7 per year. Pulp removal 8132 cannot be claimed with 8131 or any restoration, root canal and extraction codes. The subsequent restoration will need to be pre-authorised with an emailed or scanned x-ray to show the complete root canal. Extraction Codes: Maximum 1 x 8201 per quadrant per visit. \u2022 More than 4 extractions per visit require pre-authorisation. Restoration Codes: Pre-authorisation and x-rays required for: \u2022 More than 4 restorations per year. \u2022 Two or more 3 or 4 surface restorations per visit. \u2022 More than 2 anterior restorations per visit. \u2022 Multiple restorations on an anterior tooth on the same service date. \u2022 Any 3- or 4 surface restorations on wisdom teeth with supporting x-rays.",
    "crucialRules": "For extraction and restorations codes tooth numbers should not cross posterior quadrants but should be in a combination of 1st and 4th quadrants or 2nd and 3rd quadrants per visit. 1 Restoration code per tooth number in a 9 month period. Motivation required for code 8104 if no covered clinical procedure is charged.",
    "notes": "If a procedure does not attract benefit; all other treatment costs associated with the specific event does not receive benefit. 1. Very basic option 2. Lower rate applies to non network provider 3. Patient written consent needed for procedures not covered",
    "source": "https://dentalrisk.com/member-benefits/",
    "lastUpdated": "Jan-26"
  },
  {
    "scheme": "DISCOVERY HEALTH",
    "plan": "KEYCARE START",
    "administrator": "DRC",
    "contactInfo": {
      "email": [
        "auth@dentalrisk.com or fax 086 687 1285"
      ],
      "fax": [
        " 086 687 1285"
      ],
      "phone": [
        "0860 445 566"
      ]
    },
    "networked": "Yes",
    "nonNetworkedPayment": "No",
    "balancedBilling": "Yes",
    "basicTreatment": "Yes with limitations",
    "rct": "No",
    "dentures": "No",
    "crownsOrBridges": "No",
    "implants": "No",
    "surgicalExtractions": "No",
    "exclusions": "Sterilised instrumentation will only be paid if code 8731, 9013, 9011, 8201 or 8202 is claimed. 8132 cannot be claimed with 8131 or any restoration, root canal and extraction codes. Maximum of 1 per treatment date. Not covered on primary teeth.. Replacement of non-carious amalgam with resin. Restorations on non-functional wisdom teeth. No Panorex. No Crown &, Bridges, Ortho, Implants or Roor canal Fillings.",
    "preAuth": "X-ray: Pre-auth when quantity is more than the following: With 8101, 8112x2 and 8107x1, \uf0b7 With 8104, 8112x1 or 8107x1. No consult 8112x1 or 8107x1, Maximum quantity of 7 per year. Pulp removal 8132 cannot be claimed with 8131 or any restoration, root canal and extraction codes. The subsequent restoration will need to be pre-authorised with an emailed or scanned x-ray to show the complete root canal. Extraction Codes: Maximum 1 x 8201 per quadrant per visit. \u2022 More than 4 extractions per visit require pre-authorisation. Restoration Codes: Pre-authorisation and x-rays required for: \u2022 More than 4 restorations per year. \u2022 Two or more 3 or 4 surface restorations per visit. \u2022 More than 2 anterior restorations per visit. \u2022 Multiple restorations on an anterior tooth on the same service date. \u2022 Any 3- or 4 surface restorations on wisdom teeth with supporting x-rays.",
    "crucialRules": "For extraction and restorations codes tooth numbers should not cross posterior quadrants but should be in a combination of 1st and 4th quadrants or 2nd and 3rd quadrants per visit. 1 Restoration code per tooth number in a 9 month period. Motivation required for code 8104 if no covered clinical procedure is charged.",
    "notes": "If a procedure does not attract benefit; all other treatment costs associated with the specific event does not receive benefit. 1. Very basic option 2. Lower rate applies to non network provider 3. Patient written consent needed for procedures not covered",
    "source": "https://dentalrisk.com/member-benefits/",
    "lastUpdated": "Jan-26"
  },
  {
    "scheme": "DISCOVERY HEALTH",
    "plan": "LA HEALTH KEYPLUS",
    "administrator": "DRC",
    "contactInfo": {
      "email": [
        "auth@dentalrisk.com or fax 086 687 1285"
      ],
      "fax": [
        " 086 687 1285"
      ],
      "phone": [
        "0860 445 566"
      ]
    },
    "networked": "Yes",
    "nonNetworkedPayment": "No",
    "balancedBilling": "Yes",
    "basicTreatment": "Yes with limitations",
    "rct": "No",
    "dentures": "No",
    "crownsOrBridges": "No",
    "implants": "No",
    "surgicalExtractions": "No",
    "exclusions": "Sterilised instrumentation will only be paid if code 8731, 9013, 9011, 8201 or 8202 is claimed. 8132 cannot be claimed with 8131 or any restoration, root canal and extraction codes. Maximum of 1 per treatment date. Not covered on primary teeth.. Replacement of non-carious amalgam with resin. Restorations on non-functional wisdom teeth. No Panorex. No Crown &, Bridges, Ortho, Implants or Roor canal Fillings.",
    "preAuth": "X-ray: Pre-auth when quantity is more than the following: With 8101, 8112x2 and 8107x1, \uf0b7 With 8104, 8112x1 or 8107x1. No consult 8112x1 or 8107x1, Maximum quantity of 7 per year. Pulp removal 8132 cannot be claimed with 8131 or any restoration, root canal and extraction codes. The subsequent restoration will need to be pre-authorised with an emailed or scanned x-ray to show the complete root canal. Extraction Codes: Maximum 1 x 8201 per quadrant per visit. \u2022 More than 4 extractions per visit require pre-authorisation. Restoration Codes: Pre-authorisation and x-rays required for: \u2022 More than 4 restorations per year. \u2022 Two or more 3 or 4 surface restorations per visit. \u2022 More than 2 anterior restorations per visit. \u2022 Multiple restorations on an anterior tooth on the same service date. \u2022 Any 3- or 4 surface restorations on wisdom teeth with supporting x-rays.",
    "crucialRules": "For extraction and restorations codes tooth numbers should not cross posterior quadrants but should be in a combination of 1st and 4th quadrants or 2nd and 3rd quadrants per visit. 1 Restoration code per tooth number in a 9 month period. Motivation required for code 8104 if no covered clinical procedure is charged.",
    "notes": "If a procedure does not attract benefit; all other treatment costs associated with the specific event does not receive benefit. 1. Very basic option 2. Lower rate applies to non network provider 3. Patient written consent needed for procedures not covered",
    "source": "https://dentalrisk.com/member-benefits/",
    "lastUpdated": "Jan-26"
  },
  {
    "scheme": "DISCOVERY HEALTH",
    "plan": "TFG HEALTH",
    "administrator": "DRC",
    "contactInfo": {
      "email": [
        "auth@dentalrisk.com or fax 086 687 1285"
      ],
      "fax": [
        " 086 687 1285"
      ],
      "phone": [
        "0860 445 566"
      ]
    },
    "networked": "Yes",
    "nonNetworkedPayment": "No",
    "balancedBilling": "Yes",
    "basicTreatment": "Yes with limitations",
    "rct": "No",
    "dentures": "No",
    "crownsOrBridges": "No",
    "implants": "No",
    "surgicalExtractions": "No",
    "exclusions": "Sterilised instrumentation will only be paid if code 8731, 9013, 9011, 8201 or 8202 is claimed. 8132 cannot be claimed with 8131 or any restoration, root canal and extraction codes. Maximum of 1 per treatment date. Not covered on primary teeth.. Replacement of non-carious amalgam with resin. Restorations on non-functional wisdom teeth. No Panorex. No Crown &, Bridges, Ortho, Implants or Roor canal Fillings.",
    "preAuth": "X-ray: Pre-auth when quantity is more than the following: With 8101, 8112x2 and 8107x1, \uf0b7 With 8104, 8112x1 or 8107x1. No consult 8112x1 or 8107x1, Maximum quantity of 7 per year. Pulp removal 8132 cannot be claimed with 8131 or any restoration, root canal and extraction codes. The subsequent restoration will need to be pre-authorised with an emailed or scanned x-ray to show the complete root canal. Extraction Codes: Maximum 1 x 8201 per quadrant per visit. \u2022 More than 4 extractions per visit require pre-authorisation. Restoration Codes: Pre-authorisation and x-rays required for: \u2022 More than 4 restorations per year. \u2022 Two or more 3 or 4 surface restorations per visit. \u2022 More than 2 anterior restorations per visit. \u2022 Multiple restorations on an anterior tooth on the same service date. \u2022 Any 3- or 4 surface restorations on wisdom teeth with supporting x-rays.",
    "crucialRules": "For extraction and restorations codes tooth numbers should not cross posterior quadrants but should be in a combination of 1st and 4th quadrants or 2nd and 3rd quadrants per visit. 1 Restoration code per tooth number in a 9 month period. Motivation required for code 8104 if no covered clinical procedure is charged.",
    "notes": "If a procedure does not attract benefit; all other treatment costs associated with the specific event does not receive benefit. 1. Very basic option 2. Lower rate applies to non network provider 3. Patient written consent needed for procedures not covered",
    "source": "https://dentalrisk.com/member-benefits/",
    "lastUpdated": "Jan-26"
  },
  {
    "scheme": "DISCOVERY HEALTH",
    "plan": "KEYCARE START REGIONAL",
    "administrator": "DRC",
    "contactInfo": {
      "email": [
        "auth@dentalrisk.com or fax 086 687 1285"
      ],
      "fax": [
        " 086 687 1285"
      ],
      "phone": [
        "0860 445 566"
      ]
    },
    "networked": "Yes",
    "nonNetworkedPayment": "No",
    "balancedBilling": "Yes",
    "basicTreatment": "Yes with limitations",
    "rct": "No",
    "dentures": "No",
    "crownsOrBridges": "No",
    "implants": "No",
    "surgicalExtractions": "No",
    "exclusions": "Sterilised instrumentation will only be paid if code 8731, 9013, 9011, 8201 or 8202 is claimed. 8132 cannot be claimed with 8131 or any restoration, root canal and extraction codes. Maximum of 1 per treatment date. Not covered on primary teeth.. Replacement of non-carious amalgam with resin. Restorations on non-functional wisdom teeth. No Panorex. No Crown &, Bridges, Ortho, Implants or Roor canal Fillings.",
    "preAuth": "X-ray: Pre-auth when quantity is more than the following: With 8101, 8112x2 and 8107x1, \uf0b7 With 8104, 8112x1 or 8107x1. No consult 8112x1 or 8107x1, Maximum quantity of 7 per year. Pulp removal 8132 cannot be claimed with 8131 or any restoration, root canal and extraction codes. The subsequent restoration will need to be pre-authorised with an emailed or scanned x-ray to show the complete root canal. Extraction Codes: Maximum 1 x 8201 per quadrant per visit. \u2022 More than 4 extractions per visit require pre-authorisation. Restoration Codes: Pre-authorisation and x-rays required for: \u2022 More than 4 restorations per year. \u2022 Two or more 3 or 4 surface restorations per visit. \u2022 More than 2 anterior restorations per visit. \u2022 Multiple restorations on an anterior tooth on the same service date. \u2022 Any 3- or 4 surface restorations on wisdom teeth with supporting x-rays.",
    "crucialRules": "For extraction and restorations codes tooth numbers should not cross posterior quadrants but should be in a combination of 1st and 4th quadrants or 2nd and 3rd quadrants per visit. 1 Restoration code per tooth number in a 9 month period. Motivation required for code 8104 if no covered clinical procedure is charged.",
    "notes": "If a procedure does not attract benefit; all other treatment costs associated with the specific event does not receive benefit. 1. Very basic option 2. Lower rate applies to non network provider 3. Patient written consent needed for procedures not covered",
    "source": "https://dentalrisk.com/member-benefits/",
    "lastUpdated": "Jan-26"
  },
  {
    "scheme": "Enablemed",
    "plan": "Makoti Primary Option",
    "administrator": "DENIS",
    "contactInfo": {
      "email": [
        "crowns@denis.co.za, hospitalenq@denis.co.za, customercare@denis.co.za"
      ],
      "fax": [],
      "phone": [
        "0861 033 647"
      ]
    },
    "networked": "\u00ddes",
    "nonNetworkedPayment": "\u00ddes",
    "balancedBilling": "Yes",
    "basicTreatment": "Yes with limitations",
    "rct": "No",
    "dentures": "No",
    "crownsOrBridges": "No",
    "implants": "No",
    "surgicalExtractions": "No",
    "exclusions": "Plastic Dentures* - No benefit. Partial Chrome Cobalt Frame Dentures* - No benefit. Crown & Bridge - No benefit. Implants - No benefit",
    "preAuth": "Benefit for more than three fillings per beneficiary: Subject to pre-notification. Hospitalisation (General Anaesthetic) Pre-authorisation required - PMB admissions only. Moderate/Deep Sedation in Dental Rooms Pre-authorisation required - Benefit limited to extensive dental treatment",
    "crucialRules": "Benefit for fillings: Granted once per tooth in 720 days. Benefit for extractions only available for procedure code 8201",
    "notes": "All Specialised Dentistry benefits for the Makoti Comprehensive option are subject to a limit of R4 420 per family per year",
    "source": "https://denis.co.za/wp-content/uploads/2025/12/Enablemed-Dental-Benefit-Table-2026-v1.pdf",
    "lastUpdated": "Jan-26"
  },
  {
    "scheme": "Enablemed",
    "plan": "Malcor Plan D",
    "administrator": "DENIS",
    "contactInfo": {
      "email": [
        "crowns@denis.co.za, hospitalenq@denis.co.za, customercare@denis.co.za"
      ],
      "fax": [],
      "phone": [
        "0861 033 647"
      ]
    },
    "networked": "\u00ddes",
    "nonNetworkedPayment": "\u00ddes",
    "balancedBilling": "Yes",
    "basicTreatment": "Yes with limitations",
    "rct": "Yes",
    "dentures": "Yes",
    "crownsOrBridges": "No",
    "implants": "No",
    "surgicalExtractions": "Yes",
    "exclusions": "Partial Chrome Cobalt Frame Dentures* - No benefit. Crown & Bridge - No benefit. Implants - No benefit",
    "preAuth": "Dentures, Hospitalisation and Moderate/Deep Sedation in Dental Rooms must be pre-authorised. Benefit for more than three fillings per beneficiary: Subject to pre-notification. Granted once per tooth in 720 days. Benefit for extractions only available for procedure code 8201. Plastic Dentures* *Pre-authorisation required, Hospitalisation (General Anaesthetic)* *Pre-authorisation required. Moderate/Deep Sedation in Dental Rooms* *Pre-authorisation required",
    "crucialRules": "Benefit for a mouth guard: Benefit available for both the clinical and the associated laboratory fee for a mouth guard (no pre-authorisation required).",
    "notes": "",
    "source": "https://denis.co.za/wp-content/uploads/2025/12/Enablemed-Dental-Benefit-Table-2026-v1.pdf",
    "lastUpdated": "Jan-26"
  },
  {
    "scheme": "Engen",
    "plan": "Engen",
    "administrator": "Discovery",
    "contactInfo": {
      "email": [
        "service@engenmed.co.za or fax 0800 001 615"
      ],
      "fax": [
        " 0800 001 615"
      ],
      "phone": [
        "0800 001 615"
      ]
    },
    "networked": "Yes",
    "nonNetworkedPayment": "\u00ddes",
    "balancedBilling": "Yes",
    "basicTreatment": "Yes with limitations",
    "rct": "Yes",
    "dentures": "Yes",
    "crownsOrBridges": "Yes",
    "implants": "Yes",
    "surgicalExtractions": "Yes",
    "exclusions": "Bleaching of vital teeth, metal inlays in dentures and front teeth. Crowns no benefits. Implants No benefit",
    "preAuth": "Dentistry: maxillo-facial surgery Authorisation Require. Specialised dentistry. Includes: inlays, crowns, bridges,study models, metal-base dentures and the repair thereof,oral medicine, periodontics, orthodontics, prosthodontics, and osseo-integrated implantology. Limited to R10 470 per beneficiary per year, up to a maximum of R18 220 per family",
    "crucialRules": "Basic Dentistry 100% of Fund Rate from MSA. Once MSA is depleted, up to the Primary Care (day-to-day) limit. M R4 934, M + 1 R6 139, M + 2 R7 564, M + 3 R9 318, M + 4+ R10 852",
    "notes": "Benefit confirmation is required for advanced dental.",
    "source": "https://www.discovery.co.za/medical-aid/benefits-and-cover",
    "lastUpdated": "Jan-26"
  },
  {
    "scheme": "Essential Employee Benefits (EEB)",
    "plan": "PEP EXECUTIVE PLAN ESSENTIAL PLAN COMBINATION PLAN ACKERMANS ESSENTIAL PLAN",
    "administrator": "Denis",
    "contactInfo": {
      "email": [
        "customercare@denis.co.za"
      ],
      "fax": [],
      "phone": [
        "0861 445 566"
      ]
    },
    "networked": "There will be no benefit for out-of-network visits and treatment.",
    "nonNetworkedPayment": "No",
    "balancedBilling": "No",
    "basicTreatment": "Yes with limitations",
    "rct": "Root Canal Treatment Emergency only",
    "dentures": "No",
    "crownsOrBridges": "No",
    "implants": "No",
    "surgicalExtractions": "No",
    "exclusions": "There is no benefit for: Root Canal Therapy, Dentures, Specialised Dentistry, Inhalation Sedation in Dental Rooms, Moderate/Deep Sedation in Dental Rooms and Dental Treatment in hospital. NO Panorex.",
    "preAuth": "Maximum of 1 X 8201 per quadrant per visit. \u2022 More than 4 extractions per visit require pre-authorisation. Maximum of 4 fillings per member per annum. 1 Restoration code per tooth number in 365 days. \u2022 Benefits for re-treatment of a tooth subject to managed care \nprotocols. \u2022 Lower jaw posterior fillings involving anaesthetic cannot be performed across the midline.",
    "crucialRules": "Maximum of two X-rays (8107 and/or 8112) per visit per dependant Maximum quantity of seven X-rays (8107 and 8112) per dependant per year in total.",
    "notes": "There will be no benefit for out-of-network visits and treatment.",
    "source": "https://denis.co.za/wp-content/uploads/2025/12/Essential-Employee-Benefits-EEB-Dental-Benefit-Table-2026-v1.pdf",
    "lastUpdated": "Jan-26"
  },
  {
    "scheme": "Essentialmed",
    "plan": "DD 17, 21,25,29, SANLAM PROTEAN",
    "administrator": "DRC",
    "contactInfo": {
      "email": [
        "auth@dentalrisk.com or fax 086 687 1286"
      ],
      "fax": [
        " 086 687 1286"
      ],
      "phone": [
        "087 111 0033 / 087 943 9611"
      ]
    },
    "networked": "Yes",
    "nonNetworkedPayment": "Yes",
    "balancedBilling": "No",
    "basicTreatment": "Yes with limitations",
    "rct": "No",
    "dentures": "No",
    "crownsOrBridges": "No",
    "implants": "No",
    "surgicalExtractions": "No",
    "exclusions": "Complex dental procedures such as crowns, bridges, and orthodontic work are typically not covered, NO PANOREX",
    "preAuth": "More than 4 extractions per visit require pre-authorisation. More than 4 restorations per annum. \u2022 Any 3 or 4 surface restorations on wisdom teeth. \u2022 1 Restoration code per tooth number in a 9-month period. 1 Crown per member up to R4 950 per event within a 24-month period. 1 Root canal treatment up to R2 200 per member per annum.",
    "crucialRules": "Posterior restorations are covered to the value of amalgam restorations",
    "notes": "",
    "source": "https://dentalrisk.com/member-benefits/",
    "lastUpdated": "Jan-26"
  },
  {
    "scheme": "Essentialmed",
    "plan": "DD33, DD37, DD41 & DD45",
    "administrator": "DRC",
    "contactInfo": {
      "email": [
        "auth@dentalrisk.com or fax 086 687 1286"
      ],
      "fax": [
        " 086 687 1286"
      ],
      "phone": [
        "087 111 0033 / 087 943 9611"
      ]
    },
    "networked": "Yes",
    "nonNetworkedPayment": "Yes",
    "balancedBilling": "No",
    "basicTreatment": "Yes with limitations",
    "rct": "Yes",
    "dentures": "No",
    "crownsOrBridges": "Yes",
    "implants": "No",
    "surgicalExtractions": "No",
    "exclusions": "NO PANOREX. NO IMPLANTS. NO ORTHO",
    "preAuth": "More than 4 extractions per visit require pre-authorisation. More than 4 restorations per annum. \u2022 Any 3 or 4 surface restorations on wisdom teeth. \u2022 1 Restoration code per tooth number in a 9-month period.",
    "crucialRules": "Posterior restorations are covered to the value of amalgam restorations)",
    "notes": "",
    "source": "https://dentalrisk.com/member-benefits/",
    "lastUpdated": "Jan-26"
  },
  {
    "scheme": "Essentialmed",
    "plan": "DD49, DD53, DD57 & DD61",
    "administrator": "DRC",
    "contactInfo": {
      "email": [
        "auth@dentalrisk.com or fax 086 687 1286"
      ],
      "fax": [
        " 086 687 1286"
      ],
      "phone": [
        "087 111 0033 / 087 943 9611"
      ]
    },
    "networked": "Yes",
    "nonNetworkedPayment": "Yes",
    "balancedBilling": "No",
    "basicTreatment": "Yes with limitations",
    "rct": "Yes",
    "dentures": "Yes",
    "crownsOrBridges": "Yes",
    "implants": "No",
    "surgicalExtractions": "No",
    "exclusions": "NO PANOREX. NO IMPLANTS. NO ORTHO",
    "preAuth": "2 Root canal treatments up to R2 200 per event per member per annum. 2 Crowns per member up to R4 950 per event within a 24-month period. 1 Denture to the value of R3 000 per policy per annum. More than 4 restorations per annum. \u2022 Any 3 or 4 surface restorations on wisdom teeth. \u2022 1 Restoration code per tooth number in a 9-month period.",
    "crucialRules": "Posterior restorations are covered to the value of amalgam restorations)",
    "notes": "All relevant trauma codes are covered to the maximum of the stated benefits (a policy report/emergency room report is required) Once per year @ R16 971",
    "source": "https://dentalrisk.com/member-benefits/",
    "lastUpdated": "Jan-26"
  },
  {
    "scheme": "Fedhealth",
    "plan": "Myfed",
    "administrator": "DRC",
    "contactInfo": {
      "email": [
        "specialist@medscheme.co.za or fax 086 1100 220"
      ],
      "fax": [
        " 086 1100 220"
      ],
      "phone": [
        "0861 100 220"
      ]
    },
    "networked": "Yes",
    "nonNetworkedPayment": "No",
    "balancedBilling": "No",
    "basicTreatment": "Yes with limitations",
    "rct": "No",
    "dentures": "Yes",
    "crownsOrBridges": "No",
    "implants": "No",
    "surgicalExtractions": "Yes",
    "exclusions": "No metal base to complete or partial dentures allowed. No Panorex.",
    "preAuth": "Any 4 non-surgical extractions per member per year \u2013 ONLY if clinically indicated. Dentures Pre \u2013 authorisation required.",
    "crucialRules": "Restoration Codes; The following is limited to 4 per member per annum: \u2022 Resin restorations (anterior). \u2022 Resin restorations \u2022 Lower jaw posterior fillings involving anaesthetic cannot be performed across the midline. Surgical removal of tooth Maximum 4, restricted to posterior permanent teeth per year.",
    "notes": "1. Lower rate applies to non network provider 2. Patient written consent needed for procedures not covered",
    "source": "https://dentalrisk.com/member-benefits/",
    "lastUpdated": "Jan-26"
  },
  {
    "scheme": "Fedhealth",
    "plan": "Flexifed 2",
    "administrator": "DRC",
    "contactInfo": {
      "email": [
        "specialist@medscheme.co.za or fax 086 1100 220"
      ],
      "fax": [
        " 086 1100 220"
      ],
      "phone": [
        "0861 100 220"
      ]
    },
    "networked": "Yes",
    "nonNetworkedPayment": "No",
    "balancedBilling": "No",
    "basicTreatment": "Yes with limitations",
    "rct": "No",
    "dentures": "Yes",
    "crownsOrBridges": "No",
    "implants": "No",
    "surgicalExtractions": "Yes",
    "exclusions": "No metal base to complete or partial dentures allowed. No Panorex.",
    "preAuth": "Any 4 non-surgical extractions per member per year \u2013 ONLY if clinically indicated. Dentures Pre \u2013 authorisation required.",
    "crucialRules": "Restoration Codes; The following is limited to 4 per member per annum: \u2022 Resin restorations (anterior). \u2022 Resin restorations \u2022 Lower jaw posterior fillings involving anaesthetic cannot be performed across the midline. Surgical removal of tooth Maximum 4, restricted to posterior permanent teeth per year.",
    "notes": "1. Lower rate applies to non network provider 2. Patient written consent needed for procedures not covered",
    "source": "https://dentalrisk.com/member-benefits/",
    "lastUpdated": "Jan-26"
  },
  {
    "scheme": "Fedhealth",
    "plan": "Flexifed3",
    "administrator": "DRC",
    "contactInfo": {
      "email": [
        "specialist@medscheme.co.za or fax 086 1100 220"
      ],
      "fax": [
        " 086 1100 220"
      ],
      "phone": [
        "0861 100 220"
      ]
    },
    "networked": "Yes",
    "nonNetworkedPayment": "No",
    "balancedBilling": "No",
    "basicTreatment": "Yes with limitations",
    "rct": "No",
    "dentures": "Yes",
    "crownsOrBridges": "No",
    "implants": "No",
    "surgicalExtractions": "Yes",
    "exclusions": "No metal base to complete or partial dentures allowed. No Panorex.",
    "preAuth": "Any 4 non-surgical extractions per member per year \u2013 ONLY if clinically indicated. Dentures Pre \u2013 authorisation required.",
    "crucialRules": "Restoration Codes; The following is limited to 4 per member per annum: \u2022 Resin restorations (anterior). \u2022 Resin restorations \u2022 Lower jaw posterior fillings involving anaesthetic cannot be performed across the midline. Surgical removal of tooth Maximum 4, restricted to posterior permanent teeth per year.",
    "notes": "1. Lower rate applies to non network provider 2. Patient written consent needed for procedures not covered",
    "source": "https://dentalrisk.com/member-benefits/",
    "lastUpdated": "Jan-26"
  },
  {
    "scheme": "Fedhealth",
    "plan": "FlexiFed 1 Hospital Plan",
    "administrator": "Medscheme",
    "contactInfo": {
      "email": [
        "authorisations@fedhealth.co.za"
      ],
      "fax": [],
      "phone": [
        "0860 002 153"
      ]
    },
    "networked": "Yes",
    "nonNetworkedPayment": "Yes",
    "balancedBilling": "Yes",
    "basicTreatment": "Yes with limitations",
    "rct": "No",
    "dentures": "No",
    "crownsOrBridges": "No",
    "implants": "No",
    "surgicalExtractions": "Yes",
    "exclusions": "No basic dentistry. No Specialised dentisrty. In-hospital dentistry benefit for children under 7, No benefit.",
    "preAuth": "Surgical extraction of impacted wisdom teeth, You pay a co-payment of R5 100 on the hospital bill",
    "crucialRules": "8104 Consultation for a specific problem: 1 per beneficiary per annum. 8101 Two per member per year. 8107/8112 Maximum 2 per member per year. 8159 Two per member per year. 8161 Between the ages of 3-12 years. Two per member per year. 8163 Patients younger than 14; maximum of 8 per year; 2 per quadrant.",
    "notes": "Preventative Dentistry: Basic dentistry (X-rays, scaling, and polishing) is covered from the Savings account, and once the Threshold is reached, from the Threshold benefit, subject to contracted dentists.",
    "source": "https://www.fedhealth.co.za/documents-and-downloads/?e-filter-a0b3fb3-post_tag=individual-option-brochures",
    "lastUpdated": "Jan-26"
  },
  {
    "scheme": "Fedhealth",
    "plan": "maxima EXEC,",
    "administrator": "Medscheme",
    "contactInfo": {
      "email": [
        "authorisations@fedhealth.co.za"
      ],
      "fax": [],
      "phone": [
        "0860 002 153"
      ]
    },
    "networked": "Yes",
    "nonNetworkedPayment": "Yes",
    "balancedBilling": "Yes",
    "basicTreatment": "Yes with limitations",
    "rct": "Yes",
    "dentures": "Yes",
    "crownsOrBridges": "Yes",
    "implants": "Yes",
    "surgicalExtractions": "Yes",
    "exclusions": "Repairing of teeth damaged due to bruxism, toothbrush abrasion, erosion and fluorosis. Replacement of non-carious amalgam with resin. Repairing of teeth damaged due to bruxism, toothbrush, abrasion, erosion of fluorosis will not be covered.",
    "preAuth": "ADVANCED DENTISTRY Inlays, crowns, bridges, mounted study models, metal base partial dentures, oral surgery, orthodontic treatment, periodontists, prosthodontists and dental technicians Paid from Savings and Threshold. R8 530 per beneficiary per year, R25 470 per family per year before and after Threshold",
    "crucialRules": "Implants, orthognathic surgery Paid from Savings. Does not accumulate to or pay from Threshold. Limited to and included in the advanced dental benefit",
    "notes": "Preventative Dentistry: Basic dentistry (X-rays, scaling, and polishing) is covered from the Savings account, and once the Threshold is reached, from the Threshold benefit, subject to contracted dentists.",
    "source": "https://www.fedhealth.co.za/documents-and-downloads/?e-filter-a0b3fb3-post_tag=individual-option-brochures",
    "lastUpdated": "Jan-26"
  },
  {
    "scheme": "Fedhealth",
    "plan": "maxima PLUS",
    "administrator": "Medscheme",
    "contactInfo": {
      "email": [
        "authorisations@fedhealth.co.za"
      ],
      "fax": [],
      "phone": [
        "0861 002 153"
      ]
    },
    "networked": "Yes",
    "nonNetworkedPayment": "Yes",
    "balancedBilling": "Yes",
    "basicTreatment": "Yes with limitations",
    "rct": "Yes",
    "dentures": "Yes",
    "crownsOrBridges": "Yes",
    "implants": "Yes",
    "surgicalExtractions": "Yes",
    "exclusions": "Repairing of teeth damaged due to bruxism, toothbrush abrasion, erosion and fluorosis. Replacement of non-carious amalgam with resin. Repairing of teeth damaged due to bruxism, toothbrush, abrasion, erosion of fluorosis will not be covered.",
    "preAuth": "ADVANCED DENTISTRY Inlays, crowns, bridges, mounted study models, metal base partial dentures, oral surgery, orthodontic treatment, periodontists, prosthodontists and dental technicians Paid from Savings and Threshold. R8 530 per beneficiary per year, R25 470 per family per year before and after Threshold",
    "crucialRules": "Implants, orthognathic surgery Paid from Savings. Does not accumulate to or pay from Threshold. Limited to and included in the advanced dental benefit",
    "notes": "Preventative Dentistry: Basic dentistry (X-rays, scaling, and polishing) is covered from the Savings account, and once the Threshold is reached, from the Threshold benefit, subject to contracted dentists.",
    "source": "https://www.fedhealth.co.za/documents-and-downloads/?e-filter-a0b3fb3-post_tag=individual-option-brochures",
    "lastUpdated": "Jan-26"
  },
  {
    "scheme": "FISHMED",
    "plan": "STANDARD / PRIMARY",
    "administrator": "Momentum Primary care",
    "contactInfo": {
      "email": [
        "dentalmotivations@carecross.co.za enquiries@fishmed.co.za"
      ],
      "fax": [],
      "phone": [
        "0860 101 159"
      ]
    },
    "networked": "Yes",
    "nonNetworkedPayment": "Yes",
    "balancedBilling": "Yes",
    "basicTreatment": "Yes with limitations",
    "rct": "No",
    "dentures": "Yes",
    "crownsOrBridges": "No",
    "implants": "No",
    "surgicalExtractions": "No",
    "exclusions": "No panorex. Specialised dentistry such as bridges, crowns, surgical extractions, implants, root canals,gold fillings, dentures and braces are not covered",
    "preAuth": "8202 & 8202 Combined maximum of four per year with an additional four allowed upon pre-authorisation. Maximum four restorations per year with an additional four allowed only upon preauthorisation. Posterior amalgam and resin fillings are remunerated at the same tariff. Fishmed Primary and Standard Options: 1 set every year (denture limit subject to overall annual limit",
    "crucialRules": "8102 One per beneficiary per annum. 8104 Not within six weeks of 8101 or 8104. 8107/8112 Maximum four per annum combined, unless otherwise authorised. 8155 & 8159 Once per annum per member (either or 8155) 8161 Maximum of one per child per year for patients younger than 12 years. 8163 Maximum of two per child per year for patients younger than 12 years. 8935 Septic socket treatment Once per tooth.",
    "notes": "Patient written consent needed for procedures not covered.",
    "source": "https://www.primecure.co.za/wp-content/uploads/2025/12/PC-2026-Dental-Manual.pdf",
    "lastUpdated": "Jan-26"
  },
  {
    "scheme": "Gems",
    "plan": "Beryl",
    "administrator": "MHG",
    "contactInfo": {
      "email": [
        "enquiries@gems.gov.za or fax 0860 104 123"
      ],
      "fax": [
        " 0860 104 123"
      ],
      "phone": [
        "0860 104 121"
      ]
    },
    "networked": "Yes",
    "nonNetworkedPayment": "Yes",
    "balancedBilling": "Yes",
    "basicTreatment": "Yes with limitations",
    "rct": "Yes",
    "dentures": "Yes",
    "crownsOrBridges": "No",
    "implants": "No",
    "surgicalExtractions": "Yes",
    "exclusions": "No benefit available for metal frame dentures. No benefit for retreatment of a previously root canal treated tooth",
    "preAuth": "Surgical removal of erupted tooth \u2013 report per tooth Maximum of two (2) removals. Plastic dentures are subject to pre-authorisation. General anaesthesia only applicable to Beneficiaries: \u2022 up to (and including) the age of six (6) years. onscious sedation in rooms for dental services: \u2022 Only applicable to Beneficiaries up to and including the age of nine (9) years; Plastic dentures are subject to pre-authorisation. No benefit is available for metal frame dentures. Any four (4) amalgam fillings per beneficiary per year; limited to four (4) restorations overall, and once per tooth in 720 days. (4) resin fillings per beneficiary per year (anterior); limited to four (4) restorations overall.",
    "crucialRules": "Root canal therapy is limited to one (1) complete event per beneficiary in 12 months. \u2022 An event relates to only one (1) root canal treatment on one (1) tooth per beneficiary per year. \u2022 No benefit for retreatment of a previously root canal treated tooth. ntraoral radiographs \u2013 periapical, per film Maximum of six (6) per beneficiary per year. Bitewings Maximum of four (4) per beneficiary per year. Any four (4) non-surgical extractions. 8201 Extraction of tooth or exposed tooth roots Any four (4) non-surgical extractions per beneficiary per year. Root canal therapy \u2013 anteriors and premolars, first canal Limited to once per tooth per lifetime and one (1) complete root canal.",
    "notes": "Patient written consent needed for procedures not covered. 8937 Maximum of two (2) removals. 8213 Maximum of two (2) procedure \u2013 more than one (1) requires clinical motivation. Any four (4) non-surgical extractions\nper beneficiary per year; only if clinically indicated.",
    "source": "https://www.gems.gov.za/Healthcare-Providers/Provider-Guides",
    "lastUpdated": "Jan-26"
  },
  {
    "scheme": "Gems",
    "plan": "Tanzanite One",
    "administrator": "MHG",
    "contactInfo": {
      "email": [
        "enquiries@gems.gov.za or fax 0860 104 123"
      ],
      "fax": [
        " 0860 104 123"
      ],
      "phone": [
        "0860 104 121"
      ]
    },
    "networked": "Yes",
    "nonNetworkedPayment": "Yes",
    "balancedBilling": "Yes",
    "basicTreatment": "Yes with limitations",
    "rct": "Yes",
    "dentures": "Yes",
    "crownsOrBridges": "No",
    "implants": "No",
    "surgicalExtractions": "Yes",
    "exclusions": "No benefit available for metal frame dentures. No benefit for retreatment of a previously root canal treated tooth",
    "preAuth": "Surgical removal of erupted tooth \u2013 report per tooth Maximum of two (2) removals. Plastic dentures are subject to pre-authorisation. General anaesthesia only applicable to Beneficiaries: \u2022 up to (and including) the age of six (6) years. onscious sedation in rooms for dental services: \u2022 Only applicable to Beneficiaries up to and including the age of nine (9) years; Plastic dentures are subject to pre-authorisation. No benefit is available for metal frame dentures. Any four (4) amalgam fillings per beneficiary per year; limited to four (4) restorations overall, and once per tooth in 720 days. (4) resin fillings per beneficiary per year (anterior); limited to four (4) restorations overall.",
    "crucialRules": "Root canal therapy is limited to one (1) complete event per beneficiary in 12 months. \u2022 An event relates to only one (1) root canal treatment on one (1) tooth per beneficiary per year. \u2022 No benefit for retreatment of a previously root canal treated tooth. ntraoral radiographs \u2013 periapical, per film Maximum of six (6) per beneficiary per year. Bitewings Maximum of four (4) per beneficiary per year. Any four (4) non-surgical extractions. 8201 Extraction of tooth or exposed tooth roots Any four (4) non-surgical extractions per beneficiary per year. Root canal therapy \u2013 anteriors and premolars, first canal Limited to once per tooth per lifetime and one (1) complete root canal.",
    "notes": "Patient written consent needed for procedures not covered. 8937 Maximum of two (2) removals. 8213 Maximum of two (2) procedure \u2013 more than one (1) requires clinical motivation. Any four (4) non-surgical extractions\nper beneficiary per year; only if clinically indicated.",
    "source": "https://www.gems.gov.za/Healthcare-Providers/Provider-Guides",
    "lastUpdated": "Jan-26"
  },
  {
    "scheme": "Gems",
    "plan": "Emerald / EMERALD VALUE",
    "administrator": "MHG",
    "contactInfo": {
      "email": [
        "enquiries@gems.gov.za"
      ],
      "fax": [],
      "phone": [
        "0860 436 777"
      ]
    },
    "networked": "Yes",
    "nonNetworkedPayment": "Yes",
    "balancedBilling": "Yes",
    "basicTreatment": "Yes with limitations",
    "rct": "Yes",
    "dentures": "Yes",
    "crownsOrBridges": "Yes",
    "implants": "No",
    "surgicalExtractions": "Yes",
    "exclusions": "Diagnostic dentures \u2022 Snoring apparatus \u2022 Clasp or rest \u2013 cast gold \u2022 Clasp or rest \u2013 wrought gold \u2022 Inlay in denture \u2022 Metal base to full dentures \u2022 Emergency crowns not placed for immediate protection of injured teeth. Temporary and provisional crowns, including laboratory costs. Pontics on second molars. \u2022 On primary teeth or third molars. All implant related clinical and laboratory associated procedures (includes implant placement, cost of components, restorations/crowns/bridges/dentures/repairs associated with implants). Occlusal adjustment minor (pre-authorisation necessary for major occlusal adjustment).",
    "preAuth": "Pre-auth specialised dentistry procedures. \u2022 Implant supported crowns, bridges, and dentures are subject . General anaesthesia, or sedation in the rooms certain maxillofacial surgical procedures. Surgical removal of impacted teeth (In Hospital and Out-of Hospital) And up to and including the age of six (6) years. Conscious sedation in rooms beneficiries up to and including the age of nine (9) years; One (1) set of full, or full upper or full lower, or partial upper and/or partial lower plastic dentures once every four (4) years; relines, rebase, soft base every two (2) years; metal framework every five (5) years. Crowns and bridges . Implant supported crowns Benefit available for Phase 3 implant crowns, bridges and dentures. Surgical removal of impacted teeth (In Hospital and Out-of-Hospital).",
    "crucialRules": "Panoramic radiograph: Benefit from the age of six \u2013 maximum one every 36 months. 8163 Maximum of two (2) per quadrant and once every two (2) years per tooth Metal frames for partial dentures one (1) per jaw and once every five (5) years. Pre-authorisation is required for all therspecialised dentistry procedures. Two (2) annual consultations per beneficiary, one (1) every six (6) months. 8107 (periapical): limited to 10 per beneficiary per 12 months. 8112 (bitewing): Maximum of six (6) per 12 months. 8159 Once every six (6) months \u2013 from the age of 10 only. 8155 Once every six (6) months from the age of three (3) to the age of 16. 8161 F luoride three (3) to the age of 11, once every six (6) months. 8162 f luoride \u2013 adult): From the age of 12 to the age of 16, once every six (6) months. Restorations/fillings Benefits available where clinically indicated \u2013 once per tooth in 720 days.",
    "notes": "Confirmation of benefits is not a guarantee of payment \u2013An authorisation granted is not a guarantee of payment. Patient written consent needed for procedures not covered.",
    "source": "https://www.gems.gov.za/Healthcare-Providers/Provider-Guides",
    "lastUpdated": "Jan-26"
  },
  {
    "scheme": "Gems",
    "plan": "Onyx",
    "administrator": "MHG",
    "contactInfo": {
      "email": [
        "enquiries@gems.gov.za"
      ],
      "fax": [],
      "phone": [
        "0860 436 777"
      ]
    },
    "networked": "Yes",
    "nonNetworkedPayment": "Yes",
    "balancedBilling": "Yes",
    "basicTreatment": "Yes with limitations",
    "rct": "Yes",
    "dentures": "Yes",
    "crownsOrBridges": "Yes",
    "implants": "No",
    "surgicalExtractions": "Yes",
    "exclusions": "Diagnostic dentures \u2022 Snoring apparatus \u2022 Clasp or rest \u2013 cast gold \u2022 Clasp or rest \u2013 wrought gold \u2022 Inlay in denture \u2022 Metal base to full dentures \u2022 Emergency crowns not placed for immediate protection of injured teeth. Temporary and provisional crowns, including laboratory costs. Pontics on second molars. \u2022 On primary teeth or third molars. All implant related clinical and laboratory associated procedures (includes implant placement, cost of components, restorations/crowns/bridges/dentures/repairs associated with implants). Occlusal adjustment minor (pre-authorisation necessary for major occlusal adjustment).",
    "preAuth": "Pre-auth specialised dentistry procedures. \u2022 Implant supported crowns, bridges, and dentures are subject . General anaesthesia, or sedation in the rooms certain maxillofacial surgical procedures. Surgical removal of impacted teeth (In Hospital and Out-of Hospital) And up to and including the age of six (6) years. Conscious sedation in rooms beneficiries up to and including the age of nine (9) years; One (1) set of full, or full upper or full lower, or partial upper and/or partial lower plastic dentures once every four (4) years; relines, rebase, soft base every two (2) years; metal framework every five (5) years. Crowns and bridges . Implant supported crowns Benefit available for Phase 3 implant crowns, bridges and dentures. Surgical removal of impacted teeth (In Hospital and Out-of-Hospital).",
    "crucialRules": "Panoramic radiograph: Benefit from the age of six \u2013 maximum one every 36 months. 8163 Maximum of two (2) per quadrant and once every two (2) years per tooth Metal frames for partial dentures one (1) per jaw and once every five (5) years. Pre-authorisation is required for all therspecialised dentistry procedures. Two (2) annual consultations per beneficiary, one (1) every six (6) months. 8107 (periapical): limited to 10 per beneficiary per 12 months. 8112 (bitewing): Maximum of six (6) per 12 months. 8159 Once every six (6) months \u2013 from the age of 10 only. 8155 Once every six (6) months from the age of three (3) to the age of 16. 8161 F luoride three (3) to the age of 11, once every six (6) months. 8162 f luoride \u2013 adult): From the age of 12 to the age of 16, once every six (6) months. Restorations/fillings Benefits available where clinically indicated \u2013 once per tooth in 720 days.",
    "notes": "Confirmation of benefits is not a guarantee of payment \u2013An authorisation granted is not a guarantee of payment. Patient written consent needed for procedures not covered",
    "source": "https://www.gems.gov.za/Healthcare-Providers/Provider-Guides",
    "lastUpdated": "Jan-26"
  },
  {
    "scheme": "Gems",
    "plan": "Ruby",
    "administrator": "MHG",
    "contactInfo": {
      "email": [
        "enquiries@gems.gov.za"
      ],
      "fax": [],
      "phone": [
        "0860 436 777"
      ]
    },
    "networked": "Yes",
    "nonNetworkedPayment": "Yes",
    "balancedBilling": "Yes",
    "basicTreatment": "Yes with limitations",
    "rct": "Yes",
    "dentures": "Yes",
    "crownsOrBridges": "Yes",
    "implants": "Yes",
    "surgicalExtractions": "Yes",
    "exclusions": "Diagnostic dentures \u2022 Snoring apparatus \u2022 Clasp or rest \u2013 cast gold \u2022 Clasp or rest \u2013 wrought gold \u2022 Inlay in denture \u2022 Metal base to full dentures \u2022 Emergency crowns not placed for immediate protection of injured teeth. Temporary and provisional crowns, including laboratory costs. Pontics on second molars. \u2022 On primary teeth or third molars. All implant related clinical and laboratory associated procedures (includes implant placement, cost of components, restorations/crowns/bridges/dentures/repairs associated with implants). Occlusal adjustment minor (pre-authorisation necessary for major occlusal adjustment).",
    "preAuth": "Pre-auth specialised dentistry procedures. \u2022 Implant supported crowns, bridges, and dentures are subject . General anaesthesia, or sedation in the rooms certain maxillofacial surgical procedures. Surgical removal of impacted teeth (In Hospital and Out-of Hospital) And up to and including the age of six (6) years. Conscious sedation in rooms beneficiries up to and including the age of nine (9) years; One (1) set of full, or full upper or full lower, or partial upper and/or partial lower plastic dentures once every four (4) years; relines, rebase, soft base every two (2) years; metal framework every five (5) years. Crowns and bridges . Implant supported crowns Benefit available for Phase 3 implant crowns, bridges and dentures. Surgical removal of impacted teeth (In Hospital and Out-of-Hospital).",
    "crucialRules": "Panoramic radiograph: Benefit from the age of six \u2013 maximum one every 36 months. 8163 Maximum of two (2) per quadrant and once every two (2) years per tooth Metal frames for partial dentures one (1) per jaw and once every five (5) years. Pre-authorisation is required for all therspecialised dentistry procedures. Two (2) annual consultations per beneficiary, one (1) every six (6) months. 8107 (periapical): limited to 10 per beneficiary per 12 months. 8112 (bitewing): Maximum of six (6) per 12 months. 8159 Once every six (6) months \u2013 from the age of 10 only. 8155 Once every six (6) months from the age of three (3) to the age of 16. 8161 F luoride three (3) to the age of 11, once every six (6) months. 8162 f luoride \u2013 adult): From the age of 12 to the age of 16, once every six (6) months. Restorations/fillings Benefits available where clinically indicated \u2013 once per tooth in 720 days.",
    "notes": "Confirmation of benefits is not a guarantee of payment \u2013An authorisation granted is not a guarantee of payment. Patient written consent needed for procedures not covered.",
    "source": "https://www.gems.gov.za/Healthcare-Providers/Provider-Guides",
    "lastUpdated": "Jan-26"
  },
  {
    "scheme": "Genesis",
    "plan": "Med 100 (Hospitaal plan with n additional benefits.)",
    "administrator": "Genesis",
    "contactInfo": {
      "email": [
        "fax 0214 474 707"
      ],
      "fax": [],
      "phone": [
        "0860 10 20 10"
      ]
    },
    "networked": "No",
    "nonNetworkedPayment": "Yes",
    "balancedBilling": "Yes",
    "basicTreatment": "Yes with limitations",
    "rct": "Yes",
    "dentures": "Yes",
    "crownsOrBridges": "Yes",
    "implants": "Yes",
    "surgicalExtractions": "Yes",
    "exclusions": "excluding root canal treatment on wisdom teeth. ADVANCED DENTISTRY\n(e.g. orthodontic treatment) No benefit",
    "preAuth": "In Hospital: Cost up to 100% of Scheme Tariff for the surgical removal of bony impacted wisdom teeth, where pathology and pain are directly associated with wisdom teeth.Child beneficiaries, prior to attaining the age of 9 years, for extractions and fillings. Crowns, bridges or dentures limited to the lower of cost or Scheme Tariff, further limited to R5 750. Surgical removal of bony impacted wisdom teeth, where pathology and pain are directly associated with wisdom teeth .",
    "crucialRules": "Three (3) dental oral examinations \u2022 Six (6) fillings \u2022 Tooth extractions \u2022 Plain X-rays and/or wide angle / Panorex imaging limited to the lower of cost or Scheme Tariff further limited to R750 \u2022 Two (2) root canal treatments, excluding root canal treatment on wisdom teeth \u2022 Crowns, bridges or dentures limited to the lower of cost or Scheme Tariff, further limited to R5 750 \u2022 Surgical removal of bony impacted wisdom teeth, where pathology and pain are directly associated with wisdom teeth \u2022 Two (2) scales and polishing \u2022 One (1) dental implant limited to R10 000 per three year financial year cycle of membership",
    "notes": "Two (2) root canal treatments. Six (6) fillings. Tariff for the surgical removal of bony impacted wisdom teeth, where pathology and pain are directly associated with wisdom teeth Limited to the lower of cost or R15 000 per case (all inclusive) Cost up to 100% of Scheme Tariff for child beneficiaries, prior to attaining the age of 9 years, for extractions and fillings (once only, lifetime limit), limited to the lower of cost or R10 000 per case",
    "source": "https://www.genesismedical.co.za/",
    "lastUpdated": "Jan-26"
  },
  {
    "scheme": "Genesis",
    "plan": "Med 200 (Hospitaal plan with n additional benefits.)",
    "administrator": "Genesis",
    "contactInfo": {
      "email": [
        "fax 0214 474 707"
      ],
      "fax": [],
      "phone": [
        "0860 10 20 10"
      ]
    },
    "networked": "No",
    "nonNetworkedPayment": "Yes",
    "balancedBilling": "Yes",
    "basicTreatment": "Yes with limitations",
    "rct": "Yes",
    "dentures": "Yes",
    "crownsOrBridges": "Yes",
    "implants": "Yes",
    "surgicalExtractions": "Yes",
    "exclusions": "No Advanced dentistry (i.e. orthodontic treatment)",
    "preAuth": "child beneficiaries, prior to attaining the age of 9 years, for extractions and fillings. Limited to one (1) hospital admission per beneficiary p.a. Crowns, bridges or dentures limited to the lower of cost or Scheme Tariff, further limited to R5 750. Surgical removal of bony impacted wisdom teeth, where pathology and pain are directly associated with wisdom teeth. One (1) dental implant limited to R10 000 per three year financial year cycle of\nmembership.",
    "crucialRules": "Three (3) dental oral examinations \u2022 Six (6) fillings \u2022 Tooth extractions \u2022 Plain X-rays and/or wide angle / Panorex imaging limited to the lower of cost or Scheme Tariff further limited to R750 \u2022 Two (2) root canal treatments, excluding root canal treatment on wisdom teeth \u2022\u2022 Two (2) scales and polishing.",
    "notes": "Two (2) root canal treatments. Six (6) fillings. \nHospital plan with generous day-to-day benefits. Doctors covered at 200% of Scheme Tariff. Bonus: Includes day-to-day dentistry benefits.",
    "source": "https://www.genesismedical.co.za/",
    "lastUpdated": "Jan-26"
  },
  {
    "scheme": "Genesis",
    "plan": "Med 200 Plus",
    "administrator": "Genesis",
    "contactInfo": {
      "email": [
        "fax 0214 474 707"
      ],
      "fax": [],
      "phone": [
        "0860 10 20 10"
      ]
    },
    "networked": "No",
    "nonNetworkedPayment": "Yes",
    "balancedBilling": "Yes",
    "basicTreatment": "Yes with limitations",
    "rct": "Yes",
    "dentures": "Yes",
    "crownsOrBridges": "Yes",
    "implants": "Yes",
    "surgicalExtractions": "Yes",
    "exclusions": "No Advanced dentistry (i.e. orthodontic treatment)",
    "preAuth": "child beneficiaries, prior to attaining the age of 9 years, for extractions and fillings. Limited to one (1) hospital admission per beneficiary p.a. Crowns, bridges or dentures limited to the lower of cost or Scheme Tariff, further limited to R5 750. Surgical removal of bony impacted wisdom teeth, where pathology and pain are directly associated with wisdom teeth. One (1) dental implant limited to R10 000 per three year financial year cycle of membership.",
    "crucialRules": "Three (3) dental oral examinations \u2022 Six (6) fillings \u2022 Tooth extractions \u2022 Plain X-rays and/or wide angle / Panorex imaging limited to the lower of cost or Scheme Tariff further limited to R750 \u2022 Two (2) root canal treatments, excluding root canal treatment on wisdom teeth \u2022\u2022 Two (2) scales and polishing.",
    "notes": "Two (2) root canal treatments. Six (6) fillings.\nHospital plan with generous day-to-day benefits. Doctors covered at 200% of Scheme Tariff. Bonus: Includes day-to-day dentistry benefits.",
    "source": "https://www.genesismedical.co.za/",
    "lastUpdated": "Jan-26"
  },
  {
    "scheme": "GENRIC",
    "plan": "COMPREHENSIVE ADVANCED, COMPREHENSIVE PLUS,\nCOMPREHENSIVE STANDARD, PRIMARY STANDARD & PRIMARY \nSTANDARD WITH HOSPITAL PLAN",
    "administrator": "Denis",
    "contactInfo": {
      "email": [
        "customercare@denis.co.za"
      ],
      "fax": [],
      "phone": [
        "0862 445 566"
      ]
    },
    "networked": "There will be no benefit for out-of-network visits and treatment.",
    "nonNetworkedPayment": "No",
    "balancedBilling": "No",
    "basicTreatment": "Yes with limitations",
    "rct": "Root Canal Treatment Emergency only",
    "dentures": "No",
    "crownsOrBridges": "No",
    "implants": "No",
    "surgicalExtractions": "No",
    "exclusions": "There is no benefit for: Root Canal Therapy, Dentures, Specialised Dentistry, Inhalation Sedation in Dental Rooms, Moderate/Deep Sedation in Dental Rooms and Dental Treatment in hospital. NO Panorex.",
    "preAuth": "Maximum of 1 X 8201 per quadrant per visit. \u2022 More than 4 extractions per visit require pre-authorisation. Posterior restorations are covered to the value of amalgam restorations. Pre-authorisation required for more than 4 restorations per year. \u2022 Pre-authorisation and x-rays are required for any 3 or 4 surface restorations on wisdom teeth. \u2022 1 Restoration code per tooth number in a 9-month period.",
    "crucialRules": "8101 Full mouth examination, Once per 6 months per member from date of service. Code 8107 / 8112 Two per member per visit not more than 4 per year . 8159 & 8155 Once per 6 months per member from date of service.",
    "notes": "There will be no benefit for out-of-network visits and treatment.",
    "source": "https://denis.co.za/wp-content/uploads/2025/12/GENRIC-Health-Insurance-Benefit-Table-2026-v1.pdf",
    "lastUpdated": "Jan-26"
  },
  {
    "scheme": "GETCARE DENTAL TOP-UP",
    "plan": "PRIMARY CARE TOP UP (Plan B TopUp)",
    "administrator": "DRC",
    "contactInfo": {
      "email": [
        "auth@dentalrisk.com or fax 086 687 1286"
      ],
      "fax": [
        " 086 687 1286"
      ],
      "phone": [
        "087 111 0033 / 087 943 9611"
      ]
    },
    "networked": "Yes",
    "nonNetworkedPayment": "Yes",
    "balancedBilling": "Yes",
    "basicTreatment": "Yes with limitations",
    "rct": "No",
    "dentures": "No",
    "crownsOrBridges": "No",
    "implants": "No",
    "surgicalExtractions": "No",
    "exclusions": "Complex dental procedures such as crowns, bridges, and orthodontic work are typically not covered, NO PANOREX",
    "preAuth": "Pre-auth\u2022 More than 4 restorations per annum. \u2022 Three or Four surface restorations done on more than 2 teeth per visit. \u2022 More than 2 anterior restorations per visit. \u2022 Multiple restorations on an anterior tooth on the same service date. \u2022 Lower jaw posterior fillings involving anaesthetic cannot be performed across the midline. \u2022 Any 3 or 4 surface restorations on wisdom teeth. More than 4 extractions per visit require pre-authorisation.",
    "crucialRules": "Provision of heat or vapour sterilised and wrapped instrumentation. Will only be paid if code 8731, 9013, 9011, 8201 or 8202 is claimed.",
    "notes": "",
    "source": "https://dentalrisk.com/member-benefits/",
    "lastUpdated": "Jan-26"
  },
  {
    "scheme": "GETCARE DENTAL TOP-UP",
    "plan": "PRIMARY CARE TOP UP PLUS (Plan B+ TopUp)",
    "administrator": "DRC",
    "contactInfo": {
      "email": [
        "auth@dentalrisk.com or fax 086 687 1286"
      ],
      "fax": [
        " 086 687 1286"
      ],
      "phone": [
        "087 111 0033 / 087 943 9611"
      ]
    },
    "networked": "Yes",
    "nonNetworkedPayment": "Yes",
    "balancedBilling": "Yes",
    "basicTreatment": "Yes with limitations",
    "rct": "No",
    "dentures": "No",
    "crownsOrBridges": "No",
    "implants": "No",
    "surgicalExtractions": "No",
    "exclusions": "Complex dental procedures such as crowns, bridges, and orthodontic work are typically not covered, NO PANOREX",
    "preAuth": "Pre-auth\u2022 More than 4 restorations per annum. \u2022 Three or Four surface restorations done on more than 2 teeth per visit. \u2022 More than 2 anterior restorations per visit. \u2022 Multiple restorations on an anterior tooth on the same service date. \u2022 Lower jaw posterior fillings involving anaesthetic cannot be performed across the midline. \u2022 Any 3 or 4 surface restorations on wisdom teeth. More than 4 extractions per visit require pre-authorisation.",
    "crucialRules": "Provision of heat or vapour sterilised and wrapped instrumentation. Will only be paid if code 8731, 9013, 9011, 8201 or 8202 is claimed.",
    "notes": "",
    "source": "https://dentalrisk.com/member-benefits/",
    "lastUpdated": "Jan-26"
  },
  {
    "scheme": "GETCARE",
    "plan": "PRIMARY CARE (PLAN B)",
    "administrator": "DRC",
    "contactInfo": {
      "email": [
        "auth@dentalrisk.com or fax 086 687 1286"
      ],
      "fax": [
        " 086 687 1286"
      ],
      "phone": [
        "087 111 0033 / 087 943 9611"
      ]
    },
    "networked": "Yes",
    "nonNetworkedPayment": "Yes",
    "balancedBilling": "No",
    "basicTreatment": "Yes with limitations",
    "rct": "No",
    "dentures": "No",
    "crownsOrBridges": "No",
    "implants": "No",
    "surgicalExtractions": "No",
    "exclusions": "Complex dental procedures such as crowns, bridges, and orthodontic work are typically not covered, NO PANOREX",
    "preAuth": "Pre-auth\u2022 More than 4 restorations per annum. \u2022 Three or Four surface restorations done on more than 2 teeth per visit. \u2022 More than 2 anterior restorations per visit. \u2022 Multiple restorations on an anterior tooth on the same service date. \u2022 Lower jaw posterior fillings involving anaesthetic cannot be performed across the midline. \u2022 Any 3 or 4 surface restorations on wisdom teeth.",
    "crucialRules": "NO PANOREX",
    "notes": "Maximum of R1 700 per family per annum (double the benefit on accidental injury)",
    "source": "https://dentalrisk.com/member-benefits/",
    "lastUpdated": "Jan-26"
  },
  {
    "scheme": "GETCARE",
    "plan": "PRIMARY CARE PLUS (PLAN B+)",
    "administrator": "DRC",
    "contactInfo": {
      "email": [
        "auth@dentalrisk.com or fax 086 687 1286"
      ],
      "fax": [
        " 086 687 1286"
      ],
      "phone": [
        "087 111 0033 / 087 943 9611"
      ]
    },
    "networked": "Yes",
    "nonNetworkedPayment": "Yes",
    "balancedBilling": "No",
    "basicTreatment": "Yes with limitations",
    "rct": "No",
    "dentures": "No",
    "crownsOrBridges": "No",
    "implants": "No",
    "surgicalExtractions": "No",
    "exclusions": "Complex dental procedures such as crowns, bridges, and orthodontic work are typically not covered, NO PANOREX",
    "preAuth": "Pre-auth\u2022 More than 4 restorations per annum. \u2022 Three or Four surface restorations done on more than 2 teeth per visit. \u2022 More than 2 anterior restorations per visit. \u2022 Multiple restorations on an anterior tooth on the same service date. \u2022 Lower jaw posterior fillings involving anaesthetic cannot be performed across the midline. \u2022 Any 3 or 4 surface restorations on wisdom teeth.",
    "crucialRules": "NO PANOREX",
    "notes": "Maximum of R1 700 per family per annum (double the benefit on accidental injury)",
    "source": "https://dentalrisk.com/member-benefits/",
    "lastUpdated": "Jan-26"
  },
  {
    "scheme": "Glencore",
    "plan": "Glencore",
    "administrator": "Discovery",
    "contactInfo": {
      "email": [
        ""
      ],
      "fax": [],
      "phone": [
        "0860 00 21 41"
      ]
    },
    "networked": "Yes",
    "nonNetworkedPayment": "No",
    "balancedBilling": "Yes",
    "basicTreatment": "Yes with limitations",
    "rct": "Yes",
    "dentures": "Yes",
    "crownsOrBridges": "Yes",
    "implants": "Yes",
    "surgicalExtractions": "Yes",
    "exclusions": "Diagnostic dentures \u2022 Snoring apparatus \u2022 Clasp or rest \u2013 cast gold \u2022 Clasp or rest \u2013 wrought gold \u2022 Inlay in denture \u2022 Metal base to full dentures \u2022 Emergency crowns not placed for immediate protection of injured teeth. Temporary and provisional crowns, including laboratory costs. Pontics on second molars. \u2022 On primary teeth or third molars. All implant related clinical and laboratory associated procedures (includes implant placement, cost of components, restorations/crowns/bridges/dentures/repairs associated with implants). Occlusal adjustment minor (pre-authorisation necessary for major occlusal adjustment).",
    "preAuth": "in hospital for children under eight (8) and for removal of impacted wisdom teeth. Advanced dental crowns bridges, implants,ortho, metalbase dentures, inlays and study models pre auth. Basic dental,and plastic dentures, R 18430",
    "crucialRules": "Panorex once every 3 years.",
    "notes": "Basic: Includes plastic dentures and basic dentistry performed in-hospital for children under eight (8) and for removal of impacted wisdom teeth. Advanced: Oral surgery, metal base dentures, inlays, crowns, bridges, study models, orthodontics, periodontics, prosthodontics, osseointegrated implants, orthognathic surgery and dental technician fees.",
    "source": "https://www.glencoremedicalscheme.co.za/wcm/medical-schemes/glencore/assets/benefit-guides/2026/glencore-benefit-guide.pdf",
    "lastUpdated": "Jan-26"
  },
  {
    "scheme": "GOLDEN ARROW",
    "plan": "PRIMARY, STANDARD, ADVANCED",
    "administrator": "Momentum Primary care",
    "contactInfo": {
      "email": [
        "enquiries@goldenarrowmed.co.za"
      ],
      "fax": [],
      "phone": [
        "0860 104 122"
      ]
    },
    "networked": "Yes",
    "nonNetworkedPayment": "Yes",
    "balancedBilling": "Yes",
    "basicTreatment": "Yes with limitations",
    "rct": "No",
    "dentures": "Yes",
    "crownsOrBridges": "No",
    "implants": "No",
    "surgicalExtractions": "No",
    "exclusions": "No panorex. Specialised dentistry such as bridges, crowns, surgical extractions, implants, root canals,gold fillings, dentures and braces are not covered",
    "preAuth": "8203 & 8202 Combined maximum of four per year with an additional four allowed upon pre-authorisation. Maximum four restorations per year with an additional four allowed only upon preauthorisation. Posterior amalgam and resin fillings are remunerated at the same tariff. Fishmed Primary and Standard Options: 1 set every year (denture limit subject to overall annual limit",
    "crucialRules": "8103 One per beneficiary per annum. 8104 Not within six weeks of 8101 or 8104. 8107/8112 Maximum four per annum combined, unless otherwise authorised. 8155 & 8159 Once per annum per member (either or 8155) 8161 Maximum of one per child per year for patients younger than 12 years. 8163 Maximum of two per child per year for patients younger than 12 years. 8935 Septic socket treatment Once per tooth.",
    "notes": "Annual limit: Single member: R7 900 Member + 1: R9 500 Member + 2: R11 200 Member + 3: R11 400 Member + 4: R11 700",
    "source": "https://www.primecure.co.za/wp-content/uploads/2025/12/PC-2026-Dental-Manual.pdf",
    "lastUpdated": "Jan-26"
  },
  {
    "scheme": "Health4me",
    "plan": "SILVER & GOLD",
    "administrator": "Momentum Primary care",
    "contactInfo": {
      "email": [
        "dentalmotivations@carecross.co.za",
        "drnet@momentum.co.za"
      ],
      "fax": [],
      "phone": [
        "0860 101 159"
      ]
    },
    "networked": "Yes",
    "nonNetworkedPayment": "No",
    "balancedBilling": "Yes",
    "basicTreatment": "Yes with limitations",
    "rct": "No",
    "dentures": "Yes",
    "crownsOrBridges": "No",
    "implants": "No",
    "surgicalExtractions": "No",
    "exclusions": "No panorex. Specialised dentistry such as bridges, crowns, surgical extractions, implants, root canals,gold fillings, dentures and braces are not covered",
    "preAuth": "8201 & 8202 Combined maximum of four per year with an additional four allowed upon pre-authorisation. Maximum four restorations per year with an additional four allowed only upon preauthorisation. Posterior amalgam and resin fillings are remunerated at the same tariff. More than four Xrays per annum combined, unless otherwise authorised.",
    "crucialRules": "8101 One per beneficiary per annum. 8104 Not within six weeks of 8101 or 8104. 8155 & 8159 Once per annum per member (either or 8155) 8161 Maximum of one per child per year for patients younger than 12 years. 8163 Maximum of two per child per year for patients younger than 12 years. 8935 Septic socket treatment Once per tooth. Emergency root canal treatment Not covered on primary teeth.",
    "notes": "Member consent for out-of-benefit dental procedures form. On the network options, members only have benefits for general extractions. Should you need to do a surgical removal of a tooth, patients need to be informed of this prior to or on the day of service for the patient to be held responsible for the outstanding amount.",
    "source": "https://www.primecure.co.za/wp-content/uploads/2025/12/PC-2026-Dental-Manual.pdf",
    "lastUpdated": "Jan-26"
  },
  {
    "scheme": "Horizon",
    "plan": "HOSPITAL PLUS NETWORK PLAN",
    "administrator": "Momentum Primary care",
    "contactInfo": {
      "email": [
        "dentalmotivations@carecross.co.za",
        "info@horizon.co.za"
      ],
      "fax": [],
      "phone": [
        "0860 103 493"
      ]
    },
    "networked": "Yes",
    "nonNetworkedPayment": "Yes",
    "balancedBilling": "Yes",
    "basicTreatment": "Yes with limitations",
    "rct": "No",
    "dentures": "Yes",
    "crownsOrBridges": "No",
    "implants": "No",
    "surgicalExtractions": "No",
    "exclusions": "No panorex. Specialised dentistry such as bridges, crowns, surgical extractions, implants, root canals,gold fillings, dentures and braces are not covered",
    "preAuth": "8201 & 8202 Combined maximum of four per year with an additional four allowed upon pre-authorisation. Maximum four restorations per year with an additional four allowed only upon preauthorisation. Posterior amalgam and resin fillings are remunerated at the same tariff.",
    "crucialRules": "8101 One per beneficiary per annum. 8104 Not within six weeks of 8101 or 8104. 8107/8112 Maximum four per annum combined, unless otherwise authorised. 8155 & 8159 Once per annum per member (either or 8155) 8161 Maximum of one per child per year for patients younger than 12 years. 8163 Maximum of two per child per year for patients younger than 12 years. 8935 Septic socket treatment Once per tooth.",
    "notes": "Patient written consent needed for procedures not covered.",
    "source": "https://www.primecure.co.za/wp-content/uploads/2025/12/PC-2026-Dental-Manual.pdf",
    "lastUpdated": "Jan-26"
  },
  {
    "scheme": "IMPERIAL MOTUS",
    "plan": "HEALTH PLAN",
    "administrator": "Momentum Primary care",
    "contactInfo": {
      "email": [
        "dentalauths@imperialmotusmed.co.za"
      ],
      "fax": [],
      "phone": [
        "0860 467 374"
      ]
    },
    "networked": "Yes",
    "nonNetworkedPayment": "Yes",
    "balancedBilling": "Yes",
    "basicTreatment": "Yes with limitations",
    "rct": "No",
    "dentures": "Yes",
    "crownsOrBridges": "No",
    "implants": "No",
    "surgicalExtractions": "No",
    "exclusions": "Repairing of teeth damaged due to bruxism, toothbrush abrasion, erosion and fluorosis. Replacement of non-carious amalgam with resin. Repairing of teeth damaged due to bruxism, toothbrush, abrasion, erosion of fluorosis will not be covered .",
    "preAuth": "Pre-authorisation required, Inlays, onlays, veneers, crowns and bridges, Plastic dentures with a cast-metal framework, Dental implants,Wisdom teeth extractions. R13 310 per family per annum Pre-authorisation required.",
    "crucialRules": "Scaling and/or polishing and fluoride treatment Two per beneficiary per annum. Fissure sealing Once-off for permanent molars in persons under 24 years. Oral examination, Diagnostics (X-rays, etc.), Restorations (fillings),Non-surgical extractions, Root canal treatment. R4 660 per beneficiary per annum.",
    "notes": "Scaling and/or polishing: wo per beneficiary per annum",
    "source": "https://www.primecure.co.za/wp-content/uploads/2025/12/PC-2026-Dental-Manual.pdf",
    "lastUpdated": "Jan-26"
  },
  {
    "scheme": "IMPERIAL MOTUS MED",
    "plan": "BUDGET PLAN",
    "administrator": "Momentum Primary care",
    "contactInfo": {
      "email": [
        "dentalauths@imperialmotusmed.co.za"
      ],
      "fax": [],
      "phone": [
        "0860 467 375"
      ]
    },
    "networked": "Yes",
    "nonNetworkedPayment": "Yes",
    "balancedBilling": "Yes",
    "basicTreatment": "Yes with limitations",
    "rct": "No",
    "dentures": "Yes",
    "crownsOrBridges": "No",
    "implants": "No",
    "surgicalExtractions": "No",
    "exclusions": "No panorex. Specialised dentistry such as bridges, crowns, surgical extractions, implants, root canals,gold fillings, dentures and braces are not covered",
    "preAuth": "8201 & 8202 Combined maximum of four per year with an additional four allowed upon pre-authorisation. Maximum four restorations per year with an additional four allowed only upon preauthorisation. Posterior amalgam and resin fillings are remunerated at the same tariff.",
    "crucialRules": "8101 One per beneficiary per annum. 8104 Not within six weeks of 8101 or 8104. 8107/8112 Maximum four per annum combined, unless otherwise authorised. 8155 & 8159 Once per annum per member (either or 8155) 8161 Maximum of one per child per year for patients younger than 12 years. 8163 Maximum of two per child per year for patients younger than 12 years. 8935 Septic socket treatment Once per tooth.",
    "notes": "Basic dentistry : Oral examination \u00bb Diagnostics (X-rays, etc.) Restorations (fillings) Non-surgical extractions \u00bb Root canal treatment. 85% of MSR R2 970 per family per annum.",
    "source": "",
    "lastUpdated": "Jan-26"
  },
  {
    "scheme": "Ingwe",
    "plan": "Primary Care Network and Ingwe Active Network Options",
    "administrator": "Momentum Primary care",
    "contactInfo": {
      "email": [
        "dental@momentumhealth.co.za"
      ],
      "fax": [],
      "phone": [
        "0860 101 159"
      ]
    },
    "networked": "Yes",
    "nonNetworkedPayment": "Yes",
    "balancedBilling": "No",
    "basicTreatment": "Yes with limitations",
    "rct": "No",
    "dentures": "Yes",
    "crownsOrBridges": "No",
    "implants": "No",
    "surgicalExtractions": "No",
    "exclusions": "No panorex. Specialised dentistry such as bridges, crowns, surgical extractions, implants, root canals,gold fillings, dentures and braces are not covered",
    "preAuth": "8201 & 8202 Combined maximum of four per year with an additional four allowed upon pre-authorisation. Maximum four restorations per year with an additional four allowed only upon preauthorisation. Posterior amalgam and resin fillings are remunerated at the same tariff.",
    "crucialRules": "8101 One per beneficiary per annum. 8104 Not within six weeks of 8101 or 8104. 8107/8112 Maximum four per annum combined, unless otherwise authorised. 8155 & 8159 Once per annum per member (either or 8155) 8161 Maximum of one per child per year for patients younger than 12 years. 8163 Maximum of two per child per year for patients younger than 12 years. 8935 Septic socket treatment Once per tooth.",
    "notes": "Patient written consent needed for procedures not covered.",
    "source": "https://content.momentum.co.za/mmsa/complete_health/pdfs/Sales%20Tools/Provider%20Search/2026/2026_MHS_Dental_Network_guide_54.pdf",
    "lastUpdated": "Jan-26"
  },
  {
    "scheme": "Kaelo Health",
    "plan": "MyHealth Plus",
    "administrator": "PRIMECURE",
    "contactInfo": {
      "email": [
        "hospital authorisation primecure@mhs.co.za"
      ],
      "fax": [],
      "phone": [
        "0861 497 587"
      ]
    },
    "networked": "Yes",
    "nonNetworkedPayment": "Yes",
    "balancedBilling": "No",
    "basicTreatment": "Yes with limitations",
    "rct": "No",
    "dentures": "Yes",
    "crownsOrBridges": "No",
    "implants": "No",
    "surgicalExtractions": "No",
    "exclusions": "Panoramic and other extra oral x-rays (e.g., 8115) does not form part of the benefit schedule. Surgical extractions are not covered.",
    "preAuth": "8935 Treatment of septic socket First treatment no authorisation is required. For second treatment and onward authorisation is necessary (historic treatment of 8201/8202). Extractions - Pre-Authorisation is needed for four or more extractions per beneficiary per year. One (1) surgical extraction per beneficiary per year. Must be authorised . 8941 Surgical removal of impacted tooth - first tooth, 8943 Surgical removal of impacted tooth - second tooth. 8162 needs to be authorised. Fillings - White/Resin (anterior only) or Amalgam posterior - Note: Posterior Resin fillings will be paid for at Amalgam rates. Denture are limited to pre-authorisation. Dentures, reline, rebase and all specialised dentistry - Partial dentures. Conscious sedation pre auth. Inhalation sedation: under 7 years of age.",
    "crucialRules": "8101 Consultation oral examination Once per year, 8104 Examination for a specific problem not requiring full mouth examination. 8107, 8112 Intra oral radiographs/Bite Wing X-rays, per film (maximum of four X-rays per family per year). 8155 Polishing only Once a year for ages 3-12yrs.8159 Scaling and polishing Once a year over the age 12 yrs 8161 Topical application of fluoride Once a year for ages 3 to 12 yrs. 8132 Gross pulpal debridement, primary & permanent teeth (emergency root canal). Pre-authorisation if a patient neesd repairs to four or more teeth (including fillings) per person per year. One (1) consultations/ examinations code 8101 per beneficiary per year.",
    "notes": "8201, 8202 Extraction, single tooth. Code 8201 is charged for the first extraction in a quadrant. Maximum for 8201 & 8202 is three (3), thereafter pre-authorisation required for the first extraction in a quad-rant.",
    "source": "https://www.primecure.co.za/wp-content/uploads/2025/12/PC-2026-Dental-Manual.pdf",
    "lastUpdated": "Jan-26"
  },
  {
    "scheme": "Kaelo Health",
    "plan": "MyHealth Core",
    "administrator": "Primecure",
    "contactInfo": {
      "email": [
        "hospital authorisation primecure@mhs.co.za"
      ],
      "fax": [],
      "phone": [
        "0861 497 587"
      ]
    },
    "networked": "Yes",
    "nonNetworkedPayment": "Yes",
    "balancedBilling": "No",
    "basicTreatment": "Yes with limitations",
    "rct": "No",
    "dentures": "Yes",
    "crownsOrBridges": "No",
    "implants": "No",
    "surgicalExtractions": "No",
    "exclusions": "Panoramic and other extra oral x-rays (e.g., 8115) does not form part of the benefit schedule.",
    "preAuth": "8935 Treatment of septic socket First treatment no authorisation is required. For second treatment and onward authorisation is necessary (historic treatment of 8201/8202). Extractions - Pre-Authorisation is needed for four or more extractions per beneficiary per year. One (1) surgical extraction per beneficiary per year. Must be authorised . 8941 Surgical removal of impacted tooth - first tooth, 8943 Surgical removal of impacted tooth - second tooth. 8162 needs to be authorised. Fillings - White/Resin (anterior only) or Amalgam posterior - Note: Posterior Resin fillings will be paid for at Amalgam rates. Denture are limited to pre-authorisation. Dentures, reline, rebase and all specialised dentistry - Partial dentures. Conscious sedation pre auth. Inhalation sedation: under 7 years of age.",
    "crucialRules": "8101 Consultation oral examination Once per year, 8104 Examination for a specific problem not requiring full mouth examination. 8107, 8112 Intra oral radiographs/Bite Wing X-rays, per film (maximum of four X-rays per family per year). 8155 Polishing only Once a year for ages 3-12yrs.8159 Scaling and polishing Once a year over the age 12 yrs 8161 Topical application of fluoride Once a year for ages 3 to 12 yrs. 8132 Gross pulpal debridement, primary & permanent teeth (emergency root canal). Pre-authorisation if a patient neesd repairs to four or more teeth (including fillings) per person per year. One (1) consultations/ examinations code 8101 per beneficiary per year.",
    "notes": "8201, 8202 Extraction, single tooth. Code 8201 is charged for the first extraction in a quadrant. Maximum for 8201 & 8202 is three (3), thereafter pre-authorisation required for the first extraction in a quad-rant.",
    "source": "https://www.primecure.co.za/wp-content/uploads/2025/12/PC-2026-Dental-Manual.pdf",
    "lastUpdated": "Jan-26"
  },
  {
    "scheme": "Keyhealth",
    "plan": "silver",
    "administrator": "Denis",
    "contactInfo": {
      "email": [
        "keyhealthenq@denis.co.za or fax 0860 104 926"
      ],
      "fax": [
        " 0860 104 926"
      ],
      "phone": [
        "0860 104 926"
      ]
    },
    "networked": "Yes",
    "nonNetworkedPayment": "Yes",
    "balancedBilling": "Yes",
    "basicTreatment": "Yes with limitations",
    "rct": "Yes",
    "dentures": "Yes",
    "crownsOrBridges": "No",
    "implants": "No",
    "surgicalExtractions": "Yes",
    "exclusions": "Partial Chrome Cobalt Frame Dentures No benefit. Crown & Bridge No benefit. Implants No benefit",
    "preAuth": "Benefit for fillings: Granted once per tooth in 720 days, Multiple fillings: A treatment plan and X-rays may be required . Root Canal Therapy and Extractions Benefit subject to managed care protocols . Pre-authorisation required One set of plastic dentures (an upper and a lower) per beneficiary in a 4-year period. Hospitalisation (General Anaesthetic) Pre-authorisation required for children under the age of 5 years for extensive dental treatment . General anaesthetic benefit available for the removal of impacted teeth. Deep Sedation in the Dental Rooms Pre-authorisation required Benefit limited to extensive dental treatment.",
    "crucialRules": "One check-up per beneficiary per year.X-rays: Intraoral Benefit subject to managed care protocols. X-rays: Extraoral One per beneficiary in a 3-year period. Benefit for scale and polish: One scale and polish treatment per beneficiary per year . Benefit for fissure sealants: Limited to beneficiaries younger than 16 years of age. Benefit for fluoride: Limited to beneficiaries from age 5 and younger than 13 years of age",
    "notes": "Benefit not available for the clinical fee of denture repairs, denture tooth replacements and the addition of a soft base to new dentures; the laboratory fee will be covered (no pre authorisation required). Benefit for a mouth guard: Benefit available for both the clinical and the associated laboratory fee for a mouth guard (no preauthorisation required) . All authorised dental cases in Day Clinics will be exempt from a co-payment",
    "source": "https://denis.co.za/wp-content/uploads/2025/12/KeyHealth-Dental-Benefit-Table-2026-v1.pdf",
    "lastUpdated": "Jan-26"
  },
  {
    "scheme": "Keyhealth",
    "plan": "Gold",
    "administrator": "Denis",
    "contactInfo": {
      "email": [
        "keyhealthenq@denis.co.za or fax 0860 104 926"
      ],
      "fax": [
        " 0860 104 926"
      ],
      "phone": [
        "0860 104 926"
      ]
    },
    "networked": "Yes",
    "nonNetworkedPayment": "Yes",
    "balancedBilling": "Yes",
    "basicTreatment": "Yes with limitations",
    "rct": "Yes",
    "dentures": "Yes",
    "crownsOrBridges": "Yes",
    "implants": "No",
    "surgicalExtractions": "Yes",
    "exclusions": "Implants* and Associated Laboratory Costs No benefit",
    "preAuth": "Benefit for fillings: Granted once per tooth in 720 days, Multiple fillings: A treatment plan and X-rays may be required . Root Canal Therapy and Extractions Benefit subject to managed care protocols . Pre-authorisation required One set of plastic dentures per beneficiary in a 4-year period. Partial Chrome Cobalt Frame Dentures Pre-authorisation required . Crown & Bridge Two Crowns per beneficiary per year. Surgery in the dental chair: Benefit subject to managed care protocols. Hospitalisation General anaesthetic benefit available for children under the age of 5 years and benefit available for the removal of impacted teeth. Deep Sedation in the Dental Rooms Pre-authorisation required Benefit limited to extensive dental treatment .",
    "crucialRules": "Two check-up per beneficiary per year.X-rays: Intraoral Benefit subject to managed care protocols. X-rays: Extraoral One per beneficiary in a 3-year period. Benefit for scale and polish: Two scale and polish treatments per beneficiary per year (once every 6 months) . Benefit for fissure sealants: Limited to beneficiaries younger than 16 years of age. Benefit for fluoride: Limited to beneficiaries from age 5 and younger than 13 years of age",
    "notes": "Patient written consent needed for procedures not covered. Confirmation of benefits is not a guarantee of payment \u2013An authorisation granted is not a guarantee of payment. Patient written consent needed for procedures not covered.",
    "source": "https://denis.co.za/wp-content/uploads/2025/12/KeyHealth-Dental-Benefit-Table-2026-v1.pdf",
    "lastUpdated": "Jan-26"
  },
  {
    "scheme": "Keyhealth",
    "plan": "Platinum",
    "administrator": "Denis",
    "contactInfo": {
      "email": [
        "keyhealthenq@denis.co.za or fax 0860 104 926"
      ],
      "fax": [
        " 0860 104 926"
      ],
      "phone": [
        "0860 104 926"
      ]
    },
    "networked": "Yes",
    "nonNetworkedPayment": "Yes",
    "balancedBilling": "Yes",
    "basicTreatment": "Yes with limitations",
    "rct": "Yes",
    "dentures": "Yes",
    "crownsOrBridges": "Yes",
    "implants": "Yes",
    "surgicalExtractions": "Yes",
    "exclusions": "Root canal therapy on primary (milk) and on third molars (wisdom teeth) \u2022 Direct and indirect pulp capping procedures. . Diagnostic dentures and associated laboratory costs \u2022 Provisional dentures and associated laboratory costs \u2022 Snoring appliances \u2022 High impact acrylic \u2022 The metal base to full dentures Crowns on third molars \u2022 Crown and bridge procedures for cosmetic reasons. \u2022 temporary crowns \u2022 Occlusal rehabilitations \u2022 Provisional crowns. Porcelain veneers and inlays, Implants on third molars (wisdom teeth)",
    "preAuth": "Benefit for fillings: Granted once per tooth in 720 days, Multiple fillings: A treatment plan and X-rays may be required . Pre-authorisation required One set of plastic dentures per beneficiary in a 4-year period. Partial Chrome Cobalt Frame Dentures, Crown & Bridge. Implants Pre-authorisation required . Surgery in the dental chair: Benefit subject to managed care protocols. Hospitalisation General anaesthetic benefit available for children under the age of 5 years . General anaesthetic benefit available for the removal of impacted teeth. Deep Sedation in the Dental Rooms Pre-authorisation required Benefit limited to extensive dental treatment .",
    "crucialRules": "Two check-up per beneficiary per year.X-rays: Intraoral Benefit subject to managed care protocols. X-rays: Extraoral One per beneficiary in a 3-year period. Benefit for scale and polish: Two scale and polish treatments per beneficiary per year (once every 6 months) . Benefit for fissure sealants: Limited to beneficiaries younger than 16 years of age. Benefit for fluoride: Limited to beneficiaries from age 5 and younger than 13 years of age",
    "notes": "Patient written consent needed for procedures not covered. Confirmation of benefits is not a guarantee of payment \u2013An authorisation granted is not a guarantee of payment.",
    "source": "https://denis.co.za/wp-content/uploads/2025/12/KeyHealth-Dental-Benefit-Table-2026-v1.pdf",
    "lastUpdated": "Jan-26"
  },
  {
    "scheme": "Keyhealth",
    "plan": "ESSENCE",
    "administrator": "Denis",
    "contactInfo": {
      "email": [
        "keyhealthenq@denis.co.za or fax 0860 104 926"
      ],
      "fax": [
        " 0860 104 926"
      ],
      "phone": [
        "0860 104 926"
      ]
    },
    "networked": "Yes",
    "nonNetworkedPayment": "Yes",
    "balancedBilling": "No",
    "basicTreatment": "Yes with limitations",
    "rct": "No",
    "dentures": "No",
    "crownsOrBridges": "No",
    "implants": "No",
    "surgicalExtractions": "No",
    "exclusions": "NO basic or specialised dentistry.",
    "preAuth": "Hospitalisation Pre-authorisation required ONLY for the removal of impacted teeth under GA (code 8941) . Deep Sedation in the Dental Rooms Pre-authorisation required ONLY for the removal of impacted teeth (code 8941)",
    "crucialRules": "8101 One check-up per beneficiary per year (not within 6 months from the previous year\u2019s consultation). 8107 and/or 8112 Limited to 4 X-rays in total per beneficiary per year NOTE: No benefit for Extra-oral x-rays",
    "notes": "Patient written consent needed for procedures not covered. Confirmation of benefits is not a guarantee of payment \u2013An authorisation granted is not a guarantee of payment.",
    "source": "https://denis.co.za/wp-content/uploads/2025/12/KeyHealth-Dental-Benefit-Table-2026-v1.pdf",
    "lastUpdated": "Jan-26"
  },
  {
    "scheme": "Keyhealth",
    "plan": "EQUILIBRIUM",
    "administrator": "Denis",
    "contactInfo": {
      "email": [
        "keyhealthenq@denis.co.za or fax 0860 104 926"
      ],
      "fax": [
        " 0860 104 926"
      ],
      "phone": [
        "0860 104 926"
      ]
    },
    "networked": "Yes",
    "nonNetworkedPayment": "Yes",
    "balancedBilling": "No",
    "basicTreatment": "Yes with limitations",
    "rct": "Yes",
    "dentures": "Yes",
    "crownsOrBridges": "No",
    "implants": "No",
    "surgicalExtractions": "Yes",
    "exclusions": "Implants and Associated Laboratory Costs No benefit. Partial Chrome Cobalt Frame Dentures and Associated Laboratory Costs No benefit Crowns and Associated Laboratory Costs No benefit",
    "preAuth": "Fillings: Benefit for fillings: Granted once per tooth in 720 days. Multiple fillings: A treatment plan and X-rays may be required . Pre-authorisation required for plastic dentures orthodontic . Hospitalisation (General Anaesthetic) Sedation in the Dental Rooms. Root Canal Therapy and Extractions Benefit subject to managed care protocols. General anaesthetic benefit available for children under the age of 5 years for extensive dental treatment General anaesthetic benefit available for the removal of impacted teeth. Deep Sedation in the Dental Rooms Pre-authorisation required Benefit limited to extensive dental treatment.",
    "crucialRules": "One check-up per beneficiary per year. Four X-rays in total per beneficiary per year . X-rays: Extraoral One per beneficiary in a 3-year period. One scale and polish treatment per beneficiary per year (once every 6 months). Benefit for fissure sealants: Limited to beneficiaries younger than 16 years of age. Benefit for fluoride: Limited to beneficiaries from age 5 and younger than 13 years of age.",
    "notes": "Benefit not available for the clinical fee of denture repairs, denture tooth replacements and the addition of a soft base to new dentures; the laboratory fee will be covered (no pre-authorisation required). Benefit for a mouth guard: Benefit available for both the clinical and the associated laboratory fee for a mouth guard (no pre-authorisation required).",
    "source": "https://denis.co.za/wp-content/uploads/2025/12/KeyHealth-Dental-Benefit-Table-2026-v1.pdf",
    "lastUpdated": "Jan-26"
  },
  {
    "scheme": "Keyhealth",
    "plan": "Origin",
    "administrator": "Denis",
    "contactInfo": {
      "email": [
        "keyhealthenq@denis.co.za or fax 0860 104 926"
      ],
      "fax": [
        " 0860 104 926"
      ],
      "phone": [
        "0860 104 926"
      ]
    },
    "networked": "Yes",
    "nonNetworkedPayment": "Yes",
    "balancedBilling": "No",
    "basicTreatment": "Yes with limitations",
    "rct": "No",
    "dentures": "No",
    "crownsOrBridges": "No",
    "implants": "No",
    "surgicalExtractions": "No",
    "exclusions": "There is no benefit for Root Canal Therapy, Dentures, Specialised Dentistry and dental treatment In Hospital on the Origin option.",
    "preAuth": "Fillings: Benefit for fillings: Granted once per tooth in 720 days. Multiple fillings: A treatment plan and X-rays may be required . Extractions Benefit subject to managed care protocols. Hospitalisation (General Anaesthetic) Pre-authorisation required ONLY for the removal of impacted teeth under GA. Deep Sedation in the Dental Rooms Pre-authorisation required ONLY for the removal of impacted teeth",
    "crucialRules": "Four X-rays per beneficiary per year. Conservative Dentistry subject to Day-to-day Family Limit. Benefit for fillings: Granted once per tooth in 720 days",
    "notes": "Conservative Dentistry subject to Day-to-day Family Limit",
    "source": "https://denis.co.za/wp-content/uploads/2025/12/KeyHealth-Dental-Benefit-Table-2026-v1.pdf",
    "lastUpdated": "Jan-26"
  },
  {
    "scheme": "LA HEALTH",
    "plan": "FOCUS",
    "administrator": "Discovery / DRC",
    "contactInfo": {
      "email": [
        "auth@dentalrisk.com or fax 086 687 1286"
      ],
      "fax": [
        " 086 687 1286"
      ],
      "phone": [
        "0860 445 566"
      ]
    },
    "networked": "Yes",
    "nonNetworkedPayment": "Yes",
    "balancedBilling": "Yes",
    "basicTreatment": "Yes with limitations",
    "rct": "No",
    "dentures": "Yes",
    "crownsOrBridges": "No",
    "implants": "No",
    "surgicalExtractions": "No",
    "exclusions": "No Panorex. No Crown &, Bridges, Ortho, Implants or . No Specialized Dentistry. No Crowns & bridges, Implants,Ortho. No Dental in Theatre .",
    "preAuth": "Extraction; Maximum 1 x 8201 per quadrant per visit. \u2022 More than 4 extractions per visit require pre-authorisation. Pre-auth More than 5 restorations per year. \u2022 2 or more 3 or 4 surface restorations per visit. \u2022 More than 2 anterior restorations per visit.",
    "crucialRules": "Maximum of 2 x-rays per visit per member when claimed with 8101. NB: If claimed with 8104 or no consultation maximum of 1 per visit date. vapour sterilised and wrapped instrumentation Maximum of 1 per visit. Will only be paid if code 9011, 8201 and 8202 are claimed.",
    "notes": "If a procedure does not attract benefit; all other treatment costs associated with the specific event does not receive benefit. 1. Very basic option 2. Lower rate applies to non network provider 3. Patient written consent needed for procedures not covered",
    "source": "https://dentalrisk.com/member-benefits/",
    "lastUpdated": "Jan-26"
  },
  {
    "scheme": "LIONHEALTH",
    "plan": "DAY TO DAY AND COMBINED PLAN",
    "administrator": "DRC",
    "contactInfo": {
      "email": [
        "auth@dentalrisk.com"
      ],
      "fax": [],
      "phone": [
        "0879 439 612"
      ]
    },
    "networked": "Yes",
    "nonNetworkedPayment": "Yes",
    "balancedBilling": "No",
    "basicTreatment": "Yes with limitations",
    "rct": "No",
    "dentures": "No",
    "crownsOrBridges": "No",
    "implants": "No",
    "surgicalExtractions": "No",
    "exclusions": "Pan Scan NO BENEFITS. Bite Plate NO BENEITS. Mouth Guard NO BENEFITS. Root Canal NO BENEFITS. Temporary Crown NO BENEFITS",
    "preAuth": "Maximum of 1 X 8201 per quadrant per visit. \u2022 More than 4 extractions per visit require pre-authorisation.",
    "crucialRules": "Posterior restorations are covered to the value of amalgam restorations. Pre-authorisation and X-rays required for: \u2022 More than 4 restorations per annum. \u2022 Any 3 or 4 surface restorations on wisdom teeth.",
    "notes": "Posterior restorations are covered to the value of amalgam restorations",
    "source": "https://dentalrisk.com/member-benefits/",
    "lastUpdated": "Jan-26"
  },
  {
    "scheme": "Malcor",
    "plan": "Plan A, B, C",
    "administrator": "Discovery",
    "contactInfo": {
      "email": [
        "fax 0860 100 698"
      ],
      "fax": [],
      "phone": [
        "0861 123 267"
      ]
    },
    "networked": "Yes",
    "nonNetworkedPayment": "Yes",
    "balancedBilling": "Yes",
    "basicTreatment": "Yes with limitations",
    "rct": "Yes",
    "dentures": "Yes",
    "crownsOrBridges": "Yes",
    "implants": "Yes",
    "surgicalExtractions": "Yes",
    "exclusions": "Dental procedures and treatments: \u2022 Dental extractions for non-medical purposes. \u2022 Bleaching of teeth that have not been root canal treated. \u2022 High impact acrylic dentures. \u2022 The cost of the use of gold in dentures",
    "preAuth": "Specialised dentistry pre authorisation. Dentistry(maxilla-facialprocedures). Preauthorisation required Conservative dentistry and specialised dentistry not covered in-hospital unless preauthorised. In theatre dentistry - Children under the age of 12 years.",
    "crucialRules": "Benefit for fillings: Granted once per tooth in 365 days. Dentistry (conservative dentistry and specialised dentistry, inclusive of osseo-integrated implants as well as related sinus lift and bonegraph procedures).",
    "notes": "Conservative dentistry and specialised dentistry not covered in-hospital unless preauthorised",
    "source": "https://www.malcormedicalaid.co.za/wcm/medical-schemes/malcor/assets/benefit-guides/2026/benefit-guide-2026.pdf",
    "lastUpdated": "Jan-26"
  },
  {
    "scheme": "Medicall",
    "plan": "CLASSIC, OPTIMA ESTABLISH AND OPTIMA ENHANCE OPTIONS",
    "administrator": "Denis",
    "contactInfo": {
      "email": [
        "customercare@denis.co.za"
      ],
      "fax": [],
      "phone": [
        "0863 445 566"
      ]
    },
    "networked": "There will be no benefit for out-of-network visits and treatment.",
    "nonNetworkedPayment": "No",
    "balancedBilling": "No",
    "basicTreatment": "Yes with limitations",
    "rct": "Root Canal Treatment Emergency only",
    "dentures": "No",
    "crownsOrBridges": "No",
    "implants": "No",
    "surgicalExtractions": "No",
    "exclusions": "There is no benefit for: Root Canal Therapy, Dentures, Specialised Dentistry, Inhalation Sedation in Dental Rooms, Moderate/Deep Sedation in Dental Rooms and Dental Treatment in hospital. NO Panorex.",
    "preAuth": "Restoration Codes: Posterior Amalgam and Resin restorations remunerated at the same tariff below. Pre-authorisation and x-rays required for: More than 4 restorations per year. More than one: 3 or 4 surface restoration per visit. More than 2 anterior restorations per visit. Multiple restorations on an anterior tooth on the same service date. Lower jaw posterior teeth restorations cannot be performed across the midline. Deviations will only be covered if pre-authorised. Any 3 or 4 surface restorations on wisdom teeth.",
    "crucialRules": "Root Canal Treatment Emergency only",
    "notes": "There will be no benefit for out-of-network visits and treatment.",
    "source": "https://denis.co.za/wp-content/uploads/2025/12/Medicall-Healthcare-Dental-Benefit-Table-2026-v1.pdf",
    "lastUpdated": "Jan-26"
  },
  {
    "scheme": "MediClub",
    "plan": "MediClub i-Series Plans* MediClub iConnect Plan MediClub iElite Plan MediClub iPremier Plan",
    "administrator": "Denis",
    "contactInfo": {
      "email": [
        "customercare@denis.co.za"
      ],
      "fax": [],
      "phone": [
        "0861 033 648"
      ]
    },
    "networked": "There will be no benefit for out-of-network visits and treatment.",
    "nonNetworkedPayment": "No",
    "balancedBilling": "No",
    "basicTreatment": "Yes with limitations",
    "rct": "No",
    "dentures": "No",
    "crownsOrBridges": "No",
    "implants": "No",
    "surgicalExtractions": "No",
    "exclusions": "There is no benefit for: Root Canal Therapy, Dentures, Specialised Dentistry, Inhalation Sedation in Dental Rooms, Moderate/Deep Sedation in Dental Rooms and Dental Treatment in hospital.",
    "preAuth": "Fillings Motivation and records required for more than 5 fillings per dependant per year Motivation required for 3 or 4 surface fillings on wisdom teeth (3rd Molars) Benefit for fillings is granted once per tooth in 9 months",
    "crucialRules": "8102 Full mouth examination, Two consultations per dependant per year (once every 6 months). 8104 Specific consultation One specific consultation for pain and sepsis per dependant per year; not within 4 weeks of 8101. 8107 and/or 8112 Maximum of 2 X-rays films per visit per member. Code 815 & 8155 Once per 6 months per member from date of service. 8161, Once per 6 months per member from date of service. 8201 Extractions (removal of teeth) Extraction of tooth or exposed roots",
    "notes": "Benefits payable on the MediClub iConnect, iElite, and iPremier plans are subject to the use of a Network Service Provider on the DENIS Dental Network. There will be no benefit for out-of-network visits and treatment.",
    "source": "https://denis.co.za/wp-content/uploads/2025/12/NHG-MediClub-Day-to-Day-Health-Benefit-Table-2026-v1.pdf",
    "lastUpdated": "Jan-26"
  },
  {
    "scheme": "MediClub",
    "plan": "Agrihealth Plan",
    "administrator": "Denis",
    "contactInfo": {
      "email": [
        "customercare@denis.co.za"
      ],
      "fax": [],
      "phone": [
        "0864 445 566"
      ]
    },
    "networked": "There will be no benefit for out-of-network visits and treatment.",
    "nonNetworkedPayment": "No",
    "balancedBilling": "No",
    "basicTreatment": "Yes with limitations",
    "rct": "Root Canal Treatment Emergency only",
    "dentures": "No",
    "crownsOrBridges": "No",
    "implants": "No",
    "surgicalExtractions": "No",
    "exclusions": "There is no benefit for: Root Canal Therapy, Dentures, Specialised Dentistry, Inhalation Sedation in Dental Rooms, Moderate/Deep Sedation in Dental Rooms and Dental Treatment in hospital.",
    "preAuth": "Motivation and records required for more than 5 fillings per dependant per year. Motivation required for 3- or 4-surface fillings on wisdom teeth (3rd Molars) Benefit for fillings is granted once per tooth in 9 months",
    "crucialRules": "Maximum of two X-rays (8107 and/or 8112) per visit per dependant",
    "notes": "There will be no benefit for out-of-network visits and treatment.",
    "source": "https://denis.co.za/wp-content/uploads/2025/12/NHG-MediClub-Day-to-Day-Health-Benefit-Table-2026-v1.pdf",
    "lastUpdated": "Jan-26"
  },
  {
    "scheme": "MediClub",
    "plan": "Day-to-Day Health Plan",
    "administrator": "Denis",
    "contactInfo": {
      "email": [
        "customercare@denis.co.za"
      ],
      "fax": [],
      "phone": [
        "0865 445 566"
      ]
    },
    "networked": "There will be no benefit for out-of-network visits and treatment.",
    "nonNetworkedPayment": "No",
    "balancedBilling": "No",
    "basicTreatment": "Yes with limitations",
    "rct": "Root Canal Treatment Emergency only",
    "dentures": "No",
    "crownsOrBridges": "No",
    "implants": "No",
    "surgicalExtractions": "No",
    "exclusions": "There is no benefit for: Root Canal Therapy, Dentures, Specialised Dentistry, Inhalation Sedation in Dental Rooms, Moderate/Deep Sedation in Dental Rooms and Dental Treatment in hospital.",
    "preAuth": "Motivation and records required for more than 5 fillings per dependant per year. Motivation required for 3- or 4-surface fillings on wisdom teeth (3rd Molars) Benefit for fillings is granted once per tooth in 9 months",
    "crucialRules": "Maximum of two X-rays (8107 and/or 8112) per visit per dependant",
    "notes": "There will be no benefit for out-of-network visits and treatment.",
    "source": "https://denis.co.za/wp-content/uploads/2025/12/NHG-MediClub-Day-to-Day-Health-Benefit-Table-2026-v1.pdf",
    "lastUpdated": "Jan-26"
  },
  {
    "scheme": "Medihelp",
    "plan": "MedVital & MedVital Elect",
    "administrator": "DRC",
    "contactInfo": {
      "email": [
        "auth@dentalrisk.com"
      ],
      "fax": [],
      "phone": [
        "0879 439 612"
      ]
    },
    "networked": "No",
    "nonNetworkedPayment": "Yes",
    "balancedBilling": "Yes",
    "basicTreatment": "Yes with limitations",
    "rct": "No",
    "dentures": "No",
    "crownsOrBridges": "No",
    "implants": "No",
    "surgicalExtractions": "No",
    "exclusions": "CONSERVATIVE SERVICES No Benefits, SPECIALISED DENTAL SERVICES, No Benefits, INHALATION SEDATION IN THE DENTIST\u2019S ROOMS No Benefits, SEDATION: EXTENSIVE DENTAL TREATMENT FOR CHILDREN YOUNGER THAN 12 YEARS No Benefits. EXTENSIVE DENTAL TREATMENT FOR CHILDREN YOUNGER THAN 7 YEARS No Benefits",
    "preAuth": "SEDATION: REMOVAL OF IMPACTED TEETH IN THE DENTIST\u2019S ROOMS",
    "crucialRules": "NO BENEFITS FOR ADVANCED OR SPECIALISED DENTISTRY.",
    "notes": "HOSPITAL PLAN",
    "source": "https://dentalrisk.com/member-benefits/",
    "lastUpdated": "Jan-26"
  },
  {
    "scheme": "Medihelp",
    "plan": "MedAdd & MedAdd Elect",
    "administrator": "DRC",
    "contactInfo": {
      "email": [
        "auth@dentalrisk.com or fax 086 687 1285"
      ],
      "fax": [
        " 086 687 1285"
      ],
      "phone": [
        "0879 439 611"
      ]
    },
    "networked": "Yes",
    "nonNetworkedPayment": "Yes",
    "balancedBilling": "No",
    "basicTreatment": "Yes with limitations",
    "rct": "Yes",
    "dentures": "Yes",
    "crownsOrBridges": "Yes",
    "implants": "Yes",
    "surgicalExtractions": "Yes",
    "exclusions": "SEDATION: EXTENSIVE DENTAL TREATMENT FOR CHILDREN YOUNGER THAN 12 YEARS. No Benefits. EXTENSIVE DENTAL TREATMENT FOR CHILDREN YOUNGER THAN 7 YEARS: No Benefits. IMPLANTS No theatre or hospital benefit for placement of implants.",
    "preAuth": "More than 4 extractions per visit require pre-authorisation. Pre-authorisation and x-rays required for:\u2022 More than 4 restorations per year \u2022 2 or more, 3 or 4 surface restorations per visit. \u2022 More than 2 anterior restorations per visit. \u2022 3 or 4 surface restorations on third molar teeth. Sedation would require authorisation with detailed motivation and supporting. Pre-authorisation and motivation required prior to claims submission when quantity is more than the following: \u2022 More than 6 per member per annum irrespective of the tariff code used. Two partial metal frame dentures (an upper or/and a lower jaw) per member. RCT Retreatment subject to pre-authorisation and managed care protocols.",
    "crucialRules": "Conservative services for members younger than 18 years, as indicated in the protocol, will be paid from the member\u2019s annual dental benefit. All claims for members older than 18 years will be paid from the savings account CONSCIOUS SEDATION IN THE DENTIST\u2019S ROOMS. Limited to the removal of impacted third molars only. SEDATION: REMOVAL OF IMPACTED TEETH IN THE DENTIST\u2019S ROOMS. Bite plate (8169) will be covered under denture benefit. One per member every 365 days from date of service. One reline or rebase per member per 12 month period from date of service.",
    "notes": "NB: *Conservative services for members younger than 18 years, as indicated in the protocol, will be paid from the member\u2019s annual dental benefit. All claims for members older than 18 years will be paid from the savings account. If 8115 claimed - 8107 & 8112 is not covered in the same visit. Bite plate (8169) will be covered under denture benefit. One per member every 365 days from date of service. \u2022 One reline or rebase per member per 12 month period from date of service.",
    "source": "https://dentalrisk.com/member-benefits/",
    "lastUpdated": "Jan-26"
  },
  {
    "scheme": "Medihelp",
    "plan": "MedPrime & MedPrime Elect",
    "administrator": "DRC",
    "contactInfo": {
      "email": [
        "auth@dentalrisk.com or fax 086 687 1285"
      ],
      "fax": [
        " 086 687 1285"
      ],
      "phone": [
        "0879 439 611"
      ]
    },
    "networked": "Yes",
    "nonNetworkedPayment": "Yes",
    "balancedBilling": "No",
    "basicTreatment": "Yes with limitations",
    "rct": "Yes",
    "dentures": "Yes",
    "crownsOrBridges": "Yes",
    "implants": "No",
    "surgicalExtractions": "Yes",
    "exclusions": "No benefits shall be granted on crowns or crown retainers on third molars and Pontics on second molars. Clear, well defined (no cone\u0002cutting) radiographs are re\u0002quired to support crown authorisations. Teeth with sub-gingival caries OR that are periodontally compromised, OR have pathology at the apices, OR Root canal treatment without apical and coronal sealing will not be considered for restorative treatment. (eg. Crown and bridge; restorations). IMPLANTS: No Benefits.",
    "preAuth": "More than 4 extractions per visit require pre-authorisation. More than 4 restorations per year. \u2022 2 or more, 3 or 4 surface restorations per visit. More than 2 anterior restorations per visit. \u2022 3 or 4 surface restorations on third molar teeth. RCT Retreatment subject to pre-authorisation and managed care protocols. Pre-authorisation and motivation required prior to claims submission when quantity is more than the following: \u2022 More than 6 per member per annum irrespective of the tariff code used. One partial metal frame denture. CONSCIOUS SEDATION IN THE DENTIST\u2019S ROOMS . Limited to extensive dental treatment for children younger than 12 years of age and the removal of impacted third molars only. IN-HOSPITAL Limited to extensive dental treatment for children younger than 7 years of age, Frenulectomy, tooth exposure as part of the ortho treatment plan and the removal of\nimpacted third molars.",
    "crucialRules": "Pan x-ray One per member in a 3-year period from date of service. Benefit limited to members older than 5 years unless motivated. RCT limited to members 12 years and older. Bite plate (8169) will be covered under denture benefit. One reline or rebase per member per 12 month period from date of service. Rebase complete or partial denture Once per member per annum.",
    "notes": "Bite plate (8169) will be covered under denture benefit. One per member every 365 days from date of service.",
    "source": "https://dentalrisk.com/member-benefits/",
    "lastUpdated": "Jan-26"
  },
  {
    "scheme": "Medihelp",
    "plan": "MedElite",
    "administrator": "DRC",
    "contactInfo": {
      "email": [
        "auth@dentalrisk.com or fax 086 687 1285"
      ],
      "fax": [
        " 086 687 1285"
      ],
      "phone": [
        "0879 439 611"
      ]
    },
    "networked": "Yes",
    "nonNetworkedPayment": "Yes",
    "balancedBilling": "No",
    "basicTreatment": "Yes with limitations",
    "rct": "Yes",
    "dentures": "Yes",
    "crownsOrBridges": "Yes",
    "implants": "No",
    "surgicalExtractions": "Yes",
    "exclusions": "No benefits shall be granted on crowns or crown retainers on third molars and Pontics on second molars. Clear, well defined (no cone\u0002cutting) radiographs are re\u0002quired to support crown authorisations. Teeth with sub-gingival caries OR that are periodontally compromised, OR have pathology at the apices, OR Root canal treatment without apical and coronal sealing will not be considered for restorative treatment. (eg. Crown and bridge; restorations). IMPLANTS: No Benefits.",
    "preAuth": "Surgical removal of tooth Subject to pre-authorisation. More than 4 extractions per visit require pre-authorisation. Pre-authorisation and x-rays required for: \u2022 More than 4 restorations per year. \u2022 2 or more, 3 or 4 surface restorations per visit. \u2022 More than 2 anterior restorations per visit. \u2022 3 or 4 surface restorations on third molar teeth. Retreatment subject to pre-authorisation and managed care protocols. Two crowns annually per family, Two partial metal frame dentures. DENTAL SERVICES/SURGERY RENDERED IN THE DENTIST\u2019S ROOMS. CONSCIOUS SEDATION IN THE DENTIST\u2019S ROOMS ; Limited to extensive dental treatment for children younger than 12 years of age and the removal of impacted third molars only. SEDATION: EXTENSIVE DENTAL TREATMENT FOR CHILDREN YOUNGER THAN 12 YEARS.",
    "crucialRules": "Bite plate (8169) will be covered under denture benefit. Pre-authorisation and motivation required prior to claims submission when quantity is more than the following: \u2022 More than 6 per member per annum irrespective of the tariff code used.",
    "notes": "IN-HOSPITAL TREATMENT (GENERAL ANAESTHESIA) Limited to extensive dental treatment for children younger than 7 years of age, Frenulectomy, tooth exposure as part of the ortho treatment plan and the removal of impacted third molars.",
    "source": "https://dentalrisk.com/member-benefits/",
    "lastUpdated": "Jan-26"
  },
  {
    "scheme": "Medihelp",
    "plan": "MedPlus",
    "administrator": "DRC",
    "contactInfo": {
      "email": [
        "auth@dentalrisk.com or fax 086 687 1285"
      ],
      "fax": [
        " 086 687 1285"
      ],
      "phone": [
        "0879 439 611"
      ]
    },
    "networked": "Yes",
    "nonNetworkedPayment": "Yes",
    "balancedBilling": "No",
    "basicTreatment": "Yes with limitations",
    "rct": "Yes",
    "dentures": "Yes",
    "crownsOrBridges": "Yes",
    "implants": "Yes",
    "surgicalExtractions": "Yes",
    "exclusions": "No theatre or hospital benefit for placement of implants.",
    "preAuth": "Maximum of 1 X 8201 per quadrant per visit. \u2022 More than 4 extractions per visit require pre-authorisation. Surgical removal of tooth Subject to pre-authorisation. Pre-authorisation and x-rays required for: \u2022 More than 4 restorations per year. \u2022 2 or more, 3 or 4 surface restorations per visit. \u2022 More than 2 anterior restorations per visit. \u2022 3 or 4 surface restorations on third molar teeth. INCISION AND DRAINAGE OF ABSCESS Sedation would require authorisation. INTRA-ORAL X-RAYS Pre-authorisation and motivation required prior to claims submission when quantity is more than the following: \u2022 More than 6 per member. Three crowns annually per family, CONSCIOUS SEDATION IN THE DENTIST\u2019S ROOMS Limited to extensive dental treatment for children younger than 12 years of age and the removal of impacted third molars only. Benefits are subject to managed care protocols and pre-authorisation.",
    "crucialRules": "IN-HOSPITAL TREATMENT (GENERAL ANAESTHESIA) codes). Limited to extensive dental treatment for children younger than 7 years of age, Frenulectomy, tooth exposure as part of the ortho treatment plan and the removal of impacted third molars.",
    "notes": "Bite plate (8169) will be covered under denture benefit.",
    "source": "https://dentalrisk.com/member-benefits/",
    "lastUpdated": "Jan-26"
  },
  {
    "scheme": "Medihelp",
    "plan": "MedReach (NETWORK PROVIDER AND HOSPITALS)",
    "administrator": "DRC",
    "contactInfo": {
      "email": [
        "auth@dentalrisk.com or fax 086 687 1285"
      ],
      "fax": [
        " 086 687 1285"
      ],
      "phone": [
        "0879 439 611"
      ]
    },
    "networked": "Yes. Members are required to use dentists within the Dental Risk Company (DRC) network.",
    "nonNetworkedPayment": "Yes",
    "balancedBilling": "No",
    "basicTreatment": "Yes with limitations",
    "rct": "",
    "dentures": "No",
    "crownsOrBridges": "No",
    "implants": "No",
    "surgicalExtractions": "Yes",
    "exclusions": "PLASTIC DENTURES No Benefits. CROWNS AND BRIDGES No Benefits METAL FRAME DENTURES No Benefits ORTHODONTICS No Benefits PERIODONTICS No Benefits\nMAXILLOFACIAL SURGERY AND ORAL PATHOLOGY Limited to PMB only IMPLANTS No Benefits",
    "preAuth": "More than 4 extractions per visit require pre-authorisation. Surgical removal of tooth Subject to pre-authorisation. Limited to 4 restorations annually per member. Pre-authorisation and x-rays required for: \u2022 2 or more, 3 or 4 surface restorations per visit. \u2022 More than 2 anterior restorations per visit. \u2022 3 or 4 surface restorations on third molar teeth. Incision & drainage of abscess Limited to treatment in the consultation rooms. RCT Retreatment subject to preauthorisation. X-RAYS 4 x-rays annually per member. Pre-authorisation and motivation required prior to claims submission when quantity is more than the following: \u2022 Accompanying tariff code, 8104, 8112x1 or 8107x1 \u2022 No consultation, 8112x1 or 8107x1 \u2022 If 8115 claimed - 8107 & 8112 is not covered in the same visit. Surgical removal of tooth Subject to pre-authorisation.",
    "crucialRules": "CONSCIOUS SEDATION IN THE DENTIST\u2019S ROOMS Limited to extensive dental treatment for children younger than 12 years of age and the removal of impacted third molars only. IN-HOSPITAL TREATMENT Limited to extensive dental treatment for children younger than 12 years of age and the removal of impacted third molars.",
    "notes": "Benefits are limited to relevant health services prescribed by a network dental practitioner as being essential and rendered at a Medihelp network hospital.",
    "source": "https://dentalrisk.com/member-benefits/",
    "lastUpdated": "Jan-26"
  },
  {
    "scheme": "Medihelp",
    "plan": "MedSaver",
    "administrator": "DRC",
    "contactInfo": {
      "email": [
        "auth@dentalrisk.com or fax 086 687 1285"
      ],
      "fax": [
        " 086 687 1285"
      ],
      "phone": [
        "0879 439 611"
      ]
    },
    "networked": "Yes",
    "nonNetworkedPayment": "Yes",
    "balancedBilling": "Yes",
    "basicTreatment": "Yes with limitations",
    "rct": "Yes",
    "dentures": "Yes",
    "crownsOrBridges": "Yes",
    "implants": "Yes",
    "surgicalExtractions": "Yes",
    "exclusions": "SPECIALISED DENTAL SERVICES: No benefits shall be granted on crowns or crown retain\u0002ers on third molars and Pontics on second molars. Clear and well defined (no cone-cutting) radiographs are required to support crown authorisations.Teeth with sub-gingival caries OR that are periodontally compromised, OR have pathology at the apices, OR Root canal treatment without apical and coronal sealing will not be considered for restorative treatment. (eg. Crown and bridge; restorations). No theatre or hospital bene\u0002fit for placement of implants. SEDATION: EXTENSIVE DENTAL TREATMENT FOR CHILDREN YOUNGER THAN 12 YEARS No Benefits .",
    "preAuth": "More than 4 extractions per visit require pre-auth. Surgical removal of tooth Subject to pre-authorisation. RESTORATION CODES: Pre-authorisation and x-rays required for: More than 4 restorations per year (especially anterior teeth). 2 or more, 3 or 4 surface restorations per visit. More than 2 anterior restorations per visit. 3 or 4 surface restorations on third molar teeth. RCT Retreatment subject to preauthorisation. X-RAYS : Pre-auth when quantity is More than 6 per member per annum . Accompanying tariff code,8104, 8112x1 or 8107x1. No consultation, 8112x1 or 8107x1. If 8115 claimed - 8107 & 8112 is not covered in the same visit. METAL FRAME DENTURES : authorisation Two partial metal frame dentures . IMPLANTS authorisation. REMOVAL OF IMPACTED TEETH: Once per lifetime. IN-HOSPITAL TREATMENT : Limited to the removal of impacted third molars. EXTENSIVE DENTAL TREATMENT FOR CHILDREN YOUNGER THAN 7 YEARS .",
    "crucialRules": "All conservative services will be paid from member\u2019s savings account. consultation for a specific problem (Motivation required for code 8104 if no covered clinical procedure is charged). EXTRA-ORAL X-RAYS: One per member in a 3-year period from date of service. No benefits shall be granted for the clinical fee for denture repair, denture tooth replacements and the addition of a soft base to new dentures, but the laboratory fee will be covered. Bite plate (8169) will be covered under denture benefit. One per member every 365 days from date of service.",
    "notes": "CONSCIOUS SEDATION IN THE DENTIST\u2019S ROOMS Limited to the removal of impacted third molars only. SEDATION: EXTENSIVE DENTAL TREATMENT FOR CHILDREN YOUNGER THAN 12 YEARS. No Benefits. NB: Extensive dental treatment for children younger than 7 years and Frenulectomy is payable from the members available savings at time of submission of the claim. EXTENSIVE DENTAL TREATMENT FOR CHILDREN YOUNGER THAN 7 YEARS\nHospital, Anaesthetist and Dentist account payable from available savings account",
    "source": "https://dentalrisk.com/member-benefits/",
    "lastUpdated": "Jan-26"
  },
  {
    "scheme": "Medihelp",
    "plan": "MedMove",
    "administrator": "DRC",
    "contactInfo": {
      "email": [
        "auth@dentalrisk.com or fax 086 687 1285"
      ],
      "fax": [
        " 086 687 1285"
      ],
      "phone": [
        "0879 439 611"
      ]
    },
    "networked": "Yes",
    "nonNetworkedPayment": "Yes",
    "balancedBilling": "No",
    "basicTreatment": "Yes with limitations",
    "rct": "No",
    "dentures": "No",
    "crownsOrBridges": "No",
    "implants": "No",
    "surgicalExtractions": "No",
    "exclusions": "NO benefits for ; SCALE AND POLISH, FISSURE SEALANTS, FLUORIDE TREATMENT, EXTRACTIONS, RESTORATION CODES, INCISION AND DRAINAGE OF ABSCESS, ROOT CANAL TREATMENT, PLASTIC DENTURES, CROWNS AND BRIDGES, METAL FRAME DENTURES, ORTHODONTICS, MAXILLOFACIAL SURGERY AND ORAL PATHOLOGY, IMPLANTS, CONSCIOUS SEDATION IN THE DENTIST\u2019S ROOMS, SEDATION: EXTENSIVE DENTAL TREATMENT FOR CHILDREN YOUNGER THAN 12 YEARS, IN-HOSPITAL TREATMENT (GENERAL ANAESTHESIA),",
    "preAuth": "",
    "crucialRules": "R135,00 co-payment: 8101 Full mouth examination, charting and treatment planning One consultation per beneficiary per 365 days from date of service. Maximum of 4 x-rays per valid consultation (8101).",
    "notes": "",
    "source": "https://dentalrisk.com/member-benefits/",
    "lastUpdated": "Jan-26"
  },
  {
    "scheme": "Medshield",
    "plan": "MEDIBONUS (550)",
    "administrator": "Denis",
    "contactInfo": {
      "email": [
        "customercare@denis.co.za or fax 086 000 2121"
      ],
      "fax": [
        " 086 000 2121"
      ],
      "phone": [
        "0861 033 647"
      ]
    },
    "networked": "Yes",
    "nonNetworkedPayment": "Yes",
    "balancedBilling": "Yes",
    "basicTreatment": "Yes with limitations",
    "rct": "Yes",
    "dentures": "Yes",
    "crownsOrBridges": "Yes",
    "implants": "Yes",
    "surgicalExtractions": "Yes",
    "exclusions": "\u2022 Polishing of restorations. Root canal therapy on primary (milk) teeth \u2022 Root canal therapy on third molars (wisdom teeth) \u2022 Benefit not available for the clinical fee of denture repairs, denture tooth replacements and the addition of a soft base to new dentures; the laboratory fee will be covered (no pre-authorisation required). Diagnostic dentures and associated laboratory costs. Provisional dentures and associated laboratory costs. SPECIALISED DENTISTRY The metal base to full dentures \u2022. Crowns and bridges Crowns on third molars \u2022 Crown and bridge procedures where there is no extensive tooth structure loss \u2022",
    "preAuth": "Benefit for fillings: Granted once per tooth in 720 days Multiple fillings: A treatment plan and X rays required . Root Canal Therapy and Extractions. Plastic Dentures . Partial Chrome Cobalt Frame Dentures Pre-authorisation required Two partial frames per beneficiary in a 5-year period. Crown & Bridge Pre-authorisation required. Implants Pre-auth required. General anaesthetic and hospitalisation benefits for Basic Dentistry are only available for children under the age of 6 years . General anaesthetic benefit available for the removal of impacted teeth. Pre-authorisation required. Deep Sedation Basic Dentistry (beneficiaries under and over the age of 6)and Impacted Teeth.",
    "crucialRules": "Consultations Once per beneficiary every 6 months. X-rays: Intraoral Benefit subject to managed care protocols. X-rays: Extraoral Once every 3 years. fissure sealants: Limited to beneficiaries younger than 16 years of age Benefit for fluoride: Limited to beneficiaries from 5 and younger than 13 years of age, Once per beneficiary every 6 months.",
    "notes": "Benefit not available for the clinical fee of denture repairs, denture tooth replacements and the addition of a soft base to new dentures; the laboratory fee will be covered (no pre-authorisation required). Benefit for a mouth guard: Benefit available for both the clinical and the associated laboratory fee for a mouth guard (no pre-authorisation required). Patient written consent needed for procedures not covered. Specialised Dentistry\nlimit of R23 000 per family.",
    "source": "https://denis.co.za/wp-content/uploads/2026/01/Medshield-Benefit-Table-2026-v2.pdf",
    "lastUpdated": "Jan-26"
  },
  {
    "scheme": "Medshield",
    "plan": "MEDIPLUS PRIME (551) & MEDIPLUS COMPACT (561)",
    "administrator": "Denis",
    "contactInfo": {
      "email": [
        "customercare@denis.co.za or fax 086 000 2121"
      ],
      "fax": [
        " 086 000 2121"
      ],
      "phone": [
        "0861 033 647"
      ]
    },
    "networked": "Yes",
    "nonNetworkedPayment": "Yes",
    "balancedBilling": "Yes",
    "basicTreatment": "Yes with limitations",
    "rct": "Yes",
    "dentures": "Yes",
    "crownsOrBridges": "Yes",
    "implants": "Yes",
    "surgicalExtractions": "Yes",
    "exclusions": "Fillings: to restore teeth damaged due to toothbrush abrasion, attrition, erosion, and fluorosis. Root canal therapy on primary teeth. Direct and indirect pulp capping procedures. . Diagnostic dentures and associated laboratory. Provisional dentures and associated laboratory costs. The metal base to full dentures . Crowns and bridges on third molars. Laboratory fabricated temporary crowns. Provisional crowns and associated laboratory costs. Emergency crowns that are not placed for the immediate protection in tooth injury and Implants on third molars (wisdom teeth)",
    "preAuth": "Dental Implants Includes all services related to Implants. Pre-authorisation is required. Crowns, Bridges, Inlays, Mounted Study Models, Partial Metal Base Dentures and Periodontics. Plastic dentures requires pre-authorisation. In-Hospital (only for beneficiaries under the age of 6 years old). Pre-authorisation is required.",
    "crucialRules": "Consultations Once per beneficiary every 6 months. X-rays: Intraoral Benefit subject to managed care protocols. X-rays: Extraoral Once every 3 years. fissure sealants: Limited to beneficiaries younger than 16 years of age Benefit for fluoride: Limited to beneficiaries from 5 and younger than 13 years of age, Once per beneficiary every 6 months.",
    "notes": "Day-to-Day Limits Limit increased to: M0 R12 000 M+1 R16 500 M+2 R18 600 M+3 R20 300 M+4 R22 000. Dentistry: Specialised Limit increased to R16 200 per family.",
    "source": "https://denis.co.za/wp-content/uploads/2026/01/Medshield-Benefit-Table-2026-v2.pdf",
    "lastUpdated": "Jan-26"
  },
  {
    "scheme": "Medshield",
    "plan": "MEDIVALUE PRIME (552) & MEDIVALUE COMPACT (562)",
    "administrator": "Denis",
    "contactInfo": {
      "email": [
        "customercare@denis.co.za or fax 086 000 2121"
      ],
      "fax": [
        " 086 000 2121"
      ],
      "phone": [
        "0861 033 647"
      ]
    },
    "networked": "Yes",
    "nonNetworkedPayment": "Yes",
    "balancedBilling": "Yes",
    "basicTreatment": "Yes with limitations",
    "rct": "Yes",
    "dentures": "Yes",
    "crownsOrBridges": "Yes",
    "implants": "Yes",
    "surgicalExtractions": "Yes",
    "exclusions": "Fillings: to restore teeth damaged due to toothbrush abrasion, attrition, erosion, and fluorosis. Root canal therapy on primary teeth. Direct and indirect pulp capping procedures. . Diagnostic dentures and associated laboratory. Provisional dentures and associated laboratory costs. The metal base to full dentures . Crowns and bridges on third molars. Laboratory fabricated temporary crowns. Provisional crowns and associated laboratory costs. Emergency crowns that are not placed for the immediate protection in tooth injury and Implants on third molars (wisdom teeth)",
    "preAuth": "In-Hospital (only for beneficiaries under the age of 6 years old). Pre-authorisation is require. Plastic dentures requires pre-authorisation. Pre-authorisation is required for general anaesthetic and conscious analgo sedation, In- and Out-ofHospital. Dental Implants Includes all services related to Implants. Pre-authorisation is required. Crowns, Bridges, Inlays, Mounted Study Models, Partial Metal Base Dentures and Periodontics Consultations, Visits and Treatment for all such dentistry including the Technicians\u2019 fees. Pre-auth is required.",
    "crucialRules": "Consultations Once per beneficiary every 6 months. X-rays: Intraoral Benefit subject to managed care protocols. X-rays: Extraoral Once every 3 years. fissure sealants: Limited to beneficiaries younger than 16 years of age Benefit for fluoride: Limited to beneficiaries from 5 and younger than 13 years of age, Once per beneficiary every 6 months. Benefit not available for the clinical fee of denture repairs, denture tooth replacements and the addition of a soft base to new dentures; the laboratory fee will be covered (no pre-authorisation required).",
    "notes": "Limits: MediValue Prime & MediValue Compact from the Specialised Dentistry Family limit of R7 700, and once this limit has been depleted, all other Basic Dentistry is limited to and included in the day-to-day limit as per the table below Limits: MediValue Prime & MediValue Compact: M = R8 500, M +1 = R10 200, M +2 = R10 600, M +3 = R12 000, M +4+ = R13 000.",
    "source": "https://denis.co.za/wp-content/uploads/2026/01/Medshield-Benefit-Table-2026-v2.pdf",
    "lastUpdated": "Jan-26"
  },
  {
    "scheme": "Medshield",
    "plan": "Medphila",
    "administrator": "Denis",
    "contactInfo": {
      "email": [
        "customercare@denis.co.za or fax 086 000 2121"
      ],
      "fax": [
        " 086 000 2121"
      ],
      "phone": [
        "0861 033 647"
      ]
    },
    "networked": "Yes",
    "nonNetworkedPayment": "Yes",
    "balancedBilling": "Yes",
    "basicTreatment": "Yes with limitations",
    "rct": "Yes",
    "dentures": "Yes",
    "crownsOrBridges": "No",
    "implants": "No",
    "surgicalExtractions": "Yes",
    "exclusions": "Partial Chrome Cobalt Frame Dentures : No benefit Crown & Bridge No benefits Implants: No Benefits Orthodontics No Benefits.",
    "preAuth": "Multiple fillings: A treatment plan and X-rays may be required for multiple fillings; Multiple fillings: A treatment plan and X-rays may be required for multiple fillings covered at the MDT; Plastic Dentures Pre-authorisation required. Benefit not available for the clinical fee of denture repairs, denture tooth replacements and the addition of a soft base to new dentures; the laboratory fee will be covered (no pre-authorisation required). Hospitalisation: Impacted Teeth Pre-authorisation required. Sedation in Dental Rooms: Pre-authorisation required. Basic Dentistry are only available for children under the age of 6 years for extensive dental treatment",
    "crucialRules": "X-rays: Extraoral One per beneficiary in a 3-year period. Fillings Granted once per tooth in 720 days. Root Canal Therapy and Extractions, payable from a sub-limit of R1 900 per family, limited to and included in the Specialised Dentistry Limit of R7 600 per family",
    "notes": "Benefit for a mouth guard: Benefit available for both the clinical and the associated laboratory fee for a mouth guard (no preauthorisation required). Oral Surgery (Non-elective surgery only). Patient written consent needed for procedures not covered. 2. Lower rate applies to non network provider",
    "source": "https://denis.co.za/wp-content/uploads/2026/01/Medshield-Benefit-Table-2026-v2.pdf",
    "lastUpdated": "Jan-26"
  },
  {
    "scheme": "Medshield",
    "plan": "MEDISAVER (683)",
    "administrator": "Denis",
    "contactInfo": {
      "email": [
        "customercare@denis.co.za or fax 086 000 2121"
      ],
      "fax": [
        " 086 000 2121"
      ],
      "phone": [
        "0861 033 647"
      ]
    },
    "networked": "Yes",
    "nonNetworkedPayment": "Yes",
    "balancedBilling": "Yes",
    "basicTreatment": "Yes with limitations",
    "rct": "Yes",
    "dentures": "Yes",
    "crownsOrBridges": "Yes",
    "implants": "Yes",
    "surgicalExtractions": "Yes",
    "exclusions": "Fillings: to restore teeth damaged due to toothbrush abrasion, Root canal therapy on primary (milk) teeth, third molars (wisdom teeth) Diagnostic dentures and associated laboratory. Provisional dentures and associated laboratory costs. SPECIALISED DENTISTRY: The metal base to full dentures . Crowns and bridges on third molars. Laboratory fabricated temporary crowns. Provisional crowns . Emergency crowns that are not placed for the immediate protection in tooth injury and Implants on third molars (wisdom teeth)",
    "preAuth": "Fillings: Granted once per tooth in 720 days. Multiple fillings: A treatment plan and X rays required . Plastic Dentures Pre-authorisation required One set of plastic dentures (an upper and a lower) per beneficiary in a 4-year period. Partial Chrome Cobalt Frame Dentures Pre-authorisation required Two partial frames (an upper and a lower) per beneficiary in a 5-year period . Crown & Bridge Pre-authorisation required. Implants Pre-auth required. General anaesthetic and hospitalisation benefits for Basic Dentistry are only available for children under the age of 6 years . General anaesthetic benefit available for the removal of impacted teeth. Pre-authorisation required.",
    "crucialRules": "Consultations Once per beneficiary every 6 months. X-rays: Extraoral Once every 3 years. fissure sealants: Limited to beneficiaries younger than 16 years of age Benefit for fluoride: Limited to beneficiaries from 5 and younger than 13 years of age, Once per beneficiary every 6 months. Benefit not available for the clinical fee of denture repairs, denture tooth replacements and the addition of a soft base to new dentures; the laboratory fee will be covered (no pre-authorisation required).",
    "notes": "On the MediSaver option, Basic and Specialised Dentistry, unless otherwise stated, are payable from the PSA. The PSA will be allocated to the member\u2019s account on an annual basis",
    "source": "https://denis.co.za/wp-content/uploads/2026/01/Medshield-Benefit-Table-2026-v2.pdf",
    "lastUpdated": "Jan-26"
  },
  {
    "scheme": "Medshield",
    "plan": "PREMIUM PLUS (686)",
    "administrator": "Denis",
    "contactInfo": {
      "email": [
        "customercare@denis.co.za or fax 086 000 2121"
      ],
      "fax": [
        " 086 000 2121"
      ],
      "phone": [
        "0861 033 647"
      ]
    },
    "networked": "Yes",
    "nonNetworkedPayment": "Yes",
    "balancedBilling": "Yes",
    "basicTreatment": "Yes with limitations",
    "rct": "Yes",
    "dentures": "Yes",
    "crownsOrBridges": "Yes",
    "implants": "Yes",
    "surgicalExtractions": "Yes",
    "exclusions": "Root canal therapy on primary (milk) teeth, third molars (wisdom teeth) Benefit not available for the clinical fee of denture repairs, denture tooth replacements and the addition of a soft base to new dentures; the laboratory fee will be covered (no pre-authorisation required). Diagnostic dentures, Provisional dentures . SPECIALISED DENTISTRY: The metal base to full dentures and the associated laboratory costs. Crowns and bridges on third molars. Laboratory fabricated temporary crowns. Provisional crowns and associated laboratory costs. Emergency crowns that are not placed for the immediate protection in tooth injury and Implants on third molars (wisdom teeth)",
    "preAuth": "Fillings: Granted once per tooth in 720 days. Multiple fillings: A treatment plan and X rays required . Plastic Dentures Pre-authorisation required One set of plastic dentures (an upper and a lower) per beneficiary in a 4-year period. Partial Chrome Cobalt Frame Dentures Pre-authorisation required Two partial frames (an upper and a lower) per beneficiary in a 5-year period . Crown & Bridge Pre-authorisation required. Implants Pre-auth required. General anaesthetic and hospitalisation benefits for Basic Dentistry are only available for children under the age of 6 years . General anaesthetic benefit available for the removal of impacted teeth. Pre-authorisation required.",
    "crucialRules": "Consultations Once per beneficiary every 6 months. X-rays: Intraoral Benefit subject to managed care protocols. X-rays: Extraoral Once every 3 years. fissure sealants: Limited to beneficiaries younger than 16 years of age Benefit for fluoride: Limited to beneficiaries from 5 and younger than 13 years of age, Once per beneficiary every 6 months",
    "notes": "Benefit for a mouth guard: Benefit available for both the clinical and the associated laboratory fee for a mouth guard (no preauthorisation required).Patient written Accountability form needed for procedures not covered. Personal Savings Account (PSA) On the Premium Plus option, Basic and Specialised Dentistry, unless otherwise stated, are payable from the PSA with accumulation to threshold, or from the above threshold benefit once the member has reached the threshold level. The PSA will be allocated to the member\u2019s account on an annual basis on the Premium Plus option.",
    "source": "https://denis.co.za/wp-content/uploads/2026/01/Medshield-Benefit-Table-2026-v2.pdf",
    "lastUpdated": "Jan-26"
  },
  {
    "scheme": "Medshield",
    "plan": "MEDICORE (685)",
    "administrator": "Denis",
    "contactInfo": {
      "email": [
        "customercare@denis.co.za or fax 086 000 2121"
      ],
      "fax": [
        " 086 000 2121"
      ],
      "phone": [
        "0861 033 647"
      ]
    },
    "networked": "Yes",
    "nonNetworkedPayment": "Yes",
    "balancedBilling": "Yes",
    "basicTreatment": "No",
    "rct": "No",
    "dentures": "No",
    "crownsOrBridges": "No",
    "implants": "No",
    "surgicalExtractions": "Yes",
    "exclusions": "NO benefits for ; SCALE AND POLISH, FISSURE SEALANTS, FLUORIDE TREATMENT, EXTRACTIONS, RESTORATION CODES, INCISION AND DRAINAGE OF ABSCESS, ROOT CANAL TREATMENT, PLASTIC DENTURES, CROWNS AND BRIDGES, METAL FRAME DENTURES, ORTHODONTICS,",
    "preAuth": "Hospitalisation: Basic Dentistry: General anaesthetic and hospitalisation benefits for Basic Dentistry are only available for children under the age of 6 years for extensive dental treatment. Sedation in Dental : Basic Dentistry (beneficiaries under the age of 6): Anaesthetist and dental accounts payable at the MDT from the OAL.",
    "crucialRules": "Oral Surgery: Covered at the MDT; payable from the Maxillo-facial limit of R13 610 per family. Maxillo-facial Surgery: Covered at the MDT; the doctor\u2019s account can be covered up to 200% of MDT Payable from the Maxillo-facial limit of R16 000 per family",
    "notes": "Patient written consent needed for procedures not covered. 2. Lower rate applies to non network provider",
    "source": "https://denis.co.za/wp-content/uploads/2026/01/Medshield-Benefit-Table-2026-v2.pdf",
    "lastUpdated": "Jan-26"
  },
  {
    "scheme": "Medshield",
    "plan": "Medicurve",
    "administrator": "Denis",
    "contactInfo": {
      "email": [
        "customercare@denis.co.za or fax 087 000 2121"
      ],
      "fax": [
        " 087 000 2121"
      ],
      "phone": [
        "0861 033 647"
      ]
    },
    "networked": "Yes",
    "nonNetworkedPayment": "Yes",
    "balancedBilling": "Yes",
    "basicTreatment": "No",
    "rct": "No",
    "dentures": "No",
    "crownsOrBridges": "No",
    "implants": "No",
    "surgicalExtractions": "No",
    "exclusions": "Root Canal Therapy and Extractions No benefit. Plastic Dentures and Associated Laboratory Costs No benefit . SPECIALISED DENTISTRY No benefit. Hospitalisation: Basic Dentistry No benefit. Root Canal Therapy and Extractions No benefit. Plastic Dentures No benefit.",
    "preAuth": "Hospitalisation: Impacted Teeth* *Pre-authorisation required. Deep Sedation in the Dental Rooms Pre-authorisation required Benefit subject to managed care protocols ONLY for Impacted Teeth: Oral Surgery* (Non-elective surgery only) *Pre-authorisation required. Hospitalisation: Impacted Teeth* *Pre-authorisation required. Moderate/Deep Sedation in the Dental Rooms *Pre-authorisation required ONLY for Impacted Teeth:",
    "crucialRules": "8101 One dental examination (code 8101) with a R150 upfront co-payment per beneficiary; the visit in the following year must be scheduled at least 6 months after the visit in the previous year. 8104 One specific consultation (emergency) for pain and sepsis per beneficiary per year. 8107 and/or 8112 Four X-rays in total per beneficiary per year. One Extraoral X-ray (8115) per beneficiary per lifetime. One polish (8155), or one scaling and polishing (8159) per beneficiary per year; . 8163 One per tooth in a 3-year period for beneficiaries younger than 16 years of age. Benefit for 4 fillings per beneficiary per year Benefit for fillings are granted once per tooth in 720 days . 8201 Extraction of tooth or exposed roots .",
    "notes": "Patient written consent needed for procedures not covered. 2. Lower rate applies to non network provider",
    "source": "https://denis.co.za/wp-content/uploads/2026/01/Medshield-Benefit-Table-2026-v2.pdf",
    "lastUpdated": "Jan-26"
  },
  {
    "scheme": "Momentum",
    "plan": "Evolve",
    "administrator": "Momentum",
    "contactInfo": {
      "email": [
        "fax 031 573 4016"
      ],
      "fax": [],
      "phone": [
        "0860 117 859"
      ]
    },
    "networked": "Yes",
    "nonNetworkedPayment": "No",
    "balancedBilling": "Yes",
    "basicTreatment": "Yes with limitations",
    "rct": "Yes available Personal Medical Savings Account or HealthSaver+",
    "dentures": "Yes available Personal Medical Savings Account or HealthSaver+",
    "crownsOrBridges": "Yes available Personal Medical Savings Account or HealthSaver+",
    "implants": "Yes available Personal Medical Savings Account or HealthSaver+",
    "surgicalExtractions": "Yes available Personal Medical Savings Account or HealthSaver+",
    "exclusions": "Regular dental treatments (like fillings and specialised dentistry such as crowns/bridges) are not paid as a standard benefit on Evolve \u2014 whether you use a network dentist or not.",
    "preAuth": "Impacted Wisdom Teeth: Extraction of impacted wisdom teeth in a doctor\u2019s rooms is covered from the Major Medical Benefit at 100% of the Momentum Medical Scheme Rate (MMSR), subject to a R1,820 co-payment and pre-authorisation.",
    "crucialRules": "On Evolve, you only get preventative dental care (e.g., basic checks up to a set amount) covered under the Health Platform Benefit (R500 per year) at any dental provider.",
    "notes": "Members receive one dental consultation per beneficiary per year paid for by the Health Platform Benefit. Preventative Benefit Limit: For, the preventative dental care benefit has increased to R500 per beneficiary per annum. HealthSaver+: Any additional basic dentistry (e.g., fillings, extractions, or cleanings) must be funded from your own pocket or through a voluntary Momentum HealthSaver+ account.",
    "source": "https://www.momentum.co.za/momentum/personal/medical-aid",
    "lastUpdated": "Jan-26"
  },
  {
    "scheme": "Momentum",
    "plan": "Custom",
    "administrator": "Momentum",
    "contactInfo": {
      "email": [
        "fax 031 573 4016"
      ],
      "fax": [],
      "phone": [
        "0860 117 859"
      ]
    },
    "networked": "Yes",
    "nonNetworkedPayment": "Yes",
    "balancedBilling": "Yes",
    "basicTreatment": "Yes with limitations",
    "rct": "Yes available Personal Medical Savings Account or HealthSaver+",
    "dentures": "Yes available Personal Medical Savings Account or HealthSaver+",
    "crownsOrBridges": "Yes available Personal Medical Savings Account or HealthSaver+",
    "implants": "Yes available Personal Medical Savings Account or HealthSaver+",
    "surgicalExtractions": "Yes available Personal Medical Savings Account or HealthSaver+",
    "exclusions": "Bone Augmentations \u2022 Bone and tissue regeneration procedures \u2022 Crowns and bridges for cosmetic reasons and associated laboratory costs \u2022 Enamel micro abrasion \u2022 Fillings: the cost of gold, precious metal, semi-precious metal and platinum foil \u2022 Laboratory delivery fees \u2022 Othognatic surgery \u2022 Sinus lift \u2022 Gum guards or mouth protectors",
    "preAuth": "Wisdom Teeth Extraction: Covered under the Major Medical Benefit (at 100% of the Momentum Medical Scheme Rate) for impacted wisdom teeth, subject to pre-authorisation. Wisdom Teeth Extraction: Covered under the Major Medical Benefit (at 100% of the Momentum Medical Scheme Rate) for impacted wisdom teeth, subject to pre-authorisation. Maxillo-facial surgery (excluding implants) and general anaesthesia for children under 7 are covered, but other dental work, such as implants, bridges, or crowns, is not covered by the main plan and requires payment via HealthSaver+.",
    "crucialRules": "Dental specialist accounts for extraction of impacted wisdom teeth in doctors\u2019 rooms: Covered from Major Medical Benefit at 100% of the Momentum Medical Scheme Rate, subject to R1 740 co-payment and pre-authorisation Other specialised dentistry: Subject to Momentum HealthSaver+ if available",
    "notes": "You can access your Momentum HealthSaver funds with the Multiply Money Card. The card allows you to pay for purchases and services from your Momentum HealthSaver funds",
    "source": "https://www.momentum.co.za/momentum/personal/medical-aid",
    "lastUpdated": "Jan-26"
  },
  {
    "scheme": "Momentum",
    "plan": "Incentive",
    "administrator": "Momentum",
    "contactInfo": {
      "email": [
        "fax 031 573 4016"
      ],
      "fax": [],
      "phone": [
        "0860 117 859"
      ]
    },
    "networked": "Yes",
    "nonNetworkedPayment": "Yes",
    "balancedBilling": "Yes",
    "basicTreatment": "Yes with limitations",
    "rct": "Yes available Personal Medical Savings Account or HealthSaver+",
    "dentures": "Yes available Personal Medical Savings Account or HealthSaver+",
    "crownsOrBridges": "Yes available Personal Medical Savings Account or HealthSaver+",
    "implants": "Yes available Personal Medical Savings Account or HealthSaver+",
    "surgicalExtractions": "Yes available Personal Medical Savings Account or HealthSaver+",
    "exclusions": "Bone Augmentations \u2022 Bone and tissue regeneration procedures \u2022 Crowns and bridges for cosmetic reasons and associated laboratory costs \u2022 Enamel micro abrasion \u2022 Fillings: the cost of gold, precious metal, semi-precious metal and platinum foil \u2022 Laboratory delivery fees \u2022 Othognatic surgery \u2022 Sinus lift \u2022 Gum guards or mouth protectors",
    "preAuth": "implants and other specialised dentistry (such as bridges or crowns) are not covered by the standard in-hospital or day-to-day risk benefits. Certain in-hospital dental and oral benefits are covered from the In-hospital Benefit. Co-payments may apply, depending on the procedure. ental specialist accounts for extraction of impacted wisdom teeth in doctors\u2019 rooms covered from Major Medical Benefit at 100% of the Momentum Medical Scheme Rate. You need to pay a R1 820 co-payment and pre-authorisation. Other specialised dentistry subject to Savings. If no Savings available, paid out-of-pocket or from HealthSaver+ if applicable.",
    "crucialRules": "Basic dentistry: Subject to Savings. Specialised dentistry:\nDental specialist accounts for extraction of impacted wisdom teeth in doctors\u2019 rooms: covered from Major Medical Benefit at 100% of the Momentum Medical Scheme Rate, subject to R1 590 co-payment and pre-authorisation. Other specialised dentistry: Subject to Savings or HealthSaver+open_in_new, if available. Dentistry \u2013 basic (such as extractions or fillings) Subject to Savings, if available",
    "notes": "You can access your Momentum HealthSaver funds with the Multiply Money Card. The card allows you to pay for purchases and services from your Momentum HealthSaver funds",
    "source": "https://www.momentum.co.za/momentum/personal/medical-aid",
    "lastUpdated": "Jan-26"
  },
  {
    "scheme": "Momentum",
    "plan": "Extender",
    "administrator": "Momentum",
    "contactInfo": {
      "email": [
        "fax 031 573 4016"
      ],
      "fax": [],
      "phone": [
        "0860 117 859"
      ]
    },
    "networked": "Yes",
    "nonNetworkedPayment": "Yes",
    "balancedBilling": "Yes",
    "basicTreatment": "Yes with limitations",
    "rct": "Yes available Personal Medical Savings Account or HealthSaver+",
    "dentures": "Yes available Personal Medical Savings Account or HealthSaver+",
    "crownsOrBridges": "Yes available Personal Medical Savings Account or HealthSaver+",
    "implants": "Yes available Personal Medical Savings Account or HealthSaver+",
    "surgicalExtractions": "Yes available Personal Medical Savings Account or HealthSaver+",
    "exclusions": "Bone Augmentations \u2022 Bone and tissue regeneration procedures \u2022 Crowns and bridges for cosmetic reasons and associated laboratory costs \u2022 Enamel micro abrasion \u2022 Fillings: the cost of gold, precious metal, semi-precious metal and platinum foil \u2022 Laboratory delivery fees \u2022 Othognatic surgery \u2022 Sinus lift \u2022 Gum guards or mouth protectors",
    "preAuth": "Dentistry \u2013 specialised (such as bridges or crowns) R15 500 per beneficiary, R40 400 per family Both in-and out-of-hospital dental specialist accounts accumulate towards the specialised dentistry limit Dental specialist accounts for extraction of impacted wisdom teeth in doctors\u2019 rooms: Covered from Major Medical Benefit at 100% of the Momentum Medical Scheme Rate, subject to R1 590 co-payment and pre-authorisation",
    "crucialRules": "Dentistry \u2013 basic (such as extractions or fillings) Unlimited . Dentistry \u2013 specialised (such as bridges or crowns). Both in-and out-of-hospital dental specialist accounts accumulate towards the limit. Dental specialist accounts for extraction of impacted wisdom teeth in doctors\u2019 rooms: Covered from Major Medical Benefit",
    "notes": "You can access your Momentum HealthSaver funds with the Multiply Money Card. The card allows you to pay for purchases and services from your Momentum HealthSaver funds",
    "source": "https://www.momentum.co.za/momentum/personal/medical-aid",
    "lastUpdated": "Jan-26"
  },
  {
    "scheme": "Momentum",
    "plan": "Summit",
    "administrator": "Momentum",
    "contactInfo": {
      "email": [
        "fax 031 573 4016"
      ],
      "fax": [],
      "phone": [
        "0860 117 859"
      ]
    },
    "networked": "Yes",
    "nonNetworkedPayment": "Yes",
    "balancedBilling": "Yes",
    "basicTreatment": "Yes with limitations",
    "rct": "Yes available Personal Medical Savings Account or HealthSaver+",
    "dentures": "Yes available Personal Medical Savings Account or HealthSaver+",
    "crownsOrBridges": "Yes available Personal Medical Savings Account or HealthSaver+",
    "implants": "Yes available Personal Medical Savings Account or HealthSaver+",
    "surgicalExtractions": "Yes available Personal Medical Savings Account or HealthSaver+",
    "exclusions": "Bone Augmentations \u2022 Bone and tissue regeneration procedures \u2022 Crowns and bridges for cosmetic reasons and associated laboratory costs \u2022 Enamel micro abrasion \u2022 Fillings: the cost of gold, precious metal, semi-precious metal and platinum foil \u2022 Laboratory delivery fees \u2022 Othognatic surgery \u2022 Sinus lift \u2022 Gum guards or mouth protectors",
    "preAuth": "Dentistry \u2013 specialised (such as bridges or crowns) R17 800 per beneficiary, R42 900 per family. Subject to overall annual day-to-day limit of R29 700 per beneficiary. Both in- and out-of-hospital dental specialist accounts accumulate towards the limit Dental specialist accounts for extraction of impacted wisdom teeth in doctors\u2019 rooms: Covered from Major Medical Benefit at 100% of the Momentum Medical Scheme Rate, subject to pre-authorisation",
    "crucialRules": "Dentistry \u2013 basic (such as extractions or fillings) Subject to overall annual day-to-day limit, Dentistry \u2013 specialised (such as bridges or\ncrowns), Subject to overall. annual day-to-day limit of R28 000 per beneficiary. Both in- and outof-hospital dental specialist accounts accumulate towards the limit. Dental specialist accounts for extraction of impacted wisdom teeth in doctors\u2019 rooms: Covered from Major Medical Benefit.",
    "notes": "You can access your Momentum HealthSaver funds with the Multiply Money Card. The card allows you to pay for purchases and services from your Momentum HealthSaver funds",
    "source": "https://www.momentum.co.za/momentum/personal/medical-aid",
    "lastUpdated": "Jan-26"
  },
  {
    "scheme": "Moto Health Care",
    "plan": "CLASSIC OPTION AND CLASSIC NETWORK",
    "administrator": "DRC",
    "contactInfo": {
      "email": [
        "auth@dentalrisk.com"
      ],
      "fax": [],
      "phone": [
        "0879 439 611"
      ]
    },
    "networked": "Yes",
    "nonNetworkedPayment": "Yes",
    "balancedBilling": "Yes",
    "basicTreatment": "Yes with limitations",
    "rct": "Yes",
    "dentures": "Yes",
    "crownsOrBridges": "Yes",
    "implants": "Yes",
    "surgicalExtractions": "Yes",
    "exclusions": "Repairing of teeth damaged due to bruxism, toothbrush abrasion, erosion and fluorosis will not be covered. Replacement of non\u0002carious amalgam with resin will not be covered. Posterior teeth restorations cannot be performed across the midline",
    "preAuth": "More than 4 extractions per visit require pre auth. Surgical removal of erupted tooth Pre-Auth required. Pre-auth: \u2022 More than 3 restorations per visit. \u2022 Any 3 or 4 surface restorations on wisdom teeth (non-functional wisdom teeth not covered). \u2022 Multiple restorations on an anterior tooth on the same service date only per authorisation and x rays received. \u2022 Metal Frame Dentures, Crown and Bridges PRE AUTH. Hospitalisation; Pre-authorisation required apply Children under the age of 8 with extensive conservative (basic) dental treatment, limited to 1 admission per member per 24 months. Removal of impacted wisdom teeth but must be pre-authorised .",
    "crucialRules": "8101 Full mouth examination, charting and treatment planning Once per 6 months per member from date of service. 8104 consultation for a specific problem, Not within 4 weeks of an 8101, 8102, 8104. Fissure sealant Maximum of 8 can be charged per member, 2 per quadrant on members younger than 16 years. X-ray cannot be charged more than 7 times (per year).Root Canal Only covered on permanent teeth. One set of plastic dentures, full or partial (an upper and a lower) per beneficiary in a 4 year period for members. Implants \u2022 Placement covered in dental chair only.",
    "notes": "Pan Maximum 2 radiographs per member per treatment plan \u2013 per 24 months (six-month time lapse applies). Occlusal guard Pre-authorisation required. Repair of denture, Impression to repair denture, Rebase complete or partial denture, Remodel complete or partial denture, Reline, Soft base reline per denture (exclusion to new dentures, can only be claimed 6 months after new denture) 365 days per member. Patient written consent needed for procedures not covered. Bite Plate (lab codes must be included) Paid from Annual Savings 2. Lower rate applies to non network provider",
    "source": "https://dentalrisk.com/member-benefits/",
    "lastUpdated": "Jan-26"
  },
  {
    "scheme": "Moto Health Care",
    "plan": "Optimum",
    "administrator": "DRC",
    "contactInfo": {
      "email": [
        "auth@dentalrisk.com"
      ],
      "fax": [],
      "phone": [
        "0879 439 611"
      ]
    },
    "networked": "Yes",
    "nonNetworkedPayment": "Yes",
    "balancedBilling": "Yes",
    "basicTreatment": "Yes with limitations",
    "rct": "Yes",
    "dentures": "Yes",
    "crownsOrBridges": "Yes",
    "implants": "Yes",
    "surgicalExtractions": "Yes",
    "exclusions": "Repairing of teeth damaged due to bruxism, toothbrush abrasion, erosion and fluorosis will not be covered. Replacement of non\u0002carious amalgam with resin will not be covered. Posterior teeth restorations cannot be performed across the midline",
    "preAuth": "Occlusal guard Pre-authorisation required. Once every 24 months. More than 4 extractions per visit require pre-authorisation. Surgical removal of erupted tooth Pre-authorisation required. Pre-authorisation and x-rays required for: \u2022 More than 3 restorations per visit. \u2022 Any 3 or 4 surface restorations on wisdom teeth (non-functional wisdom teeth not covered). \u2022 Multiple restorations on an anterior tooth on the same service date only per authorisation . Root Canal Codes \u2013 Pre-authorisation needed. Dentures Codes \u2013 Pre-authorisation needed. Specialised Dentistry Subject to Pre-Authorisation, Dental sub limit and the Day to Day limit of:Member = R16 550 or Family = R24 550. Crown and Bridges \u2022 Pre-authorisation required. Hospitalisation Pre-authorisation.",
    "crucialRules": "Full mouth examination, Once per 6 months per member from date of service. Consultation for a specific problem, Not within 4 weeks of an 8101, 8102, 8104. 8159,8155 Once per 6 months per member from date of service. 8161, Once per 6 months per member from date of service. XRAYS not more than 7 times (per year). 2 Panoramic radiograph per member per treatment plan. Fissure sealant Maximum of 8 can be charged per member. than 16 Metal Frame Dentures 1 Frame in 5 years per member. Crown and Bridges \u2022 Pre-authorisation required. Lower jaw posterior fillings involving anaesthetic cannot be performed across the midline. \u2022 Deviations will only be covered if pre-authorised",
    "notes": "Repair of denture, Impression to repair denture, Rebase complete or partial denture, Remodel complete or partial denture, Reline, Soft base reline per denture (exclusion to new dentures, can only be claimed 6 months after new denture) 365 days per member. Patient written consent needed for procedures not covered. 2. Lower rate applies to non network provider",
    "source": "https://dentalrisk.com/member-benefits/",
    "lastUpdated": "Jan-26"
  },
  {
    "scheme": "Moto Health Care",
    "plan": "Custom and Essential Options",
    "administrator": "Primecure",
    "contactInfo": {
      "email": [
        "hprimecure@mhs.co.za"
      ],
      "fax": [],
      "phone": [
        "0861 497 587"
      ]
    },
    "networked": "Yes",
    "nonNetworkedPayment": "No",
    "balancedBilling": "Yes",
    "basicTreatment": "Yes with limitations",
    "rct": "No",
    "dentures": "Yes",
    "crownsOrBridges": "No",
    "implants": "No",
    "surgicalExtractions": "No",
    "exclusions": "No panorex. Specialised dentistry such as bridges, crowns, surgical extractions, implants, root canals,gold fillings, dentures and braces are not covered",
    "preAuth": "8201 & 8202 Combined maximum of four per year with an additional four allowed upon pre-authorisation. Maximum four restorations per year with an additional four allowed only upon preauthorisation. Posterior amalgam and resin fillings are remunerated at the same tariff. More than four Xrays per annum combined, unless otherwise authorised.",
    "crucialRules": "8101 One per beneficiary per annum. 8104 Not within six weeks of 8101 or 8104. 8155 & 8159 Once per annum per member (either or 8155) 8161 Maximum of one per child per year for patients younger than 12 years. 8163 Maximum of two per child per year for patients younger than 12 years. 8935 Septic socket treatment Once per tooth. Emergency root canal treatment Not covered on primary teeth.",
    "notes": "Member consent for out-of-benefit dental procedures form. On the network options, members only have benefits for general extractions. Should you need to do a surgical removal of a tooth, patients need to be informed of this prior to or on the day of service for the patient to be held responsible for the outstanding amount.",
    "source": "https://content.momentum.co.za/mmsa/complete_health/pdfs/Sales%20Tools/Provider%20Search/2026/2026_MHS_Dental_Network_guide_54.pdf",
    "lastUpdated": "Jan-26"
  },
  {
    "scheme": "NATIONAL HEALTHCARE GROUP (NHG)",
    "plan": "NHG Connect Plan NHG Elite Plan NHG Premier Plan",
    "administrator": "Denis",
    "contactInfo": {
      "email": [
        "customercare@denis.co.za"
      ],
      "fax": [],
      "phone": [
        "0861 445 566"
      ]
    },
    "networked": "There will be no benefit for out-of-network visits and treatment.",
    "nonNetworkedPayment": "No",
    "balancedBilling": "No",
    "basicTreatment": "Yes with limitations",
    "rct": "Root Canal Treatment Emergency only",
    "dentures": "No",
    "crownsOrBridges": "No",
    "implants": "No",
    "surgicalExtractions": "No",
    "exclusions": "There is no benefit for: Root Canal Therapy, Dentures, Specialised Dentistry, Inhalation Sedation in Dental Rooms, Moderate/Deep Sedation in Dental Rooms and Dental Treatment in hospital.",
    "preAuth": "Motivation and records required for more than 5 fillings per dependant per year Motivation required for 3 or 4 surface fillings on wisdom teeth (3rd Molars) Benefit for fillings is granted once per tooth in 9 months. 8132 Pulpectomy (pain relief) Not covered on primary teeth",
    "crucialRules": "8101 Two consultations per dependant per year (once every 6 months). 8104 Specific consultation One specific consultation for pain and sepsis per dependant per year; not within 4 weeks of 8101. 8107 and/or 8112 Maximum of 2 X-rays films per visit per dependant . Two polishing and scaling treatments per dependant per year (once every 6 months 8155 or 8159). 8161 Two treatments per year for dependants younger than 12 years of age (once every 6 months) . 8201 Extractions (removal of teeth) Extraction of tooth or exposed roots",
    "notes": "There will be no benefit for out-of-network visits and treatment.",
    "source": "https://denis.co.za/wp-content/uploads/2025/12/NHG-Health-Benefit-Table-2026-v1-1.pdf",
    "lastUpdated": "Jan-26"
  },
  {
    "scheme": "NBCPSS National Bargaining Council for Private Security Sector",
    "plan": "",
    "administrator": "DRC",
    "contactInfo": {
      "email": [
        "auth@dentalrisk.com"
      ],
      "fax": [],
      "phone": [
        "0879 439 612"
      ]
    },
    "networked": "Yes",
    "nonNetworkedPayment": "No",
    "balancedBilling": "No",
    "basicTreatment": "Yes with limitations",
    "rct": "No",
    "dentures": "No",
    "crownsOrBridges": "No",
    "implants": "No",
    "surgicalExtractions": "Yes",
    "exclusions": "Scale and Polish NO BENEFITS. Pan Scan NO BENEFITS. Bite Plate NO BENEITS. Mouth Guard NO BENEFITS. Root Canal NO BENEFITS. Temporary Crown NO BENEFITS",
    "preAuth": "3 Restorations per member per covered period. \u2022 1 Restoration code per tooth number in a 9 month period. \u2022 Pre-authorisation and x-rays required for any 3 or 4 surface restorations on wisdom teeth.",
    "crucialRules": "Surgical removal is only\ncovered when authorised with an intraoral radiograph. 8935 Treatment of septic socket More than 1 treatment per visit requires authorisation.",
    "notes": "",
    "source": "https://dentalrisk.com/member-benefits/",
    "lastUpdated": "Jan-26"
  },
  {
    "scheme": "NBCRFLI (National Bargaining Council for the Road Freight & Logistics Industry)",
    "plan": "",
    "administrator": "DRC",
    "contactInfo": {
      "email": [
        "auth@dentalrisk.com"
      ],
      "fax": [],
      "phone": [
        "0879 439 612"
      ]
    },
    "networked": "Yes",
    "nonNetworkedPayment": "No",
    "balancedBilling": "No",
    "basicTreatment": "Yes with limitations",
    "rct": "No",
    "dentures": "No",
    "crownsOrBridges": "No",
    "implants": "No",
    "surgicalExtractions": "Yes",
    "exclusions": "Scale and Polish NO BENEFITS. Pan Scan NO BENEFITS. Bite Plate NO BENEITS. Mouth Guard NO BENEFITS. Root Canal NO BENEFITS. Temporary Crown NO BENEFITS",
    "preAuth": "3 Restorations per member per covered period. \u2022 1 Restoration code per tooth number in a 9 month period. \u2022 Pre-authorisation and x-rays required for any 3 or 4 surface restorations on wisdom teeth.",
    "crucialRules": "Surgical removal is only\ncovered when authorised with an intraoral radiograph. 8935 Treatment of septic socket More than 1 treatment per visit requires authorisation.",
    "notes": "Limited to R800 per member per event. \u2022 Limited to R2 400 per member per 18 months\u2019 period.",
    "source": "https://dentalrisk.com/member-benefits/",
    "lastUpdated": "Jan-26"
  },
  {
    "scheme": "NHG MediClub Elite",
    "plan": "NHG MediClub Elite",
    "administrator": "Denis",
    "contactInfo": {
      "email": [
        "customercare@denis.co.za"
      ],
      "fax": [],
      "phone": [
        "0861 033 647"
      ]
    },
    "networked": "There will be no benefit for out-of-network visits and treatment.",
    "nonNetworkedPayment": "No",
    "balancedBilling": "No",
    "basicTreatment": "Yes with limitations",
    "rct": "No",
    "dentures": "No",
    "crownsOrBridges": "No",
    "implants": "No",
    "surgicalExtractions": "No",
    "exclusions": "There is no benefit for: Root Canal Therapy, Dentures, Specialised Dentistry, Inhalation Sedation in Dental Rooms, Moderate/Deep Sedation in Dental Rooms and Dental Treatment in hospital.",
    "preAuth": "Fillings Motivation and records required for more than 5 fillings per dependant per year Motivation required for 3 or 4 surface fillings on wisdom teeth (3rd Molars) Benefit for fillings is granted once per tooth in 9 months",
    "crucialRules": "8101 Full mouth examination, Two consultations per dependant per year (once every 6 months). 8104 Specific consultation One specific consultation for pain and sepsis per dependant per year; not within 4 weeks of 8101. 8107 and/or 8112 Maximum of 2 X-rays films per visit per member. Code 815 & 8155 Once per 6 months per member from date of service. 8161, Once per 6 months per member from date of service. 8201 Extractions (removal of teeth) Extraction of tooth or exposed roots",
    "notes": "Benefits payable on the NHG MediClub Elite Plan is subject to the use of a Network Service Provider on the DENIS Dental Network. There will be no benefit for out-of-network visits and treatment.",
    "source": "https://denis.co.za/wp-content/uploads/2025/12/NHG-MediClub-Day-to-Day-Health-Benefit-Table-2026-v1.pdf",
    "lastUpdated": "Jan-26"
  },
  {
    "scheme": "Old Mutual Health Solutions (OMHS)",
    "plan": "COMPREHENSIVE ADVANCED OMPREHENSIVE PLUS COMPREHENSIVE STANDARD PLAN PRIMARY STANDARD PRIMARY STANDARD PLUS GOLDEN HOUR PRIMARY STANDARD PLUS HOSPITAL PLAN",
    "administrator": "Denis",
    "contactInfo": {
      "email": [
        "customercare@denis.co.za"
      ],
      "fax": [],
      "phone": [
        "0862 445 566"
      ]
    },
    "networked": "There will be no benefit for out-of-network visits and treatment.",
    "nonNetworkedPayment": "No",
    "balancedBilling": "No",
    "basicTreatment": "Yes with limitations",
    "rct": "Root Canal Treatment Emergency only",
    "dentures": "No",
    "crownsOrBridges": "No",
    "implants": "No",
    "surgicalExtractions": "No",
    "exclusions": "There is no benefit for: Root Canal Therapy, Dentures, Specialised Dentistry, Inhalation Sedation in Dental Rooms, Moderate/Deep Sedation in Dental Rooms and Dental Treatment in hospital.",
    "preAuth": "Motivation and records required for more than 5 fillings per dependant per year Motivation required for 3 or 4 surface fillings on wisdom teeth (3rd Molars) Benefit for fillings is granted once per tooth in 9 months",
    "crucialRules": "8101 Full mouth examination, Two consultations per dependant per year (once every 6 months). 8104 Specific consultation One specific consultation for pain and sepsis per dependant per year; not within 4 weeks of 8101. 8107 and/or 8112 Maximum of 2 X-rays films per visit per dependant . Two polishing and scaling treatments per dependant per year (once every 6 months 8155 or 8159). 8161 Fluoride treatment Two treatments per year for dependants younger than 12 years of age (once every 6 months) 8201 Extractions (removal of teeth) Extraction of tooth or exposed roots .",
    "notes": "8132 Pulpectomy (pain relief) Not covered on primary teeth. There will be no benefit for out-of-network visits and treatment. The following products offered by Old Mutual Health Solutions do not include benefits for out-of-hospital\ndental treatment: Hospital Plan, Golden Hour, Golden Hour with Hospital Plan, and Golden Hour with Hospital\nDirect GP Visit.",
    "source": "https://denis.co.za/wp-content/uploads/2025/12/Old-Mutual-Health-Solutions-Benefit-Table-2026-v1.pdf",
    "lastUpdated": "Jan-26"
  },
  {
    "scheme": "Old Mutual Staff",
    "plan": "Network & network select",
    "administrator": "Universal",
    "contactInfo": {
      "email": [
        "enquiries@omsmaf.co.za"
      ],
      "fax": [],
      "phone": [
        "0860 100 076"
      ]
    },
    "networked": "Yes",
    "nonNetworkedPayment": "Yes",
    "balancedBilling": "No",
    "basicTreatment": "Yes with limitations",
    "rct": "No",
    "dentures": "No",
    "crownsOrBridges": "No",
    "implants": "No",
    "surgicalExtractions": "Yes",
    "exclusions": "No benefits for pulpotomy. No benefits for surgical removal of impacted teeth. No panorex.",
    "preAuth": "Fillings pre\u0002authorisation required if >4 per annum per beneficiary . Only anterior composite fillings are covered. Pre-authorisation required for 4 or more extractions per annum per beneficiary. Wisdom teeth extractions to be done in dentist\u2019s rooms under local anaesthesia. Oral Radiographs Pre authorisation required if >2 per beneficiary per annum. Root Canal Treatment . 80% of cost payable by the scheme and includes professional and laboratory fees. 20% member liability",
    "crucialRules": "Limited to 1 consultation per beneficiary. One set of dentures every 24 months per beneficiary. A 20% co- payment applies. Restorations /Composite Fillings Preauthorisation required if >4 per annum per beneficiary. Only anterior composite fillings are covered. Extractions re-authorisation required for 4 or more extractions per annum per beneficiary. Teeth extractions to be done in dentist\u2019s rooms under local anaesthesia. Oral Radiographs Pre authorisation required if >2 per beneficiary per annum. Root Canal Treatment Emergency only.",
    "notes": "Confirmation of benefits is not a guarantee of payment \u2013An authorisation granted is not a guarantee of payment",
    "source": "https://omsmaf.co.za/brochures/",
    "lastUpdated": "Jan-26"
  },
  {
    "scheme": "Old Mutual Staff",
    "plan": "Traditional & Traditional select",
    "administrator": "Old Mutual",
    "contactInfo": {
      "email": [
        "enquiries@omsmaf.co.za"
      ],
      "fax": [],
      "phone": [
        "0860 100 076"
      ]
    },
    "networked": "Yes",
    "nonNetworkedPayment": "Yes",
    "balancedBilling": "No",
    "basicTreatment": "Yes with limitations",
    "rct": "Yes",
    "dentures": "Yes",
    "crownsOrBridges": "Yes",
    "implants": "Yes",
    "surgicalExtractions": "Yes",
    "exclusions": "Fillings: \u2022 Exclusions: Fillings to restore teeth due to toothbrush abrasion; attrition; erosion Resin bonding that is charged separately Polishing of restorations\n Gold foil restorations Ozone Therapy.",
    "preAuth": "\u2022 Composite and amalgam fillings can be replaced once every two years per individual tooth. Motivation required if less than 2 years. Extractions. \u2022 1 set of plastic dentures (an upper and a lower) per beneficiary per three years \u2022 Partial dentures consisting of more than 9 teeth require clinical motivation. mmediate dentures: one tissue conditioning and one reline/rebase allowed. \u2022 2 metal dentures (2 frames for upper and lower jaws) allowed per beneficiary per 4 year cycle \u2022 Partial metal dentures of more than 9 teeth require motivation as to why a full denture cannot be made \u2022 All implant supported dentures even though they are modified plastic dentures. Crowns; Bridges Preauthorisation required . Implants and associated costs. Pre-authorisation required. \u2022 Beneficiary must be > 18 years old \u2022 Motivation required for beneficiaries > 70 years old. Hospitalisation (General anaesthetic) Children younger than 8 years on the Traditional, Traditional Plus (including Select) and Savings Plans Removal of impacted wisdom teeth (if the beneficiary is older than 30 years, a clinical motivation will be required)",
    "crucialRules": "Consultations \u2022 2 annual checks ups per beneficiary per year. X Rays: Intraoral / Extraoral \u2022 Subject to clinical protocols. Scaling and polishing \u2013 2 per annum with routine check-ups per beneficiary. \u2022 Oral hygiene instructions \u2013 1 per annum per beneficiary. issure sealant \u2022 Only in beneficiaries < 21 years old. Root canal therapy One root canal therapy allowed per tooth per lifetime",
    "notes": "Occlusal guards \u2022 Only allowed in cases for preservation of tooth structure and maintenance of the periodontium",
    "source": "https://omsmaf.co.za/brochures/",
    "lastUpdated": "Jan-26"
  },
  {
    "scheme": "PG Group",
    "plan": "PG GROUP",
    "administrator": "Denis",
    "contactInfo": {
      "email": [
        "pgenq@denis.co.za"
      ],
      "fax": [],
      "phone": [
        "0860 104 939"
      ]
    },
    "networked": "Yes",
    "nonNetworkedPayment": "Yes",
    "balancedBilling": "Yes",
    "basicTreatment": "Yes with limitations",
    "rct": "Yes",
    "dentures": "Yes",
    "crownsOrBridges": "Yes",
    "implants": "Yes",
    "surgicalExtractions": "Yes",
    "exclusions": "Fillings to restore teeth due to toothbrush abrasion; attrition; erosion Gold foil restorations Ozone Therapy. Crown & Bridge. Crowns on third molars (wisdom teeth. . Laboratory fabricated temporary crowns. Occlusal rehabilitations and associated laboratory costs. Provisional crowns and associated laboratory costs. Porcelain veneers and inlays. Emergency crowns that are not placed for the immediate protection in tooth injury and associated laboratory costs The cost of gold, precious metal, semi-precious metal and platinum foil. Laboratory delivery fees.",
    "preAuth": "Plastic Dentures Pre-authorisation required One set of plastic dentures (an upper and a lower) per beneficiary in a 4-year period . Partial Chrome Cobalt Frame Dentures Pre-authorisation required Two partial frames (an upper and a lower) per beneficiary in a 5-year period . Crown & Bridge Pre-authorisation required Three crowns per family per year. Pre-authorisation required Two implants per beneficiary in a 5-year period . General anaesthetic benefit available for children under the age of 5 years for extensive dental treatment. General anaesthetic benefit available for the removal of impacted teeth.Pre-authorisation required.",
    "crucialRules": "Two check-ups per beneficiary per year (once every 6 months). X-rays: Intraoral Benefit subject to managed care protocols. X-rays: Extraoral One per beneficiary in a 3-year period . Two annual scale and polish treatments per beneficiary (once every 6 months). Benefit for fluoride: Limited to beneficiaries from age 5 and younger than 13 years of age. Root Canal Therapy and Extractions Benefit subject to managed care protocols .",
    "notes": ". Benefit not available for the clinical fee of denture repairs, denture tooth replacements and the addition of a soft base to new dentures; the laboratory fee will be covered (no pre-authorisation required). \u2022 Benefit for a mouth guard: Benefit available for both the clinical and the associated laboratory fee for a mouth guard (no pre-authorisation required).",
    "source": "https://denis.co.za/wp-content/uploads/2025/12/PG-Group-Dental-Benefit-Table-2026-v1.pdf",
    "lastUpdated": "Jan-26"
  },
  {
    "scheme": "Pick n pay",
    "plan": "Primary (Carecross)",
    "administrator": "Primecure",
    "contactInfo": {
      "email": [
        "primecure@mhs.co.za"
      ],
      "fax": [],
      "phone": [
        "0861 497 587"
      ]
    },
    "networked": "Yes",
    "nonNetworkedPayment": "No",
    "balancedBilling": "Yes",
    "basicTreatment": "Yes with limitations",
    "rct": "No",
    "dentures": "No",
    "crownsOrBridges": "No",
    "implants": "No",
    "surgicalExtractions": "No",
    "exclusions": "No panorex. Specialised dentistry such as bridges, crowns, surgical extractions, implants, root canals,gold fillings, dentures and braces are not covered",
    "preAuth": "8201 & 8202 Combined maximum of four per year with an additional four allowed upon pre-authorisation. Maximum four restorations per year with an additional four allowed only upon preauthorisation. Posterior amalgam and resin fillings are remunerated at the same tariff.",
    "crucialRules": "8101 One per beneficiary per annum. 8104 Not within six weeks of 8101 or 8104. 8107/8112 Maximum four per annum combined, unless otherwise authorised. 8155 & 8159 Once per annum per member (either or 8155) 8161 Maximum of one per child per year for patients younger than 12 years. 8163 Maximum of two per child per year for patients younger than 12 years. 8935 Septic socket treatment Once per tooth.",
    "notes": "Patient written consent needed for procedures not covered.",
    "source": "https://content.momentum.co.za/mmsa/complete_health/pdfs/Sales%20Tools/Provider%20Search/2026/2026_MHS_Dental_Network_guide_54.pdf",
    "lastUpdated": "Jan-26"
  },
  {
    "scheme": "Pick n pay",
    "plan": "Plus",
    "administrator": "momentum",
    "contactInfo": {
      "email": [
        "picknpay@mhg.co.za"
      ],
      "fax": [],
      "phone": [
        "0800 004 389"
      ]
    },
    "networked": "Yes",
    "nonNetworkedPayment": "Yes",
    "balancedBilling": "Yes",
    "basicTreatment": "Yes with limitations",
    "rct": "Yes",
    "dentures": "Yes",
    "crownsOrBridges": "Yes",
    "implants": "Yes",
    "surgicalExtractions": "Yes",
    "exclusions": "Gum guards for sport purposes, gold in dentures and the cost of gold as an alternative to non-precious metal in crowns, inlays and bridges and bleaching of teeth",
    "preAuth": "Specialised dentistry, orthodontic, periodontic, crowns, bridgework, dentures, dental implants and osseo-integration Subject to MSA balance. Impacted Wisdom Teeth Extraction.",
    "crucialRules": "(i) Conservative dentistry, fillings, extractions, X-rays and prophylaxis Subject to MSA balance.",
    "notes": "Patient written consent needed for procedures not covered. Conservative dentistry \u2013 fillings, extractions, X-rays and prophylaxis: R2 600 per family per year, payable from the insured benefit, thereafter subject to MSA balance.",
    "source": "https://www.pnpms.co.za/benefits/plus-option",
    "lastUpdated": "Jan-26"
  },
  {
    "scheme": "Platinum health",
    "plan": "Plat Comprehensive",
    "administrator": "Platinum health",
    "contactInfo": {
      "email": [
        "hospitalconfirmations@platinumhealth.co.za"
      ],
      "fax": [],
      "phone": [
        "0800 006 942"
      ]
    },
    "networked": "Yes",
    "nonNetworkedPayment": "Yes",
    "balancedBilling": "Yes",
    "basicTreatment": "Yes with limitations",
    "rct": "Yes",
    "dentures": "Yes",
    "crownsOrBridges": "Yes",
    "implants": "Yes",
    "surgicalExtractions": "Yes",
    "exclusions": "Gum guards for sport purposes, gold in dentures and the cost of gold as an alternative to non-precious metal in crowns, inlays and bridges and bleaching of teeth",
    "preAuth": "Authorisation is required for specialised dentistry and conscious sedation treatment which is subject to managed care protocol and processes. Dentures shall be limited to one set every three years from anniversary of claiming PB, subject to benefit limit. The Scheme will accept liability for the under mentioned treatment and a 15% co-payment of the benefit limit shall apply: Internal and External orthodontic treatment Prosthodontics, periodontics, and endodontic treatment Porcelain veneers and inlays Crown and Bridge work Metal Dentures External laboratory services",
    "crucialRules": "A 15% co-payment of the benefit limit shall apply in respect of the repair and replacement of dentures. Dentures are limited to one set every three years from anniversary of claiming per beneficiary, subject to your benefit limit of R13,914 per family.",
    "notes": "General anaesthetic and hospitalisation for conservative dental work excluded, except in the case of trauma, patients under the age of eight years and impacted third molars.",
    "source": "https://www.platinumhealth.co.za/our-options/",
    "lastUpdated": "Jan-26"
  },
  {
    "scheme": "Platinum health",
    "plan": "Plat Freedom",
    "administrator": "Platinum health",
    "contactInfo": {
      "email": [
        "fax 086 233 2406"
      ],
      "fax": [],
      "phone": [
        "0800 006 942"
      ]
    },
    "networked": "Yes",
    "nonNetworkedPayment": "No",
    "balancedBilling": "No",
    "basicTreatment": "Yes with limitations",
    "rct": "Yes",
    "dentures": "Yes",
    "crownsOrBridges": "Yes",
    "implants": "Yes",
    "surgicalExtractions": "Yes",
    "exclusions": "Gum guards for sport purposes, gold in dentures and the cost of gold as an alternative to non-precious metal in crowns, inlays and bridges and bleaching of teeth",
    "preAuth": "Pre authorisation for basic dentistry performed inhospital for children under eight (8) and for removal of impacted wisdom teeth. Authorisation required for advanced dentistry, subject to clinical protocol approval. R16 800 per member family. Advanced: Oral surgery, plastic/metal base dentures, inlays, crowns, bridges, study models, orthodontics, periodontics, prosthodontics, Osseo integrated implants, orthognathic surgery and dental technician fees. uthorisation required for advanced dentistry and conscious sedation",
    "crucialRules": "Your annual limit for specialised dentistry is R17 391 per family. \u2022 We pay 100% of the lower of cost or Scheme rate. \u2022 You can get one set of dentures every three years from claiming, subject to the benefit limit of R17 391",
    "notes": "",
    "source": "https://www.platinumhealth.co.za/our-options/",
    "lastUpdated": "Jan-26"
  },
  {
    "scheme": "Platinum health",
    "plan": "Platcap",
    "administrator": "Platinum health",
    "contactInfo": {
      "email": [
        "fax 086 233 2406"
      ],
      "fax": [],
      "phone": [
        "0800 006 942"
      ]
    },
    "networked": "Yes",
    "nonNetworkedPayment": "No",
    "balancedBilling": "No",
    "basicTreatment": "Yes with limitations",
    "rct": "Yes",
    "dentures": "Yes",
    "crownsOrBridges": "Yes",
    "implants": "Yes",
    "surgicalExtractions": "Yes",
    "exclusions": "Gum guards for sport purposes, gold in dentures and the cost of gold as an alternative to non-precious metal in crowns, inlays and bridges and bleaching of teeth",
    "preAuth": "Dentures only One set of plastic dentures PB. Dentures shall be limited to one set of plastic dentures per 3 consecutive years PB, applicable over age of 21 years. (20% co-payment applies). General anaesthetic and hospitalisation benefits for Basic Dentistry are only available for children under the age of 6 years . General anaesthetic benefit available for the removal of impacted teeth. Pre-authorisation required. Deep Sedation Basic Dentistry (beneficiaries under and over the age of 7)and Impacted Teeth.",
    "crucialRules": "Dentures : We pay 80% medical scheme rates and you have to pay a 20% copayment.",
    "notes": "\u2022 Dentures shall be limited to one set of plastic dentures per 3 consecutive years PB, applicable over age of 21 years. (20% co-payment applies)",
    "source": "https://www.platinumhealth.co.za/our-options/",
    "lastUpdated": "Jan-26"
  },
  {
    "scheme": "Polmed",
    "plan": "Marine",
    "administrator": "Denis",
    "contactInfo": {
      "email": [
        "polmedhospitalauthorisations@denis.co.za",
        "polmedcustomerservice@denis.co.za"
      ],
      "fax": [],
      "phone": [
        "0860 765 633"
      ]
    },
    "networked": "Yes",
    "nonNetworkedPayment": "Yes",
    "balancedBilling": "Yes",
    "basicTreatment": "Yes with limitations",
    "rct": "Yes",
    "dentures": "Yes",
    "crownsOrBridges": "Yes",
    "implants": "No",
    "surgicalExtractions": "Yes",
    "exclusions": "NO BENEFITS FOR IMPLANTS",
    "preAuth": "Pre-authorisation is required for: Metal Frame Dentures, Crown & Bridge, Orthodontics, Periodontics, Hospital Admissions and Moderate / Deep Sedation in the Dental Rooms. General anaesthetic benefit available\nfor children under the age of 7 years for extensive dental treatment. \u2022 Dental practitioner claims paid from Basic Dentistry limit, subject to OOH limit\u2022 General anaesthetic benefit available for the removal of impacted teeth. Sedation in the Dental Rooms Benefit limited to extensive dental treatment and removal of impacted teeth only.",
    "crucialRules": "Benefit for fillings: Granted once per tooth in 720 days. Conservative Dentistry Funded from Basic Dentistry limit, subject to OOH limit. enefit for fissure sealants: Limited to beneficiaries between the ages of 5 and 25. Available from the Preventative Care Benefit ; limited to four per beneficiary in 12 months. Plastic Dentures Two plastic dentures per beneficiary in a 4 -year period .",
    "notes": "Lower rate applies to non network provider Conservative d ental benefits are paid at the P olmed Dental Tariff (PDT) Subject to the applicable Dental. Sublimit and Out-Of-Hospital ( OOH ) Limits. o M0 \u2014 R7 348 (OOH \u2014 R17 428) o M1 \u2014 R8 307 (OOH \u2014 R30 479 ) o M2 \u2014 R9 099 (OOH \u2014 R36 746 ) o M3 \u2014 R10 143 (OOH \u2014 R42 208 ) o M4+ \u2014 R11 318(OOH \u2014 R45 901 ) Specialised dental benefits are paid at the P olmed Dental Tariff subject to the Specialised Dental Limit of R18 042 per family per year.",
    "source": "https://denis.co.za/wp-content/uploads/2025/12/Polmed-Dental-Benefit-Tables-2026-v1.pdf",
    "lastUpdated": "Jan-26"
  },
  {
    "scheme": "Polmed",
    "plan": "Aquarium",
    "administrator": "Denis",
    "contactInfo": {
      "email": [
        "polmedhospitalauthorisations@denis.co.za",
        "polmedcustomerservice@denis.co.za"
      ],
      "fax": [],
      "phone": [
        "0860 765 633"
      ]
    },
    "networked": "Yes",
    "nonNetworkedPayment": "Yes",
    "balancedBilling": "Yes",
    "basicTreatment": "Yes with limitations",
    "rct": "Yes",
    "dentures": "Yes",
    "crownsOrBridges": "No",
    "implants": "No",
    "surgicalExtractions": "Yes",
    "exclusions": "NO BENEFITS FOR IMPLANTS, CROWNS & BRIDGES, METAL PARTIAL DENTURE",
    "preAuth": "Payable from Risk: \u2022 8941 (surgical removal of impacted tooth \u2013 first tooth) Payable from OOH: \u2022 8937 (surgical removal of tooth). General anaesthetic benefit available for children under the age of 7 years for extensive dental treatment.",
    "crucialRules": "Two check-ups per beneficiary per year (once every 6 months). X-rays: Intraoral Benefit subject to managed care protocols. X-rays: Extraoral One per beneficiary in a 3-year period . Two annual scale and polish treatments per beneficiary (once every 6 months). Benefit for fluoride: 8161 Limited to beneficiaries from age 5 and younger than 13 years of age, one per beneficiary in 12 months. Fissure sealant age 5-25 limit 4 per beneficiary. Root Canal Therapy and Extractions Benefit subject to managed care protocols .",
    "notes": "Dental benefits are paid at the P olmed Dental Tariff (PDT) subject to the applicable Dental Sublimit and OutOf-Hospital ( OOH ) Limits.\no M0 \u2014 R5 253 (OOH \u2014 R8 696 )\no M1 \u2014 R5 924 (OOH \u2014 R12 092 )\no M2 \u2014 R6 550 (OOH \u2014 R14 689 )\no M3 \u2014 R7 188 (OOH \u2014 R15 679 )\no M4+ \u2014 R7 842 (OOH \u2014 R17 962 ) 2. Lower rate applies to non network provider",
    "source": "https://denis.co.za/wp-content/uploads/2025/12/Polmed-Dental-Benefit-Tables-2026-v1.pdf",
    "lastUpdated": "Jan-26"
  },
  {
    "scheme": "Profmed",
    "plan": "PROPINNACLE SAVVY PROSECURE PLUS SAVVY PROSECURE SAVVY PROACTIVE PLUS SAVVY",
    "administrator": "PPS",
    "contactInfo": {
      "email": [
        "dental@profmed.co.za"
      ],
      "fax": [],
      "phone": [
        "0860 679 200"
      ]
    },
    "networked": "Yes",
    "nonNetworkedPayment": "Yes",
    "balancedBilling": "No",
    "basicTreatment": "Yes with limitations",
    "rct": "Yes",
    "dentures": "Yes",
    "crownsOrBridges": "Yes",
    "implants": "Yes",
    "surgicalExtractions": "Yes",
    "exclusions": "",
    "preAuth": "Hospitalisation: -Permanent tooth impaction removals -Extensive conservative dental treatment only for children younger than 8 years (24-month benefit). Plastic DenturesPre-authorisation required for Dentures One set of plastic dentures (an upper and a lower) per beneficiary in a 4-year period. Preauthorisation is required for: a) Specialised dentistry \u2013 implants, metal-based partial dentures, crowns and bridgework, functional orthognathic surgery, orthodontics up to 18 years of age",
    "crucialRules": "8101 Full mouth examination, charting and treatment planning Once per 6 months per member from date of service. 8104 consultation for a specific problem, Not within 4 weeks of an 8101, 8102, 8104. Codes 8159, & 8155 Once per 6 months per member from date of service. 8161, Once per 6 months per member from date of service.. 1 Restoration code per tooth number in a 9 month period. All extractions of tooth or exposed tooth roots should be charged as 8201 (Extraction of tooth or exposed roots). All surgical removal of residual roots should be charged as 8213 (Surgical removal of residual tooth roots). All surgical removal of impacted teeth should be charged as 8941 (Surgical removal of impacted tooth).",
    "notes": "Patient written consent needed for procedures not covered. 2. Lower rate applies to non network provider",
    "source": "https://profmed.co.za/download-important-documents/",
    "lastUpdated": "Jan-26"
  },
  {
    "scheme": "Profmed",
    "plan": "PROSELECT (NETWORK OPTION) PROSELECT & PROSELECT SAVVY",
    "administrator": "PPS",
    "contactInfo": {
      "email": [
        "dental@profmed.co.za"
      ],
      "fax": [],
      "phone": [
        "0860 679 200"
      ]
    },
    "networked": "Yes",
    "nonNetworkedPayment": "Yes",
    "balancedBilling": "No",
    "basicTreatment": "Yes with limitations",
    "rct": "No",
    "dentures": "No",
    "crownsOrBridges": "No",
    "implants": "No",
    "surgicalExtractions": "NO",
    "exclusions": "",
    "preAuth": "Permanent tooth impaction removals- Extensive conser vative dental treatment only for children younger than 8 years (24- month benefit) (Subject to pre-authorisation, protocols and management). Conservative dentistry (includes Restorations, extractions, root canal treatment,",
    "crucialRules": "R718 per beneficiary Maximum R1 848 per family",
    "notes": "",
    "source": "https://profmed.co.za/download-important-documents/",
    "lastUpdated": "Jan-26"
  },
  {
    "scheme": "Profmed",
    "plan": "PROPINNACLE PROSECURE PLUS PROSECURE PROACTIVE PLUS",
    "administrator": "PPS",
    "contactInfo": {
      "email": [
        "dental@profmed.co.za"
      ],
      "fax": [],
      "phone": [
        "0860 679 200"
      ]
    },
    "networked": "Yes",
    "nonNetworkedPayment": "Yes",
    "balancedBilling": "No",
    "basicTreatment": "Yes with limitations",
    "rct": "Yes",
    "dentures": "Yes",
    "crownsOrBridges": "Yes",
    "implants": "Yes",
    "surgicalExtractions": "Yes",
    "exclusions": "Functional orthognathic surgery. Includes all costs related to the admission and procedure, e.g. all medical practitioner fees, hospitalisation, etc. (Subject to pre-authorisation) No benefit",
    "preAuth": "Hospitalisation: -Permanent tooth impaction removals -Extensive conservative dental treatment only for children younger than 8 years (24-month benefit). Plastic DenturesPre-authorisation required for Dentures One set of plastic dentures (an upper and a lower) per beneficiary in a 4-year period. Preauthorisation is required for: a) Specialised dentistry \u2013 implants, metal-based partial dentures, crowns and bridgework, functional orthognathic surgery, orthodontics up to 18 years of age",
    "crucialRules": "8102 Full mouth examination, charting and treatment planning Once per 6 months per member from date of service. 8104 consultation for a specific problem, Not within 4 weeks of an 8101, 8102, 8104. Codes 8159, & 8155 Once per 6 months per member from date of service. 8161, Once per 6 months per member from date of service.. 1 Restoration code per tooth number in a 9 month period. All extractions of tooth or exposed tooth roots should be charged as 8201 (Extraction of tooth or exposed roots). All surgical removal of residual roots should be charged as 8213 (Surgical removal of residual tooth roots). All surgical removal of impacted teeth should be charged as 8941 (Surgical removal of impacted tooth).",
    "notes": "Not subject to day-to-day limit",
    "source": "https://profmed.co.za/download-important-documents/",
    "lastUpdated": "Jan-26"
  },
  {
    "scheme": "Profmed",
    "plan": "PROPINNACLE,",
    "administrator": "PPS",
    "contactInfo": {
      "email": [
        "dental@profmed.co.za"
      ],
      "fax": [],
      "phone": [
        "0860 679 200"
      ]
    },
    "networked": "No",
    "nonNetworkedPayment": "Yes",
    "balancedBilling": "No",
    "basicTreatment": "Yes with limitations",
    "rct": "Yes",
    "dentures": "Yes",
    "crownsOrBridges": "Yes",
    "implants": "Yes",
    "surgicalExtractions": "Yes",
    "exclusions": "Bone Augmentations \u2022 Bone and tissue regeneration procedures \u2022 Crowns and bridges for cosmetic reasons and associated laboratory costs \u2022 Enamel micro abrasion \u2022 Fillings: the cost of gold, precious metal, semi-precious metal and platinum foil \u2022 Laboratory delivery fees \u2022 Othognatic surgery \u2022 Sinus lift \u2022 Gum guards or mouth protectors",
    "preAuth": "Advanced dentistry (includes crowns, bridges, implants, orthodontics) Orthodontics available only up to age 18. (Orthodontics and Implants subject to Pre-authorisation. - Permanent tooth impaction removals- Extensive conservative dental treatment only for children younger than 8 years (24- month benefit) (Subject to pre-authorisation, protocols \nand management)",
    "crucialRules": "DENTISTRY \u2013 OUT OF HOSPITAL. Conservative dentistry (includes annual check-ups, restorations, extractions, root canal treatment, dentures) - The amount of R2 750 can be used for Conservative denstistry and is subject to availability of benefits. R7 772 per beneficiary. maximum R 15 444 per family.",
    "notes": "Patient written consent needed for procedures not covered. 2. Lower rate applies to non network provider The benefit is an additional R2500 cover for out-of-o ce consulations, and is payable once the overall day-to-day benefits have been depleted. The amount of R2 500 can be used for Conservative denstistry and is subject to availability of benefits.",
    "source": "https://profmed.co.za/download-important-documents/",
    "lastUpdated": "Jan-26"
  },
  {
    "scheme": "Profmed",
    "plan": "PROSECURE PLUS,",
    "administrator": "PPS",
    "contactInfo": {
      "email": [
        "dental@profmed.co.za"
      ],
      "fax": [],
      "phone": [
        "0861 679 200"
      ]
    },
    "networked": "No",
    "nonNetworkedPayment": "Yes",
    "balancedBilling": "No",
    "basicTreatment": "Yes with limitations",
    "rct": "Yes",
    "dentures": "Yes",
    "crownsOrBridges": "Yes",
    "implants": "Yes",
    "surgicalExtractions": "Yes",
    "exclusions": "Bone Augmentations \u2022 Bone and tissue regeneration procedures \u2022 Crowns and bridges for cosmetic reasons and associated laboratory costs \u2022 Enamel micro abrasion \u2022 Fillings: the cost of gold, precious metal, semi-precious metal and platinum foil \u2022 Laboratory delivery fees \u2022 Othognatic surgery \u2022 Sinus lift \u2022 Gum guards or mouth protectors",
    "preAuth": "Advanced dentistry (includes crowns, bridges, implants, orthodontics) Orthodontics available only up to age 18. (Orthodontics and Implants subject to Pre-authorisation. - Permanent tooth impaction removals- Extensive conservative dental treatment only for children younger than 8 years (24- month benefit) (Subject to pre-authorisation, protocols\nand management)",
    "crucialRules": "DENTISTRY \u2013 OUT OF HOSPITAL. Conservative dentistry (includes annual check-ups, restorations, extractions, root canal treatment, dentures) - The amount of R2 750 can be used for Conservative denstistry and is subject to availability of benefits. R6558 per beneficiary. maximum R 13 222 per family.",
    "notes": "Patient written consent needed for procedures not covered. 2. Lower rate applies to non network provider The benefit is an additional R2500 cover for out-of-o ce consulations, and is payable once the overall day-to-day benefits have been depleted. The amount of R2 500 can be used for Conservative denstistry and is subject to availability of benefits.",
    "source": "https://profmed.co.za/download-important-documents/",
    "lastUpdated": "Jan-26"
  },
  {
    "scheme": "Profmed",
    "plan": "PROSECURE,",
    "administrator": "PPS",
    "contactInfo": {
      "email": [
        "dental@profmed.co.za"
      ],
      "fax": [],
      "phone": [
        "0862 679 200"
      ]
    },
    "networked": "No",
    "nonNetworkedPayment": "Yes",
    "balancedBilling": "No",
    "basicTreatment": "Yes with limitations",
    "rct": "Yes",
    "dentures": "Yes",
    "crownsOrBridges": "Yes",
    "implants": "Yes",
    "surgicalExtractions": "Yes",
    "exclusions": "Bone Augmentations \u2022 Bone and tissue regeneration procedures \u2022 Crowns and bridges for cosmetic reasons and associated laboratory costs \u2022 Enamel micro abrasion \u2022 Fillings: the cost of gold, precious metal, semi-precious metal and platinum foil \u2022 Laboratory delivery fees \u2022 Othognatic surgery \u2022 Sinus lift \u2022 Gum guards or mouth protectors",
    "preAuth": "Advanced dentistry (includes crowns, bridges, implants, orthodontics) Orthodontics available only up to age 18. (Orthodontics and Implants subject to Pre-authorisation. - Permanent tooth impaction removals- Extensive conservative dental treatment only for children younger than 8 years (24- month benefit) (Subject to pre-authorisation, protocols\nand management)",
    "crucialRules": "DENTISTRY \u2013 OUT OF HOSPITAL. Conservative dentistry (includes annual check-ups, restorations, extractions, root canal treatment, dentures) - The amount of R2 750 can be used for Conservative denstistry and is subject to availability of benefits. R7 772 per beneficiary. maximum R 15 444 per family.",
    "notes": "Patient written consent needed for procedures not covered. 2. Lower rate applies to non network provider The benefit is an additional R2500 cover for out-of-o ce consulations, and is payable once the overall day-to-day benefits have been depleted. The amount of R2 500 can be used for Conservative denstistry and is subject to availability of benefits.",
    "source": "https://profmed.co.za/download-important-documents/",
    "lastUpdated": "Jan-26"
  },
  {
    "scheme": "Profmed",
    "plan": "PROACTIVE PLUS",
    "administrator": "PPS",
    "contactInfo": {
      "email": [
        "dental@profmed.co.za"
      ],
      "fax": [],
      "phone": [
        "0863 679 200"
      ]
    },
    "networked": "No",
    "nonNetworkedPayment": "Yes",
    "balancedBilling": "No",
    "basicTreatment": "Yes with limitations",
    "rct": "Yes",
    "dentures": "Yes",
    "crownsOrBridges": "Yes",
    "implants": "Yes",
    "surgicalExtractions": "Yes",
    "exclusions": "Bone Augmentations \u2022 Bone and tissue regeneration procedures \u2022 Crowns and bridges for cosmetic reasons and associated laboratory costs \u2022 Enamel micro abrasion \u2022 Fillings: the cost of gold, precious metal, semi-precious metal and platinum foil \u2022 Laboratory delivery fees \u2022 Othognatic surgery \u2022 Sinus lift \u2022 Gum guards or mouth protectors",
    "preAuth": "Advanced dentistry (includes crowns, bridges, implants, orthodontics) Orthodontics available only up to age 18. (Orthodontics and Implants subject to Pre-authorisation. - Permanent tooth impaction removals- Extensive conservative dental treatment only for children younger than 8 years (24- month benefit) (Subject to pre-authorisation, protocols\nand management)",
    "crucialRules": "DENTISTRY \u2013 OUT OF HOSPITAL. Conservative dentistry (includes annual check-ups, restorations, extractions, root canal treatment, dentures) - The amount of R2 750 can be used for Conservative denstistry and is subject to availability of benefits. R7 772 per beneficiary. maximum R 15 444 per family.",
    "notes": "Patient written consent needed for procedures not covered. 2. Lower rate applies to non network provider The benefit is an additional R2500 cover for out-of-o ce consulations, and is payable once the overall day-to-day benefits have been depleted. The amount of R2 500 can be used for Conservative denstistry and is subject to availability of benefits.",
    "source": "https://profmed.co.za/download-important-documents/",
    "lastUpdated": "Jan-26"
  },
  {
    "scheme": "Profmed",
    "plan": "PROSELECT. (network option)",
    "administrator": "PPS",
    "contactInfo": {
      "email": [
        "dental@profmed.co.za"
      ],
      "fax": [],
      "phone": [
        "0864 679 200"
      ]
    },
    "networked": "No",
    "nonNetworkedPayment": "Yes",
    "balancedBilling": "No",
    "basicTreatment": "Yes with limitations",
    "rct": "Yes",
    "dentures": "Yes",
    "crownsOrBridges": "Yes",
    "implants": "Yes",
    "surgicalExtractions": "Yes",
    "exclusions": "Bone Augmentations \u2022 Bone and tissue regeneration procedures \u2022 Crowns and bridges for cosmetic reasons and associated laboratory costs \u2022 Enamel micro abrasion \u2022 Fillings: the cost of gold, precious metal, semi-precious metal and platinum foil \u2022 Laboratory delivery fees \u2022 Othognatic surgery \u2022 Sinus lift \u2022 Gum guards or mouth protectors",
    "preAuth": "Advanced dentistry (includes crowns, bridges, implants, orthodontics) Orthodontics available only up to age 18. (Orthodontics and Implants subject to Pre-authorisation. - Permanent tooth impaction removals- Extensive conservative dental treatment only for children younger than 8 years (24- month benefit) (Subject to pre-authorisation, protocols\nand management)",
    "crucialRules": "DENTISTRY \u2013 OUT OF HOSPITAL. Conservative dentistry (includes annual check-ups, restorations, extractions, root canal treatment, dentures) - R739 per beneficiary.",
    "notes": "Patient written consent needed for procedures not covered. 2. Lower rate applies to non network provider The benefit is an additional R2500 cover for out-of-o ce consulations, and is payable once the overall day-to-day benefits have been depleted. The amount of R2 500 can be used for Conservative denstistry and is subject to availability of benefits.",
    "source": "https://profmed.co.za/download-important-documents/",
    "lastUpdated": "Jan-26"
  },
  {
    "scheme": "Profmed",
    "plan": "PROPINNACLE SAVVY",
    "administrator": "PPS",
    "contactInfo": {
      "email": [
        "dental@profmed.co.za"
      ],
      "fax": [],
      "phone": [
        "0860 679 200"
      ]
    },
    "networked": "No",
    "nonNetworkedPayment": "Yes",
    "balancedBilling": "No",
    "basicTreatment": "Yes with limitations",
    "rct": "No",
    "dentures": "No",
    "crownsOrBridges": "No",
    "implants": "No",
    "surgicalExtractions": "NO",
    "exclusions": "",
    "preAuth": "HOSPITALISATION: Permanent tooth impaction removals- Extensive conservative dental treatment only for children younger than 8 years (24-month benefit) (Subject to pre-authorisation, protocols, manage ment and use of the DSPN) Advanced dentistry (includes crowns, bridges, implants, orthodontics) Orthodontics available only up to age 18.",
    "crucialRules": "Conservative den tistry (includes annual check-ups, restorations, extractions, root canal treatment, dentures). R7 722 per beneficiary Maximum R15 444 per family subject to day-to-day limit",
    "notes": "Full mouth examinations will be covered once every 6 months. 2. Restorations on the same tooth will be covered once within a 9-month period. 3. Where code 8132 is claimed, restorations cannot be claimed on the same tooth number and same service date.",
    "source": "https://profmed.co.za/download-important-documents/",
    "lastUpdated": "Jan-26"
  },
  {
    "scheme": "Profmed",
    "plan": "PROSECURE PLUS SAVVY",
    "administrator": "PPS",
    "contactInfo": {
      "email": [
        "dental@profmed.co.za"
      ],
      "fax": [],
      "phone": [
        "0860 679 200"
      ]
    },
    "networked": "No",
    "nonNetworkedPayment": "Yes",
    "balancedBilling": "No",
    "basicTreatment": "Yes with limitations",
    "rct": "Yes",
    "dentures": "Yes",
    "crownsOrBridges": "Yes",
    "implants": "Yes",
    "surgicalExtractions": "Yes",
    "exclusions": "Functional orthognathic surgery. Includes all costs related to the admission and procedure, e.g. all medical practitioner fees, hospitalisation, etc. (Subject to pre-authorisation) No benefit",
    "preAuth": "Hospitalisation: -Permanent tooth impaction removals -Extensive conservative dental treatment only for children younger than 8 years (24-month benefit). Plastic DenturesPre-authorisation required for Dentures One set of plastic dentures (an upper and a lower) per beneficiary in a 4-year period. Preauthorisation is required for: a) Specialised dentistry \u2013 implants, metal-based partial dentures, crowns and bridgework, functional orthognathic surgery, orthodontics up to 18 years of age",
    "crucialRules": "R6 558 per beneficiary Maximum R13 222 per family Not subject to day-to-day limit",
    "notes": "Full mouth examinations will be covered once every 6 months. 2. Restorations on the same tooth will be covered once within a 9-month period. 3. Where code 8132 is claimed, restorations cannot be claimed on the same tooth number and same service date.",
    "source": "https://profmed.co.za/download-important-documents/",
    "lastUpdated": "Jan-26"
  },
  {
    "scheme": "Profmed",
    "plan": "PROSECURE SAVVY",
    "administrator": "PPS",
    "contactInfo": {
      "email": [
        "dental@profmed.co.za"
      ],
      "fax": [],
      "phone": [
        "0861 679 200"
      ]
    },
    "networked": "No",
    "nonNetworkedPayment": "Yes",
    "balancedBilling": "No",
    "basicTreatment": "Yes with limitations",
    "rct": "Yes",
    "dentures": "Yes",
    "crownsOrBridges": "Yes",
    "implants": "Yes",
    "surgicalExtractions": "Yes",
    "exclusions": "Functional orthognathic surgery. Includes all costs related to the admission and procedure, e.g. all medical practitioner fees, hospitalisation, etc. (Subject to pre-authorisation) No benefit",
    "preAuth": "Hospitalisation: -Permanent tooth impaction removals -Extensive conservative dental treatment only for children younger than 8 years (24-month benefit). Plastic DenturesPre-authorisation required for Dentures One set of plastic dentures (an upper and a lower) per beneficiary in a 4-year period. Preauthorisation is required for: a) Specialised dentistry \u2013 implants, metal-based partial dentures, crowns and bridgework, functional orthognathic surgery, orthodontics up to 18 years of age",
    "crucialRules": "R6 558 per beneficiary Maximum R13 222 per family Not subject to day-to-day limit",
    "notes": "Full mouth examinations will be covered once every 6 months. 2. Restorations on the same tooth will be covered once within a 9-month period. 3. Where code 8132 is claimed, restorations cannot be claimed on the same tooth number and same service date.",
    "source": "https://profmed.co.za/download-important-documents/",
    "lastUpdated": "Jan-26"
  },
  {
    "scheme": "Profmed",
    "plan": "PROACTIVE PLUS SAVVY",
    "administrator": "PPS",
    "contactInfo": {
      "email": [
        "dental@profmed.co.za"
      ],
      "fax": [],
      "phone": [
        "0862 679 200"
      ]
    },
    "networked": "No",
    "nonNetworkedPayment": "Yes",
    "balancedBilling": "No",
    "basicTreatment": "Yes with limitations",
    "rct": "Yes",
    "dentures": "Yes",
    "crownsOrBridges": "Yes",
    "implants": "Yes",
    "surgicalExtractions": "Yes",
    "exclusions": "Functional orthognathic surgery. Includes all costs related to the admission and procedure, e.g. all medical practitioner fees, hospitalisation, etc. (Subject to pre-authorisation) No benefit",
    "preAuth": "Hospitalisation: -Permanent tooth impaction removals -Extensive conservative dental treatment only for children younger than 8 years (24-month benefit). Plastic DenturesPre-authorisation required for Dentures One set of plastic dentures (an upper and a lower) per beneficiary in a 4-year period. Preauthorisation is required for: a) Specialised dentistry \u2013 implants, metal-based partial dentures, crowns and bridgework, functional orthognathic surgery, orthodontics up to 18 years of age",
    "crucialRules": ". 1 Restoration code per tooth number in a 9 month period. All extractions of tooth or exposed tooth roots should be charged as 8201 (Extraction of tooth or exposed roots). All surgical removal of residual roots should be charged as 8213 (Surgical removal of residual tooth roots). All surgical removal of impacted teeth should be charged as 8941 (Surgical removal of impacted tooth).",
    "notes": "Full mouth examinations will be covered once every 6 months. 2. Restorations on the same tooth will be covered once within a 9-month period. 3. Where code 8132 is claimed, restorations cannot be claimed on the same tooth number and same service date.",
    "source": "https://profmed.co.za/download-important-documents/",
    "lastUpdated": "Jan-26"
  },
  {
    "scheme": "Profmed",
    "plan": "PROSELECT SAVVY",
    "administrator": "PPS",
    "contactInfo": {
      "email": [
        "dental@profmed.co.za"
      ],
      "fax": [],
      "phone": [
        "0863 679 200"
      ]
    },
    "networked": "No",
    "nonNetworkedPayment": "Yes",
    "balancedBilling": "No",
    "basicTreatment": "Yes with limitations",
    "rct": "Yes",
    "dentures": "Yes",
    "crownsOrBridges": "Yes",
    "implants": "Yes",
    "surgicalExtractions": "Yes",
    "exclusions": "Functional orthognathic surgery. Includes all costs related to the admission and procedure, e.g. all medical practitioner fees, hospitalisation, etc. (Subject to pre-authorisation) No benefit",
    "preAuth": "Hospitalisation: -Permanent tooth impaction removals -Extensive conservative dental treatment only for children younger than 8 years (24-month benefit). Plastic DenturesPre-authorisation required for Dentures One set of plastic dentures (an upper and a lower) per beneficiary in a 4-year period. Preauthorisation is required for: a) Specialised dentistry \u2013 implants, metal-based partial dentures, crowns and bridgework, functional orthognathic surgery, orthodontics up to 18 years of age",
    "crucialRules": ". 1 Restoration code per tooth number in a 9 month period. All extractions of tooth or exposed tooth roots should be charged as 8201 (Extraction of tooth or exposed roots). All surgical removal of residual roots should be charged as 8213 (Surgical removal of residual tooth roots). All surgical removal of impacted teeth should be charged as 8941 (Surgical removal of impacted tooth).",
    "notes": "Full mouth examinations will be covered once every 6 months. 2. Restorations on the same tooth will be covered once within a 9-month period. 3. Where code 8132 is claimed, restorations cannot be claimed on the same tooth number and same service date.",
    "source": "https://profmed.co.za/download-important-documents/",
    "lastUpdated": "Jan-26"
  },
  {
    "scheme": "Rand water",
    "plan": "Option B Plus",
    "administrator": "DRC",
    "contactInfo": {
      "email": [
        "network@dentalrisk.com"
      ],
      "fax": [],
      "phone": [
        "0879 439 611"
      ]
    },
    "networked": "Yes",
    "nonNetworkedPayment": "Yes",
    "balancedBilling": "Yes",
    "basicTreatment": "Yes with limitations",
    "rct": "Yes",
    "dentures": "Yes",
    "crownsOrBridges": "Yes",
    "implants": "Yes",
    "surgicalExtractions": "Yes",
    "exclusions": "No Benefit for root canal treatment on third molars (wisdom teeth \u2013 18/28/38/48) and primary teeth unless adequately motivated. \u2022 No Benefit for Crowns on third molars (wisdom teeth \u2013 18/28/38/48) unless adequately motivated. \u2022 No Benefit for Pontics on second molars (17/27/37/47) unless 8\u2019s are fully functional and pre-authorised unless adequately motivated.\n\u2022 No Benefit for Laboratory fabricated crowns on primary teeth unless adequately motivated.",
    "preAuth": "All basic dentistry is payable from risk subject to pre-authorisation and treatment protocol. More than 5 extractions per visit require pre-authorisation. Occlusal guard Pre-authorisation required.Once every 24 months. Pre-auth and x-rays required for \u2022 More than 4 restorations per member in a year require pre-authorisation and motivation. Maxillofacial Surgery and Oral Pathology (pre-authorisation required) Limited to R20 780 per family per annum subject to the overall hospital limit. IN-HOSPITAL TREATMENT (GENERAL ANAESTHESIA) - Pre-authorisation. EXTENSIVE DENTAL TREATMENT FOR CHILDREN YOUNGER THAN 7 YEARS.",
    "crucialRules": "Posterior restorations are covered to the value of amalgam restorations. Root Canal Treatment (payable from risk pool)",
    "notes": "8115 Panoramic x-ray Maximum of 1 per year.",
    "source": "https://dentalrisk.com/member-benefits/",
    "lastUpdated": "Jan-26"
  },
  {
    "scheme": "Rand water",
    "plan": "OPTION A",
    "administrator": "DRC",
    "contactInfo": {
      "email": [
        "network@dentalrisk.com"
      ],
      "fax": [],
      "phone": [
        "0879 439 612"
      ]
    },
    "networked": "Yes",
    "nonNetworkedPayment": "Yes",
    "balancedBilling": "Yes",
    "basicTreatment": "Yes with limitations",
    "rct": "Yes",
    "dentures": "Yes",
    "crownsOrBridges": "Yes",
    "implants": "Yes",
    "surgicalExtractions": "Yes",
    "exclusions": "Emergency root canal/pulp removal (pulpectomy) charged on the same day as complete therapy. Diagnostic dentures Metal base to full dentures. Crowns used to restore teeth for cosmetic reasons Crowns where the tooth has been recently restored to function Composite or porcelain veneers Laboratory fabricated crowns are not covered on primary teeth or third molars (wisdom teeth) Crowning of teeth involving failed R.C.T Temporary /provisional and emergency crowns including lab costs.",
    "preAuth": "X rays Only 7 per member per year. \u2022 More than 5 extractions per visit require preauthorisation. Occlusal guard Pre-authorisation required. Pre-authorisation and xrays required for \u2022 More than 4 restorations per member in a year require pre-authorisation and motivation. Plastic Dentures (pre-authorisation required) Limited to one set per beneficiary once every 4 years. Limited to 1 crown per tooth number every 5 years. Implants and Augmentation (pre-authorisation required). Pre-Authorisation is required for hospitalisation related to dental trauma cases, removal of impacted teeth as well as children under 7 years of age.",
    "crucialRules": "Panoramic x-ray Maximum of 1 per year. Impression to repair denture, Rebase complete or partial denture, Remodel complete or partial denture, Reline, Soft base reline per denture (exclusion to new dentures, can only be claimed 6 months after new denture) 365 days per member.",
    "notes": "Panoramic x-ray (Extra-oral) Maximum of 1 per year.In the case of fillings on posterior teeth (molars and pre-molars) the Dental Risk Company tariff for amalgam fillings will apply, regardless of the material used.",
    "source": "https://dentalrisk.com/member-benefits/",
    "lastUpdated": "Jan-26"
  },
  {
    "scheme": "REEF BUS SECTOR",
    "plan": "",
    "administrator": "DRC",
    "contactInfo": {
      "email": [
        "auth@dentalrisk.com"
      ],
      "fax": [],
      "phone": [
        "0879 439 612"
      ]
    },
    "networked": "Yes",
    "nonNetworkedPayment": "Yes",
    "balancedBilling": "No",
    "basicTreatment": "Yes with limitations",
    "rct": "No",
    "dentures": "No",
    "crownsOrBridges": "No",
    "implants": "No",
    "surgicalExtractions": "Yes",
    "exclusions": "Scale and Polish NO BENEFITS. Pan Scan NO BENEFITS. Bite Plate NO BENEITS. Mouth Guard NO BENEFITS. Root Canal NO BENEFITS. Temporary Crown NO BENEFITS",
    "preAuth": "3 Restorations per member per covered period. \u2022 1 Restoration code per tooth number in a 9 month period. \u2022 Pre-authorisation and x-rays required for any 3 or 4 surface restorations on wisdom teeth.",
    "crucialRules": "Surgical removal is only covered when authorised with an intraoral radiograph. 8935 Treatment of septic socket More than 1 treatment per visit requires authorisation.",
    "notes": "",
    "source": "https://dentalrisk.com/member-benefits/",
    "lastUpdated": "Jan-26"
  },
  {
    "scheme": "Remedi",
    "plan": "Comprehensive",
    "administrator": "Discovery",
    "contactInfo": {
      "email": [
        "fax 0860 116 116"
      ],
      "fax": [],
      "phone": [
        "0860 116 116"
      ]
    },
    "networked": "Yes",
    "nonNetworkedPayment": "Yes",
    "balancedBilling": "No",
    "basicTreatment": "Yes with limitations",
    "rct": "Yes",
    "dentures": "Yes",
    "crownsOrBridges": "Yes",
    "implants": "Yes",
    "surgicalExtractions": "Yes",
    "exclusions": "Bone Augmentations \u2022 Bone and tissue regeneration procedures \u2022 Crowns and bridges for cosmetic reasons and associated laboratory costs \u2022 Enamel micro abrasion \u2022 Fillings: the cost of gold, precious metal, semi-precious metal and platinum foil \u2022 Laboratory delivery fees \u2022 Othognatic surgery \u2022 Sinus lift \u2022 Gum guards or mouth protectors",
    "preAuth": "Benefit for re-treatment of a tooth: Subject to managed care protocols Multiple fillings: A treatment plan and X\u0002rays may be required for multiple fillings.Once per tooth within 12 months. Benefit for retreatment of a tooth is subject to clinical protocols. Conservative dentistry under anaesthesia for patients younger than seven years.",
    "crucialRules": "Consultations Two check-ups per beneficiary per year (once every 6 months). Code 8159 & 8155 Once per 6 months per member from date of service. . 8163 Fissure sealant Limited to beneficiaries from age 5 and younger than 16 years of age . Root Canal Therapy and Extractions Benefit subject to managed care protocols. Benefit not available for the clinical fee of denture repairs, denture tooth replacements and the addition of a soft base to new dentures; the laboratory fee will be covered (no pre-authorisation required). Root Canal Therapy and Extractions Benefit subject to managed care protocols.",
    "notes": "The hospital account and anaesthesiologists\u2019 account for patients under the age of seven years and for wisdom-teeth removal. The dentist\u2019s account is paid from the Insured Out-of-Hospital Benefit and thereafter from the Personal Medical Savings Account. Authorisation is needed for the above.",
    "source": "https://www.yourremedi.co.za/wcm/medical-schemes/remedi/assets/benefit-guides/2026/remedi-dental-and-oral-benefit.pdf",
    "lastUpdated": "Jan-26"
  },
  {
    "scheme": "Remedi",
    "plan": "Classic",
    "administrator": "Discovery",
    "contactInfo": {
      "email": [
        "fax 0860 116 116"
      ],
      "fax": [],
      "phone": [
        "0860 116 116"
      ]
    },
    "networked": "Yes",
    "nonNetworkedPayment": "Yes",
    "balancedBilling": "No",
    "basicTreatment": "Yes with limitations",
    "rct": "Yes",
    "dentures": "Yes",
    "crownsOrBridges": "Yes",
    "implants": "Yes",
    "surgicalExtractions": "Yes",
    "exclusions": "There is no benefit for conservative dentistry in hospital, the anaesthesiologists\u2019 account and the hospital account will be paid by the member. The dentist account is paid from the Insured Out-of-Hospital Benefit",
    "preAuth": "Benefit for re-treatment of a tooth: Subject to managed care protocols Multiple fillings: A treatment plan and X\u0002rays may be required for multiple fillings.Once per tooth within 12 months. Benefit for retreatment of a tooth is subject to clinical protocols. Conservative dentistry under anaesthesia for patients younger than seven years.",
    "crucialRules": "Consultations Two check-ups per beneficiary per year (once every 6 months). Code 8159 & 8155 Once per 6 months per member from date of service. . 8163 Fissure sealant Limited to beneficiaries from age 5 and younger than 16 years of age . Root Canal Therapy and Extractions Benefit subject to managed care protocols. Root Canal Therapy and Extractions Benefit subject to managed care protocols.",
    "notes": "The hospital account and anaesthesiologists\u2019 account for patients under the age of seven years and for wisdom-teeth removal. The dentist\u2019s account is paid from the Insured Out-of-Hospital Benefit and thereafter from the Personal Medical Savings Account. Authorisation is needed for the above.",
    "source": "https://www.yourremedi.co.za/wcm/medical-schemes/remedi/assets/benefit-guides/2026/remedi-dental-and-oral-benefit.pdf",
    "lastUpdated": "Jan-26"
  },
  {
    "scheme": "REMEDI:",
    "plan": "Standard Option",
    "administrator": "Discovery / DRC",
    "contactInfo": {
      "email": [
        "auth@dentalrisk.com or fax 086 687 1286"
      ],
      "fax": [
        " 086 687 1286"
      ],
      "phone": [
        "0860 445 566"
      ]
    },
    "networked": "Yes",
    "nonNetworkedPayment": "No",
    "balancedBilling": "No",
    "basicTreatment": "Yes with limitations",
    "rct": "No",
    "dentures": "No",
    "crownsOrBridges": "No",
    "implants": "No",
    "surgicalExtractions": "No",
    "exclusions": "No Panorex. No Crown &, Bridges, Ortho, Implants or Roor canal Fillings. No Specialized Dentistry. No Crowns & bridges, Implants,Ortho, or Root canal fillings. No Dental in Theatre .",
    "preAuth": "8132 cannot be claimed with 8131 or any restoration, root canal and extraction codes on the same tooth number. \u2022 The subsequent restoration will need to be pre-authorised with an emailed or scanned x-ray to show the complete root canal. Pre-auth required for: \u2022 More than 4 restorations per year. \u2022 Two or more 3 or 4 surface restorations per visit. \u2022 More than 2 anterior restorations per visit. \u2022 Multiple restorations on an anterior tooth on the same service date.\u2022 Any 3 or 4 surface restorations on wisdom teeth.",
    "crucialRules": "Maximum of 2 x-rays per visit per member. \u2022 Maximum quantity of 7 per year. Vapour sterilised and wrapped instrumentation Will only be paid if code 8201 or 8202 is claimed. Extraction Maximum 1 x 8201 per quadrant per visit. Posterior Amalgam and Resin restorations remunerated at the same tariff. 1 Restoration code per tooth number in a 9-month period.",
    "notes": "If a procedure does not attract benefit; all other treatment costs associated with the specific event does not receive benefit. 1. Very basic option 2. Lower rate applies to non network provider 3. Patient written consent needed for procedures not covered",
    "source": "https://dentalrisk.com/member-benefits/",
    "lastUpdated": "Jan-26"
  },
  {
    "scheme": "Sab breweries",
    "plan": "Comprehensive Option",
    "administrator": "Discovery",
    "contactInfo": {
      "email": [
        "fax 0860 455 566"
      ],
      "fax": [],
      "phone": [
        "0860 445 566"
      ]
    },
    "networked": "Yes",
    "nonNetworkedPayment": "Yes",
    "balancedBilling": "No",
    "basicTreatment": "Yes with limitations",
    "rct": "Yes",
    "dentures": "Yes",
    "crownsOrBridges": "Yes",
    "implants": "Yes",
    "surgicalExtractions": "Yes",
    "exclusions": "Bone Augmentations \u2022 Bone and tissue regeneration procedures \u2022 Crowns and bridges for cosmetic reasons and associated laboratory costs \u2022 Enamel micro abrasion \u2022 Fillings: the cost of gold, precious metal, semi-precious metal and platinum foil \u2022 Laboratory delivery fees \u2022 Othognatic surgery \u2022 Sinus lift \u2022 Gum guards or mouth protectors",
    "preAuth": "A treatment plan and X\u0002rays may be required for multiple fillings.Once per tooth within 12 months. Benefit for retreatment of a tooth is subject to clinical protocols. Plastic Dentures Pre-authorisation required One set of plastic dentures (an upper and a lower) per beneficiary in a 4-year period .",
    "crucialRules": "For basic dentistry 80% of the lower of cost or Scheme Rate. Consultations Two check-ups per beneficiary per year (once every 6 months) . Code 8159 & 8155 Once per 6 months per member from date of service. 8161, Once per 6 months per member from date of service. 8163 Fissure sealant Limited to beneficiaries from age 5 and younger than 16 years of age. Root Canal Therapy and Extractions Benefit subject to managed care protocols.",
    "notes": "Basic dentistry includes oral medical procedures, plastic dentures and dental technician fees for all\ndentists, oral hygienists, and dental therapists. It is funded at 80% of the claimed amount or the \nScheme Rate, whichever is lower. We pay the remaining 20% from the available funds in your \nMedical Savings Account or it will come off your salary. Alternatively, for members that pay their \n If your provider charges more than the Scheme Rate, you will be required to pay the difference from your own pocket.",
    "source": "https://sabmas.co.za/wp-content/uploads/2025/10/SABMAS-2026-Benefit-Guide.pdf",
    "lastUpdated": "Jan-26"
  },
  {
    "scheme": "Sab breweries",
    "plan": "Essential",
    "administrator": "Discovery",
    "contactInfo": {
      "email": [
        "fax 0860 455 567"
      ],
      "fax": [],
      "phone": [
        "0860 445 567"
      ]
    },
    "networked": "Yes",
    "nonNetworkedPayment": "Yes",
    "balancedBilling": "No",
    "basicTreatment": "Yes with limitations",
    "rct": "No",
    "dentures": "No",
    "crownsOrBridges": "No",
    "implants": "No",
    "surgicalExtractions": "No",
    "exclusions": "Advanced dentistry + Implants No Benefit.",
    "preAuth": "A treatment plan and X\u0002rays may be required for multiple fillings.Once per tooth within 12 months. Benefit for retreatment of a tooth is subject to clinical protocols. Plastic Dentures Pre-authorisation required One set of plastic dentures (an upper and a lower) per beneficiary in a 4-year period .",
    "crucialRules": "For basic dentistry 80% of the lower of cost or Scheme Rate Consultations Two check-ups per beneficiary per year (once every 6 months). Code 8159 & 8155 Once per 6 months per member from date of service. 8161, Once per 6 months per member from date of service. 8163 Fissure sealant Limited to beneficiaries from age 5 and younger than 16 years of age",
    "notes": "80% of the lower of cost or Scheme Rate M = R3 890 M + 1 = R6 419 M + 2 = R7 551 M + 3 = R8 663",
    "source": "https://sabmas.co.za/wp-content/uploads/2025/10/SABMAS-2026-Benefit-Guide.pdf",
    "lastUpdated": "Jan-26"
  },
  {
    "scheme": "Samwumed",
    "plan": "Option A:",
    "administrator": "DENIS",
    "contactInfo": {
      "email": [
        "customercare@denis.co.za"
      ],
      "fax": [],
      "phone": [
        "0861 033 647"
      ]
    },
    "networked": "Yes",
    "nonNetworkedPayment": "Yes",
    "balancedBilling": "Yes",
    "basicTreatment": "Yes with limitations",
    "rct": "No",
    "dentures": "Yes",
    "crownsOrBridges": "No",
    "implants": "No",
    "surgicalExtractions": "No",
    "exclusions": "No benefit for advanced dentistry on Option A. Crown & Bridge No benefit . Implants No benefit",
    "preAuth": "Pre-authorisation*: - Hospitalisation, and certain dentistry procedures must be pre-authorised. - Pre-authorisation is required for: Dentures, Hospital Admissions and Moderate / Deep Sedation in the Dental Rooms. Partial Chrome Cobalt Frame Dentures Pre-authorisation required.",
    "crucialRules": "X-rays: Extraoral - One per beneficiary in a 3-year period. Benefit for fillings: Granted once per tooth in 720 days. Root Canal Therapy - Benefit ONLY available for the treatment of pain and sepsis: Code 8132 \u2013 Pulp removal. General anaesthetic benefit available for children under the age of 6 years for extensive dental treatment. Sedation in the Dental Rooms Pre-authorisation required - Benefit limited to extensive dental treatment and removal of impacted teeth.",
    "notes": "Dental benefits are paid at the SAMWUMED Dental Tariff (SDT), subject to the applicable Dental Financial Limits*. o M0 \u2014 R4 640 o M1 \u2014 R5 520 o M2 \u2014 R7 700 o M3+ \u2014 R9 270",
    "source": "https://denis.co.za/wp-content/uploads/2025/12/SAMWUMED-Dental-Benefit-Table-2026-v1.pdf",
    "lastUpdated": "Jan-26"
  },
  {
    "scheme": "Samwumed",
    "plan": "Option B",
    "administrator": "DENIS",
    "contactInfo": {
      "email": [
        "customercare@denis.co.za"
      ],
      "fax": [],
      "phone": [
        "0862 033 647"
      ]
    },
    "networked": "Yes",
    "nonNetworkedPayment": "Yes",
    "balancedBilling": "Yes",
    "basicTreatment": "Yes with limitations",
    "rct": "Yes",
    "dentures": "Yes",
    "crownsOrBridges": "Yes",
    "implants": "No",
    "surgicalExtractions": "Yes",
    "exclusions": "Implants and Associated Laboratory Costs No benefit",
    "preAuth": "Hospitalisation, and certain dentistry procedures must be pre-authorised. - Pre-authorisation is required for: Dentures, Crown & Bridge, Orthodontics, Periodontics, Hospital Admissions and Moderate / Deep Sedation in the Dental Rooms. Partial Chrome Cobalt Frame Dentures Pre-authorisation required. Pre-authorisation required - Benefit for crowns.",
    "crucialRules": "X-rays: Extraoral - One per beneficiary in a 3-year period. Benefit for fillings: Granted once per tooth in 720 days. Benefit subject to managed care protocols. General anaesthetic benefit available for children under the age of 6 years for extensive dental treatment. General anaesthetic benefit available for the removal of impacted teeth. Sedation in the Dental Rooms Pre-authorisation required - Benefit limited to extensive dental treatment and removal of impacted teeth.",
    "notes": "Benefit not available for the clinical fee of denture repairs, denture tooth replacements and the addition of a soft base to new dentures; the laboratory fee will be covered (no preauthorisation required).",
    "source": "https://denis.co.za/wp-content/uploads/2025/12/SAMWUMED-Dental-Benefit-Table-2026-v1.pdf",
    "lastUpdated": "Jan-26"
  },
  {
    "scheme": "SASOLMED",
    "plan": "COMPREHENSIVE NETWORK OPTION",
    "administrator": "DRC",
    "contactInfo": {
      "email": [
        "authorisations@sasolmed.co.za or fax 0860 002 134"
      ],
      "fax": [
        " 0860 002 134"
      ],
      "phone": [
        "0879 439 611"
      ]
    },
    "networked": "Yes",
    "nonNetworkedPayment": "Yes",
    "balancedBilling": "Yes",
    "basicTreatment": "Yes with limitations",
    "rct": "Yes",
    "dentures": "Yes",
    "crownsOrBridges": "Yes",
    "implants": "Yes",
    "surgicalExtractions": "Yes",
    "exclusions": "Metal base to complete dentures, including laboratory cost. Conservative dental treatment (restorations; extractions and root canal therapy) for adults in-\nhospital.",
    "preAuth": "X-ray Pre-auth \u2022 More than 6 per member per annum. Pan More than 1 within this period requires authorisation. More than 4 extractions per visit require pre-authorisation. Pre-auth More than 4 restorations per year. \u2022 2 or more, 3 or 4 surface restorations per visit. \u2022 More than 2 anterior restorations per visit. \u2022 3 or 4 surface restorations on third molar teeth. More than 1 code 8937/8953 requires authorisation. Retreatment subject to pre-authorisation and managed care protocols. PLASTIC DENTURES. CROWNS AND BRIDGES, METAL FRAME DENTURES, IMPLANTS Pre auth. DENTAL SERVICES/SURGERY RENDERED IN THE DENTIST\u2019S ROOMS Benefits are subject to pre-authorisation. CONSCIOUS SEDATION IN THE DENTIST\u2019S ROOMS Limited to extensive dental treatment for children younger than 8 years of age and the removal of impacted third molars only.",
    "crucialRules": "One restoration per tooth number within 12 months from date of service. SEDATION: EXTENSIVE DENTAL TREATMENT FOR CHILDREN YOUNGER THAN 8 YEARS",
    "notes": "Dental procedures in a hospital are generally limited to specific cases, such as the removal of impacted teeth or extensive treatment for children under age 5, and require strict pre-authorization.",
    "source": "https://dentalrisk.com/member-benefits/",
    "lastUpdated": "Jan-26"
  },
  {
    "scheme": "SASOLMED",
    "plan": "RESTRICTED NETWORK OPTIONS (NETWORK BOUND)",
    "administrator": "DRC",
    "contactInfo": {
      "email": [
        "authorisations@sasolmed.co.za or fax 0860 002 134"
      ],
      "fax": [
        " 0860 002 134"
      ],
      "phone": [
        "0879 439 611"
      ]
    },
    "networked": "Yes",
    "nonNetworkedPayment": "No",
    "balancedBilling": "No",
    "basicTreatment": "Yes with limitations",
    "rct": "Yes",
    "dentures": "Yes",
    "crownsOrBridges": "Yes",
    "implants": "Yes",
    "surgicalExtractions": "Yes",
    "exclusions": "Metal base to complete dentures, including laboratory cost. Conservative dental treatment (restorations; extractions and root canal therapy) for adults in-\nhospital.",
    "preAuth": "X-ray Pre-auth \u2022 More than 6 per member per annum. Pan More than 1 within this period requires authorisation. More than 4 extractions per visit require pre-authorisation. Pre-auth More than 4 restorations per year. \u2022 2 or more, 3 or 4 surface restorations per visit. \u2022 More than 2 anterior restorations per visit. \u2022 3 or 4 surface restorations on third molar teeth. More than 1 code 8937/8953 requires authorisation. Retreatment subject to pre-authorisation and managed care protocols. PLASTIC DENTURES. CROWNS AND BRIDGES, METAL FRAME DENTURES, IMPLANTS Pre auth. DENTAL SERVICES/SURGERY RENDERED IN THE DENTIST\u2019S ROOMS Benefits are subject to pre-authorisation. CONSCIOUS SEDATION IN THE DENTIST\u2019S ROOMS Limited to extensive dental treatment for children younger than 8 years of age and the removal of impacted third molars only.",
    "crucialRules": "One restoration per tooth number within 12 months from date of service. SEDATION: EXTENSIVE DENTAL TREATMENT FOR CHILDREN YOUNGER THAN 8 YEARS",
    "notes": "Network Utilization: Members must choose dental providers within this specified network to avoid co-payments or a lack of cover for voluntary out-of-network use",
    "source": "https://dentalrisk.com/member-benefits/",
    "lastUpdated": "Jan-26"
  },
  {
    "scheme": "Sisonke",
    "plan": "Heritage",
    "administrator": "Momentum",
    "contactInfo": {
      "email": [
        "info@sisonkehealth.co.za"
      ],
      "fax": [],
      "phone": [
        "0860 104 012"
      ]
    },
    "networked": "Yes",
    "nonNetworkedPayment": "Yes",
    "balancedBilling": "No",
    "basicTreatment": "Yes with limitations",
    "rct": "Yes",
    "dentures": "Yes",
    "crownsOrBridges": "Yes",
    "implants": "Yes",
    "surgicalExtractions": "Yes",
    "exclusions": "Emergency root canal/pulp removal (pulpectomy) charged on the same day as complete therapy. Diagnostic dentures Metal base to full dentures. Crowns used to restore teeth\nfor cosmetic reasons Crowns where the tooth has been recently restored to function Composite or porcelain veneers Laboratory fabricated crowns are not covered on primary teeth or third molars (wisdom teeth) Crowning of teeth involving failed R.C.T Temporary /provisional and emergency crowns including lab costs.",
    "preAuth": "Specialised dentistry limited to R8 052 per beneficiary, up to a maximum of R16 109 per member family",
    "crucialRules": "In Hospital Dentistry Covered to R 13 508 per Beneficiary. Scheme Rates apply",
    "notes": "Limit General: Unlimited at preferred provider at Scheme rates \u2022 All dentists in 20km radius of Medical centre - Non -pp: 20% co-payment will apply at non-preferred provider. \u2022 All dentists outside of 20km radius of Medical Centre : Unlimited at preferred provider at Scheme rates \u2022 Dentures (every 3 years): R6 035 PB \u2022 Specialised: R 7 669 PB to max of R15 342 PMF",
    "source": "",
    "lastUpdated": "Jan-26"
  },
  {
    "scheme": "Sisonke",
    "plan": "Diversity and Pride Options",
    "administrator": "Momentum PRIMECURE",
    "contactInfo": {
      "email": [
        "dentalmotivations@carecross.co.za"
      ],
      "fax": [],
      "phone": [
        "0860 101 159"
      ]
    },
    "networked": "Yes",
    "nonNetworkedPayment": "Yes",
    "balancedBilling": "No",
    "basicTreatment": "Yes with limitations",
    "rct": "No",
    "dentures": "No",
    "crownsOrBridges": "No",
    "implants": "No",
    "surgicalExtractions": "No",
    "exclusions": "No panorex. Specialised dentistry such as bridges, crowns, surgical extractions, implants, root canals,gold fillings, dentures and braces are not covered",
    "preAuth": "8201 & 8202 Combined maximum of four per year with an additional four allowed upon pre-authorisation. Maximum four restorations per year with an additional four allowed only upon preauthorisation. Posterior amalgam and resin fillings are remunerated at the same tariff.",
    "crucialRules": "8101 One per beneficiary per annum. 8104 Not within six weeks of 8101 or 8104. 8107/8112 Maximum four per annum combined, unless otherwise authorised. 8155 & 8159 Once per annum per member (either or 8155) 8161 Maximum of one per child per year for patients younger than 12 years. 8163 Maximum of two per child per year for patients younger than 12 years. 8935 Septic socket treatment Once per tooth. 8259 Rebase of denture (laboratory) Rebase complete or partial denture (once a calendar year per member). 8261 Remodel of denture Rebase complete or partial denture (once a calendar year per member. Reline complete or partial denture (once a calendar year per member) Repair denture Twice per calendar year per member",
    "notes": "Patient written consent needed for procedures not covered.",
    "source": "https://content.momentum.co.za/mmsa/complete_health/pdfs/Sales%20Tools/Provider%20Search/2026/2026_MHS_Dental_Network_guide_54.pdf",
    "lastUpdated": "Jan-26"
  },
  {
    "scheme": "SIZWE HOSMED",
    "plan": "ACCESS SAVER",
    "administrator": "Discovery / DRC",
    "contactInfo": {
      "email": [
        "auth@dentalrisk.com or fax 086 687 1286"
      ],
      "fax": [
        " 086 687 1286"
      ],
      "phone": [
        "0860 445 566"
      ]
    },
    "networked": "Yes",
    "nonNetworkedPayment": "No",
    "balancedBilling": "Yes",
    "basicTreatment": "Yes with limitations",
    "rct": "No",
    "dentures": "Yes",
    "crownsOrBridges": "No",
    "implants": "No",
    "surgicalExtractions": "No",
    "exclusions": "Metal Frame Dentures: Typically not covered or requires specific motivation/MSA funds.",
    "preAuth": "More than 4 extractions per visit require preauth. Surgical removal of tooth and roots More than 1 removal per visit requires authorisation. required for: More than 4 restorations. \u2022 More than two: 3 or 4 surface restorations per visit. \u2022 More than 2 anterior restorations per visit. Conscious sedation in the dentist Rooms Limited to children up to the age of 16 years (pre-authorisation required).",
    "crucialRules": "Conservative dentistry payable from the Risk Pool. Crowns & Bridgework, Metal Frame Dentures, Orthodontics (up to the age of 21 years), removal of impacted wisdom teeth, non-surgical wisdom teeth and non-surgical periodontics are covered from available MSA (Medical Savings account).",
    "notes": "\u2013 Conservative dentistry payable from the Risk Pool. Crowns & Bridgework, Metal Frame Dentures, Orthodontics (up to the age of 21 years), removal of impacted wisdom teeth, non-surgical wisdom teeth and non- surgical periodontics are covered from available MSA (Medical",
    "source": "https://dentalrisk.com/member-benefits/",
    "lastUpdated": "Jan-26"
  },
  {
    "scheme": "SIZWE HOSMED",
    "plan": "TITANIUM EXECUTIVE",
    "administrator": "Discovery / DRC",
    "contactInfo": {
      "email": [
        "auth@dentalrisk.com or fax 086 687 1286"
      ],
      "fax": [
        " 086 687 1286"
      ],
      "phone": [
        "0860 445 566"
      ]
    },
    "networked": "Yes",
    "nonNetworkedPayment": "No",
    "balancedBilling": "Yes",
    "basicTreatment": "Yes with limitations",
    "rct": "Yes",
    "dentures": "Yes",
    "crownsOrBridges": "Yes",
    "implants": "Yes",
    "surgicalExtractions": "Yes",
    "exclusions": "Multiple restorations on an anterior tooth on the same service date only per authorisation and x-rays received \uf0b7 Repairing of teeth damaged due to bruxism, toothbrush abrasion, erosion and fluorosis will not be covered \uf0b7 Replacement of non\u0002carious amalgam restored tooth with a resin will not be covered. Posterior teeth restorations cannot be performed across the midline. Inlay/onlay or \u00be crowns not covered \uf0b7 Crowns on non\u0002functional 3rd molars are not covered.",
    "preAuth": "8169 Occlusal guard Pre-authorisation required. Once every 24 months. More than 4 extractions per visit require pre-authorisation. Surgical removal of tooth More than 1 removal per visit. requires authorisation. Pre-authorisation and x-rays required for: \u2022 More than 4 restorations per year. \u2022 More than 3 restorations per visit. \u2022 Any 3 or 4 surface restorations on wisdom teeth (non-functional wisdom teeth notcovered). \u2022 Multiple restorations on an anterior tooth on the same service date only per authorisation and x-rays received. Lower jaw posterior fillings involving anaesthetic cannot be performed across the midline. \u2022 Deviations will only be covered if pre-authorised. SPECIALISED DENTISTRY Pre-authorisation is required for all services. Extensive Dental treatment covered under conscious sedation (pre-authorisation required). General anaesthetic benefits are available for: Extensive dental treatment for children under the age of 7 years and more than 3 teeth involved.",
    "crucialRules": "8101 Full mouth examination, Once per 6 months per member from date of service. 8104 consultation for a specific problem, Not within 4 weeks of an 8101, 8102, 8104. Code 8107, 8112 and 8121 cannot be charged more than 7 times (per year). 8159,8155,8161 Once per 6 months per member from date of service. 8163 Maximum of 4 can be charged per member per annum. RCT Only covered on permanent teeth. \u2022 Excluding wisdom teeth (3rd molars). 1 Set of plastic dentures, full or partial (an upper and a lower) per beneficiary in a 4 year period for members.",
    "notes": "Treatment of septic socket Once per tooth number. Conservative dentistry payable from available Savings.",
    "source": "https://dentalrisk.com/member-benefits/",
    "lastUpdated": "Jan-26"
  },
  {
    "scheme": "SIZWE HOSMED",
    "plan": "VALUE PLATINUM AND VALUE PLATINUM CORE",
    "administrator": "Discovery / DRC",
    "contactInfo": {
      "email": [
        "auth@dentalrisk.com or fax 086 687 1286"
      ],
      "fax": [
        " 086 687 1286"
      ],
      "phone": [
        "0860 445 566"
      ]
    },
    "networked": "Yes",
    "nonNetworkedPayment": "No",
    "balancedBilling": "Yes",
    "basicTreatment": "Yes with limitations",
    "rct": "Yes",
    "dentures": "Yes",
    "crownsOrBridges": "Yes",
    "implants": "Yes",
    "surgicalExtractions": "Yes",
    "exclusions": "Repairing of teeth damaged due to bruxism, toothbrush abrasion, erosion and fluorosis will not be covered. \u2022 Replacement of non-carious amalgam restored tooth with a resin will not be covered.",
    "preAuth": "Occlusal guard Pre-authorisation required. Once every 24 months. More than 4 extractions per visit require pre-authorisation. Surgical removal of tooth More than 1 removal per visit requires Authorisation. Pre-authorisation and x-rays required for: \u2022 More than 4 restorations per year. \u2022 More than 3 restorations per visit. \u2022 Any 3 or 4 surface restorations on wisdom teeth (non-functional wisdom teeth not covered). \u2022 Multiple restorations on an anterior tooth on the same service date only per authorisation and x- rays received. Crowns & Bridgework (pre-authorisation required). Implants (pre-authorisation required). Conscious Sedation in the Dentist Rooms Limited to beneficiaries below the age of 16 years (pre-authorisation required). Extensive Dental treatment covered under conscious sedation (pre-authorisation required).",
    "crucialRules": "8101 Full mouth examination, Once per 6 months per member from date of service. 8104 consultation for a specific problem, Not within 4 weeks of an 8101, 8102, 8104. Code 8107, 8112 and 8121 cannot be charged more than 7 times (per year). 8159,8155,8161 Once per 6 months per member from date of service. 8163 Maximum of 4 can be charged per member per annum. RCT Only covered on permanent teeth. \u2022 Excluding wisdom teeth (3rd molars). 1 Set of plastic dentures, full or partial (an upper and a lower) per beneficiary in a 4 year period for members.",
    "notes": "1 PAN per member every 2 years. Conservative dentistry payable from MSA. Value Platinum Core plan: Subject to contracted Network Provider and DSP hospital network.",
    "source": "https://dentalrisk.com/member-benefits/",
    "lastUpdated": "Jan-26"
  },
  {
    "scheme": "SIZWE HOSMED",
    "plan": "OLD ASCEND AND GOLD ASCEND EDO",
    "administrator": "DRC",
    "contactInfo": {
      "email": [
        "auth@dentalrisk.com"
      ],
      "fax": [],
      "phone": [
        "0879 439 611"
      ]
    },
    "networked": "Yes",
    "nonNetworkedPayment": "No",
    "balancedBilling": "Yes",
    "basicTreatment": "Yes with limitations",
    "rct": "Yes",
    "dentures": "Yes",
    "crownsOrBridges": "No",
    "implants": "No",
    "surgicalExtractions": "No",
    "exclusions": "Multiple restorations on an anterior tooth on the same service date only per authorisation and x\u0002rays received \uf0b7 Repairing of teeth damaged due to bruxism, toothbrush abrasion, erosion and fluorosis will not be covered \uf0b7 Replacement of non\u0002carious amalgam with resin will not be cover. \uf0b7 Posterior teeth restorations cannot be performed across the midline. No Specialised dentistry. Metal, porcelain or Resin inlays except where such inlays form part of a bridge. Root canal treatment and laboratory fabricated crowns on primary teeth.",
    "preAuth": "More than 4 extractions per visit require preauthorisation. 8937 Surgical removal of tooth More than 1 removal per visit requires authorisation. Pre-auth required for: \u2022 More than 4 restorations per year. \u2022 More than 3 restorations per visit. \u2022 Any 3 or 4 surface restorations on wisdom teeth (non-functional wisdom teeth not covered). \u2022 Multiple restorations on an anterior tooth on the same service date only per authorisation and x rays received. More than 4 extractions per visit require pre-authorisation. Surgical removal of tooth More than 1 removal per visit requires authorisation. Pre-authorisation and x- rays required for: \u2022 More than 4 restorations per year. \u2022 More than 3 restorations per visit. \u2022 Any 3 or 4 surface restorations on wisdom teeth (non-functional wisdom teeth not covered). \u2022 Multiple restorations on an anterior tooth on the same service date only per authorisation and x-rays received. Limited to beneficiaries below the age of 16 years \u2013 pre-authorisation required. Extensive Dental treatment covered under conscious sedation - pre-authorisation. Impactions (pre-authorisation required).",
    "crucialRules": "8101 Full mouth examination, charting and treatment planning Once per 6 months per member from date of service. 8104 consultation for a specific problem, Not within 4 weeks of an 8101, 8102, 8104. 8159,8155 Once per 6 months per member from date of service. 8161, Once per 6 months per member from date of service. 8163 Maximum of 4 can be charged per member per annum. Code 8107, 8112 and 8121 cannot be charged more than 7 times (per year). Root Canal Only covered on permanent teeth.",
    "notes": "Where root canal treatment has failed; benefits are allocated for a re-root canal treatment on the tooth. In the event that the re-root canal treatment fails, benefits will be available for an apicectomy. \uf0b7 Crowns and four surface restorations on third molars require pre-authorisation with supporting radiograph. Patient written consent needed for procedures not covered. 2. Lower rate applies to non network provider",
    "source": "https://dentalrisk.com/member-benefits/",
    "lastUpdated": "Jan-26"
  },
  {
    "scheme": "SIZWE HOSMED",
    "plan": "ESSENTIAL COPPER",
    "administrator": "3Sixty Heath.",
    "contactInfo": {
      "email": [
        "customercare@denis.co.za or fax 086 000 2121"
      ],
      "fax": [
        " 086 000 2121"
      ],
      "phone": [
        "0861 033 647"
      ]
    },
    "networked": "Yes",
    "nonNetworkedPayment": "No",
    "balancedBilling": "Yes",
    "basicTreatment": "Yes with limitations",
    "rct": "No",
    "dentures": "No",
    "crownsOrBridges": "No",
    "implants": "No",
    "surgicalExtractions": "No",
    "exclusions": "X-rays: Extraoral No Benefits. No benefit for root canal therapy. No Benefits for specialised dentistry",
    "preAuth": "The following benefits are limited to PMB cases:\n\u2022 Extensive conservative treatment for children under 7 years of age.",
    "crucialRules": "",
    "notes": "Patient written Accountability form needed for procedures not covered.",
    "source": "https://dentalrisk.com/member-benefits/",
    "lastUpdated": "Jan-26"
  },
  {
    "scheme": "Standard Bank Health Insurance",
    "plan": "SBHI Primary Standard Plan SBHI Primary Standard Plus Hospital Plan",
    "administrator": "Denis",
    "contactInfo": {
      "email": [
        "customercare@denis.co.za"
      ],
      "fax": [],
      "phone": [
        "0862 445 566"
      ]
    },
    "networked": "There will be no benefit for out-of-network visits and treatment.",
    "nonNetworkedPayment": "No",
    "balancedBilling": "No",
    "basicTreatment": "Yes with limitations",
    "rct": "Root Canal Treatment Emergency only",
    "dentures": "No",
    "crownsOrBridges": "No",
    "implants": "No",
    "surgicalExtractions": "No",
    "exclusions": "There is no benefit for: Root Canal Therapy, Dentures, Specialised Dentistry, Inhalation Sedation in Dental Rooms, Moderate/Deep Sedation in Dental Rooms and Dental Treatment in hospital.",
    "preAuth": "Motivation and records required for more than 5 fillings per dependant per year Motivation required for 3 or 4 surface fillings on wisdom teeth (3rd Molars) Benefit for fillings is granted once per tooth in 9 months",
    "crucialRules": "8102 Full mouth examination, Two consultations per dependant per year (once every 6 months). 8104 Specific consultation One specific consultation for pain and sepsis per dependant per year; not within 4 weeks of 8101. 8107 and/or 8112 Maximum of 2 X-rays films per visit per dependant . Two polishing and scaling treatments per dependant per year (once every 6 months 8155 or 8159). 8161 Fluoride treatment Two treatments per year for dependants younger than 12 years of age (once every 6 months) 8201 Extractions (removal of teeth) Extraction of tooth or exposed roots .",
    "notes": "8133 Pulpectomy (pain relief) Not covered on primary teeth. There will be no benefit for out-of-network visits and treatment. The following products offered by Old Mutual Health Solutions do not include benefits for out-of-hospital\ndental treatment: Hospital Plan, Golden Hour, Golden Hour with Hospital Plan, and Golden Hour with Hospital\nDirect GP Visit.",
    "source": "https://denis.co.za/wp-content/uploads/2025/12/Standard-Bank-Health-Insurance-Benefit-Table-2026-v1.pdf",
    "lastUpdated": "Jan-26"
  },
  {
    "scheme": "STANDARDBANK INSURANCE",
    "plan": "BEWELL 103 PLAN",
    "administrator": "Denis",
    "contactInfo": {
      "email": [
        "customercare@denis.co.za"
      ],
      "fax": [],
      "phone": [
        "0860 445 566"
      ]
    },
    "networked": "There will be no benefit for out-of-network visits and treatment.",
    "nonNetworkedPayment": "No",
    "balancedBilling": "No",
    "basicTreatment": "Yes with limitations",
    "rct": "Root Canal Treatment Emergency only",
    "dentures": "No",
    "crownsOrBridges": "No",
    "implants": "No",
    "surgicalExtractions": "No",
    "exclusions": "There is no benefit for: Root Canal Therapy, Dentures, Specialised Dentistry, Inhalation Sedation in Dental Rooms, Moderate/Deep Sedation in Dental Rooms and Dental Treatment in hospital. NO Panorex.",
    "preAuth": "Motivation and records required for more than 5 fillings per dependant per year Motivation required for 3- or 4-surface fillings on wisdom teeth (3rd Molars) Benefit for fillings is granted once per tooth in 9 months",
    "crucialRules": "8101 Full mouth examination, charting & treatment planning General Dental Practitioner or Dental Therapist Two consultations per dependant per year (once every 6 months). 8107 and/or 8112 Maximum of 2 X-rays films per visit per dependant . 8155 and/or 8159 Two polishing and scaling treatments per dependant per year (once every 6 months 8155 or 8159). 8161 Fluoride treatment Two treatments per year for dependants younger than 12 years of age (once every 6 months) . 8201 Extractions (removal of teeth) Extraction of tooth or exposed roots . 8132 Pulpectomy (pain relief) Not covered on primary teeth",
    "notes": "Benefits payable on the BeWell 103 Plan are subject to the use of a Network Service Provider on the DENIS Dental Network. There will be no benefit for out-of-network visits and treatment.",
    "source": "https://denis.co.za/wp-content/uploads/2025/12/Standard-Bank-Health-Insurance-Benefit-Table-2026-v1.pdf",
    "lastUpdated": "Jan-26"
  },
  {
    "scheme": "Suremed",
    "plan": "Explorer and Shuttle Options",
    "administrator": "Momentum PRIMECURE",
    "contactInfo": {
      "email": [
        "dentalmotivations@carecross.co.za"
      ],
      "fax": [],
      "phone": [
        "0860 101 159"
      ]
    },
    "networked": "Yes",
    "nonNetworkedPayment": "Yes",
    "balancedBilling": "No",
    "basicTreatment": "Yes with limitations",
    "rct": "No",
    "dentures": "No",
    "crownsOrBridges": "No",
    "implants": "No",
    "surgicalExtractions": "No",
    "exclusions": "No panorex. Specialised dentistry such as bridges, crowns, surgical extractions, implants, root canals,gold fillings, dentures and braces are not covered",
    "preAuth": "8201 & 8202 Combined maximum of four per year with an additional four allowed upon pre-authorisation. Maximum four restorations per year with an additional four allowed only upon preauthorisation. Posterior amalgam and resin fillings are remunerated at the same tariff. 1 set per family every 24 months. A co-payment is\npayable on all dentures, equal to 20% of the total fees charged by the dentist and laboratory",
    "crucialRules": "8101 One per beneficiary per annum. 8104 Not within six weeks of 8101 or 8104. 8107/8112 Maximum four per annum combined, unless otherwise authorised. 8155 & 8159 Once per annum per member (either or 8155) 8161 Maximum of one per child per year for patients younger than 12 years. 8163 Maximum of two per child per year for patients younger than 12 years. 8935 Septic socket treatment Once per tooth. 8259 Rebase of denture (laboratory) Rebase complete or partial denture (once a calendar year per member). 8261 Remodel of denture Rebase complete or partial denture (once a calendar year per member. Reline complete or partial denture (once a calendar year per member) Repair denture Twice per calendar year per member",
    "notes": "Patient written consent needed for procedures not covered.",
    "source": "https://content.momentum.co.za/mmsa/complete_health/pdfs/Sales%20Tools/Provider%20Search/2026/2026_MHS_Dental_Network_guide_54.pdf",
    "lastUpdated": "Jan-26"
  },
  {
    "scheme": "Suremed",
    "plan": "Challenger",
    "administrator": "Momentum",
    "contactInfo": {
      "email": [
        "info@suremedhealth.co.za"
      ],
      "fax": [],
      "phone": [
        "0860 080 888"
      ]
    },
    "networked": "Yes",
    "nonNetworkedPayment": "Yes",
    "balancedBilling": "Yes",
    "basicTreatment": "Yes with limitations",
    "rct": "Yes",
    "dentures": "Yes",
    "crownsOrBridges": "Yes",
    "implants": "Yes",
    "surgicalExtractions": "Yes",
    "exclusions": "Multiple restorations on an anterior tooth on the same service date only per authorisation and x-rays received . Repairing of teeth damaged due to bruxism, toothbrush abrasion, erosion and fluorosis will not be covered \uf0b7 Replacement of non\u0002carious amalgam restored tooth with a resin will not be covered. Posterior teeth restorations cannot be performed across the midline. Inlay/onlay or \u00be crowns not covered . Crowns on non\u0002functional 3rd molars are not covered.",
    "preAuth": "Plastic Dentures Pre-authorisation required One set of plastic dentures (an upper and a lower) per beneficiary in a 4-year period . Partial Chrome Cobalt Frame Dentures Pre-authorisation required Two partial metal frames (an upper and a lower) per beneficiary in a 5-year period.",
    "crucialRules": "Emergency pain and sepsis treatment and extractions only, one per beneficiary per year. No Panorex.X-rays: Extraoral One per beneficiary in a 3-year period. 8159,8155 Once per 6 months per member from date of service. 8161, Once per 6 months per member from date of service. 8163 Fissure sealant Limited to beneficiaries from age 5 and younger than 16 years of age . Root Canal Therapy and Extractions",
    "notes": "Patient written consent needed for procedures not covered. 2. Lower rate applies to non network provider",
    "source": "https://www.suremedhealth.co.za/index.php/downloads/",
    "lastUpdated": "Jan-26"
  },
  {
    "scheme": "Suremed",
    "plan": "Navigator",
    "administrator": "Momentum",
    "contactInfo": {
      "email": [
        "info@suremedhealth.co.za"
      ],
      "fax": [],
      "phone": [
        "0861 080 888"
      ]
    },
    "networked": "Yes",
    "nonNetworkedPayment": "Yes",
    "balancedBilling": "No",
    "basicTreatment": "Yes with limitations",
    "rct": "Yes",
    "dentures": "Yes",
    "crownsOrBridges": "Yes",
    "implants": "Yes",
    "surgicalExtractions": "Yes",
    "exclusions": "Repairing of teeth damaged due to bruxism, toothbrush abrasion, erosion and fluorosis will not be covered \uf0b7 Replacement of non\u0002carious amalgam with resin will not be cover. Crowns on non\u0002functional 3rd molars are not coveredered",
    "preAuth": "Plastic Dentures Pre-authorisation required One set of plastic dentures (an upper and a lower) per beneficiary in a 4-year period . Partial Chrome Cobalt Frame Dentures Pre-authorisation required Two partial metal frames (an upper and a lower) per beneficiary in a 5-year period.",
    "crucialRules": "Emergency pain and sepsis treatment and extractions only, one per beneficiary per year. No Panorex.X-rays: Extraoral One per beneficiary in a 3-year period. 8159,8155 Once per 6 months per member from date of service. 8161, Once per 6 months per member from date of service. 8163 Fissure sealant Limited to beneficiaries from age 5 and younger than 16 years of age . Root Canal Therapy and Extractions",
    "notes": "Patient written consent needed for procedures not covered. 2. Lower rate applies to non network provider",
    "source": "https://www.suremedhealth.co.za/index.php/downloads/",
    "lastUpdated": "Jan-26"
  },
  {
    "scheme": "Thebemed",
    "plan": "ENERGY",
    "administrator": "DEnis",
    "contactInfo": {
      "email": [
        "customercare@denis.co.za"
      ],
      "fax": [],
      "phone": [
        "0860 445 566"
      ]
    },
    "networked": "Yes",
    "nonNetworkedPayment": "Yes",
    "balancedBilling": "Yes",
    "basicTreatment": "Yes with limitations",
    "rct": "Yes",
    "dentures": "Yes",
    "crownsOrBridges": "Yes",
    "implants": "No",
    "surgicalExtractions": "Yes",
    "exclusions": "Implants and Associated Laboratory Costs No benefit",
    "preAuth": "Benefit for fillings: Granted once per tooth in 720 days, Multiple fillings: A treatment plan and X-rays may be required for multiple fillings. Pre-authorisation required One set of plastic dentures (an upper and a lower) per beneficiary in a 4-year period. Pre-authorisation required One partial metal frame (an upper or a lower) per beneficiary in a 5-year period . Pre-authorisation required One crown per beneficiary per year. Hospitalisation \n(General Anaesthetic) Pre-authorisation required General anaesthetic benefit available for children under the age of 5 years for extensive dental treatment General anaesthetic benefit available for the removal of impacted teeth . Deep Sedation in the Dental Rooms Pre-authorisation required Benefit limited to extensive dental treatment",
    "crucialRules": "Two check-ups per beneficiary per year (once every 6 months). X-rays: Intraoral Benefit subject to managed care protocols. X-rays: Extraoral One per beneficiary in a 3-year period. Benefit for scale and polish: Two scale and polish treatments per beneficiary per year (once every 6 months) Benefit for fissure sealants: Limited to beneficiaries younger than 16 years of age Benefit for fluoride: Limited to beneficiaries from age 5 and younger than 13 years of age. Root Canal Therapy and Extractions Benefit subject to managed care protocols.",
    "notes": "Benefit not available for the clinical fee of denture repairs, denture tooth replacements and the addition of a soft base to new dentures; the laboratory fee will be covered (no pre-authorisation required). \u2022 Benefit for a mouth guard: Benefit available for both the clinical and the associated laboratory fee for a mouth guard (no pre-authorisation required).",
    "source": "https://denis.co.za/wp-content/uploads/2025/12/Thebemed-Benefit-Tables-2026-v1.pdf",
    "lastUpdated": "Jan-26"
  },
  {
    "scheme": "Thebemed",
    "plan": "UNIVERSAL PLAN & EDO",
    "administrator": "DENIS",
    "contactInfo": {
      "email": [
        "customercare@denis.co.za"
      ],
      "fax": [],
      "phone": [
        "0860 445 566"
      ]
    },
    "networked": "Yes",
    "nonNetworkedPayment": "Yes",
    "balancedBilling": "Yes",
    "basicTreatment": "Yes with limitations",
    "rct": "Yes",
    "dentures": "Yes",
    "crownsOrBridges": "No",
    "implants": "No",
    "surgicalExtractions": "Yes",
    "exclusions": "No Panorex No specialised dentistry",
    "preAuth": "Maximum of four fillings per beneficiary per calendar year Benefit for fillings granted once per tooth in 720 days. Plastic Dentures Pre-authorisation required One set of plastic dentures (an upper and a lower) per beneficiary in a 4-year period .",
    "crucialRules": "8101 One per beneficiary per calendar year. 8107 & 8112 Four X-rays in total per beneficiary per calendar year . 8159 & 8155 One per beneficiary per calendar year (either 8159 or 8155). 8104 Benefit subject to managed care protocols . 8129 Benefit subject to managed care protocols . 8132 Benefit subject to managed care protocols. Root Canal Treatment All other codes: ONLY covered on permanent teeth . 8201 Extraction of tooth or exposed roots",
    "notes": "Benefits payable on the Universal Plan and the Universal Plan EDO are subject to the use of a Designated Service Provider (DSP) on the DENIS Dental Network. If there is no DSP in the member\u2019s area, the member needs to contact DENIS prior to treatment. Patient written consent needed for procedures not covered. 2. Lower rate applies to non network provider onservative dentistry benefits are limited to the specified list of procedure codes and benefit limitations stipulated in the Conservative Dentistry table below. There is no benefit for Specialised dentistry.",
    "source": "https://denis.co.za/wp-content/uploads/2025/12/Thebemed-Benefit-Tables-2026-v1.pdf",
    "lastUpdated": "Jan-26"
  },
  {
    "scheme": "Thebemed",
    "plan": "Fantasy",
    "administrator": "DENIS",
    "contactInfo": {
      "email": [
        "customercare@denis.co.za"
      ],
      "fax": [],
      "phone": [
        "0860 445 566"
      ]
    },
    "networked": "Yes",
    "nonNetworkedPayment": "Yes",
    "balancedBilling": "Yes",
    "basicTreatment": "Yes with limitations",
    "rct": "Yes",
    "dentures": "Yes",
    "crownsOrBridges": "Yes",
    "implants": "No",
    "surgicalExtractions": "Yes",
    "exclusions": "Implants and Associated Laboratory Costs No benefit",
    "preAuth": "Pre-authorisation is required for Plastic & Partial Metal Frame Dentures, Crowns, Periodontics and Moderate/ Deep Sedation in the Dental Rooms. PMB treatment is the only dental treatment covered in hospital. Pre-authorisation by DENIS is required for any dental related PMB hospitalisation.",
    "crucialRules": "8102 One per beneficiary per calendar year. 8107 & 8112 Four X-rays in total per beneficiary per calendar year . 8159 & 8155 One per beneficiary per calendar year (either 8159 or 8155). 8104 Benefit subject to managed care protocols . 8129 Benefit subject to managed care protocols . 8132 Benefit subject to managed care protocols. Root Canal Treatment All other codes: ONLY covered on permanent teeth . 8201 Extraction of tooth or exposed roots . In-Chair Procedures: Surgical removal of impacted teeth is included as part of the extraction benefit when performed in the dental chair.",
    "notes": "Conservative dentistry benefits are payable from Risk, limited to the specified list of procedure codes and benefit limitations stipulated in the Conservative Dentistry table below. Specialised dentistry benefits are payable from the Member\u2019s Savings Account,",
    "source": "https://denis.co.za/wp-content/uploads/2025/12/Thebemed-Benefit-Tables-2026-v1.pdf",
    "lastUpdated": "Jan-26"
  },
  {
    "scheme": "Transmed",
    "plan": "TRANSMED SELECT",
    "administrator": "Denis",
    "contactInfo": {
      "email": [
        "customercare@denis.co.za"
      ],
      "fax": [],
      "phone": [
        "0860 445 566"
      ]
    },
    "networked": "Yes",
    "nonNetworkedPayment": "Yes",
    "balancedBilling": "Yes",
    "basicTreatment": "Yes with limitations",
    "rct": "Yes",
    "dentures": "Yes",
    "crownsOrBridges": "Yes",
    "implants": "No",
    "surgicalExtractions": "Yes",
    "exclusions": "Extraoral X-ray \u2013 panoramic 8115 No benefit - Covered if provided with impacted wisdom tooth removal authorisation application; an additional 8115 can be allowed for Orthodontics. Implants and Associated Laboratory Costs No benefit",
    "preAuth": "Pre-authorisation is required for dentures, crown and bridgework, orthodontics, moderate/deep sedation in the dental rooms and general anaesthetic in hospital. No pre-authorisation will result in no payment. Emergencies require authorisation within 48 hours of admission. Restoration Codes (Authorisation required on quantity; see limitations). Pre-authorisation and X-rays required for any 3 or 4 surface fillings on wisdom teeth (non-functional wisdom teeth not covered. Plastic Dentures* *Pre-authorisation required Specialised Dentistry limit of R5 900 per family per year. Surgical removal of impacted tooth. \u2013 report per tooth 8941 Surgery in Hospital *Pre-authorisation is required. Moderate/Deep Sedation in the Dental Rooms Pre-authorisation required.",
    "crucialRules": "8101 Two annual consultations per beneficiary per year . 8104 Not within 4 weeks of an 8101, 8102, 8104 . 8107 and/or 8112 cannot be charged more than 7 times per year in total . Two annual treatments per beneficiary per year in total; once in 6 months (i.e. 180 days apart) for codes 8155 and/or 8159 . Two annual treatments per beneficiary per year (once in 6 months, i.e. 180 days apart from previous code 8161 or 8162) . 8167 Two annual treatments per beneficiary per year (once in 6 months, i.e. 180 days apart from previous 8167) .8201 A maximum of 8 per quadrant per permanent dentition and 5 per primary dentition . Emergency Pulp removal for the relief of acute pain prior to root canal therapy 8132 . 8163 Maximum of 8 (2 per quadrant) can be charged for beneficiaries younger than 16 years of age.",
    "notes": "8269 Repair of denture . 8273 Impression to repair denture, Rebase complete or partial denture, Remodel complete or partial denture, Reline, Soft base reline per denture (exclusion to new dentures, can only be claimed 6 months after new denture) . Surgical removal of a tooth 8937 No pre-authorisation required; only covered out of hospital",
    "source": "https://denis.co.za/wp-content/uploads/2025/12/Transmed-Dental-Benefit-Tables-2026-v1.pdf",
    "lastUpdated": "Jan-26"
  },
  {
    "scheme": "Transmed",
    "plan": "GUARDIAN",
    "administrator": "Denis",
    "contactInfo": {
      "email": [
        "customercare@denis.co.za"
      ],
      "fax": [],
      "phone": [
        "0860 445 566"
      ]
    },
    "networked": "Yes",
    "nonNetworkedPayment": "Yes",
    "balancedBilling": "Yes",
    "basicTreatment": "Yes with limitations",
    "rct": "Yes",
    "dentures": "Yes",
    "crownsOrBridges": "Yes",
    "implants": "No",
    "surgicalExtractions": "Yes",
    "exclusions": "Implants No benefit. Orthodontics No benefit. Metal base to full dentures, including the laboratory costs. Provisional crowns and associated laboratory costs \u2022 Emergency crowns and associated laboratory costs. Extraoral X-rays 8115 No benefit",
    "preAuth": "Pre-authorisation is required for dentures, crown and bridgework, moderate/deep sedation in the dental rooms and general anaesthetic in hospital. PMB treatment and certain procedures are the only dental treatment covered in hospital on the Guardian option. Pre-authorisation and X-rays required for any 3 or 4 surface fillings on wisdom teeth (non-functional wisdom teeth not covered). Plastic Dentures All codes (8231 \u2013 8273) are subject to a denture limit of R1 290 per family. Once depleted, the balance is payable from the available Specialised dentistry limit of R5 090 per family per year. Sedation in Dental Rooms* *Pre-authorisation required.",
    "crucialRules": "Extraction of tooth or exposed roots 8201 Maximum of 8 per quadrant per permanent dentition and 5 per primary dentition. Surgery in the dental chair PMB and certain procedures only.",
    "notes": "8269 Repair of denture . 8273 Impression to repair denture, Rebase complete or partial denture, Remodel complete or partial denture, Reline, Soft base reline per denture (exclusion to new dentures, can only be claimed 6 months after new denture) 365 days per member.",
    "source": "https://denis.co.za/wp-content/uploads/2025/12/Transmed-Dental-Benefit-Tables-2026-v1.pdf",
    "lastUpdated": "Jan-26"
  },
  {
    "scheme": "Transmed Medical Fund",
    "plan": "Link Plan",
    "administrator": "Universal",
    "contactInfo": {
      "email": [
        "network@universal.co.za"
      ],
      "fax": [],
      "phone": [
        "0803 628 677"
      ]
    },
    "networked": "Yes",
    "nonNetworkedPayment": "Yes",
    "balancedBilling": "No",
    "basicTreatment": "Yes with limitations",
    "rct": "Root Canal Treatment Emergency only",
    "dentures": "Yes",
    "crownsOrBridges": "No",
    "implants": "No",
    "surgicalExtractions": "No",
    "exclusions": "No benefits for pulpotomy. No benefits for surgical removal of impacted teeth. No panorex.",
    "preAuth": "Fillings pre\u0002authorisation required if >4 per annum per beneficiary . Only anterior composite fillings are covered. Pre-authorisation required for 4 or more extractions per annum per beneficiary. Wisdom teeth extractions to be done in dentist\u2019s rooms under local anaesthesia. Oral Radiographs Pre authorisation required if >2 per beneficiary per annum. Root Canal Treatment . 80% of cost payable by the scheme and includes professional and laboratory fees. 20% member liability",
    "crucialRules": "Limited to 1 consultation per beneficiary. One set of dentures every 24 months per beneficiary. A 20% co- payment applies. Restorations /Composite Fillings Preauthorisation required if >4 per annum per beneficiary. Only anterior composite fillings are covered. Extractions re-authorisation required for 4 or more extractions per annum per beneficiary. Teeth extractions to be done in dentist\u2019s rooms under local anaesthesia. Oral Radiographs Pre authorisation required if >2 per beneficiary per annum. Root Canal Treatment Emergency only.",
    "notes": "Confirmation of benefits is not a guarantee of payment \u2013An authorisation granted is not a guarantee of payment",
    "source": "https://www.transmed.co.za/benefits/day-to-day-cover-select-plan#!",
    "lastUpdated": "Jan-26"
  },
  {
    "scheme": "Umvuzo",
    "plan": "EXTREME",
    "administrator": "Umvuzo",
    "contactInfo": {
      "email": [
        "info@umvuzohealth.co.za or fax 0866 700 242"
      ],
      "fax": [
        " 0866 700 242"
      ],
      "phone": [
        "0600 702 095"
      ]
    },
    "networked": "No",
    "nonNetworkedPayment": "Yes",
    "balancedBilling": "No",
    "basicTreatment": "Yes with limitations",
    "rct": "No",
    "dentures": "No",
    "crownsOrBridges": "No",
    "implants": "No",
    "surgicalExtractions": "No",
    "exclusions": "No panorex. gold inlays in dentures. Orthodontic treatment, is excluded from benefits. No dental procedure under general anaesthesia or conscious sedation will be funded. Dental benefits are limited to procedures as per agreed list of codes in the rooms contracted preferred providers as set out above.",
    "preAuth": "SPECIALISED DENTISTRY; R10 200 per family per year\u2022 Orthodontic, Periodontic and Prosthodontic Treatment\u2022 Metal Base Dentures\u2022 Ceramic/Laminated Inlays\u2022 Gold Inlays",
    "crucialRules": "only Emergency root canal.",
    "notes": "This Option allows members to have more secondary benefits, makes use of the Universal Network",
    "source": "https://umvuzohealth.co.za/plans/",
    "lastUpdated": "Jan-26"
  },
  {
    "scheme": "Umvuzo",
    "plan": "ACTIVATOR",
    "administrator": "Umvuzo",
    "contactInfo": {
      "email": [
        "info@umvuzohealth.co.za or fax 0866 700 242"
      ],
      "fax": [
        " 0866 700 242"
      ],
      "phone": [
        "0600 702 095"
      ]
    },
    "networked": "No",
    "nonNetworkedPayment": "Yes",
    "balancedBilling": "No",
    "basicTreatment": "Yes with limitations",
    "rct": "No",
    "dentures": "No",
    "crownsOrBridges": "No",
    "implants": "No",
    "surgicalExtractions": "No",
    "exclusions": "No panorex. gold inlays in dentures. Orthodontic treatment, is excluded from benefits. No dental procedure under general anaesthesia or conscious sedation will be funded. Dental benefits are limited to procedures as per agreed list of codes in the rooms contracted preferred providers as set out above.",
    "preAuth": "Fillings: \u2022 Composite and amalgam fillings can be replaced once every two years per individual tooth. Motivation required if less than 2 years.",
    "crucialRules": "only Emergency root canal. \u00bbConsultations \u00bbCleaning, Preventative & Fluoride Treatment, \u00bbScaling & Polishing \u00bbFillings \u00bbWisdom Teeth Extraction \u00bbDentures \u00bbCrowns \u00bbBridges",
    "notes": "Confirmation of benefits is not a guarantee of payment \u2013An authorisation granted is not a guarantee of payment",
    "source": "https://umvuzohealth.co.za/plans/",
    "lastUpdated": "Jan-26"
  },
  {
    "scheme": "Umvuzo",
    "plan": "SUPREME",
    "administrator": "Umvuzo",
    "contactInfo": {
      "email": [
        "info@umvuzohealth.co.za or fax 0866 700 242"
      ],
      "fax": [
        " 0866 700 242"
      ],
      "phone": [
        "0600 702 095"
      ]
    },
    "networked": "No",
    "nonNetworkedPayment": "Yes",
    "balancedBilling": "No",
    "basicTreatment": "Yes with limitations",
    "rct": "No",
    "dentures": "No",
    "crownsOrBridges": "No",
    "implants": "No",
    "surgicalExtractions": "No",
    "exclusions": "No panorex. gold inlays in dentures. Orthodontic treatment, is excluded from benefits. No dental procedure under general anaesthesia or conscious sedation will be funded. Dental benefits are limited to procedures as per agreed list of codes in the rooms contracted preferred providers as set out above.",
    "preAuth": "Fillings: \u2022 Composite and amalgam fillings can be replaced once every two years per individual tooth. Motivation required if less than 2 years. Plastic dentures \u2022 1 set of plastic dentures (an upper and a lower) per beneficiary per three years. \u2022 Partia",
    "crucialRules": "only Emergency root canal. \u00bbConsultations \u00bbCleaning, Preventative & Fluoride Treatment, \u00bbScaling & Polishing \u00bbFillings \u00bbWisdom Teeth Extraction \u00bbDentures \u00bbCrowns \u00bbBridges",
    "notes": "Confirmation of benefits is not a guarantee of payment \u2013An authorisation granted is not a guarantee of payment",
    "source": "https://umvuzohealth.co.za/plans/",
    "lastUpdated": "Jan-26"
  },
  {
    "scheme": "Umvuzo Health",
    "plan": "Standard Option",
    "administrator": "Universal",
    "contactInfo": {
      "email": [
        "network@universal.co.za"
      ],
      "fax": [],
      "phone": [
        "0803 628 677"
      ]
    },
    "networked": "Yes",
    "nonNetworkedPayment": "Yes",
    "balancedBilling": "No",
    "basicTreatment": "Yes with limitations",
    "rct": "Root Canal Treatment Emergency only",
    "dentures": "Yes",
    "crownsOrBridges": "No",
    "implants": "No",
    "surgicalExtractions": "No",
    "exclusions": "No benefits for pulpotomy. No benefits for surgical removal of impacted teeth. No panorex.",
    "preAuth": "Fillings pre\u0002authorisation required if >4 per annum per beneficiary . Only anterior composite fillings are covered. Pre-authorisation required for 4 or more extractions per annum per beneficiary. Wisdom teeth extractions to be done in dentist\u2019s rooms under local anaesthesia. Oral Radiographs Pre authorisation required if >2 per beneficiary per annum.",
    "crucialRules": "Root Canal Treatment Emergency only Dentures No benefits.",
    "notes": "Confirmation of benefits is not a guarantee of payment \u2013An authorisation granted is not a guarantee of payment",
    "source": "https://umvuzohealth.co.za/plans/",
    "lastUpdated": "Jan-26"
  },
  {
    "scheme": "Umvuzo Health",
    "plan": "Ultra Affordable Value Option",
    "administrator": "Universal",
    "contactInfo": {
      "email": [
        "network@universal.co.za"
      ],
      "fax": [],
      "phone": [
        "0803 628 677"
      ]
    },
    "networked": "Yes",
    "nonNetworkedPayment": "Yes",
    "balancedBilling": "No",
    "basicTreatment": "Yes with limitations",
    "rct": "Root Canal Treatment Emergency only",
    "dentures": "Yes",
    "crownsOrBridges": "Yes",
    "implants": "No",
    "surgicalExtractions": "No",
    "exclusions": "No panorex. gold inlays in dentures. Orthodontic treatment, is excluded from benefits. No dental procedure under general anaesthesia or conscious sedation will be funded.",
    "preAuth": "Fillings pre\u0002authorisation required if >4 per annum per beneficiar. Pre-authorisation required for 4 or more extractions per annum per beneficiary. Wisdom teeth extractions to be done in dentist\u2019s rooms under local anaesthesia. Oral Radiographs Pre authorisation required if >2 per beneficiary per annum. Elective maxillo -facial and oral surgery;",
    "crucialRules": "Essential dentistry which includes the following: \u00bbR3 700 per beneficiary per year \u00bbBenefit includes: Extractions, Preventative & Fluoride Treatment, Cleaning, Scaling & Polishing, Dental Fillings, Oral X-rays, Crowns, Bridges \u00bb Emergency Root Canal \u00bbWisdom Teeth Extraction (in the dentists\u2019 rooms).",
    "notes": "Confirmation of benefits is not a guarantee of payment \u2013An authorisation granted is not a guarantee of payment",
    "source": "https://umvuzohealth.co.za/plans/",
    "lastUpdated": "Jan-26"
  },
  {
    "scheme": "UNITY HEALTH",
    "plan": "Unity Plan C, Stratum, Elixi Gold & The Unlimited:",
    "administrator": "",
    "contactInfo": {
      "email": [
        "networks@unityhealth.co.za"
      ],
      "fax": [],
      "phone": [
        "0861 366 006"
      ]
    },
    "networked": "Yes",
    "nonNetworkedPayment": "Yes",
    "balancedBilling": "No",
    "basicTreatment": "Yes with limitations",
    "rct": "No",
    "dentures": "No",
    "crownsOrBridges": "No",
    "implants": "No",
    "surgicalExtractions": "No",
    "exclusions": "NO BENEFITS FOR SPECIALISED DENTISTRY",
    "preAuth": "",
    "crucialRules": "Basic Dentistry Single member: Limited to an overall annual limit of R1 550 per year. Member and one dependant: Limited to R1 550 per person with an overall annual limit of R3 100. Member and two or more dependants: Limited to R1 550 per person with an overall annual limit of R4 650 per family shared \namong all members. Treatment includes: Full mouth assessment, intra-oral radiographs, scale & polish, extractions, fillings, pain and sepsis",
    "notes": "SEE SPECIFIC CODES",
    "source": "",
    "lastUpdated": "Jan-26"
  },
  {
    "scheme": "UNITY HEALTH",
    "plan": "Elixi Black:",
    "administrator": "",
    "contactInfo": {
      "email": [
        "networks@unityhealth.co.za"
      ],
      "fax": [],
      "phone": [
        "0861 366 006"
      ]
    },
    "networked": "Yes",
    "nonNetworkedPayment": "Yes",
    "balancedBilling": "No",
    "basicTreatment": "",
    "rct": "",
    "dentures": "",
    "crownsOrBridges": "",
    "implants": "",
    "surgicalExtractions": "",
    "exclusions": "NO BENEFITS FOR SPECIALISED DENTISTRY",
    "preAuth": "",
    "crucialRules": "Single member: Limited to an overall annual limit of R1 860 per year. Member and one dependant: Limited to R1 860 per person with an overall annual limit of R3 720. Member and two or more dependants: Limited to R1 860 per person with an overall annual limit of R5 580 per family shared among all members",
    "notes": "SEE SPECIFIC CODES",
    "source": "",
    "lastUpdated": "Jan-26"
  },
  {
    "scheme": "Universal Workplace Health Plan (WHP)",
    "plan": "truCARE truHEALTH truWELLNESS",
    "administrator": "Universal",
    "contactInfo": {
      "email": [
        "network@universal.co.za"
      ],
      "fax": [],
      "phone": [
        "0803 628 677"
      ]
    },
    "networked": "Yes",
    "nonNetworkedPayment": "Yes",
    "balancedBilling": "No",
    "basicTreatment": "Yes with limitations",
    "rct": "Root Canal Treatment Emergency only",
    "dentures": "Yes",
    "crownsOrBridges": "No",
    "implants": "No",
    "surgicalExtractions": "No",
    "exclusions": "No benefits for pulpotomy. No benefits for surgical removal of impacted teeth. No panorex.",
    "preAuth": "Fillings pre\u0002authorisation required if >4 per annum per beneficiary . Only anterior composite fillings are covered. Pre-authorisation required for 4 or more extractions per annum per beneficiary. Wisdom teeth extractions to be done in dentist\u2019s rooms under local anaesthesia. Oral Radiographs Pre authorisation required if >2 per beneficiary per annum. Root Canal Treatment",
    "crucialRules": "Root Canal Treatment Emergency only",
    "notes": "Confirmation of benefits is not a guarantee of payment \u2013An authorisation granted is not a guarantee of payment",
    "source": "",
    "lastUpdated": "Jan-26"
  },
  {
    "scheme": "Witbank Coalfields Medical Aid Scheme",
    "plan": "Ntsika Option",
    "administrator": "Universal",
    "contactInfo": {
      "email": [
        "network@universal.co.za"
      ],
      "fax": [],
      "phone": [
        "0803 628 677"
      ]
    },
    "networked": "Yes",
    "nonNetworkedPayment": "Yes",
    "balancedBilling": "No",
    "basicTreatment": "Yes with limitations",
    "rct": "Root Canal Treatment Emergency only",
    "dentures": "Yes",
    "crownsOrBridges": "No",
    "implants": "No",
    "surgicalExtractions": "No",
    "exclusions": "No benefits for pulpotomy. No benefits for surgical removal of impacted teeth. No panorex.",
    "preAuth": "Fillings pre\u0002authorisation required if >4 per annum per beneficiary . Only anterior composite fillings are covered. Pre-authorisation required for 4 or more extractions per annum per beneficiary. Wisdom teeth extractions to be done in dentist\u2019s rooms under local anaesthesia. Oral Radiographs Pre authorisation required if >2 per beneficiary per annum. Root Canal Treatment . 80% of cost payable by the scheme and includes professional and laboratory fees. 20% member liability",
    "crucialRules": "Limited to 1 consultation per beneficiary. One set of dentures every 24 months per beneficiary. A 20% co- payment applies. Restorations /Composite Fillings Preauthorisation required if >4 per annum per beneficiary. Only anterior composite fillings are covered. Extractions re-authorisation required for 4 or more extractions per annum per beneficiary. Teeth extractions to be done in dentist\u2019s rooms under local anaesthesia. Oral Radiographs Pre authorisation required if >2 per beneficiary per annum. Root Canal Treatment Emergency only.",
    "notes": "Confirmation of benefits is not a guarantee of payment \u2013An authorisation granted is not a guarantee of payment",
    "source": "https://wcmas.co.za/comprehensive-option/",
    "lastUpdated": "Jan-26"
  },
  {
    "scheme": "NETCARE",
    "plan": "",
    "administrator": "DISCOVERY",
    "contactInfo": {
      "email": [
        "member@netcaremedicalscheme.co.za"
      ],
      "fax": [],
      "phone": [
        "0860 100 696"
      ]
    },
    "networked": "Yes",
    "nonNetworkedPayment": "Yes",
    "balancedBilling": "Yes",
    "basicTreatment": "Yes",
    "rct": "Yes",
    "dentures": "Yes",
    "crownsOrBridges": "Yes",
    "implants": "Yes",
    "surgicalExtractions": "Yes",
    "exclusions": "Bone Augmentations \u2022 Bone and tissue regeneration procedures \u2022 Crowns and bridges for cosmetic reasons and associated laboratory costs \u2022 Enamel micro abrasion \u2022 Fillings: the cost of gold, precious metal, semi-precious metal and platinum foil \u2022 Laboratory delivery fees \u2022 Othognatic surgery \u2022 Sinus lift \u2022 Gum guards or mouth protectors",
    "preAuth": "AUTH FOR ALL SECIALISED DENTAL",
    "crucialRules": "Dentistry (overall limit applicable to basic\nand specialised, in and out of hospital)\nIncludes orthodontic (braces) treatment\nCombined in-hospital and out-of-hospital dentistry limit\nM \u2013 R5,900\nM+1 \u2013 R9,210\nM+2 \u2013 R11,800\nM+3+ \u2013 R14,490",
    "notes": "Confirmation of benefits is not a guarantee of payment \u2013An authorisation granted is not a guarantee of payment",
    "source": "https://www.netcaremedicalscheme.co.za/wcm/medical-schemes/netcare/assets/brochures/netcare-medical-scheme-brochure-2026.pdf",
    "lastUpdated": "Jan-26"
  }
]